webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(6);
var BaseService = /** @class */ (function () {
    function BaseService(Restangular, AppService, itemName) {
        var _this = this;
        this.Restangular = Restangular;
        this.AppService = AppService;
        this.itemName = itemName;
        this.observerCallbacks = [];
        this.collection = null;
        this.subscribe = function (ctrlname, callback) {
            _this.observerCallbacks.push({ callback: callback, ctrl: ctrlname });
        };
        this.unsubscribe = function (ctrlname) {
            _.remove(_this.observerCallbacks, { ctrl: ctrlname });
        };
        this.notifyObservers = function (type) {
            _this.observerCallbacks.forEach(function (item) {
                item.callback(type);
            });
        };
        this.all = function (params) {
            if (params === void 0) { params = { 'limit': 5000 }; }
            return _this.Restangular.all(_this.itemName).customGET('', params).then(function (response) {
                _this.list = response.plain().value;
                return _this.listLoaded(_this.list);
            });
        };
        this.listLoaded = function (list) {
            return list;
        };
        this.getList = function (params) {
            if (params === void 0) { params = { 'limit': 5000 }; }
            return _this.Restangular.all(_this.itemName).customGET('', params).then(function (response) {
                return _this.getListLoaded(response.plain());
            });
        };
        this.getListLoaded = function (collection) {
            return collection;
        };
        this.customAll = function (url, queryParams) {
            if (queryParams === void 0) { queryParams = { 'limit': 5000 }; }
            // console.log('customAll')
            return _this.Restangular.all(_this.itemName + '/' + url).getList(queryParams).then(function (list) {
                _this.list = list;
                return list.plain();
            });
        };
        this.collection = Restangular.all(itemName);
    }
    BaseService.prototype.one = function (id) {
        if (id === void 0) { id = null; }
        if (id) {
            return this.Restangular.one(this.itemName, id.toString());
        }
        else {
            return this.Restangular.one(this.itemName);
        }
    };
    BaseService.prototype.get = function (id) {
        var _this = this;
        if (id) {
            return this.Restangular.one(this.itemName, id.toString()).get().then(function (item) {
                _this.item = item;
                return item.plain();
            });
        }
        else {
            this.item = null;
            return null;
        }
    };
    // public create(): Restangular.IElement {
    //     return this.Restangular.one(this.itemName);
    // }
    BaseService.prototype.delete = function (id) {
        var _this = this;
        var promise = this.Restangular.one(this.itemName, id.toString()).remove();
        promise
            .then(function (result) {
            _this.itemId = id;
            _this.notifyObservers('delete');
            _this.AppService.NotifyService.success('Verwijderd', 'De gegevens zijn verwijderd');
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
        });
        return promise;
    };
    BaseService.prototype.post = function (data) {
        var _this = this;
        return this.collection.post(data).then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            _this.item = item.plain();
            _this.notifyObservers('post');
            return item.plain();
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    };
    BaseService.prototype.customPost = function (url, data, displayResult) {
        var _this = this;
        if (displayResult === void 0) { displayResult = true; }
        return this.collection.customPOST(data, url).then(function (item) {
            if (displayResult) {
                _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            }
            return item;
        })
            .catch(function (error) {
            if (displayResult) {
                _this.AppService.NotifyService.error('Foutmelding', error.data);
            }
            return error;
        });
    };
    BaseService.prototype.put = function (id, data) {
        var _this = this;
        var promise = this.Restangular.one(this.itemName, id.toString()).customPUT(data);
        promise
            .then(function (result) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            _this.item = result.plain();
            _this.notifyObservers('put');
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
        });
        return promise;
    };
    BaseService.prototype.customPut = function (url, data) {
        var _this = this;
        // console.log(data);
        return this.collection.customPUT(data, url).then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item;
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    };
    BaseService.prototype.customGet = function (url, params) {
        var _this = this;
        if (params === void 0) { params = null; }
        return this.Restangular.one(this.itemName + '/' + url).get(params).then(function (item) {
            if (item) {
                _this.item = item;
                if (typeof item !== "string" && item.plain()) {
                    return item.plain();
                }
                else {
                    return item;
                }
            }
            else {
                return null;
            }
        });
    };
    BaseService.prototype.getChild = function (id, childName, params) {
        var _this = this;
        if (params === void 0) { params = { 'limit': 5000 }; }
        if ((typeof id === "number" && id > 0) || (typeof id === "string" && id !== undefined)) {
            return this.Restangular.one(this.itemName, id.toString()).customGET(childName, params).then(function (item) {
                _this.item = item.value;
                return item.value;
            });
        }
        else {
            this.item = null;
            return null;
        }
    };
    BaseService.prototype.postChild = function (data, parentId, childName) {
        var _this = this;
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customPOST(data, childName);
        promise
            .then(function (result) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
        });
        return promise;
    };
    BaseService.prototype.putChild = function (data, parentId, childName, childId) {
        var _this = this;
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customPUT(data, childName + '/' + childId);
        promise
            .then(function (result) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
        });
        return promise;
    };
    BaseService.prototype.deleteChild = function (childId, parentId, childName) {
        var _this = this;
        var promise = this.Restangular.one(this.itemName, parentId.toString()).customDELETE(childName + '/' + childId);
        promise.then(function (result) {
            _this.AppService.NotifyService.success('Verwijderd', 'De gegevens zijn verwijderd');
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
        });
        return promise;
    };
    BaseService.prototype.customDelete = function (url) {
        var _this = this;
        return this.collection.customDELETE(url).then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item;
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    };
    return BaseService;
}());
exports.BaseService = BaseService;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
exports.ngmodule = angular.module("app", [
    'abo-theme',
    'ui.router',
    'restangular',
    'LocalStorageModule',
    'ngLetterAvatar',
    'ui.router.modal',
    'angularFileUpload',
    'ngMessages',
    'gettext',
    'permission',
    'permission.ui',
    'angular.filter',
    'ng.deviceDetector',
    'matchMedia',
    'ngFileSaver',
    'infinite-scroll',
    'ngclipboard'
]);
var BLANK_MODULE = {
    states: [],
    components: {},
    directives: {},
    services: {},
    filters: {},
    factories: {},
    configBlocks: [],
    runBlocks: []
};
/**
 * Register each app module's states, directives, components, filters, services,
 * and config/run blocks with the `ngmodule`
 *
 * @param ngModule the `angular.module()` object
 * @param appModule the feature module consisting of components, states, services, etc
 */
exports.loadNg1Module = function (ngModule, appModule) {
    var module = Object.assign({}, BLANK_MODULE, appModule);
    ngModule.config(['$stateProvider', function ($stateProvider) { return module.states.forEach(function (state) { return $stateProvider.state(state); }); }]);
    Object.keys(module.components).forEach(function (name) { return ngModule.component(name, module.components[name]); });
    Object.keys(module.directives).forEach(function (name) { return ngModule.directive(name, module.directives[name]); });
    Object.keys(module.services).forEach(function (name) { return ngModule.service(name, module.services[name]); });
    Object.keys(module.filters).forEach(function (name) { return ngModule.filter(name, module.filters[name]); });
    Object.keys(module.factories).forEach(function (name) { return ngModule.factory(name, module.factories[name]); });
    module.configBlocks.forEach(function (configBlock) { return ngModule.config(configBlock); });
    module.runBlocks.forEach(function (runBlock) { return ngModule.run(runBlock); });
    return ngModule;
};


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(716));
__export(__webpack_require__(719));
__export(__webpack_require__(720));
__export(__webpack_require__(725));
__export(__webpack_require__(727));
__export(__webpack_require__(730));
__export(__webpack_require__(722));
__export(__webpack_require__(268));
__export(__webpack_require__(265));
__export(__webpack_require__(728));
__export(__webpack_require__(726));
__export(__webpack_require__(723));
__export(__webpack_require__(15));
__export(__webpack_require__(721));
__export(__webpack_require__(724));
__export(__webpack_require__(269));
__export(__webpack_require__(264));
__export(__webpack_require__(731));
__export(__webpack_require__(262));
__export(__webpack_require__(267));
__export(__webpack_require__(22));
__export(__webpack_require__(266));
__export(__webpack_require__(718));
__export(__webpack_require__(717));
__export(__webpack_require__(271));
__export(__webpack_require__(263));
__export(__webpack_require__(24));
__export(__webpack_require__(23));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseEntity = /** @class */ (function () {
    function BaseEntity() {
    }
    return BaseEntity;
}());
exports.BaseEntity = BaseEntity;


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var isProd = ($.trim("develop") == 'production');
var isStaging = ($.trim("develop") == 'staging');
var isDev = ($.trim("develop") == 'develop');
var isDemo = ($.trim("develop") == 'demo');
var config = {
    VERSION: '1.27.0',
    BASE_URL: '',
    BASE_AUTH_URL: '',
    API_URL: '',
    AUTH_API_URL: '',
    AUTH_LOGIN_URL: '',
    AUTH_LOGOUT_URL: '',
    AUTH_CLIENT_ID: '',
    AUTH_SCOPES: '',
};
config.AUTH_CLIENT_ID = 'js';
config.AUTH_SCOPES = 'openid profile api';
if (isProd) {
    config.BASE_URL = 'https://operando-api.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth.tccapps.nl/';
}
else if (isStaging) {
    config.BASE_URL = 'https://operando-api-staging.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-staging.tccapps.nl/';
}
else if (isDev) {
    config.BASE_URL = 'https://operando-api-develop.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-develop.tccapps.nl/';
}
else {
    config.BASE_URL = 'http://operando-api-develop.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-develop.tccapps.nl/';
    //config.BASE_URL = 'http://localhost:5000/';
    //https://operando-auth-develop.tccapps.nl/config.BASE_AUTH_URL = 'https://operando-auth-develop.azurewebsites.net/';
}
config.API_URL = config.BASE_URL + 'api/';
config.AUTH_API_URL = config.BASE_AUTH_URL + 'auth/';
config.AUTH_LOGIN_URL = config.BASE_AUTH_URL + 'connect/authorize';
config.AUTH_LOGOUT_URL = config.BASE_AUTH_URL + 'connect/endsession';
exports.default = config;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IShift = /** @class */ (function (_super) {
    __extends(IShift, _super);
    function IShift() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscribed = false;
        _this.isInThePast = false;
        return _this;
    }
    return IShift;
}(base_entity_1.BaseEntity));
exports.IShift = IShift;
var IBulkactionData = /** @class */ (function () {
    function IBulkactionData() {
    }
    return IBulkactionData;
}());
exports.IBulkactionData = IBulkactionData;
var ShiftService = /** @class */ (function (_super) {
    __extends(ShiftService, _super);
    ShiftService.$inject = ["Restangular", "AppService"];
    function ShiftService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'shift') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.getFilter = function (params) {
            params.limit = params.limit ? params.limit : 5000;
            return _this.Restangular.all(_this.itemName).customGET('', params).then(function (response) {
                _this.list = response.plain().value;
                return _this.listLoaded(_this.list);
            });
        };
        _this.getLightByDate = function (params) {
            params.limit = params.limit ? params.limit : 5000;
            return _this.Restangular.all(_this.itemName + '/getLightByDate').customGET('', params).then(function (response) {
                _this.list = response.plain().value;
                return _this.listLoaded(_this.list);
            });
        };
        _this.getByEmployee = function (start, end, employeeId) {
            var params = { 'start': start, 'end': end };
            return _this.Restangular.all(_this.itemName + '/employee').customGET(employeeId, params).then(function (response) {
                _this.list = response.plain();
                return _this.listLoaded(_this.list);
            });
        };
        _this.getByCurrentEmployee = function (start, end) {
            var params = { 'start': start, 'end': end };
            return _this.Restangular.all(_this.itemName + '/employee').customGET('', params).then(function (response) {
                _this.list = response.plain();
                return _this.listLoaded(_this.list);
            });
        };
        _this.bulkAction = function (data) {
            return _this.Restangular.all(_this.itemName + '/bulk').post(data).then(function (item) {
                _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                return item.plain();
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
        };
        return _this;
    }
    return ShiftService;
}(base_service_1.BaseService));
exports.ShiftService = ShiftService;


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var ICalendarShift = /** @class */ (function (_super) {
    __extends(ICalendarShift, _super);
    function ICalendarShift() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ICalendarShift;
}(base_entity_1.BaseEntity));
exports.ICalendarShift = ICalendarShift;
var CalendarService = /** @class */ (function (_super) {
    __extends(CalendarService, _super);
    CalendarService.$inject = ["Restangular", "AppService"];
    function CalendarService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'calendar') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.all = function (params) {
            return _this.Restangular.all('calendar').customGET('', params).then(function (response) {
                _this.list = response.plain();
                return _this.listLoaded(_this.list);
            });
        };
        return _this;
    }
    return CalendarService;
}(base_service_1.BaseService));
exports.CalendarService = CalendarService;


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IEmployeeAvailability = /** @class */ (function (_super) {
    __extends(IEmployeeAvailability, _super);
    function IEmployeeAvailability() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IEmployeeAvailability;
}(base_entity_1.BaseEntity));
exports.IEmployeeAvailability = IEmployeeAvailability;
var EmployeeAvailabilityService = /** @class */ (function (_super) {
    __extends(EmployeeAvailabilityService, _super);
    EmployeeAvailabilityService.$inject = ["Restangular", "AppService"];
    function EmployeeAvailabilityService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/EmployeeAvailability') || this;
        _this.AppService = AppService;
        return _this;
    }
    return EmployeeAvailabilityService;
}(base_service_1.BaseService));
exports.EmployeeAvailabilityService = EmployeeAvailabilityService;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var HourCodeService = /** @class */ (function (_super) {
    __extends(HourCodeService, _super);
    HourCodeService.$inject = ["Restangular", "AppService"];
    function HourCodeService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/hourcode') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.getBySalaryScaleGroupId = function (salaryScaleGroupId) {
            return _this.Restangular.one(_this.itemName + '/group/' + salaryScaleGroupId).get().then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            });
        };
        _this.getBySalaryScaleGroupIdForTimezones = function (salaryScaleGroupId) {
            return _this.Restangular.one(_this.itemName + '/group/' + salaryScaleGroupId + '/fortimezones').get().then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            });
        };
        _this.getByType = function (type) {
            return _this.Restangular.one(_this.itemName + '/type/' + type).get().then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            });
        };
        return _this;
    }
    return HourCodeService;
}(base_service_1.BaseService));
exports.HourCodeService = HourCodeService;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var SalaryScaleGroupService = /** @class */ (function (_super) {
    __extends(SalaryScaleGroupService, _super);
    SalaryScaleGroupService.$inject = ["Restangular", "AppService"];
    function SalaryScaleGroupService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/salaryscalegroup') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return SalaryScaleGroupService;
}(base_service_1.BaseService));
exports.SalaryScaleGroupService = SalaryScaleGroupService;
var SalaryScaleService = /** @class */ (function (_super) {
    __extends(SalaryScaleService, _super);
    SalaryScaleService.$inject = ["Restangular", "AppService"];
    function SalaryScaleService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/salaryscale') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.getBySalaryScaleGroupId = function (salaryScaleGroupId) {
            return _this.Restangular.one(_this.itemName + '/group/' + salaryScaleGroupId).get().then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            });
        };
        return _this;
    }
    return SalaryScaleService;
}(base_service_1.BaseService));
exports.SalaryScaleService = SalaryScaleService;


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/beschikbaarheid2.jpg";

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IAuthUser = /** @class */ (function () {
    function IAuthUser() {
    }
    return IAuthUser;
}());
exports.IAuthUser = IAuthUser;
var IAuthClaims = /** @class */ (function () {
    function IAuthClaims() {
    }
    return IAuthClaims;
}());
exports.IAuthClaims = IAuthClaims;
var AuthUserService = /** @class */ (function (_super) {
    __extends(AuthUserService, _super);
    AuthUserService.$inject = ["AuthSettingsApi", "AppService", "AuthService", "localStorageService", "$q"];
    function AuthUserService(AuthSettingsApi, AppService, AuthService, localStorageService, $q) {
        'ngInject';
        var _this = _super.call(this, AuthSettingsApi, AppService, 'user') || this;
        _this.AppService = AppService;
        _this.AuthService = AuthService;
        _this.localStorageService = localStorageService;
        _this.$q = $q;
        _this.all = function () {
            return _this.Restangular.all(_this.itemName).getList().then(function (response) {
                _this.list = response.plain();
                return _this.listLoaded(_this.list);
            });
        };
        _this.resetPassword = function (user) {
            return _this.collection.one(user.id).all('resetpassword').post(user).then(function (response) {
                return response;
            });
        };
        _this.getRoles = function (user) {
            return _this.collection.one(user.id).all('roles').getList().then(function (response) {
                return response.plain();
            });
        };
        _this.getClaims = function (user) {
            return _this.collection.one(user.id).all('claims').getList().then(function (response) {
                return response.plain();
            });
        };
        _this.getCurrentUser = function () {
            var tokendata = _this.AuthService.getDataFromToken(_this.AuthService.GetAuthorizationData());
            var userId = tokendata.sub;
            if (_this.localStorageService.get("user") && _this.localStorageService.get("user").id == userId) {
                var deferred = _this.$q.defer();
                var user = _this.localStorageService.get("user");
                deferred.resolve(user);
                return deferred.promise;
            }
            else {
                return _this.get(userId).then(function (user) {
                    return _this.getClaims(user).then(function (claims) {
                        return _this.getRoles(user).then(function (roles) {
                            user.roles = roles;
                            _this.localStorageService.set("user", user);
                            return user;
                        });
                    });
                });
            }
        };
        return _this;
    }
    AuthUserService.prototype.post = function (data) {
        var _this = this;
        return this.collection.post(data).then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            _this.item = item.plain();
            return item.plain();
        })
            .catch(function (error) {
            if (error.status == 406) {
                if (error.data[0].code == "DuplicateUserName") {
                    throw "DuplicateUserName";
                }
            }
            _this.AppService.NotifyService.error('Foutmelding', "Account kon niet worden opgeslagen!");
            return error;
        });
    };
    return AuthUserService;
}(base_service_1.BaseService));
exports.AuthUserService = AuthUserService;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.hrState = {
    parent: "app",
    name: "hr",
    url: "/hr",
    redirectTo: "hr.employees",
    component: "hrComponent",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.hrDashboardState = {
    name: "hr.dashboard",
    url: "/dashboard",
    views: {
        "main": 'hrDashboardComponent'
    }
};
exports.employeesState = {
    name: "hr.employees",
    url: "/employees",
    redirectTo: "hr.employees.list",
    views: {
        "main": "employeesComponent"
    }
};
exports.employeesListState = {
    name: "hr.employees.list",
    url: "/list",
    resolve: {},
    views: {
        "main": 'employeesListComponent'
    }
};
exports.employeesItemState = {
    name: "hr.employees.item",
    url: "/:id",
    params: {
        "tab": null
    },
    resolve: {
        tasks: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return EmployeesService.getChild($stateParams['id'], 'tasks');
            }
        }],
        notes: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return EmployeesService.getChild($stateParams['id'], 'notes', { sortfield: 'date', sortorder: 'DESC' });
            }
        }],
        employee: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return EmployeesService.get($stateParams['id']);
            }
        }],
        history: ["DeclarationService", "$stateParams", function (DeclarationService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return DeclarationService.customAll('employee/' + $stateParams['id'] + '/summary');
            }
        }],
        employeeSkills: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return EmployeesService.getChild($stateParams['id'], 'skills');
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
    },
    views: {
        "main": 'employeesItemComponent'
    }
};
exports.employeesItemBasicState = {
    name: "hr.employees.item.basic",
    url: "/basic",
    params: {
        "tab": null
    },
    modal: ['employee'],
    size: "lg",
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        transportationTypes: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('TransportationType');
        }],
        salaryScales: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('WageCodes');
        }]
    },
    component: 'employeesItemBasicComponent'
};
exports.shiftsItemState = {
    name: "hr.employees.item.shift",
    url: "/shift/:shiftId",
    params: {
        "shiftId": null
    },
    modal: ['employee', 'shifts'],
    resolve: {},
    component: 'shiftsItemComponent'
};
exports.availabilityItemState = {
    name: "hr.employees.item.availability",
    url: "/availability/:employeeId/:availabilityId",
    params: {
        "availabilityId": null
    },
    modal: [],
    resolve: {
        statuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('AvalabilityStatus');
        }]
    },
    component: 'availabilityItemComponent'
};
exports.skillsItemState = {
    name: "hr.employees.item.skill",
    url: "/skill/:employeeSkillId",
    params: {
        "employeeSkillId": null
    },
    modal: ['employee', 'employeeSkills'],
    resolve: {
        skills: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Skills');
        }]
    },
    component: 'skillsItemComponent'
};
exports.availabilityListState = {
    name: "hr.availability",
    url: "/availability",
    resolve: {
        avalabilityStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('AvalabilityStatus');
        }],
    },
    views: {
        "main": 'availabilityListComponent'
    }
};
exports.applicantsState = {
    name: "hr.applicants",
    url: "/applicants",
    redirectTo: "hr.applicants.list",
    views: {
        "main": "applicantsComponent"
    }
};
exports.applicantsListState = {
    name: "hr.applicants.list",
    url: "/list?status&recruiter&function&targetaudiance",
    params: {
        "status": null,
        "recruiter": null,
        "function": null,
        "targetaudiance": null,
    },
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
        users: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.gatBackoffice();
        }],
    },
    views: {
        "main": 'applicantsListComponent'
    }
};
exports.applicantsArchiveState = {
    name: "hr.applicants.archive",
    url: "/archive?status&recruiter&function&targetaudiance",
    params: {
        "status": null,
        "recruiter": null,
        "function": null,
        "targetaudiance": null,
        "archive": true
    },
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
        users: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.gatBackoffice();
        }]
    },
    views: {
        "main": 'applicantsListComponent'
    }
};
exports.applicantsItemState = {
    name: "hr.applicants.item",
    url: "/:id",
    params: {
        "tab": null
    },
    resolve: {
        applicant: ["ApplicantsService", "$stateParams", function (ApplicantsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantsService.get($stateParams['id']);
            }
        }],
        notes: ["ApplicantsService", "$stateParams", function (ApplicantsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantsService.getChild($stateParams['id'], 'notes', { sortfield: 'date', sortorder: 'DESC' });
            }
        }],
        applicationStatusHistories: ["ApplicantStatusHistoryService", "$stateParams", function (ApplicantStatusHistoryService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantStatusHistoryService.getPerApplicant($stateParams['id']);
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
        users: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.gatBackoffice();
        }],
    },
    views: {
        "main": 'applicantsItemComponent'
    }
};
exports.applicantsArchiveItemState = {
    name: "hr.applicants.archiveitem",
    url: "/archive/:id",
    params: {
        "tab": null,
        "archive": true
    },
    resolve: {
        applicant: ["ApplicantsService", "$stateParams", function (ApplicantsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantsService.get($stateParams['id']);
            }
        }],
        notes: ["ApplicantsService", "$stateParams", function (ApplicantsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantsService.getChild($stateParams['id'], 'notes', { sortfield: 'date', sortorder: 'DESC' });
            }
        }],
        applicationStatusHistories: ["ApplicantStatusHistoryService", "$stateParams", function (ApplicantStatusHistoryService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ApplicantStatusHistoryService.getPerApplicant($stateParams['id']);
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
        users: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.gatBackoffice();
        }],
    },
    views: {
        "main": 'applicantsItemComponent'
    }
};
exports.applicantsItemBasicState = {
    name: "hr.applicants.item.basic",
    url: "/basic",
    params: {
        "tab": null
    },
    modal: ['applicant', 'users'],
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
    },
    component: 'applicantsItemBasicComponent'
};
exports.applicantsArchiveItemBasicState = {
    name: "hr.applicants.archiveitem.basic",
    url: "/basic",
    params: {
        "tab": null,
        "archive": true
    },
    modal: ['applicant', 'users'],
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        preferredTargetAudiences: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('PreferredTargetAudience');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }],
    },
    component: 'applicantsItemBasicComponent'
};
exports.applicantsItemEmployeeState = {
    name: "hr.applicants.item.employee",
    url: "/employee",
    params: {
        "tab": null
    },
    modal: ['applicant'],
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Functions');
        }],
        applicationStatuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('ApplicationStatus');
        }]
    },
    component: 'applicantsItemEmployeeComponent'
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftState = {
    parent: 'app',
    name: "shifts",
    url: "/shifts",
    component: 'shiftComponent',
    redirectTo: 'shifts.list',
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.shiftCalendarState = {
    name: "shifts.calendar",
    url: "/calendar",
    views: {
        "main": 'shiftCalendarComponent'
    }
};
exports.shiftItemState = {
    name: "shifts.calendar.item",
    url: "/item/:id",
    modal: true,
    size: "lg",
    component: 'shiftItemComponent',
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        employees: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }]
    }
};
exports.shiftListState = {
    name: "shifts.list",
    url: "/list?:start&:end&:refreshShift",
    params: {
        "start": { dynamic: true },
        "end": { dynamic: true },
        "refreshShift": { dynamic: true }
    },
    views: {
        "main": 'shiftListComponent'
    },
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }],
        employees: ["EmployeesService", "PermPermissionStore", function (EmployeesService, PermPermissionStore) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
    },
    data: {
        contentClasses: 'no-padding'
    }
};
exports.shiftListItemState = {
    name: "shifts.list.item",
    url: "/item/:id",
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
    },
    views: {
        "shiflistitem@shifts.list": 'shiftListItemComponent'
    },
};
exports.shiftListSubscriptionsModalState = {
    name: "shifts.list.subscriptionsmodal",
    url: "/subscriptions/:id",
    modal: true,
    size: "lg",
    component: 'subscriptionsModalComponent',
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }]
    }
};
exports.shiftListEmployeeState = {
    name: "shifts.list.item.employee",
    url: "/employee",
    params: {
        filter: null
    },
    resolve: {},
    views: {
        "shiflistitem@shifts.list": 'shiftListEmployeeComponent'
    },
};
exports.checkAvailabilityState = {
    name: "shifts.list.checkAvailability",
    url: "/checkAvailability",
    modal: true,
    component: 'checkAvailabilityModalComponent',
    size: "huge",
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }]
    }
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IAgreement = /** @class */ (function (_super) {
    __extends(IAgreement, _super);
    function IAgreement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IAgreement;
}(base_entity_1.BaseEntity));
exports.IAgreement = IAgreement;
var AgreementService = /** @class */ (function (_super) {
    __extends(AgreementService, _super);
    AgreementService.$inject = ["Restangular", "AppService"];
    function AgreementService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/AccountAgreements') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return AgreementService;
}(base_service_1.BaseService));
exports.AgreementService = AgreementService;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var ICootjeEmployee = /** @class */ (function (_super) {
    __extends(ICootjeEmployee, _super);
    function ICootjeEmployee() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ICootjeEmployee;
}(base_entity_1.BaseEntity));
exports.ICootjeEmployee = ICootjeEmployee;
var ICootjeDienst = /** @class */ (function (_super) {
    __extends(ICootjeDienst, _super);
    function ICootjeDienst() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ICootjeDienst;
}(base_entity_1.BaseEntity));
exports.ICootjeDienst = ICootjeDienst;
var CootjeService = /** @class */ (function (_super) {
    __extends(CootjeService, _super);
    CootjeService.$inject = ["Restangular", "AppService"];
    function CootjeService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'finance/cootje') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    CootjeService.prototype.sendToCootje = function (diensten) {
        return this.Restangular.all(this.itemName).one('sendToCootje').customPOST(diensten).then(function (item) {
            return item;
        });
    };
    return CootjeService;
}(base_service_1.BaseService));
exports.CootjeService = CootjeService;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var base_entity_1 = __webpack_require__(8);
var angular = __webpack_require__(5);
var IEmployeeSkill = /** @class */ (function (_super) {
    __extends(IEmployeeSkill, _super);
    function IEmployeeSkill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IEmployeeSkill;
}(base_entity_1.BaseEntity));
exports.IEmployeeSkill = IEmployeeSkill;
var IBlob = /** @class */ (function () {
    function IBlob() {
    }
    return IBlob;
}());
exports.IBlob = IBlob;
var EmployeeSkillsService = /** @class */ (function (_super) {
    __extends(EmployeeSkillsService, _super);
    EmployeeSkillsService.$inject = ["Restangular", "AppService"];
    function EmployeeSkillsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/employeeSkill') || this;
        _this.AppService = AppService;
        return _this;
    }
    EmployeeSkillsService.prototype.postBlob = function (id, file) {
        var _this = this;
        // Create FormData to send in the request
        var formData = new FormData();
        formData.append('file', file, file.name);
        return this.Restangular.one('hr/employeeSkill', id)
            .withHttpConfig({ transformRequest: angular.identity })
            .customPOST(formData, 'blobs', undefined, { 'Content-Type': undefined })
            .then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            _this.item = item.plain();
            return item.plain();
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    };
    EmployeeSkillsService.prototype.getBlobs = function (id) {
        return this.Restangular.one('hr/employeeSkill', id).all('blobs').customGET('').then(function (collection) {
            return collection.plain();
        });
    };
    EmployeeSkillsService.prototype.getBlob = function (id, blobid) {
        this.Restangular.setFullResponse(true);
        return this.Restangular.one('hr/employeeSkill', id).one('blobs', blobid).customGET('').then(function (response) {
            return new Blob([response.data], { type: response.headers('Content-Type') });
        });
    };
    return EmployeeSkillsService;
}(base_service_1.BaseService));
exports.EmployeeSkillsService = EmployeeSkillsService;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var ILocation = /** @class */ (function (_super) {
    __extends(ILocation, _super);
    function ILocation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ILocation;
}(base_entity_1.BaseEntity));
exports.ILocation = ILocation;
var LocationService = /** @class */ (function (_super) {
    __extends(LocationService, _super);
    LocationService.$inject = ["Restangular", "AppService"];
    function LocationService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/locations') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return LocationService;
}(base_service_1.BaseService));
exports.LocationService = LocationService;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var INewsItem = /** @class */ (function () {
    function INewsItem() {
    }
    return INewsItem;
}());
exports.INewsItem = INewsItem;
var NewsService = /** @class */ (function (_super) {
    __extends(NewsService, _super);
    NewsService.$inject = ["Restangular", "AppService"];
    function NewsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'newsItem') || this;
        _this.AppService = AppService;
        _this.getUnread = function () {
            return _this.Restangular.all(_this.itemName).customGET('unread', {}).then(function (response) {
                return _this.getListLoaded(response.plain());
            });
        };
        return _this;
    }
    return NewsService;
}(base_service_1.BaseService));
exports.NewsService = NewsService;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var NmbrsService = /** @class */ (function (_super) {
    __extends(NmbrsService, _super);
    NmbrsService.$inject = ["Restangular", "AppService"];
    function NmbrsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'nmbrs') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return NmbrsService;
}(base_service_1.BaseService));
exports.NmbrsService = NmbrsService;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IPerson = /** @class */ (function (_super) {
    __extends(IPerson, _super);
    function IPerson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IPerson;
}(base_entity_1.BaseEntity));
exports.IPerson = IPerson;
var PersonService = /** @class */ (function (_super) {
    __extends(PersonService, _super);
    PersonService.$inject = ["Restangular", "AppService"];
    function PersonService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'person') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return PersonService;
}(base_service_1.BaseService));
exports.PersonService = PersonService;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var ITeam = /** @class */ (function (_super) {
    __extends(ITeam, _super);
    function ITeam() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ITeam;
}(base_entity_1.BaseEntity));
exports.ITeam = ITeam;
var TeamService = /** @class */ (function (_super) {
    __extends(TeamService, _super);
    TeamService.$inject = ["Restangular", "AppService"];
    function TeamService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'team') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return TeamService;
}(base_service_1.BaseService));
exports.TeamService = TeamService;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var ITimezone = /** @class */ (function () {
    function ITimezone() {
    }
    return ITimezone;
}());
exports.ITimezone = ITimezone;
var TimezonesService = /** @class */ (function (_super) {
    __extends(TimezonesService, _super);
    TimezonesService.$inject = ["Restangular", "AppService"];
    function TimezonesService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'timezone') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return TimezonesService;
}(base_service_1.BaseService));
exports.TimezonesService = TimezonesService;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var TwinfieldService = /** @class */ (function (_super) {
    __extends(TwinfieldService, _super);
    /** Constructor */
    TwinfieldService.$inject = ["Restangular", "AppService", "localStorageService"];
    function TwinfieldService(Restangular, AppService, localStorageService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'twinfield') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.localStorageService = localStorageService;
        /**
         * Check if Twinfield API token in APIis still valid.
         *
         * @return  {void}
         */
        _this.verifyToken = function () {
            return _this.Restangular.one('twinfield').withHttpConfig({ cache: false }).customGET('');
        };
        /**
         * Set Twinfield API token with oAuth2 code
         *
         * @return  {void}
         */
        _this.setToken = function (code) {
            return _this.Restangular.one('twinfield').withHttpConfig({ cache: false }).customGET(code, {
                redirectUrl: window.location.protocol + '//' + window.location.host + '/app/twinfield'
            });
        };
        /**
         * Set redirect URL for
         *
         * @return  {void}
         */
        _this.setTwinfieldRedirectUri = function () {
            /** Log */
            console.log('twinfieldRedirect: ' + window.location.pathname + window.location.search);
            /** Set URI */
            _this.localStorageService.set('twinfieldRedirect', window.location.pathname + window.location.search);
        };
        return _this;
    }
    return TwinfieldService;
}(base_service_1.BaseService));
exports.TwinfieldService = TwinfieldService;


/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports) {

angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('nl_NL', {"A password has to have at least 8 characters with minimal one uppercase, number and non alphanumeric character":"Een wachtwoord moet minimaal een hoofdletter, een nummer en een niet-alfanumeriek karakter bevatten","Account":"Account","Account notes":"Notities","Account/Employee/Applicant":"Bedrijf/Medewerker/Sollicitant","Account:":"Account:","Accounts":"Accounts","Actions":"Acties","Add Account":"Account toevoegen","Add Applicant":"Sollicitant toevoegen","First Status":"Eerste Status","Last Status":"Laatste Status","Add Contact":"Contact toevoegen","Add Contact Person":"Contactpersoon toevoegen","Add Employee":"Medewerker toevoegen","Add Lead":"Lead toevoegen","Add News Item":"Nieuws item toevoegen","Add Shift":"Dienst toevoegen","Add Task":"Taak toevoegen","Add User":"Gebruiker toevoegen","Add agreement":"Overeenkomst toevoegen","Add availability":"Beschikbaarheid toevoegen","Add employee":"Medewerker toevoegen","Add location":"Locatie toevoegen","Add note":"Notitie toevoegen","Add reminder interval":"Herinnerings interval toevoegen","Add salary scale":"Salarisschaal toevoegen","Add skill":"Vaardigheid toevoegen","Add timezone":"Tijdslot toevoegen","Address":"Adres","Address:":"Adres:","Age":"Leeftijd","Age:":"Leeftijd:","Agreement":"Overeenkomst","Agreements":"Overeenkomsten","Ammount":"Hoeveelheid","Amount":"Per uur","Amount of hours":"Aantal uur","Amount:":"Per uur:","Applicant basic information":"Sollicitant informatie","Applicants":"Sollicitanten","Apply":"Uitvoeren","Approved":"Goedgekeurd","Archive":"Archief","Assign":"Medewerker toewijzen","Auth Settings":"Authorisatie Instellingen","Availability":"Beschikbaarheid","Available":"Beschikbaar","BIC:":"BIC:","BSN":"BSN","BSN:":"BSN:","Back":"Terug","Bank Account Number":"Bankrekeningnummer","Bank account":"Bankrekeningnummer","Basic info":"Basis info","Birthday":"Verjaardag","Birthday:":"Verjaardag:","Calculation index":"Omrekenfactor","Calendar":"Kalender","Cancel":"Annuleren","Chamber Of Commerce Number":"KvK nummer","Chamber of Commerce Number":"KvK nummer","Check availability":"Beschikbaarheid controleren","Logout":"Uitloggen","City":"Stad","City:":"Stad:","Claims":"Claims","Close":"Sluiten","Code":"Code","Code:":"RVA Code:","Comment":"Opmerking","Comment customer":"Opmerking klant","Comment employee":"Opmerking medewerker","Comment internal":"Opmerking intern","Comment:":"Opmerking:","Company":"Bedrijf","Company Name":"Bedrijfsnaam","Company basic information":"Bedrijfsinformatie","Company contact information":"Contact","Company financial information":"Financieel","Confirm password":"Wachtwoord bevestigen","Conflicting shift:":"Overlappende dienst:","Contact":"Contact","Contact Persons":"Contactpersonen","Contact basic information":"Contact","Contact:":"Contact:","Contacts":"Contacten","Contract":"Contract","Contract ID:":"Contact:","Count":"Hoeveelheid","Country":"Land","Country of birth:":"Geboorteland:","Country:":"Land:","Create account":"Account maken","Create employee":"Medewerker aanmaken","Create task":"Taak maken","Created by me":"Aangemaakt door mij","Creation date:":"Vervaldatum:","Customer reference":"Klant referentie","Date":"Datum","Date:":"Datum:","Declarations":"Declaraties","Declarations count":"Aantal declaraties","Declared hours sum":"Totaal gedeclareerde uren","Declared:":"Gedeclareerd:","Delete":"Verwijderen","Delete account":"Account verwijderen","Delete applicant":"Sollicitant verwijderen","Delete contact":"Contact verwijderen","Delete employee":"Medewerker verwijderen","Delete task":"Taak verwijderen","Delete timezone":"Medewerker verwijderen","Delete user":"Verwijder gebruiker","Delivery day":"Bezorgdag","Description":"Beschrijving","Description:":"Beschrijving:","Display name:":"Naam:","Distance":"Afstand","Distance:":"Afstand:","Document of proof":"Bewijs document","Edit":"Bewerken","Edit task":"Taak bewerken","Email":"Email","Email Address":"Emailadres","Email employee":"Email Medewerkers","Email team":"Email team","Email:":"Email:","Employee":"Medewerkers","Employee basic information":"Medewerker","Employee selector":"Medewerker selecteren","Employee:":"Medewerker:","Employees":"Medewerkers","End":"Einde","End Date":"Einddatum","End date":"Einddatum","Expenses declaration":"Onkosten declaratie","Fax":"Fax","Fax:":"Fax:","Files":"Bestanden","Status history":"Status geschiedenis","Filter by function":"Filteren op functie","Filter by max distance":"Filter op max. afstand","Filter by status":"Filter op status","Filter created by":"Aangemaakt door allen","Filters":"Filters","Financial":"Financieel","First name":"Voornaam","First name:":"Voornaam:","From":"Van","From:":"Van:","Full Name":"Volledige naam","Function":"Functie","Function:":"Functie:","Gender:":"Gesalcht:","Get emails":"Emailadressen kopiëren","Global filters":"Algemene filters","Gross hourly wage":"Uurloon","Herhaal wachtwoord":"Herhaal wachtwoord","Hour code":"Uurcode","HourCodeName:":"Naam:","Hourly wage":"Uurloon","Hours sum":"Totaal uren","I know Operando from":"Kent Operando van","I know Operando from:":"Kent Operando van:","IBAN":"IBAN","IBAN:":"IBAN:","ID":"ID","In progress":"Bezig","Inactive":"Niet actief","Invoices":"Facturen","Job offer":"Vacature","Job offer:":"Vacature:","Kilometers":"Kilometers","Last name":"Achternaam","Last name:":"Achternaam:","Last shifts:":"Laatste diensten:","Leads":"Leads","Leads information":"Leads","LinkedIn":"LinkedIn","List":"Lijst","Location":"Locatie","Location:":"Locatie:","Locations":"Locaties","Login URL":"Login URL","Logout URL":"Logout URL","Marital status:":"Huwelijkse staat:","Middle name":"Tussenvoegsel","Mileage":"Kilometers","More":"Meer","Name":"Naam","Name and Address":"Naam en adres","Name:":"Naam:","New shift":"Shift toevoegen","News":"Nieuws","News item":"Nieuws item","Next":"Volgende","Nickname:":"Naam:","Nmbrs":"Nmbrs","NmbrsId:":"NmbrsId:","No items found":"Geen items gevonden","Note":"Notitie","Notes":"Notities","Notes:":"Notities:","Notify employee":"Email medewerker","Notify team":"Email team","Number":"Nummer","Number declared":"Aantal gedeclareerd","Number of approved hours":"Totaal geaccordeerde uren","Number of approved shifts":"Aantal geaccordeerde diensten","Number of declared hours":"Totaal gedeclareerde uren","Number of declared shifts":"Aantal gedeclareerde diensten","Number of scheduled hours":"Totaal geplande uren","Number of scheduled shifts":"Aantal geplande diensten","Number of services":"Aantal diensten","Opdrachtgever":"Opdrachtgever","Open":"Open","Overview":"Overzicht","Password":"Wachtwoord","Percentage":"Percentage","Percentage:":"Percentage:","Personal info":"Persoonlijke informatie","Phone":"Telefoon","Phone Number":"Telefoonnummer","Phone:":"Telefoon:","Planned:":"Ingepland:","Post Address":"Postadres","Post City":"Stad","Post Country":"Land","Post Number":"Nummer","Post Street":"Straat","Post Zip":"Postcode","Postal code:":"Postcode:","Preferred target audience":"Doelgroep","Preferred target audience:":"Doelgroep","Prev":"Vorige","Previously at location":"Eerder op locatie geweest","Previously at location:":"Eerder op locatie geweest:","Priority":"Prioriteit","Priority:":"Prioriteit:","Pro forma invoices":"Pro forma facturen","RVA Code":"RVA Code","Recruiter":"Recruiter","Recruiter:":"Recruiter","Refresh all employees from NMBRS":"Herlaad alle medewerker uit NMBRS","Refresh employee from NMBRS":"Herlaad medewerker uit NMBRS","Rejected":"Geweigerd","Reminder interval":"Herinnering interval","Reset Password":"Wachtwoord aanpassen","Reset all":"Reset alle filters","Reset filter":"Reset alle filters","Restore employee":"Medewerker terugzetten","Roles":"Rollen","SCA Code":"SCA Code","Salary scale":"Salarisschaal","Salary scale:":"Salarisschaal:","Save":"Opslaan","Save and copy":"Opslaan en kopiëren","Save and new":"Opslaan en nieuwe","Saved":"Opgeslagen","Schedule":"Agenda","Search":"Zoeken","Select status":"Status selecteren","Send to Nmbrs":"Verstuur naar Nmbrs","Send to Twinfield":"Naar Twinfield versturen","Server Settings":"Server instellingen","Set employee":"Medewerker selecteren","Set status":"Status selecteren","Settings":"Instellingen","Shift":"Dienst","Shift data":"Dienst gegevens","Shift subscriptions":"Inschrijving","Shifts":"Diensten","Shifts count":"Aantal diensten","Sign up":"Aanmelden","Skill":"Vaardigheid","Skills":"Vaardigheden","Social information":"Social informatie","Start":"Start","Start date:":"Start:","Startdatum":"Startdatum","Starttijd":"Starttijd","Status":"Status","Status:":"Status:","Street":"Straat","Subscribe":"Inschrijven","Subscribed":"Ingeschreven","Subscription":"Inschrijving","Sync with Nmbrs":"Synchroniseer met Nmbrs","Tags":"Kenmerken","Tags:":"Kenmerken:","Target audience":"Doelgroep","Tasks":"Taken","Team":"Team","Team:":"Team:","The text is too long. It should be max 1024 characters":"Tekst is te lang. Maximaal 1024 tekens","This field is required":"Dit veld is verplicht","Till":"Tot","Till:":"Tot:","Time":"Tijd","Time declaration":"Uren declaratie","Timesheets":"Urenregistratie","Timezone basic information":"Tijdslot informatie","Timezones":"Tijdslots","Title":"Titel","Total":"Totaal","Total amount":"Totaal bedrag","Transportation type":"Vervoersmiddel","Transportation type:":"Vervoersmiddel:","Twinfield ID":"Twinfield ID","Twinfield Id":"Twinfield Id","Twinfield amount":"Twinfield amount","Type":"Type","Type:":"Type:","Unassign":"Medewerker verwijderen","Unknown":"Onbekend","Unsubscribe":"Uitschrijven","Upload file":"Upload bestand","User":"Gebruiker","User-Account":"Gebruikersaccount","User:":"Gebruiker:","Username":"Gebruikersnaam","Username:":"Gebruikersnaam:","Users":"Gebruikers","VAT Code":"BTW code","VAT Number":"BTW nummer","Website":"Website","Website:":"Website:","Wijzigen":"Wijzigen","Work history":"Werkhistorie","Your passwords did not match":"Uw wachtwoorden komen niet overeen","Zip":"Postcode","choose a status":"filter op status","choose a tag":"filter op kenmerk","hours":"uren","km":"km","locations":"locaties","search":"zoeken","teams":"teams","times":"aantal keer","to":"tot","until":"tot"});
/* jshint +W100 */
}]);

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(534);
var auth_states_1 = __webpack_require__(528);
var ngmodule_1 = __webpack_require__(4);
var login_1 = __webpack_require__(530);
var logout_1 = __webpack_require__(531);
var authorized_1 = __webpack_require__(529);
var unauthorized_1 = __webpack_require__(535);
var auth_hook_1 = __webpack_require__(532);
var authorizationAppModule = {
    components: { login: login_1.login, logout: logout_1.logout, authorized: authorized_1.authorized, unauthorized: unauthorized_1.unauthorized },
    states: [auth_states_1.loginState, auth_states_1.logoutState, auth_states_1.authorizedState, auth_states_1.unauthorizedState],
    services: { AuthService: services_1.AuthService },
    runBlocks: [auth_hook_1.authHookRunBlock]
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, authorizationAppModule);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authsettings_usersItem_component_1 = __webpack_require__(541);
var authsettings_server_component_1 = __webpack_require__(539);
var authusers_service_1 = __webpack_require__(259);
var authsettings_factory_1 = __webpack_require__(543);
var authsettings_run_1 = __webpack_require__(536);
var authsettings_users_component_1 = __webpack_require__(540);
var authsettings_component_1 = __webpack_require__(538);
var resetPassword_component_1 = __webpack_require__(542);
var authsettings_states_1 = __webpack_require__(537);
var authsettings_service_1 = __webpack_require__(544);
var ngmodule_1 = __webpack_require__(4);
var authSettingsAppModule = {
    components: { authSettingsComponent: authsettings_component_1.authSettingsComponent, authSettingsUsersComponent: authsettings_users_component_1.authSettingsUsersComponent, authSettingsServerComponent: authsettings_server_component_1.authSettingsServerComponent, authSettingsUsersItemComponent: authsettings_usersItem_component_1.authSettingsUsersItemComponent, resetPasswordComponent: resetPassword_component_1.resetPasswordComponent },
    states: [authsettings_states_1.authSettingsState, authsettings_states_1.authSettingsUsersState, authsettings_states_1.authSettingsServerState, authsettings_states_1.authSettingsUsersItemState],
    services: { AuthSettingsService: authsettings_service_1.AuthSettingsService, AuthUserService: authusers_service_1.AuthUserService },
    runBlocks: [authsettings_run_1.authServiceRun],
    factories: { AuthSettingsApi: authsettings_factory_1.AuthSettingsApi }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, authSettingsAppModule);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var globalAppModule = {
    directives: {},
    services: {},
    runBlocks: []
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, globalAppModule);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dateTimePicker_component_1 = __webpack_require__(673);
var fixedHeight_1 = __webpack_require__(550);
var browser_page_component_1 = __webpack_require__(559);
var compareTo_1 = __webpack_require__(548);
var passwordValidation_1 = __webpack_require__(551);
var bytes_filter_1 = __webpack_require__(552);
var location_service_1 = __webpack_require__(265);
var app_service_1 = __webpack_require__(557);
var ngmodule_1 = __webpack_require__(4);
var app_component_1 = __webpack_require__(554);
var app_states_1 = __webpack_require__(558);
var app_config_1 = __webpack_require__(555);
var app_run_1 = __webpack_require__(556);
var services_1 = __webpack_require__(7);
var navbar_component_1 = __webpack_require__(561);
var chatPanel_component_1 = __webpack_require__(560);
var newsPanel_component_1 = __webpack_require__(562);
var file_1 = __webpack_require__(549);
var twinfield_component_1 = __webpack_require__(547);
/**
 * Setting main app module
 */
var mainAppModule = {
    components: { app: app_component_1.app, operandoNavbar: navbar_component_1.operandoNavbar, chatPanelComponent: chatPanel_component_1.chatPanelComponent, browserPageComponent: browser_page_component_1.browserPageComponent, dateTimePickerComponent: dateTimePicker_component_1.dateTimePickerComponent, newsPanelComponent: newsPanel_component_1.newsPanelComponent, twinfieldComponent: twinfield_component_1.twinfieldComponent },
    states: [app_states_1.appState, app_states_1.browserState],
    configBlocks: [app_config_1.config, app_config_1.otherwiseConfigBlock, app_config_1.html5ConfigBlock, app_config_1.themeConfigBlock],
    runBlocks: [app_run_1.run],
    services: { AppService: app_service_1.AppService, LocationService: location_service_1.LocationService, SettingsService: services_1.SettingsService, EnumService: services_1.EnumService },
    filters: { bytes: bytes_filter_1.bytes },
    directives: { passwordValidation: passwordValidation_1.passwordValidation, compareTo: compareTo_1.compareTo, fixedHeight: fixedHeight_1.fixedHeight, file: file_1.file }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, mainAppModule);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(602);
__webpack_require__(582);
__webpack_require__(625);
__webpack_require__(656);
__webpack_require__(705);
__webpack_require__(635);
__webpack_require__(680);
__webpack_require__(641);
__webpack_require__(692);
__webpack_require__(688);
__webpack_require__(592);
__webpack_require__(610);
__webpack_require__(697);
__webpack_require__(631);
__webpack_require__(712);


/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    'use strict';
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

/***/ }),
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 27,
	"./af.js": 27,
	"./ar": 34,
	"./ar-dz": 28,
	"./ar-dz.js": 28,
	"./ar-kw": 29,
	"./ar-kw.js": 29,
	"./ar-ly": 30,
	"./ar-ly.js": 30,
	"./ar-ma": 31,
	"./ar-ma.js": 31,
	"./ar-sa": 32,
	"./ar-sa.js": 32,
	"./ar-tn": 33,
	"./ar-tn.js": 33,
	"./ar.js": 34,
	"./az": 35,
	"./az.js": 35,
	"./be": 36,
	"./be.js": 36,
	"./bg": 37,
	"./bg.js": 37,
	"./bn": 38,
	"./bn.js": 38,
	"./bo": 39,
	"./bo.js": 39,
	"./br": 40,
	"./br.js": 40,
	"./bs": 41,
	"./bs.js": 41,
	"./ca": 42,
	"./ca.js": 42,
	"./cs": 43,
	"./cs.js": 43,
	"./cv": 44,
	"./cv.js": 44,
	"./cy": 45,
	"./cy.js": 45,
	"./da": 46,
	"./da.js": 46,
	"./de": 49,
	"./de-at": 47,
	"./de-at.js": 47,
	"./de-ch": 48,
	"./de-ch.js": 48,
	"./de.js": 49,
	"./dv": 50,
	"./dv.js": 50,
	"./el": 51,
	"./el.js": 51,
	"./en-au": 52,
	"./en-au.js": 52,
	"./en-ca": 53,
	"./en-ca.js": 53,
	"./en-gb": 54,
	"./en-gb.js": 54,
	"./en-ie": 55,
	"./en-ie.js": 55,
	"./en-nz": 56,
	"./en-nz.js": 56,
	"./eo": 57,
	"./eo.js": 57,
	"./es": 59,
	"./es-do": 58,
	"./es-do.js": 58,
	"./es.js": 59,
	"./et": 60,
	"./et.js": 60,
	"./eu": 61,
	"./eu.js": 61,
	"./fa": 62,
	"./fa.js": 62,
	"./fi": 63,
	"./fi.js": 63,
	"./fo": 64,
	"./fo.js": 64,
	"./fr": 67,
	"./fr-ca": 65,
	"./fr-ca.js": 65,
	"./fr-ch": 66,
	"./fr-ch.js": 66,
	"./fr.js": 67,
	"./fy": 68,
	"./fy.js": 68,
	"./gd": 69,
	"./gd.js": 69,
	"./gl": 70,
	"./gl.js": 70,
	"./gom-latn": 71,
	"./gom-latn.js": 71,
	"./he": 72,
	"./he.js": 72,
	"./hi": 73,
	"./hi.js": 73,
	"./hr": 74,
	"./hr.js": 74,
	"./hu": 75,
	"./hu.js": 75,
	"./hy-am": 76,
	"./hy-am.js": 76,
	"./id": 77,
	"./id.js": 77,
	"./is": 78,
	"./is.js": 78,
	"./it": 79,
	"./it.js": 79,
	"./ja": 80,
	"./ja.js": 80,
	"./jv": 81,
	"./jv.js": 81,
	"./ka": 82,
	"./ka.js": 82,
	"./kk": 83,
	"./kk.js": 83,
	"./km": 84,
	"./km.js": 84,
	"./kn": 85,
	"./kn.js": 85,
	"./ko": 86,
	"./ko.js": 86,
	"./ky": 87,
	"./ky.js": 87,
	"./lb": 88,
	"./lb.js": 88,
	"./lo": 89,
	"./lo.js": 89,
	"./lt": 90,
	"./lt.js": 90,
	"./lv": 91,
	"./lv.js": 91,
	"./me": 92,
	"./me.js": 92,
	"./mi": 93,
	"./mi.js": 93,
	"./mk": 94,
	"./mk.js": 94,
	"./ml": 95,
	"./ml.js": 95,
	"./mr": 96,
	"./mr.js": 96,
	"./ms": 98,
	"./ms-my": 97,
	"./ms-my.js": 97,
	"./ms.js": 98,
	"./my": 99,
	"./my.js": 99,
	"./nb": 100,
	"./nb.js": 100,
	"./ne": 101,
	"./ne.js": 101,
	"./nl": 103,
	"./nl-be": 102,
	"./nl-be.js": 102,
	"./nl.js": 103,
	"./nn": 104,
	"./nn.js": 104,
	"./pa-in": 105,
	"./pa-in.js": 105,
	"./pl": 106,
	"./pl.js": 106,
	"./pt": 108,
	"./pt-br": 107,
	"./pt-br.js": 107,
	"./pt.js": 108,
	"./ro": 109,
	"./ro.js": 109,
	"./ru": 110,
	"./ru.js": 110,
	"./sd": 111,
	"./sd.js": 111,
	"./se": 112,
	"./se.js": 112,
	"./si": 113,
	"./si.js": 113,
	"./sk": 114,
	"./sk.js": 114,
	"./sl": 115,
	"./sl.js": 115,
	"./sq": 116,
	"./sq.js": 116,
	"./sr": 118,
	"./sr-cyrl": 117,
	"./sr-cyrl.js": 117,
	"./sr.js": 118,
	"./ss": 119,
	"./ss.js": 119,
	"./sv": 120,
	"./sv.js": 120,
	"./sw": 121,
	"./sw.js": 121,
	"./ta": 122,
	"./ta.js": 122,
	"./te": 123,
	"./te.js": 123,
	"./tet": 124,
	"./tet.js": 124,
	"./th": 125,
	"./th.js": 125,
	"./tl-ph": 126,
	"./tl-ph.js": 126,
	"./tlh": 127,
	"./tlh.js": 127,
	"./tr": 128,
	"./tr.js": 128,
	"./tzl": 129,
	"./tzl.js": 129,
	"./tzm": 131,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 131,
	"./uk": 132,
	"./uk.js": 132,
	"./ur": 133,
	"./ur.js": 133,
	"./uz": 135,
	"./uz-latn": 134,
	"./uz-latn.js": 134,
	"./uz.js": 135,
	"./vi": 136,
	"./vi.js": 136,
	"./x-pseudo": 137,
	"./x-pseudo.js": 137,
	"./yo": 138,
	"./yo.js": 138,
	"./zh-cn": 139,
	"./zh-cn.js": 139,
	"./zh-hk": 140,
	"./zh-hk.js": 140,
	"./zh-tw": 141,
	"./zh-tw.js": 141
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/beschikbaarheid1.jpg";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/beschikbaarheid3.jpg";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst.jpg";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst1.jpg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst2.jpg";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst3.jpg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst4.jpg";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst5.jpg";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/dienst6.jpg";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/howtoinschrijven.jpg";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/inschrijven3.jpg";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren1.jpg";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren2.jpg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren3.jpg";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren4.jpg";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren5.jpg";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren6.jpg";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/urendeclareren7.jpg";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/logo-dark.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/logo-white.png";

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports) {

module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>Loading..</h1> Returning back to application </div> </div>";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = " ";

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>Logging out...</h1> </div> </div>";

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>UnAuthorized</h1> <p> <a class=\"btn btn-primary btn-lg\" ui-sref=home role=button>Back to home</a> </p> </div> </div>";

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=authsettings translate>Auth Settings</a> </li> </ol> </div> <div class=panel-body> <a class=\"btn btn-primary\" ui-sref=authsettings.users>Users</a> <a class=\"btn btn-primary\" ui-sref=authsettings.server>Identity Server</a> </div> </div> <div ui-view=main></div>";

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=authsettings translate>Auth Settings</a> </li> <li class=active> <a ui-sref=authsettings.server translate>Server Settings</a> </li> </ol> </div> <div class=panel-body> <form> <div class=form-group> <label translate>Login URL</label> <input class=form-control name=loginURL ng-model=$ctrl.server.loginURL> </div> <div class=form-group> <label translate>Logout URL</label> <input class=form-control name=logoutURL ng-model=$ctrl.server.logoutURL> </div> </form> </div> </div>";

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=authsettings translate>Auth Settings</a> </li> <li class=active> <a ui-sref=authsettings.users translate>Users</a> </li> </ol> </div> <div class=panel-body> <button type=button class=\"btn btn-primary\" ui-sref=\"authsettings.users.item({'id': 0})\" translate>Add User</button><hr/> <table datatable=ng id=customers-table class=\"table table-striped table-hover table-bordered\"> <thead> <tr> <th translate>ID</th> <th translate>Username</th> <th translate>Email</th> </tr></thead> <tbody> <tr ui-sref=\"authsettings.users.item({'id': item.id})\" ng-repeat=\"item in $ctrl.authUsers\"> <td>{{ item.id }}</td> <td>{{ item.userName }}</td> <td>{{ item.email }}</td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-md-8> <div class=panel ng-if=$ctrl.authUser.userName> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=authsettings translate>Auth Settings</a> </li> <li> <a ui-sref=authsettings.users translate>Users</a> </li> <li class=active> <a ui-sref=authsettings.users.item>{{$ctrl.authUser.userName}}</a> </li> </ol> </div> <div class=panel-body> <form role=form id=update-user-form name=updateUserForm ng-submit=\"updateUserForm.$valid && $ctrl.updateUser()\" novalidate> <div class=form-group ng-class=\"{ 'has-error': updateUserForm.userName.$touched && updateUserForm.userName.$invalid || updateUserForm.$submitted && updateUserForm.userName.$invalid}\"> <label translate>Username</label> <div class=row> <div class=col-md-12> <input type=text class=form-control name=userName ng-model=$ctrl.authUser.userName required> <div ng-messages=updateUserForm.userName.$error ng-show=\"updateUserForm.userName.$touched || updateUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': updateUserForm.email.$touched && updateUserForm.email.$invalid || updateUserForm.$submitted && updateUserForm.email.$invalid}\"> <label translate>Email</label> <div class=row> <div class=col-md-12> <input type=text class=form-control name=email ng-model=$ctrl.authUser.email required> <div ng-messages=updateUserForm.email.$error ng-show=\"updateUserForm.email.$touched || updateUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <button type=submit class=\"btn btn-primary\" form=update-user-form>Save user</button> </form> </div> </div> <div class=panel ng-if=$ctrl.authUser.userName> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Roles</a> </li> </ol> </div> <div class=panel-body> <form class=form-inline> <div class=form-group> <label>Name</label> <input type=text class=form-control ng-model=$ctrl.roleedit.name> </div> <button type=button ng-click=$ctrl.saveRole() class=\"btn btn-default\">Opslaan</button> </form> <hr/> <table class=\"table table-bordered bordered table-striped\"> <tr ng-repeat=\"(index,value) in $ctrl.authUser.roles\"> <td>{{index}}</td> <td>{{value}}</td> <td> <button type=button class=\"btn btn-xs btn-default\" ng-click=\"$ctrl.editRole(index, value)\">Edit</button> <button type=button class=\"btn btn-xs btn-default\" ng-click=\"$ctrl.deleteRole(index, value)\">Delete</button> </td> </tr> </table> </div> </div> <div class=panel ng-if=$ctrl.authUser.userName> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Claims</a> </li> </ol> </div> <div class=panel-body> <form class=form-inline> <div class=form-group> <label>Name</label> <input type=text class=form-control ng-model=$ctrl.fieldedit.name> </div> <div class=form-group> <label>Value</label> <input type=text class=form-control ng-model=$ctrl.fieldedit.value> </div> <button type=button ng-click=$ctrl.saveFields() class=\"btn btn-default\">Opslaan</button> </form> <hr/> <table class=\"table table-bordered bordered table-striped\"> <tr ng-repeat=\"(index,value) in  $ctrl.authUser.claims\"> <td>{{index}}</td> <td>{{value}}</td> <td> <button type=button class=\"btn btn-xs btn-default\" ng-click=\"$ctrl.editField(index, value)\">Edit</button> <button type=button class=\"btn btn-xs btn-default\" ng-click=\"$ctrl.deleteField(index, value)\">Delete</button> </td> </tr> </table> </div> </div> <div class=panel ng-if=!$ctrl.authUser.userName> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=authsettings translate>Auth Settings</a> </li> <li> <a ui-sref=authsettings.users translate>Users</a> </li> <li class=active> <a translate>Create account</a> </li> </ol> </div> <div class=panel-body> <form role=form id=create-user-form name=createUserForm ng-submit=\"createUserForm.$valid && $ctrl.createAccount()\" novalidate> <div class=form-group ng-class=\"{ 'has-error': createUserForm.displayName.$touched && createUserForm.displayName.$invalid || createUserForm.$submitted && createUserForm.displayName.$invalid}\"> <label translate>Name</label> <div class=row> <div class=col-md-12> <input type=text class=form-control name=displayName ng-model=$ctrl.authUser.displayName required> <div ng-messages=createUserForm.displayName.$error ng-show=\"createUserForm.displayName.$touched || createUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': createUserForm.email.$touched && createUserForm.email.$invalid || createUserForm.$submitted && createUserForm.email.$invalid}\"> <label translate>Email</label> <div class=row> <div class=col-md-12> <input type=text class=form-control name=email ng-model=$ctrl.authUser.email required> <div ng-messages=createUserForm.email.$error ng-show=\"createUserForm.email.$touched || createUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': createUserForm.password.$touched && createUserForm.password.$invalid || createUserForm.$submitted && createUserForm.password.$invalid}\"> <label translate>Password</label> <div class=row> <div class=col-md-12> <input type=password class=form-control name=password ng-model=$ctrl.authUser.password required> <div ng-messages=createUserForm.password.$error ng-show=\"createUserForm.password.$touched || createUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': createUserForm.confirmPassword.$touched && createUserForm.confirmPassword.$invalid || createUserForm.$submitted && createUserForm.confirmPassword.$invalid}\"> <label translate>Confirm password</label> <div class=row> <div class=col-md-12> <input type=password class=form-control name=confirmPassword match-password=password ng-model=$ctrl.authUser.confirmPassword required> <div ng-messages=createUserForm.confirmPassword.$error ng-show=\"createUserForm.confirmPassword.$touched || createUserForm.$submitted\"> <div ng-message=required translate>This field is required</div> <div ng-message=passwordMatch translate>Your passwords did not match</div> </div> </div> </div> </div> <div class=row> <div class=col-md-4> <button type=sumit class=\"btn btn-primary\">Create account</button> </div> </div> </form> </div> </div> </div> <div class=col-md-4> <div class=panel ng-if=$ctrl.authUser.userName> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Reset Password</a> </li> </ol> </div> <reset-password-component auth-user=$ctrl.authUser></reset-password-component> </div> </div> </div> ";

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "<div class=panel-body ng-if=$ctrl.authUser.userName> <form role=form id=password-form name=passwordForm ng-submit=\"passwordForm.$valid && $ctrl.resetPassword()\" novalidate> <div class=form-group ng-class=\"{ 'has-error': passwordForm.password.$touched && passwordForm.password.$invalid || passwordForm.$submitted && passwordForm.password.$invalid}\"> <label translate>Password</label> <div class=row> <div class=col-md-12> <input type=password class=form-control name=password ng-model=$ctrl.authUser.password required> <div ng-messages=passwordForm.password.$error ng-show=\"passwordForm.password.$touched || passwordForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': passwordForm.confirmPassword.$touched && passwordForm.confirmPassword.$invalid || passwordForm.$submitted && passwordForm.confirmPassword.$invalid}\"> <label translate>Confirm password</label> <div class=row> <div class=col-md-12> <input type=password class=form-control name=confirmPassword match-password=password ng-model=$ctrl.authUser.confirmPassword required> <div ng-messages=passwordForm.confirmPassword.$error ng-show=\"passwordForm.confirmPassword.$touched || passwordForm.$submitted\"> <div ng-message=required translate>This field is required</div> <div ng-message=passwordMatch translate>Your passwords did not match</div> </div> </div> </div> </div> <div class=row> <div class=modal-footer> <button type=submit class=\"btn btn-primary\" translate>Reset password</button> </div> </div> </form> </div>";

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<button ng-if=status type=button class=\"btn btn-sm btn-success btn-icon check-avail-btn mr5\"> <i class=\"fa fa-check mr5\"></i><span translate>Twinfield: online</span> </button> <button ng-if=!status type=button class=\"btn btn-sm btn-warning btn-icon check-avail-btn mr5\" ng-click=$ctrl.authenticateTwinfield()> <i class=\"fa fa-exclamation-triangle mr5\"></i><span translate>Twinfield: koppelen</span> </button>";

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app layout-fixed-header\"> <sidebar class=\"sidebar-panel offscreen-left\" menuitems=$ctrl.menuItems version=$ctrl.version></sidebar> <div class=main-panel> <operando-navbar shifts=$ctrl.shifts current-shift=$ctrl.currentShift news=$ctrl.news class=\"header navbar\" user-name=$ctrl.user.userName></operando-navbar> <div class=main-content ui-view></div> </div> <div class=chat-panel> <chat-panel-component shifts=$ctrl.shifts current-shift=$ctrl.currentShift locations=$ctrl.locations teams=$ctrl.teams account-notes=$ctrl.accountNotes employees=$ctrl.employees selected-employee=$ctrl.selectedEmployee></chat-panel-component> </div> <div class=news-panel> <news-panel-component news=$ctrl.news></news-panel-component> </div> </div> <div class=modal id=check-availability-modal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=\"modal-dialog modal-huge\"> <div class=modal-content> <check-availability-modal-component shifts=$ctrl.shifts shift=$ctrl.currentShift locations=$ctrl.locations teams=$ctrl.teams account-notes=$ctrl.accountNotes employees=$ctrl.employees selected-employee=$ctrl.selectedEmployee></check-availability-modal-component> </div> </div> </div> <div class=modal id=ResetPasswordModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Reset Password</h4> </div> <reset-password-component></reset-password-component> </div> </div> </div>";

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<div class=container style=margin-top:5%;height:80%> <div class=jumbotron> <h1>Internet Explorer wordt niet ondersteund</h1> <p>Het ziet eruit dat u gebruik maakt van Internet Explorer. Op het moment ondersteund deze applicatie geen Internet Explorer.</p> <p>Om gebruik te maken van de deze applicatie gebruik Chrome of Firefox.</p> <p><a class=\"btn btn-lg btn-primary\" href=https://www.google.com/chrome/ >Download Chrome</a></p> </div> </div>";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div class=search> <form class=form> <div class=search-bar> <input class=form-control name=search ng-model=$ctrl.search placeholder=search /> </div> </form> </div> <div class=chat-inner> <div class=chat-users> <div class=list-line ng-class=\"{'active': $ctrl.currentShift === item}\" ng-repeat=\"item in $ctrl.shifts | orderBy:['start','name']:true | filterBy : ['teamLocationName', 'teamName', 'employeeDisplayName'] : $ctrl.search\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\" ng-click=$ctrl.openShift(item)> <div class=\"letter-avatar valign-center\"> <ng-letter-avatar data=\"{{ item.teamLocationName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> </div> <div class=shift-item> <span class=bold>{{ item.teamLocationName }}</span><br/> <span class=bold>{{ item.teamName }}</span> <div class=\"shift-summary small\"> <span ng-if=\"!$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date : \"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date : \"HH:mm\" }}</span> <span translate>to</span> {{ item.end | date : \"HH:mm dd-MM-yyyy\" }} <span class=\"chip status-chip\" ng-style=\"{background: item.statusColor}\" ng-if=item.status>{{ item.statusName }}</span> </div> <span class=bold>{{ item.employeeDisplayName }}</span> </div> <i class=\"fa fa-check check-big icon-success valign-center link accept-btn\" ng-click=\"$ctrl.approve($event, item)\" ng-if=item.employeeId></i> <i class=\"fa fa-close close-big icon-danger valign-center link reject-btn\" ng-click=\"$ctrl.reject($event, item)\"></i> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"brand visible-xs\"> <div class=toggle-offscreen> <a href=# class=\"hamburger-icon visible-xs\" ng-click=$ctrl.toggleSidebar()> <span></span> <span></span> <span></span> </a> </div> <div class=brand-logo> <img ng-src={{$ctrl.logo}} height=15 alt=\"\"> </div> </div> <ul class=\"nav navbar-nav navbar-left hidden-xs\"> <li permission permission-except=\"['EMPLOYEE']\" style=padding-left:10px> <twinfield-component></twinfield-component> </li> </ul> <ul class=\"nav navbar-nav navbar-right hidden-xs\"> <li permission permission-except=\"['EMPLOYEE', 'CUSTOMER']\"> <button type=button class=\"btn btn-sm btn-info btn-icon check-avail-btn mr5\" ng-click=$ctrl.showAvailModal()> <i class=\"fa fa-plus mr5\"></i><span translate>Check availability</span> </button> </li> <li permission permission-except=\"['EMPLOYEE', 'CUSTOMER']\"> <a href=javascript:; class=\"hamburger-icon v2\" ng-click=$ctrl.toggleSlider()> <span></span> <span></span> <span></span> </a> </li> <li permission permission-only=\"['EMPLOYEE', 'CUSTOMER']\"> <button type=button class=\"btn btn-sm btn-info btn-icon check-avail-btn mr5\" ng-click=$ctrl.toggleNewsSlider()> <i class=\"fa fa-newspaper-o mr5\"></i><span translate>News</span> <span class=badge permission permission-only=\"['EMPLOYEE', 'CUSTOMER']\">{{$ctrl.unreadCnt}}</span> </button> </li> <li> <a href=javascript:; data-toggle=dropdown> <div style=display:flex;flex-direction:row> <div>{{$ctrl.userName}}</div> <div style=margin-top:-6px;margin-left:6px><ng-letter-avatar ng-if=$ctrl.userName data={{$ctrl.userName}} shape=round charcount=2 height=30px width=30px fontsize=15></ng-letter-avatar></div> </div> </a> <ul class=dropdown-menu> <li> <a ng-click=$ctrl.openResetPasswordModal() translate>Reset Password</a> </li> <li> <a href=/logout translate>Logout</a> </li> </ul> </li> </ul>";

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "<div class=chat-inner> <div class=chat-users> <div class=list-line ng-repeat=\"item in $ctrl.news\"> <span class=bold>{{item.createdDate | date : 'dd-MM'}} {{ item.title }}</span> <div class=pull-right> <span class=badge style=margin-left:2px ng-if=!item.read>Nieuw</span> <span class=badge style=margin-left:2px ng-if=item.read>Gelezen</span> </div> <br/> <span>{{ item.text }}</span> <div ng-if=!item.read permission permission-only=\"['EMPLOYEE', 'CUSTOMER']\"> <br/> <hr/> <button ng-if=!item.read class=\"btn btn-success btn-sm\" ng-click=$ctrl.setRead(item.id)>Markeer als gelezen</button> </div> </div> </div> </div>";

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=basic-info-form name=basicInfoForm class=tab-form-demo ng-submit=\"basicInfoForm.$valid && $ctrl.submitAccountBasicInfo()\"> <uib-tabset active=activeJustified justified=true class=primary> <uib-tab index=0> <uib-tab-heading translate>Name and Address</uib-tab-heading> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': basicInfoForm.name.$touched && basicInfoForm.name.$invalid || basicInfoForm.$submitted && basicInfoForm.name.$invalid }\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.account.name required> <div ng-messages=basicInfoForm.name.$error ng-show=\"basicInfoForm.name.$touched || basicInfoForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-12\"> <label translate>Type</label> <select multiple=multiple class=\"form-control chosen\" chosen data-placeholder=\"Choose an account type\" ng-model=$ctrl.account.AccountTypes ng-options=\"value for (key, value) in $ctrl.EnumService.accountTypes\"> <option value=\"\"></option> </select> </div> <div class=\"form-group col-md-9\"> <label translate>Street</label> <input class=\"form-control col-md-9\" name=street ng-model=$ctrl.account.visitingAddress.street> </div> <div class=\"form-group col-md-3\"> <label translate>Number</label> <input class=form-control name=street ng-model=$ctrl.account.visitingAddress.number> </div> <div class=\"form-group col-md-3\"> <label translate>Zip</label> <input class=form-control name=zip ng-model=$ctrl.account.visitingAddress.zip> </div> <div class=\"form-group col-md-9\"> <label translate>City</label> <input class=form-control name=city ng-model=$ctrl.account.visitingAddress.city> </div> <div class=\"form-group col-md-12\"> <label translate>Country</label> <input class=form-control name=city ng-model=$ctrl.account.visitingAddress.country> </div> </div> </uib-tab> <uib-tab index=1> <uib-tab-heading translate>Contact</uib-tab-heading> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" style=padding-top:25px> <label translate>Phone</label> <input class=form-control name=phone ng-model=$ctrl.account.phoneNumber> </div> <div class=\"form-group col-md-12\"> <label translate>Fax</label> <input class=form-control name=fax ng-model=$ctrl.account.faxNumber> </div> <div class=\"form-group col-md-9\"> <label translate>Post Street</label> <input class=form-control name=\"mailing Adress\" ng-model=$ctrl.account.mailingAddress.street> </div> <div class=\"form-group col-md-3\"> <label translate>Post Number</label> <input class=form-control name=\"mailing Number\" ng-model=$ctrl.account.mailingAddress.number> </div> <div class=\"form-group col-md-3\"> <label translate>Post Zip</label> <input class=form-control name=\"mailing Zip\" ng-model=$ctrl.account.mailingAddress.zip> </div> <div class=\"form-group col-md-9\"> <label translate>Post City</label> <input class=form-control name=\"mailing City\" ng-model=$ctrl.account.mailingAddress.city> </div> <div class=\"form-group col-md-12\"> <label translate>Post Country</label> <input class=form-control name=\"mailing Country\" ng-model=$ctrl.account.mailingAddress.country> </div> <div class=\"form-group col-md-12\"> <label translate>Email</label> <input class=form-control name=email ng-model=$ctrl.account.emailAddress> </div> <div class=\"form-group col-md-12\"> <label translate>Website</label> <input class=form-control name=website ng-model=$ctrl.account.websiteURL> </div> </div> </uib-tab> <uib-tab index=2> <uib-tab-heading translate>Financial</uib-tab-heading> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" style=padding-top:25px> <label translate>Chamber of Commerce Number</label> <input class=form-control name=vatNumber ng-model=$ctrl.account.chamberOfCommerceNumber> </div> <div class=\"form-group col-md-12\"> <label translate>VAT Number</label> <input class=form-control name=vatCode ng-model=$ctrl.account.vatNumber> </div> <div class=\"form-group col-md-12\"> <label translate>IBAN</label> <input class=form-control name=iban ng-model=$ctrl.account.iban> </div> <div class=\"form-group col-md-12\"> <label translate>Twinfield Id</label> <input class=form-control name=iban ng-model=$ctrl.account.twinfieldId> </div> <div class=\"form-group col-md-12\"> <label translate>CAO</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.account.salaryScaleGroup ng-options=\"item as item.name for item in $ctrl.salaryScaleGroups | orderBy: 'name'\" required data-placeholder=\"Selecteer een CAO\"> <option value=\"\">Selecteer een CAO</option> </select> </div> <div class=\"form-group col-md-12\"> <label translate>Gelijke beloning per uur (bedrag per uur)</label> <input type=number step=0.01 min=0 class=form-control ng-model=$ctrl.account.caoSurcharge placeholder=0.00> <small class=text-muted translate>Extra toeslag per uur in euro's</small> </div> </div> </uib-tab> </uib-tabset> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </form>";

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=crm.accounts translate>Accounts</a> </li> <li class=active>{{ $ctrl.account.name }}</li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-danger btn-icon btn-sm\" ng-click=$ctrl.deleteAccount() ng-if=$ctrl.account.id><i class=\"fa fa-trash\"></i><span translate>Delete account</span></a> </div> </div> <div class=responsive-container> <div class=row> <div class=col-md-4> <div class=\"panel p15\"> <div class=\"panel-heading border\"> <div class=panel-controls> <a ng-click=$ctrl.editAccountBasicInfoModal() class=primary><i class=\"fa fa-edit\"></i></a> </div> <table> <tr> <td> <ng-letter-avatar data=\"{{ $ctrl.account.name }}\" shape=round charcount=2 height=50px width=50px fontsize=20></ng-letter-avatar> </td> <td> <h4 class=\"panel-title ml15\">{{ $ctrl.account.name }}</h4> <div class=ml15> <span ng-repeat=\"type in $ctrl.account.AccountTypes\" class=chip>{{ type }}</span> </div> </td> </tr> </table> </div> <div class=panel-body> <div class=row ng-if=\"$ctrl.account.visitingAddress.street || $ctrl.account.visitingAddress.number || $ctrl.account.visitingAddress.zip || $ctrl.account.visitingAddress.city || $ctrl.account.visitingAddress.country\"> <div class=col-md-4><b translate>Address</b></div> <div class=col-md-8> {{ $ctrl.account.visitingAddress.street }} {{ $ctrl.account.visitingAddress.number }} {{ $ctrl.account.visitingAddress.numberSuffix}} <br ng-if=$ctrl.account.visitingAddress.street /> {{ $ctrl.account.visitingAddress.zip }} {{$ctrl.account.visitingAddress.city}} <br ng-if=\"$ctrl.account.visitingAddress.zip || $ctrl.account.visitingAddress.city\"/> {{ $ctrl.account.visitingAddress.country}} </div> </div> <hr ng-if=\"$ctrl.account.phoneNumber || $ctrl.account.faxNumber || $ctrl.account.mailingAddress.street || $ctrl.account.mailingAddress.zip || $ctrl.account.mailingAddress.city || $ctrl.account.mailingAddress.country || $ctrl.account.emailAdress || $ctrl.account.websiteUrl\"/> <div class=row ng-if=$ctrl.account.phoneNumber> <div class=col-md-4><b translate>Phone</b></div> <div class=col-md-8>{{ $ctrl.account.phoneNumber }}</div> </div> <div class=row ng-if=$ctrl.account.faxNumber> <div class=col-md-4><b translate>Fax</b></div> <div class=col-md-8>{{ $ctrl.account.faxNumber }}</div> </div> <div class=row ng-if=\"$ctrl.account.mailingAddress.street || $ctrl.account.mailingAddress.zip || $ctrl.account.mailingAddress.city || $ctrl.account.mailingAddress.country\"> <div class=col-md-4><b translate>Post Address</b></div> <div class=col-md-8> {{ $ctrl.account.mailingAddress.street }} {{ $ctrl.account.mailingAddress.number }} {{ $ctrl.account.malingAddress.numberSuffix}} <br ng-if=$ctrl.account.mailingAddress.street /> {{ $ctrl.account.mailingAddress.zip }} {{$ctrl.account.mailingAddress.city}} <br ng-if=\"$ctrl.account.mailingAddress.zip || $ctrl.account.mailingAddress.city\"/> {{ $ctrl.account.mailingAddress.country}} </div> </div> <div class=row ng-if=$ctrl.account.emailAdress> <div class=col-md-4><b translate>Email</b></div> <div class=col-md-8>{{ $ctrl.account.emailAddress }}</div> </div> <div class=row ng-if=$ctrl.account.websiteUrl> <div class=col-md-4><b translate>Website</b></div> <div class=col-md-8><a href=http://{{$ctrl.account.websiteUrl}} target=_blank>{{ $ctrl.account.websiteUrl }}</a></div> </div> <hr ng-if=\"$ctrl.account.chamberOfCommerceNumber || $ctrl.account.vatNumber || $ctrl.account.iban || $ctrl.account.bankAccountNumber\"/> <div class=row ng-if=$ctrl.account.iban> <div class=col-md-4><b translate>IBAN</b></div> <div class=col-md-8>{{ $ctrl.account.iban }}</div> </div> <div class=row ng-if=$ctrl.account.bankAccountNumber> <div class=col-md-4><b translate>Bank Account Number</b></div> <div class=col-md-8>{{ $ctrl.account.bankAccountNumber}}</div> </div> <div class=row ng-if=$ctrl.account.chamberOfCommerceNumber> <div class=col-md-4><b translate>Chamber Of Commerce Number</b></div> <div class=col-md-8>{{ $ctrl.account.chamberOfCommerceNumber }}</div> </div> <div class=row ng-if=$ctrl.account.vatNumber> <div class=col-md-4><b translate>VAT Number</b></div> <div class=col-md-8>{{ $ctrl.account.vatNumber }}</div> </div> <div class=row ng-if=$ctrl.account.twinfieldId> <div class=col-md-4><b translate>Twinfield ID</b></div> <div class=col-md-8>{{ $ctrl.account.twinfieldId }}</div> </div> <hr ng-if=\"$ctrl.account.scaCode || $ctrl.account.rvaCode\"/> <div class=row ng-if=$ctrl.account.scaCode> <div class=col-md-4><b translate>SCA Code</b></div> <div class=col-md-8>{{ $ctrl.account.scaCode }}</div> </div> <div class=row ng-if=$ctrl.account.rvaCode> <div class=col-md-4><b translate>RVA Code</b></div> <div class=col-md-8>{{ $ctrl.account.rvaCode }}</div> </div> </div> </div> </div> <div class=col-md-8> <uib-tabset active=$ctrl.activeTabIndex justified=true class=primary> <uib-tab index=0> <uib-tab-heading translate>Contact Persons</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <a ui-sref=\"crm.contacts.item({'id': '', 'accountId': $ctrl.account.id})\" class=\"btn btn-info btn-sm btn-icon\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Contact Person</span></a> </div> </div> <div class=panel-body> <div class=list-line ng-repeat=\"item in $ctrl.contacts\"> <div class=media> <div class=row> <div class=\"comment col-md-9 ellipsis link\" ui-sref=\"crm.contacts.item({'id': item.id})\"> <span> <ng-letter-avatar data=\"{{ item.firstName }} {{ item.lastName }}\" shape=round charcount=2 height=35px width=35px fontsize=12></ng-letter-avatar> <span style=margin-left:15px><b>{{ item.firstName }} {{ item.lastName }}</b></span> </span> </div> <div class=\"meta h6 col-md-3 no-margin\"></div> </div> </div> </div> </div> </div> </uib-tab> <uib-tab index=1> <uib-tab-heading translate>Notes</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <select id=tag-filter ng-change=$ctrl.filterNotes() ng-model=$ctrl.selectedTag> <option value=\"\">-- Selecteer een Kenmerk --</option> <option ng-repeat=\"tag in $ctrl.tags\" value=\"{{ tag.name }}\">{{ tag.name }}</option> </select> <a ng-click=$ctrl.addNoteModal() class=\"btn btn-info btn-sm btn-icon\"><i class=\"fa fa-plus mr5\"></i><span translate>Add note</span></a> </div> </div> <div class=panel-body> <list-component list=$ctrl.filteredNotes on-update=\"$ctrl.updateNote(item, action)\"></list-component> </div> </div> </uib-tab> <uib-tab index=3> <uib-tab-heading translate>Locations</uib-tab-heading> <locations-list-component locations=$ctrl.locations></locations-list-component> </uib-tab> <uib-tab index=4> <uib-tab-heading translate>Agreements</uib-tab-heading> <agreements-list-component agreements=$ctrl.agreements></agreements-list-component> </uib-tab> <uib-tab index=5> <uib-tab-heading translate>Employees</uib-tab-heading> <account-employees-list-component account-employees=$ctrl.accountEmployees></account-employees-list-component> </uib-tab> <uib-tab index=6> <uib-tab-heading translate>Settings</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <a ui-sref=.reminder class=\"btn btn-info btn-sm btn-icon\"><i class=\"fa fa-plus mr5\"></i><span translate>Add reminder interval</span></a> </div> </div> <div class=\"panel-body p15\"> <table class=\"table table-hover\"> <thead> <tr> <th translate>Name</th> <th translate>Interval</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.reminderIntervals | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\" ui-sref=\".reminder({'index': item.index})\"> <td>{{item.name}}</td> <td>{{item.interval}}</td> </tr> </tbody> </table> <div class=datatable-bottom> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.accountEmployees.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last ng-if=\"$ctrl.accountEmployees.length > 0\"></ul> </div> </div> </div> </uib-tab> </uib-tabset> </div> </div> </div> <div class=modal id=accountBasicInfoModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Company basic information</h4> </div> <account-basic-info-component account=$ctrl.account on-update=$ctrl.submitAccount(account)></account-basic-info-component> </div> </div> </div> <div class=modal id=contactInfoModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Company contact information</h4> </div> <contact-info-component account=$ctrl.account on-update=$ctrl.submitAccount(account)></contact-info-component> </div> </div> </div> <div class=modal id=financialInfoModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Company financial information</h4> </div> <financial-info-component account=$ctrl.account on-update=$ctrl.submitAccount(account)></financial-info-component> </div> </div> </div> <div class=modal id=noteModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Note</h4> </div> <crm-note-component note=$ctrl.currentNote on-update=$ctrl.submitNote(note)></crm-note-component> </div> </div> </div> ";

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=crm.accounts translate>Accounts</a> </li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-info btn-icon btn-sm\" ui-sref=\"crm.accounts.item({'id': ''})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Account</span></a> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control style=\"font-family:FontAwesome,'Open Sans'\" name=search ng-model=$ctrl.search placeholder=\"&#xf002; search\"/> </div> <div class=col-md-9> <div class=\"btn-group pull-right\"> <label class=\"btn btn-white\" ng-model=$ctrl.menu uib-btn-radio=\"'list'\"><i class=\"fa fa-list\" aria-hidden=true></i></label> <label class=\"btn btn-white\" ng-model=$ctrl.menu uib-btn-radio=\"'card'\"><i class=\"fa fa-address-card-o\" aria-hidden=true></i></label> </div> </div> </div> </form> </div> </div> <div class=row ng-if=\"$ctrl.menu=='card'\"> <div class=col-md-4 ng-repeat=\"item in $ctrl.accounts | filter : $ctrl.search | orderBy: 'name'\" ui-sref=\"crm.accounts.item({'id': item.id})\"> <div class=\"panel listcard\" style=height:125px> <div class=panel-body> <table> <tr> <td> <ng-letter-avatar data={{item.name}} shape=round charcount=2 height=50px width=50px fontsize=20></ng-letter-avatar> </td> <td> <h4 class=\"panel-title ml15\">{{ item.name }}</h4> <div class=ml15> <span ng-repeat=\"type in item.AccountTypes\" class=chip>{{ type }}</span> </div> </td> </tr> <tr> <td></td> <td> <div class=ml15> {{item.visitingAddress.street}} {{item.visitingAddress.number}} {{item.vistingAddress.numberSuffix}}<br> {{item.visitingAddress.zip}} {{item.visitingAddress.city}} </div> </td> </tr> </table> </div> </div> </div> </div> <div class=panel ng-if=\"$ctrl.menu=='list'\"> <div class=panel-body> <table id=accounts-table class=\"table table-hover\"> <thead> <tr> <th style=width:45%> <a href=# ng-click=\"$ctrl.sortType = 'name'; sortReverse = !sortReverse\"> <span translate>Company Name</span> <span ng-show=\"$ctrl.sortType == 'name' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'name' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'vistingAddress.street'; sortReverse = !sortReverse\"> <span translate>Address</span> <span ng-show=\"$ctrl.sortType == 'vistingAddress.street' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'vistingAddress.street' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"crm.accounts.item({ 'id': item.id})\" ng-repeat=\"item in $ctrl.accounts | filter : $ctrl.search | orderBy:$ctrl.sortType:sortReverse\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=12></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{item.name}}</span> <div style=margin-left:50px> <span ng-repeat=\"type in item.AccountTypes\" class=chip>{{ type }}</span> </div> </td> <td> {{ item.visitingAddress.street }} {{ item.visitingAddress.number }} {{ item.vistingAddress.numberSuffix }} <br> {{ item.visitingAddress.zip }} {{ item.visitingAddress.city }} </td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=contact-info-form name=contactInfoForm ng-submit=\"contactInfoForm.$valid && $ctrl.submitContactInfo()\"> <div class=modal-body> <div class=form-group> <label translate>Phone:</label> <input class=form-control name=phone ng-model=$ctrl.account.phone> </div> <div class=form-group> <label translate>Fax:</label> <input class=form-control name=fax ng-model=$ctrl.account.fax> </div> <div class=form-group> <label translate>Email:</label> <input class=form-control name=email ng-model=$ctrl.account.email> </div> <div class=form-group> <label translate>Website:</label> <input class=form-control name=website ng-model=$ctrl.account.website> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </form>";

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=basic-info-form name=basicInfoForm ng-submit=\"basicInfoForm.$valid && $ctrl.submitFinancialInfo()\"> <div class=modal-body> <div class=form-group> <label translate>VAT Number</label> <input class=form-control name=vatNumber ng-model=$ctrl.account.vatNumber> </div> <div class=form-group> <label translate>VAT Code</label> <input class=form-control name=vatCode ng-model=$ctrl.account.vatCode> </div> <div class=form-group> <label translate>IBAN</label> <input class=form-control name=iban ng-model=$ctrl.account.iban> </div> <div class=form-group> <label translate>Delivery day</label> <input type=date class=form-control name=deliveryDay ng-model=$ctrl.account.deliveryDay> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </form>";

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = " <div class=modal-header> <button type=button class=close aria-label=Close ui-sref=^><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Reminder interval</h4> </div> <form role=form id=basic-info-form name=basicInfoForm ng-submit=\"basicInfoForm.$valid && $ctrl.submit()\"> <div class=modal-body> <div class=form-group> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.reminderInterval.name> </div> <div class=form-group> <label translate>Interval</label> <input class=form-control name=interval ng-model=$ctrl.reminderInterval.interval> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button class=\"btn btn-sm btn-danger\" type=button ng-click=$ctrl.delete() ng-if=\"$ctrl.reminderInterval.index >= 0\" translate>Delete</button> <button type=button class=\"btn btn-warning\" ui-sref=^ translate>Cancel</button> </div> </form>";

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Agreement</h4> </div> <div class=modal-body> <form class=form role=form id=agreementForm ng-submit=$ctrl.submitAgreement()> <div class=row style=padding:15px> <div class=\"form-group col-md-6\" style=margin-top:16px> <input type=checkbox id=perCompany ng-model=$ctrl.perCompany ng-change=\"$ctrl.handleCheckboxChange('perCompany')\"/> <label translate for=perCompany>Per bedrijf</label> </div> <div class=\"form-group col-md-6\" style=margin-top:16px> <input type=checkbox id=byEmployee ng-model=$ctrl.byEmployee ng-change=\"$ctrl.handleCheckboxChange('byEmployee')\"/> <label translate for=byEmployee>Per medewerker</label> </div> <div class=\"form-group col-md-6\" style=margin-top:16px> <input type=checkbox id=bySalaryScale ng-model=$ctrl.bySalaryScale ng-change=\"$ctrl.handleCheckboxChange('bySalaryScale')\"/> <label translate for=bySalaryScale>Per salarisschaal</label> </div> <div class=\"form-group col-md-6\" style=margin-top:16px> <input id=ort type=checkbox ng-model=$ctrl.agreement.ort ng-change=\"$ctrl.handleCheckboxChange('ort')\"/> <label translate for=ort>Alleen voor ORT</label> </div> <div class=\"form-group col-md-12\"> <div class=col-md-6> <label translate>Start</label> <date-time-picker-component date=$ctrl.agreement.dateTimeFrom time=false></date-time-picker-component> </div> <div class=col-md-6> <label translate>End</label> <date-time-picker-component date=$ctrl.agreement.dateTimeTo time=false></date-time-picker-component> </div> </div> <div class=\"form-group col-md-12\" ng-if=$ctrl.byEmployee> <label translate>Employee</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.agreement.employeeId ng-options=\"item.id as item.displayName for item in $ctrl.employees | orderBy: 'displayName'\"> <option value=\"\">Select an employee</option> </select> </div> <div class=\"form-group col-md-12\" ng-if=$ctrl.bySalaryScale> <label translate>Salary scale</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.agreement.salaryScaleId ng-options=\"item.id as item.name for item in $ctrl.salaryScales | orderBy: 'name'\"> <option value=\"\">Select an salary scale</option> </select> </div> <div class=\"form-group col-md-12\" ng-if=$ctrl.byEmployee> <label translate>Gross hourly wage</label> <input class=form-control name=grossHourlyWageValue ng-model=$ctrl.agreement.grossHourlyWageValue> </div> <div class=\"form-group col-md-12\" ng-if=\"!$ctrl.agreement.ort && !$ctrl.bySalaryScale\"> <label translate>Toeslag</label> <input class=form-control name=fee ng-model=$ctrl.agreement.fee> </div> <div class=\"form-group col-md-12\" ng-if=!$ctrl.byEmployee> <label translate>Calculation index</label> <input class=form-control name=calculationIndex ng-model=$ctrl.agreement.calculationIndex> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=agreementForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-click=$ctrl.delete(); ng-if=\"$ctrl.agreement.id && $ctrl.agreement.id != ''\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button type=button class=\"btn btn-info btn-sm btn-icon mr5\" ui-sref=\"crm.accounts.item.agreement({agreementId: ''})\"> <i class=\"fa fa-plus mr5\"></i><span translate>Add agreement</span> </button> </div> </div> <div class=\"panel-body p15\"> <table class=\"table table-hover\"> <thead> <tr> <th translate style=width:100px>Start</th> <th translate style=width:100px>End</th> <th translate>Medewerker</th> <th translate>Salary scale</th> <th translate style=width:50px;text-align:center>ORT</th> <th translate style=width:100px;text-align:right>Gross hourly wage</th> <th translate style=width:100px;text-align:right>Toeslag</th> <th translate style=width:125px;text-align:right>Calculation index</th> </tr> </thead> <tbody> <tr ui-sref=\"crm.accounts.item.agreement({agreementId: item.id})\" ng-repeat=\"item in $ctrl.agreements | orderBy: parseDate: true | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <td>{{item.dateTimeFrom | date : \"dd-MM-yyyy\"}}</td> <td>{{item.dateTimeTo | date : \"dd-MM-yyyy\"}}</td> <td>{{item.employeeDisplayName}}</td> <td>{{item.salaryScale.name}}</td> <td style=text-align:center><input type=checkbox ng-model=item.ort disabled=disabled /></td> <td style=text-align:right>{{item.grossHourlyWageValue | currency : \"€\" : 2 }}</td> <td style=text-align:right>{{item.fee | currency : \"€\" : 2 }}</td> <td style=text-align:center>{{item.calculationIndex}}</td> </tr> </tbody> </table> <div class=datatable-bottom ng-if=\"$ctrl.itemsPerPage < $ctrl.agreements.length\"> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.agreements.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=Eerste last-text=Laatste ng-if=\"$ctrl.agreements.length > 0\"></ul> </div> </div> </div>";

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=basic-info-form name=basicInfoForm ng-submit=\"basicInfoForm.$valid && $ctrl.submitContactBasicInfo()\"> <div class=modal-body> <div class=form-group ng-class=\"{ 'has-error': contactForm.firstName.$touched && contactForm.firstName.$invalid || contactForm.$submitted && contactForm.firstName.$invalid}\"> <label translate>First name</label> <input class=form-control name=firstName ng-model=$ctrl.contact.firstName required> <div ng-messages=contactForm.firstName.$error ng-show=\"contactForm.firstName.$touched || contactForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <label translate>Middle name</label> <input class=form-control name=middleName ng-model=$ctrl.contact.middleName> </div> <div class=form-group ng-class=\"{ 'has-error': contactForm.lastName.$touched && contactForm.lastName.$invalid || contactForm.$submitted && contactForm.lastName.$invalid}\"> <label translate>Last name</label> <input class=form-control name=lastName ng-model=$ctrl.contact.lastName required> <div ng-messages=contactForm.lastName.$error ng-show=\"contactForm.lastName.$touched || contactForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <label translate>Tags</label> <select class=\"form-control chosen\" multiple=multiple chosen=$ctrl.contactTags ng-model=$ctrl.contact.tags name=tag ng-options=\"item.name as item.name for item in $ctrl.contactTags\"> <option value=\"\"></option> </select> </div> <div class=form-group ng-if=\"$ctrl.contact.accountId != 'true'\"> <label translate>Company</label> <select class=\"form-control chosen\" chosen name=client ng-model=$ctrl.contact.accountId ng-if=$ctrl.accounts ng-options=\"item.id as item.name for item in $ctrl.accounts\" ng-change=$ctrl.accountSelected()> </select> </div> <div class=form-group ng-if=$ctrl.contact.accountId> <label translate>Location</label> <select class=\"form-control chosen\" chosen=$ctrl.locations name=location ng-model=$ctrl.contact.locationId ng-options=\"item.id as item.name for item in $ctrl.locations\"> <option value=\"\"></option> </select> </div> <div class=form-group> <label translate>Function</label> <input class=form-control name=function ng-model=$ctrl.contact.function> </div> <div class=form-group> <label translate>Phone</label> <input class=form-control name=phone ng-model=$ctrl.contact.phoneNumber> </div> <div class=form-group> <label translate>Email</label> <input class=form-control name=email ng-model=$ctrl.contact.emailAddress> </div> <div class=\"dropdown form-group dropdown-start-parent\"> <label translate>Birthday</label> <a class=dropdown-toggle id=dropdownStart role=button data-toggle=dropdown data-target=.dropdown-start-parent href=#> <div class=\"input-group date\"> <input class=form-control data-date-time-input=DD-MM-YYYY data-ng-model=$ctrl.contact.birthday /> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=\"dropdown-menu pop-above\" role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=$ctrl.contact.birthday data-datetimepicker-config=\"{ dropdownSelector: '#dropdownStart', renderOn: 'start-date-changed', minView: 'day' }\"></datetimepicker> </ul> </div> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </form>";

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=contact-social-form ng-submit=$ctrl.submitSocialForm()> <div class=modal-body> <div class=form-group> <label translate>Phone</label> <input class=form-control name=phone ng-model=$ctrl.contact.phone> </div> <div class=form-group> <label translate>Email</label> <input class=form-control name=email ng-model=$ctrl.contact.email> </div> <div class=form-group> <label translate>LinkedIn</label> <input class=form-control name=linkedin ng-model=$ctrl.contact.linkedIn> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </div></form>";

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=crm.contacts translate>Contacts</a> </li> <li> <a ui-sref=\"crm.accounts.item({id: $ctrl.account.id})\" translate>{{ $ctrl.account.name }}</a> </li> <li class=active> {{$ctrl.fullName}} </li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-danger btn-icon btn-sm\" ng-click=$ctrl.deleteContact() ng-if=$ctrl.contact.id><i class=\"fa fa-trash\"></i><span translate>Delete contact</span></a> </div> </div> <div class=responsive-container> <div class=row> <div class=col-md-4> <div class=\"panel panel p15\"> <div class=\"panel-heading border\"> <div class=panel-controls> <a ng-click=$ctrl.editContactBasicInfoModal() class=primary><i class=\"fa fa-edit\"></i></a> </div> <table> <tr> <td> <ng-letter-avatar data=\"{{ $ctrl.contact.firstName }} {{ $ctrl.contact.lastName }}\" shape=round charcount=2 height=50px width=50px fontsize=20></ng-letter-avatar> </td> <td class> <h4 class=\"panel-title ml15\">{{ $ctrl.fullName }}</h4> <div class=ml15> <span class=\"chip chip-info\" ng-if=$ctrl.contact.function>{{$ctrl.contact.function}}</span> <span class=\"chip chip-success\" ng-if=$ctrl.account.name><a ui-sref=\"crm.accounts.item({id: $ctrl.account.id})\">{{$ctrl.account.name}}</a></span> <span class=chip ng-repeat=\"tag in $ctrl.contact.tags\">{{ tag }}</span> </div> </td> </tr> </table> </div> <div class=panel-body> <div class=row ng-if=$ctrl.contact.phoneNumber> <div class=col-md-4><b translate>Phone</b></div> <div class=col-md-8>{{ $ctrl.contact.phoneNumber }}</div> </div> <div class=row ng-if=$ctrl.contact.emailAddress> <div class=col-md-4><b translate>Email</b></div> <div class=col-md-8>{{ $ctrl.contact.emailAddress }}</div> </div> <div class=row ng-if=$ctrl.contact.locationName> <div class=col-md-4><b translate>Location</b></div> <div class=col-md-8>{{ $ctrl.contact.locationName }}</div> </div> <hr ng-if=$ctrl.contact.birthday> <div class=row ng-if=$ctrl.contact.birthday> <div class=col-md-4><b translate>Birthday</b></div> <div class=col-md-8>{{ $ctrl.contact.birthday | date:'fullDate' }}</div> </div> </div> </div> </div> <div class=col-md-8> <uib-tabset active=activeJustified justified=true class=primary> <uib-tab index=2> <uib-tab-heading translate>User-Account</uib-tab-heading> <user-account-component contact=$ctrl.contact></user-account-component> </uib-tab> </uib-tabset> </div> </div> </div> <div class=modal id=contactBasicInfoModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Contact basic information</h4> </div> <contact-basic-info-component contact=$ctrl.contact on-update=$ctrl.submitContact(contact)></contact-basic-info-component> </div> </div> </div> <div class=modal id=noteModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Notes</h4> </div> <note-component note=$ctrl.currentNote on-update=$ctrl.submitNote(note)></note-component> </div> </div> </div> <div class=modal id=contactSocialModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Social information</h4> </div> <contact-social-component contact=$ctrl.contact on-update=$ctrl.submitContact(contact)></contact-social-component> </div> </div> </div>";

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=crm.contacts translate>Contacts</a> </li> </ol> </div> <div class=buttons> <button class=\"pull-right btn btn-info btn-icon btn-sm\" ui-sref=\"crm.contacts.item({'id': '', 'accountId': $ctrl.accountId})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Contact</span></button> <button class=\"pull-right btn btn-primary btn-icon btn-sm mr5\" ng-click=$ctrl.emailToClipboard()><i class=\"fa fa-copy mr5\"></i><span translate>Get emails</span></button> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control name=search ng-model=$ctrl.search placeholder=search /> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen=$ctrl.contactTags ng-model=$ctrl.tag placeholder=\"choose a tag\" ng-options=\"item.name as item.name for item in $ctrl.contactTags\"> <option value=\"\">Filter for a tag<span> </span></option></select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.company placeholder=\"choose a company\" ng-options=\"item.name as item.name for item in $ctrl.accounts\"> <option value=\"\">Filter for a company</option> </select> </div> <div class=col-md-3> <button class=\"btn btn-info btn\" ng-click=$ctrl.resetFilter()><span translate>Reset filter</span></button> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:250px> <a href=# ng-click=\"sortType = 'lastName'; sortReverse = !sortReverse\"> <span translate>Full Name</span> <span ng-show=\"sortType == 'lastName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"sortType == 'lastName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:250px> <a href=# ng-click=\"sortType = 'emailAddress'; sortReverse = !sortReverse\"> <span translate>Email</span> <span ng-show=\"sortType == 'emailAddress' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"sortType == 'emailAddress' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"sortType = 'phoneNumber'; sortReverse = !sortReverse\"> <span translate>Phone</span> <span ng-show=\"sortType == 'phoneNumber' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"sortType == 'phoneNumber' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"sortType = 'locationName'; sortReverse = !sortReverse\"> <span translate>Location</span> <span ng-show=\"sortType == 'locationName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"sortType == 'locationName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"crm.contacts.item({'id': item.id, 'accountId': $ctrl.accountId})\" ng-repeat=\"item in $ctrl.contacts | filter: {'accountName': $ctrl.company} | filter: $ctrl.tag | filter : {'name': $ctrl.search} | orderBy:sortType:sortReverse\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=12></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.name }}</span> <div style=margin-left:50px> <span ng-if=item.function class=\"chip chip-info\">{{item.function}}</span> <span class=\"chip chip-success\">{{ item.accountName }}</span> <span ng-repeat=\"tag in item.tags\" class=chip>{{ tag }}</span> </div> </td> <td>{{ item.emailAddress }}</td> <td>{{ item.phoneNumber }}</td> <td>{{ item.locationName }}</td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-md-6> <div class=\"panel p15\"> <div class=\"panel-heading border\"> <h4 class=panel-title translate>Accounts</h4> </div> <div class=panel-body> <table class=\"table table-hover\"> <thead> <tr> <th> <a href=# ng-click=\"$ctrl.sortType = 'name'; sortReverse =!sortReverse\"> <span translate>Company</span> <span ng-show=\"$ctrl.sortType == 'name' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'name' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"crm.accounts.item({'id': item.id})\" ng-repeat=\"item in $ctrl.accounts | filter:$ctrl.searchAccount | orderBy:$ctrl.sortType:sortReverse\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.name }}</span> </td> </tr> </tbody> </table> </div> </div> </div> <div class=col-md-6> <div class=\"panel p15\"> <div class=\"panel-heading border\"> <h4 class=panel-title translate>Contacts</h4> </div> <div class=panel-body> <table class=\"table table-hover\"> <thead> <th> <a href=# ng-click=\"$ctrl.sortTypeContacts = 'lastName'; sortReverse = !sortReverse\"> <span translate>Contact</span> <span ng-show=\"$ctrl.sortTypeContacts == 'lastName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortTypeContacts == 'lastName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortTypeContacts = 'accountName'; sortReverse = !sortReverse\"> <span translate>Company</span> <span ng-show=\"$ctrl.sortTypeContacts == 'accountName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortTypeContacts == 'accountName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </thead> <tbody> <tr ui-sref=\"crm.contacts.item({'id': item.id})\" ng-repeat=\"item in $ctrl.contacts | filter:$ctrl.searchContact | orderBy:$ctrl.sortTypeContacts:sortReverse\"> <td> <ng-letter-avatar data=\"{{ item.firstName }} {{ item.lastName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700 ng-if=\"item.firstName != null || item.lastName != null\">{{ item.firstName }} {{ item.lastName }}</span> </td> <td> <span>{{ item.accountName}}</span> </td> </tr> </tbody> </table> </div> </div> </div> </div>";

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Employee</h4> </div> <div class=modal-body> <form class=form role=form id=employeeForm ng-submit=$ctrl.submitAccountEmployee()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>Employee</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.accountEmployee.employeeId ng-options=\"item.id as item.displayName for item in $ctrl.employees | orderBy: 'displayName'\"> <option value=\"\">Select an employee</option> </select> </div> <div class=\"form-group col-md-12\"> <div class=\"\"> <label>End</label> <date-time-picker-component date=$ctrl.accountEmployee.dateTimeTo time=false on-change=$ctrl.getShiftsByDate()></date-time-picker-component> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5 btn-sm\" type=submit form=employeeForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5 btn-sm\" type=button ng-click=$ctrl.delete(); ng-if=\"$ctrl.accountEmployee.id != ''\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5 btn-sm\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button type=button class=\"btn btn-info btn-sm btn-icon mr5\" ui-sref=\"crm.accounts.item.employee({accountEmployeeId: ''})\"> <i class=\"fa fa-plus mr5\"></i><span translate>Add employee</span> </button> </div> </div> <div class=\"panel-body p15\"> <table class=\"table table-hover\"> <thead> <tr> <th translate>Name</th> <th translate>End</th> </tr> </thead> <tbody> <tr ui-sref=\"crm.accounts.item.employee({accountEmployeeId: item.id})\" ng-repeat=\"item in $ctrl.accountEmployees | orderBy: parseDate: true | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <td>{{item.employeeDisplayName}}</td> <td>{{item.dateTimeTo | date : \"dd-MM-yyyy HH:mm\"}}</td> </tr> </tbody> </table> <div class=datatable-bottom> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.accountEmployees.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last ng-if=\"$ctrl.accountEmployees.length > 0\"></ul> </div> </div> </div>";

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=lead-form name=leadForm ng-submit=\"leadForm.$valid && $ctrl.submitLead()\" novalidate> <div class=panel> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=crm.leads translate>Leads</a> </li> <li class=active> <a>{{$ctrl.lead.name}}</a> </li> </ol> </div> <div class=panel-body> <div class=form-group ng-class=\"{ 'has-error': leadForm.name.$touched && leadForm.name.$invalid || leadForm.$submitted && leadForm.name.$invalid}\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.lead.name required> <div ng-messages=leadForm.name.$error ng-show=\"leadForm.name.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.firstName.$touched && leadForm.firstName.$invalid || leadForm.$submitted && leadForm.firstName.$invalid}\"> <label translate>First name</label> <input class=form-control name=firstName ng-model=$ctrl.lead.firstName required> <div ng-messages=leadForm.firstName.$error ng-show=\"leadForm.firstName.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.middleName.$touched && leadForm.middleName.$invalid || leadForm.$submitted && leadForm.middleName.$invalid}\"> <label translate>Middle name</label> <input class=form-control name=middleName ng-model=$ctrl.lead.middleName> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.lastName.$touched && leadForm.lastName.$invalid || leadForm.$submitted && leadForm.lastName.$invalid}\"> <label translate>Last name</label> <input class=form-control name=lastName ng-model=$ctrl.lead.lastName required> <div ng-messages=leadForm.lastName.$error ng-show=\"leadForm.lastName.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <label translate>Email Address</label> <input class=form-control name=emailAddress ng-model=$ctrl.lead.email> </div> <div class=form-group> <label translate>Phone Number</label> <input class=form-control name=phonenumber ng-model=$ctrl.lead.phone> </div> </div> </div> <div class=panel> <div class=panel-body> <button type=button class=\"btn btn-primary\" ui-sref=crm.leads.list translate>Back</button> <button type=button class=\"btn btn-danger\" ng-click=$ctrl.deleteLead() translate>Delete</button> <button type=submit class=\"btn btn-success\" translate>Save</button> </div> </div> </form>";

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=crm.leads translate>Leads</a> </li> </ol> </div> <div class=buttons> <a class=pull-right data-toggle=modal data-target=#leadsModal translate>Add Lead</a> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-6> <input class=form-control name=search ng-model=$ctrl.search placeholder=search /> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=leads-table class=\"table table-hover\"> <thead> <tr> <th translate style=width:30%>Company Name</th> <th translate style=width:30%>Full Name</th> <th translate>Phone</th> </tr> </thead> <tbody> <tr ui-sref=\"crm.leads.item({'id': item.id})\" ng-repeat=\"item in $ctrl.leads | filter : $ctrl.search\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{item.name}}</span> </td> <td>{{ item.firstName }} {{ item.middleName }} {{ item.lastName }} </td> <td> {{ item.phoneNumber }} </td> </tr> </tbody> </table> </div> </div> <div class=modal id=leadsModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close> <span aria-hidden=true>&times;</span> </button> <h4 class=modal-title translate>Leads information</h4> </div> <leads-info-component lead=$ctrl.Lead on-update=$ctrl.submitLead()></leads-info-component> </div> </div> </div>";

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<form role=form id=lead-form name=leadForm ng-submit=\"leadForm.$valid && $ctrl.submitLead()\" novalidate> <div class=modal-body> <div class=form-group ng-class=\"{ 'has-error': leadForm.name.$touched && leadForm.name.$invalid || leadForm.$submitted && leadForm.name.$invalid}\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.lead.name required> <div ng-messages=leadForm.name.$error ng-show=\"leadForm.name.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.firstName.$touched && leadForm.firstName.$invalid || leadForm.$submitted && leadForm.firstName.$invalid}\"> <label translate>First name</label> <input class=form-control name=firstName ng-model=$ctrl.lead.firstName required> <div ng-messages=leadForm.firstName.$error ng-show=\"leadForm.firstName.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.middleName.$touched && leadForm.middleName.$invalid || leadForm.$submitted && leadForm.middleName.$invalid}\"> <label translate>Middle name</label> <input class=form-control name=middleName ng-model=$ctrl.lead.middleName> </div> <div class=form-group ng-class=\"{ 'has-error': leadForm.lastName.$touched && leadForm.lastName.$invalid || leadForm.$submitted && leadForm.lastName.$invalid}\"> <label translate>Last name</label> <input class=form-control name=lastName ng-model=$ctrl.lead.lastName required> <div ng-messages=leadForm.lastName.$error ng-show=\"leadForm.lastName.$touched || leadForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <label translate>Phone Number</label> <input class=form-control name=phoneNumber ng-model=$ctrl.lead.phoneNumber> </div> <div class=modal-footer> <button type=submit class=\"btn btn-success\" translate onclick='$(\".modal\").modal(\"hide\")'>Save</button> <button type=button class=\"btn btn-warning\" data-dismiss=modal translate>Cancel</button> </div> </div></form>";

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Location</h4> </div> <div class=modal-body> <form class=form role=form id=locationForm ng-submit=$ctrl.submitLocation()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': locationForm.name.$touched && locationForm.name.$invalid || locationForm.$submitted && locationForm.name.$invalid }\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.location.name required> <div ng-messages=locationForm.name.$error ng-show=\"locationForm.name.$touched || locationForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-9\"> <label translate>Street</label> <input class=\"form-control col-md-9\" name=street ng-model=$ctrl.location.address.street> </div> <div class=\"form-group col-md-3\"> <label translate>Number</label> <input class=form-control name=street ng-model=$ctrl.location.address.number> </div> <div class=\"form-group col-md-3\"> <label translate>Zip</label> <input class=form-control name=zip ng-model=$ctrl.location.address.zip> </div> <div class=\"form-group col-md-9\"> <label translate>City</label> <input class=form-control name=city ng-model=$ctrl.location.address.city> </div> <div class=\"form-group col-md-12\"> <label translate>Country</label> <input class=form-control name=city ng-model=$ctrl.location.address.country> </div> <div class=\"form-group col-md-12\"> <label translate>CAO overschrijven</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.location.salaryScaleGroup ng-options=\"item as item.name for item in $ctrl.salaryScaleGroups | orderBy: 'name'\" data-placeholder=\"Geen override (gebruik account CAO)\"> <option value=\"\">Geen override (gebruik account CAO)</option> </select> <small class=text-muted translate>Optioneel: overschrijf de CAO van het account voor deze locatie</small> </div> <div class=\"form-group col-md-12\"> <label translate>Gelijke beloning per uur (bedrag per uur)</label> <input type=number step=0.01 min=0 class=form-control ng-model=$ctrl.location.caoSurcharge placeholder=0.00> <small class=text-muted translate>Optioneel: overschrijf de gelijke beloning per uur van het account voor deze locatie</small> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=locationForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-click=$ctrl.delete(); ng-if=\"$ctrl.location.id != ''\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button ui-sref=\"crm.accounts.item.location({locationId: ''})\" class=\"btn btn-info btn-sm btn-icon mr5\"><i class=\"fa fa-plus mr5\"></i><span translate>Add location</span></button> </div> </div> <div class=\"panel-body p15\"> <table class=\"table table-hover\"> <thead> <tr> <th>Name</th> <th style=width:40%>Address</th> <th style=width:30%>Teams</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.locations track by item.id\"> <td ui-sref=\"crm.accounts.item.location({locationId: item.id})\">{{item.name}}</td> <td ui-sref=\"crm.accounts.item.location({locationId: item.id})\"> {{ item.address.street }} {{ item.address.number }} {{ item.address.numberSuffix}} <br ng-if=item.address.street> {{ item.address.zip }} {{item.address.city}} <br ng-if=\"item.address.zip || item.address.city\"> {{ item.address.country}} </td> <td class=no-padding> <teams-list-component teams=item.teams location-id=item.id></teams-list-component> </td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-body> <div class=modal-content-cta> <div class=panel> <form role=form id=note-form name=noteForm ng-submit=\"noteForm.$valid && $ctrl.submitNote()\" novalidate> <div class=panel-body> <div class=form-group ng-class=\"{ 'has-error': noteForm.category.$touched && noteForm.category.$invalid || noteForm.$submitted && noteForm.category.$invalid}\"> <label translate>Tags</label> <select multiple=multiple chosen=$ctrl.tags class=\"form-control chosen\" ng-model=$ctrl.note.tags data-placeholder=\"Choose tags\" name=category ng-options=\"item.name as item.name for item in $ctrl.tags\"></select> </div> <div class=form-group> <label translate>End Date</label> <date-time-picker-component date=$ctrl.note.endDate time=false></date-time-picker-component> </div> <div class=form-group ng-class=\"{ 'has-error': noteForm.description.$touched && noteForm.description.$invalid || noteForm.$submitted && noteForm.description.$invalid}\"> <label translate>Description</label> <textarea class=form-control name=description ng-model=$ctrl.note.description ng-maxlength=1024 rows=5 required></textarea> <div ng-messages=noteForm.description.$error ng-show=\"noteForm.description.$touched || noteForm.$submitted\"> <div ng-message=required translate>This field is required</div> <div ng-message=maxlength translate>The text is too long. It should be max 1024 characters</div> </div> </div> </div> </form> </div> </div> </div> <div class=modal-footer> <div class=panel-body> <button type=submit class=\"btn btn-success btn-submit-modal\" form=note-form translate>Save</button> <button type=button class=\"btn btn-info\" data-dismiss=modal translate>Cancel</button> </div> </div> ";

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Team</h4> </div> <div class=modal-body> <form class=form role=form id=teamForm ng-submit=$ctrl.submitTeam()> <div class=row style=padding-left:15px;padding-right:15px;margin-bottom:0> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': teamForm.name.$touched && teamForm.name.$invalid || teamForm.$submitted && teamForm.name.$invalid }\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.team.name required> <div ng-messages=teamForm.name.$error ng-show=\"teamForm.name.$touched || teamForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> <div class=row style=padding-left:15px;padding-right:15px;margin-bottom:0> <div class=\"form-group col-md-12\"> <label translate>Description</label> <textarea class=form-control name=description ng-model=$ctrl.team.description></textarea> </div> </div> <div class=row style=padding-left:15px;padding-right:15px;margin-bottom:0 ng-if=$ctrl.team.id> <div class=\"form-group col-md-12\" ng-if=\"$ctrl.team.teamContacts.length > 0\"> <table class=\"table table-hover\"> <thead> <tr> <th>Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.team.teamContacts track by item.id\"> <td class=link ui-sref=\"crm.contacts.item({id: item.contactId})\"> <div style=position:relative> {{item.contactName}} <i class=\"fa fa-minus-square-o remove-btn link\" ng-click=\"$ctrl.deleteContact($event, item)\"></i> </div> </td> </tr> </tbody> </table> </div> <div class=\"form-group col-md-12\"> <select class=\"form-control chosen\" chosen name=teamContact data-placeholder=\"Add contact\" ng-model=$ctrl.newContact ng-options=\"item as item.name for item in $ctrl.contacts\" ng-change=$ctrl.addContact()> </select> </div> </div> <div class=row style=padding-left:15px;padding-right:15px;margin-bottom:0> <div class=\"col-xs-12 mb5\"><b translate>GUID voor Cootje:</b></div> <div class=\"col-xs-12 mb5\"><input class=form-control name=teamGuid ng-model=$ctrl.team.id ng-disabled=true></div> <div class=\"col-xs-12 mb5\">Selecteer de GUID en klik op CMD-C of CTRL-C</div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=teamForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-click=$ctrl.delete(); ng-if=\"$ctrl.team.id != ''\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "<table class=\"table table-hover no-margin teams-table\"> <tbody> <tr ui-sref=\"crm.accounts.item.team({locationId: $ctrl.locationId, teamId: item.id})\" ng-repeat=\"item in $ctrl.teams track by item.id\"> <td>{{item.name}} <span class=pull-right>{{item.teamContacts.length}}</span></td> </tr> </tbody> </table> <div class=add-team-btn-cta> <i class=\"fa fa-plus link\" ui-sref=\"crm.accounts.item.team({locationId: $ctrl.locationId})\"></i> </div>";

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar shift-calendar-header-cta\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Shifts</a> </li> </ol> </div> <div class=buttons> <button type=button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=^.list><i class=\"fa fa-list mr5\"></i><span translate>List</span></button> <button type=button class=\"pull-right btn btn-primary btn-icon btn-sm mr10\" ui-sref=\"customerShifts.list.item({'id': ''})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></button> </div> </div> <div class=row> <div class=col-sm-12> <div class=calendar-viewer> <div ui-calendar=$ctrl.uiConfig.calendar class=fullcalendar calendar=shiftsCalendar ng-model=$ctrl.eventSources></div> </div> </div> </div>";

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div>";

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:calc(100%)> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Beschikbare medewerkers</h4> </div> <div style=\"overflow-y:auto;height:calc(100% - 80px)\"> <table class=\"table table-hover\"> <thead> <tr> <th translate>Name</th> <th translate>Status</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.employeeAvailability | limitTo: 10\"> <td>{{ item.employeeDisplayName }}</td> <td>{{ item.status }}</td> </tr> </tbody> </table> </div> <div class=pull-right style=cursor:pointer;line-height:50px ui-sref=hr.availability><span translate>More</span>...</div> </div> </div>";

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\"> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Verjaardagen</h4> <small class=text-uppercase>Eerst volgende 10 verjaardagen</small></div> <a href=javascript:; class=widget-list-item ng-repeat=\"employee in $ctrl.employees | limitTo:10\"> <span class=\"label label-info pull-right\">{{employee.birthday | date : 'dd-MM'}}</span>{{employee.displayName}} </a> </div> </div>";

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "<div class=main-content style=\"position:relative;height:calc(100vh - 75px)\"> <div class=dashboard-container id=dashboard permission permission-only=\"['BACKOFFICE']\"> <div class=col-md-6 style=height:100%;overflow:hidden> <div class=row style=height:50%;overflow:hidden;margin-bottom:10px> <div class=\"col-md-12 mt0\" style=height:100%;overflow:hidden> <dashboard-notes-component></dashboard-notes-component> </div> </div> <div class=row style=height:50%;overflow:hidden> <div class=\"col-md-12 mt0\" style=height:100%;overflow:hidden> <dashboard-news-component></dashboard-news-component> </div> </div> </div> <div class=col-md-6 style=height:100%;overflow:hidden> <div class=row style=height:50%;overflow:hidden;margin-bottom:10px> <div class=col-md-6 style=height:100%;overflow:hidden> <dashboard-available-employees-component></dashboard-available-employees-component> </div> <div class=\"col-md-6 mt0\" style=height:100%;overflow:hidden> <dashboard-timesheets-summary-component></dashboard-timesheets-summary-component> </div> </div> <div class=row style=height:50%;overflow:hidden> <div class=\"col-md-12 mt0\" style=height:100%;overflow:hidden> <dashboard-tasks-component></dashboard-tasks-component> </div> </div> </div> </div> </div>";

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:100%;overflow:hidden> <div class=\"widget-details widget-list\" style=height:100%;overflow:hidden> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Open diensten</h4> <small class=text-uppercase>Niet ingevulde diensten voor komende week</small> </div> <div style=\"height:calc(100% - 60px);overflow:auto\"> <a ui-sref=\"\" class=widget-list-item ng-repeat=\"shift in $ctrl.shifts\"> <b>{{shift.teamLocationName}} - {{shift.teamName}}</b> <span class=\"chip status-chip pull-right\" ng-style=\"{background: shift.statusColor}\" ng-if=shift.status>{{ shift.statusName }} <span ng-if=\"shift.status==2\">({{ shift.subscriptionsCount }})</span></span> <br/> <span ng-if=\"!$ctrl.isSameDay(shift.start, shift.end)\">{{ shift.start | date :\"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(shift.start, shift.end)\">{{ shift.start | date :\"HH:mm\" }}</span> <span translate>to</span> {{ shift.end | date :\"HH:mm dd-MM-yyyy\" }} </a> </div> </div> </div>";

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = " <div class=\"widget bg-white\" style=height:100%> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Vaardigheden</h4> <small class=text-uppercase>Vaardigheden die komende maand verlopen</small> <a href=javascript:; class=widget-list-item ng-repeat=\"skill in $ctrl.skills | limitTo:10\"> <span class=\"label label-info pull-right\" ng-class=\"$ctrl.isExpired(skill.end) ? 'label-danger' : 'label-info'\">{{skill.end | date : 'dd-MM-yyyy'}}</span><b>{{skill.employee.displayName}}</b><br/> <span> {{skill.skillName}} </span> </a> </div> </div></div>";

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:calc(100%)> <div class=\"widget-details widget-list\"> <div class=mb20> <div class=row> <h4 class=\"no-margin text-uppercase col-md-7\">Laatst toegevoegde nieuws</h4> <div class=\"buttons col-md-5\" permission permission-only=\"['BACKOFFICE']\"> <button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=\"dashboard.newsitem({'id': ''})\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Add News Item</span> </button> </div> </div> <div class=row> <div class=col-md-12 permission permission-only=\"['BACKOFFICE']\"> <hr/> <div class=col-md-6> <label> <input type=checkbox ng-model=$ctrl.all ng-change=$ctrl.setAll() /> Toon alle items </label> </div> <div class=col-md-6> </div> <hr/> </div> </div> </div> <div style=\"overflow-y:auto;height:calc(100% - 150px)\"> <div ng-repeat=\"item in $ctrl.news | limitTo: 10\" ui-sref=\"dashboard.newsitem({'id': item.id})\"> <div class=\"list-line heading-line\"> <div style=position:relative;height:20px> <div class=pull-left>{{item.createdDate | date : 'dd-MM'}} {{item.title}}</div> <div class=pull-right> <span class=badge ng-repeat=\"type in item.newsItemTypeList\" style=margin-left:2px>{{$ctrl.getType(type)}}</span> </div> </div> </div> <div class=list-line> {{item.text}} </div> </div> </div> </div> </div>";

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>News item</h4> </div> <div class=modal-body> <form class=form role=form id=newsBasicInfoForm ng-submit=$ctrl.save()> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Titel</label> <input class=form-control name=title ng-model=$ctrl.newsItem.title> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Tekst</label> <textarea class=form-control name=text rows=6 ng-model=$ctrl.newsItem.text></textarea> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Type</label> <select class=\"form-control chosen\" multiple=multiple chosen=$ctrl.newsItemTypes ng-model=$ctrl.newsItem.newsItemTypeList name=newsItemTypeList ng-options=\"item.id as item.name for item in $ctrl.newsItemTypes\"> </select> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Aanmaak datum</label> <date-time-picker-component date=$ctrl.newsItem.createdDate time=false></date-time-picker-component> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Verlopen datum</label> <date-time-picker-component date=$ctrl.newsItem.expireDate time=false></date-time-picker-component> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-danger btn-sm btn-icon\" ng-click=$ctrl.delete() ng-if=$ctrl.newsItem.id><i class=\"fa fa-trash\"></i><span translate>Delete</span></button> <button class=\"btn btn-success btn-icon btn-sm mr5\" type=submit form=newsBasicInfoForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:calc(100%)> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Laatst toegevoegde notities</h4> </div> <div style=\"overflow-y:auto;height:calc(100% - 80px)\"> <table class=\"table table-hover\"> <thead> <tr> <th translate>Account/Employee/Applicant</th> <th translate>Description</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.notes | limitTo: 10\"> <td>{{$ctrl.getNoteAuthorName(item)}}</td> <td>{{item.description}}</td> </tr> </tbody> </table> </div> <div class=pull-right style=cursor:pointer;line-height:50px ui-sref=notes><span translate>More</span>...</div> </div> </div> ";

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:calc(100%)> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Openstaande taken</h4> </div> <div style=\"overflow-y:auto;height:calc(100% - 80px)\"> <table class=\"table table-hover\"> <thead> <tr> <th translate>Description</th> <th translate>End date</th> <th translate>User</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.tasks | limitTo: 10\"> <td>{{ item.description }}</td> <td>{{ item.date | date : \"dd-MM-yyyy\" }}</td> <td>{{ item.userName }}</td> </tr> </tbody> </table> </div> <div class=pull-right style=cursor:pointer;line-height:50px ui-sref=tasks><span translate>More</span>...</div> </div> </div>";

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "<div class=\"widget bg-white\" style=height:calc(100%)> <div class=\"widget-details widget-list\"> <div class=mb20> <h4 class=\"no-margin text-uppercase\">Totaal ingeplande uren</h4> </div> <div style=\"overflow-y:auto;height:calc(100% - 40px)\"> <timesheets-summary-component employees=$ctrl.timesheetsWeek1 style=display:inline-block;margin-top:0;width:100% ng-if=$ctrl.timesheetsWeek1></timesheets-summary-component> <timesheets-summary-component employees=$ctrl.timesheetsWeek2 style=display:inline-block;margin-top:10px;width:100% ng-if=$ctrl.timesheetsWeek2></timesheets-summary-component> </div> </div> </div>";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"col-lg-6 col-md-6 col-md-offset-1 col-lg-offset-1\"> <div class=item> <h3>Hoe schrijf ik in voor een dienst?</h3> <div class=thumbnail> <img src=" + __webpack_require__(364) + " class=img alt=\"kies het kopje inschrijven\" title=inschrijven> <div class=caption> <p>Ga naar het menuitem 'inschrijven'.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(363) + " class=img> <div class=caption> <ol> <li>Kies een dienst waarvoor je je wil inschrijven.</li> <li>Verstuur een verzoek.</li> </ol> </div> </div> </div> <hr id=2> <div class=item> <h3>Hoe kan ik mijn beschikbaarheid aangeven?</h3> <div class=thumbnail> <img src=" + __webpack_require__(354) + " class=img> <div class=caption> <p>Klik op de knop Beschikbaarheid toevoegen.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(143) + " class=img> <div class=caption> <ol> <li>Kies een start en einddatum en/of -tijd.</li> <li>Klik om het menu met de beschikbaarheidsopties uit te klappen.</li> </ol> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(355) + " class=img> <div class=caption> <p>Selecteer de optie die van toepassing is.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(143) + " class=img> <div class=caption> <ol start=3> <li>Omschrijf de reden van het verzoek.</li> <li>Sla de aanvraag op.</li> </ol> </div> </div> </div> <hr id=3> <div class=item> <h3>Hoe maak ik zelf een dienst aan?</h3> <div class=thumbnail> <img src=" + __webpack_require__(356) + " class=img> <div class=caption> <p>Klik op de knop Dienst toevoegen.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(357) + " class=img> <div class=caption> <ol> <li>Geef de start en eindtijd aan.</li> </ol> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(358) + " class=img> <div class=caption> <p>Geef aan in welke functie je gaat werken.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(359) + " class=img> <div class=caption> <p>Geef aan voor wie je gaat werken.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(360) + " class=img> <div class=caption> <p>Kies een Locatie.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(361) + " class=img> <div class=caption> <p>Kies dan een Team.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(362) + " class=img> <div class=caption> <ol> <li>Schrijf een klantreferentie.</li> <li>Sla op met de knop opslaan voor een enkele dienst, opslaan en kopieren voor dezelfde dienst de volgende dag en opslaan en nieuwe om een nieuwe dienst aan te maken</li> </ol> </div> </div> </div> <hr id=4> <div class=item> <h3>Hoe declareer ik mijn uren?</h3> <div class=thumbnail> <img src=" + __webpack_require__(365) + "> <div class=caption> <p>Klik op een dienst in de agenda om naar het weekoverzicht te gaan.</p> </div> </div> <p><b>Je wordt nu doorverwezen naar het weekoverzicht.</b></p> <div class=thumbnail> <img src=" + __webpack_require__(366) + "> <div class=caption> <ol> <li>Klik op de betreffende dienst.</li> <li>Klik op het icoontje met de klok.</li> </ol> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(367) + "> <div class=caption id=5> <ol> <li>Bevestig of wijzig de start en eindtijd van de dienst.</li> <li>Schrijf eventueel een korte beschrijving in het geval van bijzonderheden.</li> <li>Klik op opslaan om de dienst te bevestigen.</li> </ol> </div> </div> <h4>In het geval van reiskosten en/of onkosten vergoeding.</h4> <div class=thumbnail> <img src=" + __webpack_require__(368) + "> <div class=caption> <p>Klik op het icoontje met de auto.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(370) + "> <div class=caption> <p>Klik op 'select an option'.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(369) + "> <div class=caption> <p>Kies de onkostenvergoeding die van toepassing is.</p> </div> </div> <div class=thumbnail> <img src=" + __webpack_require__(371) + "> <div class=caption> <ol> <li>In het geval van kilometervergoeding verschijnt er een veld voor het aantal gereden kilometers.</li> <li>Voer de beschrijving van de gemaakte onkosten in (verplicht in alle gevallen buiten kilometervergoeding).</li> <li>Verstuur het verzoek voor de onkostenvergoeding.</li> </ol> </div> </div> </div> </div> <div class=\"col-md-offset-1 col-lg-offset-1 col-lg-3 col-md-3\"> <ul class=\"documentationmenu affix\"> <li><a href=#>Hoe schrijf ik mij in voor een dienst?</a></li> <li><a href=#2>Hoe kan ik een verlofverzoek indienen?</a></li> <li><a href=#3>Hoe maak ik zelf een dienst aan?</a></li> <li><a href=#4>Hoe declareer ik mijn uren?</a></li> <ul class=submenu> <li><a href=#5>Onkostenvergoeding</a></li> </ul> </ul> </div>";

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^.^ ng-if=!$ctrl.applicant.id aria-label=Close><span aria-hidden=true>&times;</span></a> <a class=close ui-sref=^ ng-if=$ctrl.applicant.id aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Applicant basic information</h4> </div> <div class=modal-body> <form class=form role=form id=applicantBasicInfoForm ng-submit=$ctrl.save()> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" ng-class=\"{ 'has-error': applicantForm.name.$touched && applicantForm.name.$invalid || applicantForm.$submitted && applicantForm.name.$invalid}\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.applicant.name required ng-disabled=\"$ctrl.applicant.nmbrsId > 0\"> <div ng-messages=applicantForm.name.$error ng-show=\"applicantForm.name.$touched || applicantForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-6\"> <label translate>Email</label> <input class=form-control name=email ng-model=$ctrl.applicant.email> </div> <div class=\"form-group col-md-6\"> <label translate>Phone</label> <input class=form-control name=phoneNumber ng-model=$ctrl.applicant.phoneNumber> </div> <div class=\"form-group col-md-6\"> <label translate>City</label> <input class=form-control name=city ng-model=$ctrl.applicant.city> </div> <div class=\"form-group col-md-6\"> <label translate>Beschikbaar vanaf</label> <date-time-picker-component date=$ctrl.applicant.date time=false></date-time-picker-component> </div> <div class=\"form-group col-md-6\"> <label translate>Age</label> <input class=form-control name=age ng-model=$ctrl.applicant.age> </div> <div class=\"form-group col-md-6\"> <label translate>Job offer</label> <input class=form-control name=jobOffer ng-model=$ctrl.applicant.jobOffer> </div> <div class=\"form-group col-md-6\"> <label translate>I know Operando from</label> <input class=form-control name=iKnowOperandoFrom ng-model=$ctrl.applicant.iKnowOperandoFrom> </div> <div class=\"form-group col-md-6\"> <label translate>Recruiter</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.applicant.userId name=userId ng-options=\"item.id as item.userName for item in $ctrl.users\"> <option value=\"\"></option> </select> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': applicantForm.preferredTargetAudience.$touched && applicantForm.preferredTargetAudience.$invalid || applicantForm.$submitted && applicantForm.preferredTargetAudience.$invalid}\"> <label translate>Preferred target audience</label> <select class=\"form-control chosen\" chosen name=preferredTargetAudience ng-model=$ctrl.applicant.preferredTargetAudienceId ng-options=\"item.id as item.name for item in $ctrl.preferredTargetAudiences | orderBy: 'name'\"> <option value=\"\">Select preferred target audience</option> </select> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': applicantForm.applicationStatus.$touched && applicantForm.applicationStatus.$invalid || applicantForm.$submitted && applicantForm.applicationStatus.$invalid}\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen name=applicationStatus ng-model=$ctrl.applicant.applicationStatusId ng-options=\"item.id as item.name for item in $ctrl.applicationStatuses | orderBy: 'name'\"> <option value=\"\">Select status</option> </select> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': applicantForm.function.$touched && applicantForm.function.$invalid || applicantForm.$submitted && applicantForm.function.$invalid}\"> <label translate>Function</label> <select class=\"form-control chosen\" chosen name=function ng-model=$ctrl.applicant.functionId ng-options=\"item.id as item.name for item in $ctrl.functions | orderBy: 'name'\"> <option value=\"\">Select function</option> </select> </div> <div class=\"form-group col-md-12\"> <label> <input type=checkbox ng-model=$ctrl.applicant.zzp /> ZZP'er</label> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon btn-sm mr5\" type=submit form=applicantBasicInfoForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^.^ ng-if=!$ctrl.applicant.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^ ng-if=$ctrl.applicant.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Create employee</h4> </div> <div class=modal-body> <form class=form role=form id=applicantEmployeeInfoForm ng-submit=$ctrl.save()> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" ng-class=\"{ 'has-error': applicantForm.name.$touched && applicantForm.name.$invalid || applicantForm.$submitted && applicantForm.name.$invalid}\"> <label translate>First name</label> <input class=form-control name=firstName ng-model=$ctrl.employee.firstName required ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> <div ng-messages=applicantForm.name.$error ng-show=\"applicantForm.name.$touched || applicantForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-6\" ng-class=\"{ 'has-error': applicantForm.name.$touched && applicantForm.name.$invalid || applicantForm.$submitted && applicantForm.name.$invalid}\"> <label translate>Last name</label> <input class=form-control name=lastName ng-model=$ctrl.employee.lastName required ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> <div ng-messages=applicantForm.name.$error ng-show=\"applicantForm.name.$touched || applicantForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-6\"> <label translate>Email</label> <input class=form-control name=email ng-model=$ctrl.employee.emailPrivate> </div> <div class=\"form-group col-md-6\"> <label translate>Phone</label> <input class=form-control name=telephoneMobilePrivate ng-model=$ctrl.employee.telephoneMobilePrivate> </div> <div class=\"form-group col-md-9\"> <label translate>Street</label> <input class=\"form-control col-md-9\" name=street ng-model=$ctrl.employee.homeAddress.street> </div> <div class=\"form-group col-md-3\"> <label translate>Number</label> <input class=form-control name=street ng-model=$ctrl.employee.homeAddress.number> </div> <div class=\"form-group col-md-3\"> <label translate>Zip</label> <input class=form-control name=zip ng-model=$ctrl.employee.homeAddress.zip> </div> <div class=\"form-group col-md-9\"> <label translate>City</label> <input class=form-control name=city ng-model=$ctrl.employee.homeAddress.city> </div> <div class=\"form-group col-md-6\"> <label translate>Country</label> <input class=form-control name=city ng-model=$ctrl.employee.homeAddress.country> </div> <div class=\"form-group col-md-6\"> <label translate>BSN</label> <input class=form-control name=bsn ng-model=$ctrl.employee.bsn> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': applicantForm.function.$touched && applicantForm.function.$invalid || applicantForm.$submitted && applicantForm.function.$invalid}\"> <label translate>Function</label> <select class=\"form-control chosen\" chosen name=function ng-model=$ctrl.employee.functionId ng-options=\"item.id as item.name for item in $ctrl.functions | orderBy: 'name'\"> <option value=\"\">Select function</option> </select> </div> <div class=\"form-group col-md-12\"> <label> <input type=checkbox ng-model=$ctrl.employee.zzp /> ZZP'er</label> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon btn-sm mr5\" type=submit form=applicantEmployeeInfoForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=hr.applicants translate ng-if=!$ctrl.archive>Sollicitanten</a> <a ui-sref=hr.applicants.archive translate ng-if=$ctrl.archive>Sollicitanten archief</a> </li> <li class=active> <a>{{$ctrl.applicant.name}}</a> </li> </ol> </div> <div class=buttons> <a ng-click=$ctrl.deleteApplicant() class=\"btn btn-danger btn-sm btn-icon pull-right mr5\"> <i class=\"fa fa-trash mr5\"></i> <span translate>Delete applicant</span> </a> <a ng-click=$ctrl.archiveApplicant() class=\"btn btn-warning btn-sm btn-icon pull-right mr5\" ng-if=!$ctrl.archive> <i class=\"fa fa-archive mr5\"></i> <span translate>Plaats in archief</span> </a> <a ng-click=$ctrl.unarchiveApplicant() class=\"btn btn-warning btn-sm btn-icon pull-right mr5\" ng-if=$ctrl.archive> <i class=\"fa fa-archive mr5\"></i> <span translate>Verplaats naar sollicitanten</span> </a> <a ui-sref=\"hr.applicants.item.employee({'id': $ctrl.applicant.id})\" class=\"btn btn-primary btn-sm btn-icon pull-right mr5\" ng-if=\"!$ctrl.applicant.employeeId && !$ctrl.archive\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Create employee</span> </a> </div> </div> <div class=row> <div class=col-md-4> <div class=\"panel panel-primary\"> <div class=panel-heading> <div class=pull-left translate>Basic info</div> <div class=panel-controls> <a ui-sref=\"hr.applicants.item.basic({'id': $ctrl.applicant.id})\" ng-if=!$ctrl.archive><i class=\"fa fa-edit\"></i></a> <a ui-sref=\"hr.applicants.archiveitem.basic({'id': $ctrl.applicant.id})\" ng-if=$ctrl.archive><i class=\"fa fa-edit\"></i></a> </div> </div> <div class=\"panel-body p25\"> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Name:</b></div> <div class=col-xs-7>{{$ctrl.applicant.name}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Email:</b></div> <div class=col-xs-7>{{$ctrl.applicant.email}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>City:</b></div> <div class=col-xs-7>{{$ctrl.applicant.city}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Age:</b></div> <div class=col-xs-7>{{$ctrl.applicant.age}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Function:</b></div> <div class=col-xs-7>{{$ctrl.applicant.functionName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Beschikbaar vanaf:</b></div> <div class=col-xs-7>{{$ctrl.applicant.date | date : \"dd-MM-yyyy\"}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Preferred target audience:</b></div> <div class=col-xs-7>{{$ctrl.applicant.preferredTargetAudienceName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Notitie:</b></div> <div class=col-xs-7>{{$ctrl.applicant.note}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Job offer:</b></div> <div class=col-xs-7>{{$ctrl.applicant.jobOffer}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Email:</b></div> <div class=col-xs-7>{{$ctrl.applicant.email}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>I know Operando from:</b></div> <div class=col-xs-7>{{$ctrl.applicant.iKnowOperandoFrom}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Status:</b></div> <div class=col-xs-7>{{$ctrl.applicant.applicationStatusName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Recruiter:</b></div> <div class=col-xs-7>{{$ctrl.applicant.userName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>ZZP'er:</b></div> <div class=col-xs-7> <span ng-if=$ctrl.applicant.zzp>Ja</span> <span ng-if=!$ctrl.applicant.zzp>Nee</span> </div> </div> </div> </div> </div> <div class=col-md-8> <uib-tabset active=$ctrl.activeTabIndex justified=true class=primary> <uib-tab index=0> <uib-tab-heading translate>Notes</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <select id=tag-filter ng-change=$ctrl.filterNotes() ng-model=$ctrl.selectedTag> <option value=\"\">-- Selecteer een Kenmerk --</option> <option ng-repeat=\"tag in $ctrl.tags\" value=\"{{ tag.name }}\">{{ tag.name }}</option> </select> <a ng-click=$ctrl.addNoteModal() class=\"btn btn-info btn-sm btn-icon\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Add note</span></a> </div> </div> <div class=panel-body> <list-component list=$ctrl.filteredNotes on-update=\"$ctrl.updateNote(item, action)\"></list-component> </div> </div> </uib-tab> <uib-tab index=1> <uib-tab-heading translate>Files</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <file id=myUploader name=document ng-model=$ctrl.uploadfile accept=* ng-change=$ctrl.uploadAll() style=display:none /> <a ng-click=$ctrl.clickUpload() class=\"btn btn-info btn-sm btn-icon\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Upload file</span></a> </div> </div> <div class=panel-body> <table class=table> <tr ng-repeat=\"file in $ctrl.files\"> <td>{{file.name}}</td> <td> <button class=\"btn btn-xs pull-right btn-info\" ng-click=$ctrl.downloadFile(file)>Download</button> <button class=\"btn btn-xs pull-right btn-danger\" ng-click=$ctrl.deleteFile(file.id) style=margin-right:5px>Delete</button> </td> </tr> </table> </div> </div> </uib-tab> <uib-tab index=2> <uib-tab-heading translate>Status history</uib-tab-heading> <div class=panel> <div class=panel-body> <list-component list=$ctrl.applicationStatusHistories hide-delete=true></list-component> </div> </div> </uib-tab> </uib-tabset> </div> </div> <div class=modal id=noteModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Notes</h4> </div> <crm-note-component note=$ctrl.currentNote on-update=$ctrl.submitNote(note)></crm-note-component> </div> </div> </div>";

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title style=width:200px> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate ng-if=!$ctrl.archive>Applicants</a> <a translate ng-if=$ctrl.archive>Sollicitanten archief</a> </li> </ol> </div> <div class=\"buttons pull-right\" style=width:680px> <button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=\"hr.applicants.item.basic({'id': ''})\" ng-if=!$ctrl.archive><i class=\"fa fa-plus mr5\"></i><span translate>Add Applicant</span></button> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-12> <input class=form-control name=search ng-model=$ctrl.search placeholder=\"{{'search' | translate}}\" ng-change=$ctrl.getApplicants() /> </div> </div> <div class=row> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.functionFilter placeholder=\"Selecteer een functie\" ng-options=\"item.id as item.name for item in $ctrl.functions\" ng-change=$ctrl.filter()> <option value=\"\">Filter op functie</option> </select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.targetAudienceFilter placeholder=\"choose an audience\" ng-options=\"item.id as item.name for item in $ctrl.preferredTargetAudiences\" ng-change=$ctrl.filter()> <option value=\"\">Filter op doelgroep</option> </select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.userFilter placeholder=\"choose an audience\" ng-options=\"item.id as item.userName for item in $ctrl.users | orderBy: 'userName'\" ng-change=$ctrl.filter()> <option value=\"\">Filter op recruiter</option> </select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.statusFilter placeholder=\"Selecteer een status\" ng-options=\"item.id as item.name for item in $ctrl.applicationStatuses | orderBy: 'name'\" ng-change=$ctrl.filter()> <option value=\"\">Filter op status</option> </select> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'name'; sortReverse = !sortReverse\"> <span translate>Name</span> <span ng-show=\"$ctrl.sortType == 'name' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'name' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'city'; sortReverse = !sortReverse\"> <span translate>City</span> <span ng-show=\"$ctrl.sortType == 'city' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'city' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'preferredTargetAudienceName'; sortReverse = !sortReverse\"> <span translate>Target audience</span> <span ng-show=\"$ctrl.sortType == 'preferredTargetAudienceName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'preferredTargetAudienceName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'userName'; sortReverse = !sortReverse\"> <span translate>Recruiter</span> <span ng-show=\"$ctrl.sortType == 'userName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'userName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'firstStatusDate'; sortReverse = !sortReverse\"> <span translate>First Status</span> <span ng-show=\"$ctrl.sortType == 'firstStatusDate' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'firstStatusDate' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'lastStatusDate'; sortReverse = !sortReverse\"> <span translate>Last Status</span> <span ng-show=\"$ctrl.sortType == 'lastStatusDate' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'lastStatusDate' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'applicationStatusName'; sortReverse = !sortReverse\"> <span translate>Status</span> <span ng-show=\"$ctrl.sortType == 'applicationStatusName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'applicationStatusName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"hr.applicants.item({'id': item.id})\" ng-repeat=\"item in $ctrl.filteredApplicants | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\" ng-if=!$ctrl.archive> <td style=width:16%> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=12></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.name }}</span> <div style=margin-left:50px> <span ng-if=item.functionName class=\"chip chip-info\">{{ item.functionName }}</span> </div> </td> <td style=width:16%>{{ item.city }}</td> <td style=width:16%>{{ item.preferredTargetAudienceName }}</td> <td style=width:16%>{{ item.userName }}</td> <td style=width:16%>{{ item.firstStatusDate | date : \"dd-MM-yyyy HH:mm\" }}</td> <td style=width:16%>{{ item.lastStatusDate | date : \"dd-MM-yyyy HH:mm\" }}</td> <td style=width:16%>{{ item.applicationStatusName }}</td> </tr> <tr ui-sref=\"hr.applicants.archiveitem({'id': item.id})\" ng-repeat=\"item in $ctrl.filteredApplicants | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\" ng-if=$ctrl.archive> <td style=width:16%> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=12></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.name }}</span> <div style=margin-left:50px> <span ng-if=item.functionName class=\"chip chip-info\">{{ item.functionName }}</span> </div> </td> <td style=width:16%>{{ item.city }}</td> <td style=width:16%>{{ item.preferredTargetAudienceName }}</td> <td style=width:16%>{{ item.userName }}</td> <td style=width:16%>{{ item.firstStatusDate | date : \"dd-MM-yyyy\" }}</td> <td style=width:16%>{{ item.lastStatusDate | date : \"dd-MM-yyyy\" }}</td> <td style=width:16%>{{ item.applicationStatusName }}</td> </tr> </tbody> </table> <div class=datatable-bottom> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.filteredApplicants.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last ng-if=\"$ctrl.applicants.length > 0\"></ul> </div> </div> </div>";

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=search> <form class=form ng-submit=$ctrl.getAvailabilityByDate()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()> <i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=date-input> <date-time-picker-component date=$ctrl.startDate time=false add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=date-input style=width:auto;line-height:30px> tot </div> <div class=date-input> <date-time-picker-component date=$ctrl.endDate time=false add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.nextWeek()> <span translate>Next</span> <i class=\"fa fa-angle-right ml5\"></i> </button> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=submit> <i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> <div class=form-group> <select class=\"form-control input-sm\" ng-model=$ctrl.statusFilter ng-options=\"availability.name as availability.name for availability in $ctrl.avalabilityStatuses\" ng-change=$ctrl.setFilters()> <option value=\"\" translate>Filter by status</option> </select> </div> </div> </form> </div> </div> <div class=row> <div fixed-height style=overflow:hidden class=col-md-12> <div class=panel style=height:100%> <div class=panel-body style=height:100%;overflow:auto;padding:0> <table class=\"table table-hover\"> <thead> <tr> <th style=width:10% translate>Startdatum</th> <th style=width:10% translate>Einddatum</th> <th style=width:8% translate>Starttijd</th> <th style=width:8% translate>Eindtijd</th> <th style=width:15% translate>Name</th> <th style=width:13% translate>Function</th> <th style=width:10% translate>Status</th> <th style=width:25%>Note</th> </tr> </thead> <tbody> <tr ng-repeat=\"availability in $ctrl.availabilities | filter: (!!$ctrl.statusFilter || undefined) && { status: $ctrl.statusFilter }\"> <td> {{availability.start | date :\"dd-MM-yyyy\"}} </td> <td> {{availability.end | date :\"dd-MM-yyyy\"}} </td> <td> {{availability.start | date :\"HH:mm\"}} </td> <td>{{availability.end | date :\"HH:mm\"}}</td> <td> {{ availability.employeeDisplayName }} </td> <td> {{ availability.employeeFunctionName }} </td> <td> <span class=\"chip status-chip\" ng-if=availability.status> {{ availability.status }} </span> </td> <td> {{ availability.title }} </td> </tr> </tbody> </table> </div> </div> </div> </div>";

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button type=button class=\"btn btn-info btn-sm btn-icon mr5\" ui-sref=\"hr.employees.item.availability({'employeeId': $ctrl.employeeId, 'availabilityId': ''})\"> <i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span> </button> </div> </div> <div class=\"panel-body p15\"> <div class=calendar-viewer> <div ui-calendar=$ctrl.uiConfig.calendar class=fullcalendar calendar=employeeCalendar ng-model=$ctrl.eventSources></div> </div> </div> </div> ";

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Availability</h4> </div> <div class=modal-body> <form class=form role=form id=availabilityForm name=availabilityForm ng-submit=$ctrl.submitAvailability()> <div class=row style=padding:15px> <div class=form-group> <div class=\"form-group col-md-12\"> <label translate>Status</label> <select class=form-control name=client ng-model=$ctrl.availability.availabilityStatusId ng-options=\"item.id as item.name for item in $ctrl.statuses\" required> </select> </div> <div class=\"form-group col-md-12\"> <label translate>Title</label> <input class=form-control name=title ng-model=$ctrl.availability.title> </div> <div class=\"form-group col-md-12\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.availability.start max-date=$ctrl.availability.end></date-time-picker-component> </div> <div class=\"form-group col-md-12\"> <label translate>End</label> <date-time-picker-component date=$ctrl.availability.end min-date=$ctrl.availability.start></date-time-picker-component> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-sm btn-success btn-icon mr2\" type=submit form=availabilityForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-sm btn-danger btn-icon mr2\" type=button ng-click=$ctrl.delete(); ng-if=$ctrl.availability.id><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-sm btn-info btn-icon mr2\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^.^ ng-if=!$ctrl.employee.id aria-label=Close><span aria-hidden=true>&times;</span></a> <a class=close ui-sref=^ ng-if=$ctrl.employee.id aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Employee basic information</h4> </div> <div class=modal-body> <form class=form role=form id=employeeBasicInfoForm ng-submit=$ctrl.save()> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" ng-class=\"{ 'has-error': employeeForm.firstName.$touched && employeeForm.firstName.$invalid || employeeForm.$submitted && employeeForm.firstName.$invalid}\"> <label translate>First name</label> <input class=form-control name=firstName ng-model=$ctrl.employee.firstName required ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> <div ng-messages=employeeForm.firstName.$error ng-show=\"employeeForm.firstName.$touched || employeeForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-6\" ng-class=\"{ 'has-error': employeeForm.lastName.$touched && employeeForm.lastName.$invalid || employeeForm.$submitted && employeeForm.lastName.$invalid}\"> <label translate>Last name</label> <input class=form-control name=lastName ng-model=$ctrl.employee.lastName required ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> <div ng-messages=employeeForm.lastName.$error ng-show=\"employeeForm.lastName.$touched || employeeForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-12\"> <label translate>Type</label> <select multiple=multiple class=\"form-control chosen\" chosen ng-model=$ctrl.employee.tags name=tag ng-options=\"value for (key, value) in $ctrl.EnumService.employeeTypes\"> <option value=\"\"></option> </select> </div> <div class=\"form-group col-md-6\"> <label translate>Email</label> <input class=form-control name=emailPrivate ng-model=$ctrl.employee.emailPrivate ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-6\"> <label translate>Phone</label> <input class=form-control name=telephoneMobilePrivate ng-model=$ctrl.employee.telephoneMobilePrivate ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-9\"> <label translate>Street</label> <input class=\"form-control col-md-9\" name=street ng-model=$ctrl.employee.homeAddress.street ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-3\"> <label translate>Number</label> <input class=form-control name=street ng-model=$ctrl.employee.homeAddress.number ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-3\"> <label translate>Zip</label> <input class=form-control name=zip ng-model=$ctrl.employee.homeAddress.zip ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-9\"> <label translate>City</label> <input class=form-control name=city ng-model=$ctrl.employee.homeAddress.city ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-6\"> <label translate>Country</label> <input class=form-control name=city ng-model=$ctrl.employee.homeAddress.country ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-6\"> <label translate>BSN</label> <input class=form-control name=bsn ng-model=$ctrl.employee.bsn ng-disabled=\"$ctrl.employee.nmbrsId > 0\"> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': employeeForm.function.$touched && employeeForm.function.$invalid || employeeForm.$submitted && employeeForm.function.$invalid}\"> <label translate>Function</label> <select class=\"form-control chosen\" chosen name=function ng-model=$ctrl.employee.functionId ng-options=\"item.id as item.name for item in $ctrl.functions | orderBy: 'name'\" ng-if=\"!$ctrl.employee.nmbrsId > 0\"> <option value=\"\">Selecteer functie</option> </select> <input class=form-control ng-model=$ctrl.employee.functionName ng-if=\"$ctrl.employee.nmbrsId > 0\" disabled=disabled> </div> <div class=\"form-group col-md-12\"> <label translate>Salarisschalen (max 3, verschillende CAO's)</label> <div ng-repeat=\"ess in $ctrl.employeeSalaryScales track by ess.scaleNumber\" class=\"panel panel-default\" style=margin-bottom:10px> <div class=panel-body> <div class=row> <div class=col-md-1> <strong>Schaal {{ ess.scaleNumber }}:</strong> </div> <div class=col-md-11> <div ng-if=\"ess.salaryScale && ess.salaryScale.salaryScaleGroupId && ess.salaryScaleId\"> <div class=row> <div class=col-md-10> <strong> {{ $ctrl.getSalaryScaleGroupName(ess.salaryScale.salaryScaleGroupId) }} - {{ ess.salaryScale.name }} ({{ ess.salaryScale.code }}) </strong> </div> <div class=\"col-md-2 text-right\"> <button type=button class=\"btn btn-xs btn-danger\" ng-click=$ctrl.removeSalaryScale(ess.scaleNumber)> <i class=\"fa fa-trash\"></i> Verwijderen </button> </div> </div> </div> <div ng-if=\"!ess.salaryScale || !ess.salaryScale.salaryScaleGroupId || !ess.salaryScaleId\"> <div class=row> <div class=col-md-5> <label>CAO</label> <select class=form-control ng-model=ess.newSalaryScaleGroupId ng-options=\"group.id as group.name for group in $ctrl.getAvailableGroupsForScale(ess.scaleNumber) | orderBy:'name'\" ng-change=\"$ctrl.onGroupChange(ess.newSalaryScaleGroupId, ess.scaleNumber)\"> <option value=\"\">-- Selecteer CAO --</option> </select> </div> <div class=col-md-5> <label>Loonschaal</label> <select class=form-control ng-model=ess.newSalaryScaleId ng-options=\"scale.id as (scale.name + ' (' + scale.code + ')') for scale in $ctrl.availableScalesByGroup[ess.newSalaryScaleGroupId] | orderBy:'code'\" ng-disabled=!ess.newSalaryScaleGroupId> <option value=\"\">-- Selecteer loonschaal --</option> </select> </div> <div class=col-md-2> <label>&nbsp;</label> <button type=button class=\"btn btn-success btn-block\" ng-click=$ctrl.addSalaryScale(ess.scaleNumber) ng-disabled=\"!ess.newSalaryScaleGroupId || !ess.newSalaryScaleId\"> <i class=\"fa fa-plus\"></i> Toevoegen </button> </div> </div> <div ng-if=$ctrl.errorMessages[ess.scaleNumber] class=\"alert alert-danger\" style=margin-top:10px> {{ $ctrl.errorMessages[ess.scaleNumber] }} </div> </div> </div> </div> </div> </div> </div> <div class=\"form-group col-md-12\"> <label translate>Transportation type</label> <select class=\"form-control chosen\" chosen name=transportationType ng-model=$ctrl.employee.transportationTypeId ng-options=\"item.id as item.name for item in $ctrl.transportationTypes | orderBy: 'name'\"> <option value=\"\">Selecteer vervoerstype</option> </select> </div> <div class=\"form-group col-md-12\" ng-if=\"$ctrl.employee.zzp > 0\"> <label> <input type=checkbox ng-model=$ctrl.employee.incoiceMonthly /> Maandelijks factureren</label> </div> <div class=\"form-group col-md-12\" ng-if=!$ctrl.employee.id> <label> <input type=checkbox ng-model=$ctrl.employee.zzp /> ZZP'er</label> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon btn-sm mr5\" type=submit form=employeeBasicInfoForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^.^ ng-if=!$ctrl.employee.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^ ng-if=$ctrl.employee.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=hr.employees translate>Employees</a> </li> <li class=active> <a>{{$ctrl.employee.displayName}}</a> </li> </ol> </div> <div class=buttons> <a ng-click=$ctrl.refreshEmployeeNmbrs() class=\"btn btn-info btn-sm btn-icon pull-right mr5\" ng-if=\"$ctrl.employee.nmbrsId > 0\"> <i class=\"fa fa-refresh mr5\"></i> <span translate>Refresh employee from NMBRS</span> </a> <a ng-click=$ctrl.deleteEmployee() class=\"btn btn-danger btn-sm btn-icon pull-right mr5\" ng-if=!$ctrl.employee.inactive> <i class=\"fa fa-trash mr5\"></i> <span translate>Delete employee</span> </a> <a ng-click=$ctrl.restoreEmployee() class=\"btn btn-success btn-sm btn-icon pull-right mr5\" ng-if=\"$ctrl.employee.inactive && !$ctrl.employee.nmbrsId\"> <i class=\"fa fa-check mr5\"></i> <span translate>Restore employee</span> </a> </div> </div> <div class=row> <div class=col-md-4> <div class=\"panel panel-primary\"> <div class=panel-heading> <div class=pull-left translate>Basic info</div> <div class=panel-controls> <a ui-sref=\"hr.employees.item.basic({'id': $ctrl.employee.id})\"><i class=\"fa fa-edit\"></i></a> </div> </div> <div class=\"panel-body p25\"> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Name:</b></div> <div class=col-xs-7>{{$ctrl.employee.displayName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Tags:</b></div> <div class=col-xs-7><span class=chip ng-repeat=\"tag in $ctrl.employee.tags\">{{ tag }}</span></div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Username:</b></div> <div class=col-xs-7>{{$ctrl.employee.username}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Email:</b></div> <div class=col-xs-7>{{$ctrl.employee.emailPrivate}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Phone:</b></div> <div class=col-xs-7>{{$ctrl.employee.telephoneMobilePrivate}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.homeAddress.street || $ctrl.employee.homeAddress.number || $ctrl.employee.homeAddress.zip || $ctrl.employee.homeAddress.city || $ctrl.employee.homeAddress.country\"> <div class=col-md-5><b translate>Address</b></div> <div class=col-md-7>{{ $ctrl.employee.homeAddress.street }} {{ $ctrl.employee.homeAddress.number }} {{ $ctrl.employee.homeAddress.numberSuffix}} <br ng-if=$ctrl.employee.homeAddress.street> {{ $ctrl.employee.homeAddress.zip }} {{$ctrl.employee.homeAddress.city}} <br ng-if=\"$ctrl.employee.homeAddress.zip || $ctrl.employee.homeAddress.city\"> {{ $ctrl.employee.homeAddress.country}} </div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>BSN:</b></div> <div class=col-xs-7>{{$ctrl.employee.bsn}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Function:</b></div> <div class=col-xs-7>{{$ctrl.employee.functionName}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employeeSalaryScales && $ctrl.employeeSalaryScales.length > 0\"> <div class=col-xs-5><b>Loonschalen:</b></div> <div class=col-xs-7> <div ng-repeat=\"ess in $ctrl.employeeSalaryScales\" style=margin-bottom:5px> <span ng-if=ess.salaryScale> <strong>{{ $ctrl.getSalaryScaleGroupName(ess.salaryScale.salaryScaleGroupId) }}</strong> - {{ ess.salaryScale.name }} ({{ ess.salaryScale.code }}) </span> </div> </div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Transportation type:</b></div> <div class=col-xs-7>{{$ctrl.employee.transportationTypeName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Notes:</b></div> <div class=col-xs-7>{{$ctrl.employee.notes}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.nmbrsId > 0\"> <div class=col-xs-5><b translate>NmbrsId:</b></div> <div class=col-xs-7>{{$ctrl.employee.nmbrsId}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.nmbrsId > 0\"> <div class=col-xs-5><b translate>Personeelsnummer:</b></div> <div class=col-xs-7>{{$ctrl.employee.number}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.zzp > 0\"> <div class=col-xs-5><b translate>ZZP-nummer:</b></div> <div class=col-xs-7>{{$ctrl.employee.zzpNumber}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.zzp > 0\"> <div class=col-xs-7><b translate>Maandelijks factureren:</b></div> <div class=col-xs-5>{{$ctrl.employee.incoiceMonthly}}</div> </div> <div class=\"row mb5\" ng-if=\"$ctrl.employee.zzp > 0\"> <div class=\"col-xs-12 mb5\"><b translate>GUID voor Cootje:</b></div> <div class=\"col-xs-12 mb5\"><input class=form-control name=employeeGuid ng-model=$ctrl.employee.id ng-disabled=true></div> <div class=\"col-xs-12 mb5\">Selecteer de GUID en klik op CMD-C of CTRL-C</div> </div> </div> </div> </div> <div class=col-md-8> <uib-tabset active=$ctrl.activeTabIndex justified=true class=primary> <uib-tab index=0 permission permission-only=\"['BACKOFFICE']\"> <uib-tab-heading translate>Work history</uib-tab-heading> <shifts-list-component history=$ctrl.history></shifts-list-component> </uib-tab> <uib-tab index=1> <uib-tab-heading translate>Notes</uib-tab-heading> <div class=panel> <div class=panel-heading> <div class=panel-controls> <select id=tag-filter ng-change=$ctrl.filterNotes() ng-model=$ctrl.selectedTag> <option value=\"\">-- Selecteer een Kenmerk --</option> <option ng-repeat=\"tag in $ctrl.tags\" value=\"{{ tag.name }}\">{{ tag.name }}</option> </select> <a ng-click=$ctrl.addNoteModal() class=\"btn btn-info btn-sm btn-icon\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Add note</span></a> </div> </div> <div class=panel-body> <list-component list=$ctrl.filteredNotes on-update=\"$ctrl.updateNote(item, action)\"></list-component> </div> </div> </uib-tab> <uib-tab index=3 select=\"render = true\"> <uib-tab-heading translate>Availability</uib-tab-heading> <availability-calendar-component employee-id=$ctrl.employee.id ng-if=\"render == true\"></availability-calendar-component> </uib-tab> <uib-tab index=4> <uib-tab-heading translate>Skills</uib-tab-heading> <skills-list-component employee-skills=$ctrl.employeeSkills></skills-list-component> </uib-tab> <uib-tab index=5> <uib-tab-heading translate>User-Account</uib-tab-heading> <user-account-component employee=$ctrl.employee></user-account-component> </uib-tab> <uib-tab index=6 permission permission-only=\"['FINANCE']\" ng-if=\"$ctrl.employee.nmbrsId > 0\"> <uib-tab-heading translate>Nmbrs</uib-tab-heading> <nmbrs-component nmbrs-employee=$ctrl.nmbrsEmployee nmbrs-employee-address=$ctrl.nmbrsEmployeeAddress nmbrs-employee-bank-account=$ctrl.nmbrsEmployeeBankAccount nmbrs-employee-function=$ctrl.nmbrsEmployeeFunction nmbrs-employee-salary=$ctrl.nmbrsEmployeeSalary nmbrs-employee-contract=$ctrl.nmbrsEmployeeContract functions=$ctrl.functions></nmbrs-component> </uib-tab> </uib-tabset> </div> </div> <div class=modal id=noteModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Notes</h4> </div> <crm-note-component note=$ctrl.currentNote on-update=$ctrl.submitNote(note)></crm-note-component> </div> </div> </div>";

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar style=\"\"> <div class=title style=width:200px> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Employees</a> </li> </ol> </div> <div class=\"buttons pull-right\" style=width:680px> <button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=\"hr.employees.item.basic({'id': ''})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Employee</span></button> <button class=\"pull-right btn btn-primary btn-icon btn-sm mr5\" ngclipboard data-clipboard-text={{$ctrl.emailaddresses}} ngclipboard-success=$ctrl.onCopySuccess(e);><i class=\"fa fa-copy mr5\"></i><span translate>Get emails</span></button> <button ng-click=$ctrl.refreshEmployeesNmbrs() class=\"btn btn-info btn-sm btn-icon pull-right mr5\"> <i class=\"fa fa-refresh mr5\"></i> <span translate>Refresh all employees from NMBRS</span> </button> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control name=search ng-model=$ctrl.search placeholder=\"{{'search' | translate}}\" ng-change=$ctrl.getEmployees() /> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.tag placeholder=\"{{'choose a tag' | translate }}\" ng-options=\"value for (key, value) in $ctrl.EnumService.employeeTypes\" ng-change=$ctrl.getEmployees()> <option value=\"\">filter op kenmerk</option> </select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.accountingFilter placeholder=\"{{'choose a status' | translate }}\" ng-change=$ctrl.getEmployees()> <optiono value=\"\" translate>filter op dienstverband</optiono> <option value=zzp translate>ZZP</option> <option value=nmbrs translate>NMBRS</option> </select> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.statusFilter placeholder=\"{{'choose a status' | translate }}\" ng-change=$ctrl.getEmployees()> <option value=\"\" translate>Active</option> <option value=inactive translate>Inactive</option> </select> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:28%> <a href=# ng-click=\"$ctrl.sortType = 'displayName'; sortReverse = !sortReverse\"> <span translate>Name</span> <span ng-show=\"$ctrl.sortType == 'displayName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'displayName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:28%> <a href=# ng-click=\"$ctrl.sortType = 'homeAddressCity'; sortReverse = !sortReverse\"> <span translate>Woonplaats</span> <span ng-show=\"$ctrl.sortType == 'homeAddressCity' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'homeAddressCity' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:28%> <a href=# ng-click=\"$ctrl.sortType = 'telephoneMobilePrivate'; sortReverse = !sortReverse\"> <span translate>Phone</span> <span ng-show=\"$ctrl.sortType == 'telephoneMobilePrivate' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'telephoneMobilePrivate' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:16%> <a href=# ng-click=\"$ctrl.sortType = 'nmbrsId'; sortReverse = !sortReverse\"> <span translate></span> <span ng-show=\"$ctrl.sortType == 'nmbrsId' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'nmbrsId' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"hr.employees.item({'id': item.id})\" ng-repeat=\"item in $ctrl.filteredEmployees | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <td style=width:28%> <ng-letter-avatar data=\"{{ item.displayName }}\" shape=round charcount=2 height=30px width=30px fontsize=12></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.displayName }}</span> <div style=margin-left:50px> <span ng-if=item.functionName class=\"chip chip-info\">{{item.functionName}}</span> <span ng-repeat=\"tag in item.tags\" class=chip>{{ tag }}</span> </div> </td> <td style=width:28%>{{ item.homeAddressCity }}</td> <td style=width:28%>{{ item.telephoneMobilePrivate }}</td> <td style=width:16%>{{ item.nmbrsId ? 'Nmbrs' : 'ZZP' }}</td> </tr> </tbody> </table> <div class=datatable-bottom> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.filteredEmployees.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last ng-if=\"$ctrl.employees.length > 0\"></ul> </div> </div> </div> <div class=modal id=notificationModal tabindex=-1 role=dialog aria-labelledby=myModalLabel data-backdrop=static data-keyboard=false> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <h4 class=modal-title translate>Sync with Nmbrs</h4> </div> <div class=modal-body> <div>Bezig met het synchoniseren van medewerkers. Dit kan even duren...</div> </div> <div class=modal-footer> <button type=button class=\"btn btn-primary\" data-dismiss=modal ng-disabled=$ctrl.inProgress>Close</button> </div> </div> </div> </div>";

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "HrDashboard";

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=\"panel-body p15\"> <uib-tabset active=$ctrl.activeTabIndex class=\"primary vertical\" vertical=true> <uib-tab index=0> <uib-tab-heading translate>Personal info</uib-tab-heading> <div class=p15> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>Display name:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.displayName }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>First name:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.firstName }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Last name:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.lastName }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Nickname:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.nickname }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Gender:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.gender }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Country of birth:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.countryOfBirthISOCode }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Marital status:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.burgerlijkeStaat }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Phone:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.telephoneMobilePrivate }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Email:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.emailPrivate }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b>Naamstelling:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.naamstelling }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Birthday:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployee.birthday }}</div> </div> </div> </uib-tab> <uib-tab index=1> <uib-tab-heading translate>Address</uib-tab-heading> <div class=p15> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>Address:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeAddress.street }} {{ $ctrl.nmbrsEmployeeAddress.houseNumber }}</div> </div> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>City:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeAddress.city }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Postal code:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeAddress.postalCode }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Country:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeAddress.countryISOCode }}</div> </div> </div> </uib-tab> <uib-tab index=2> <uib-tab-heading translate>Bank account</uib-tab-heading> <div class=p15> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>IBAN:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeBankAccount.iban }}</div> </div> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>BIC:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeBankAccount.bic }}</div> </div> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>Type:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeBankAccount.type }}</div> </div> </div> </uib-tab> <uib-tab index=3> <uib-tab-heading translate>Contract</uib-tab-heading> <div class=p15> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>Contract ID:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeContract.contractID }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Creation date:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeContract.creationDate | date : \"dd-MM-yyyy\" }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Start date:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeContract.startDate | date : \"dd-MM-yyyy\" }}</div> </div> <div class=\"row mb5\"> <div class=col-xs-3><b translate>Indefinite:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeContract.indefinite }}</div> </div> </div> </uib-tab> <uib-tab index=5> <uib-tab-heading translate>Function</uib-tab-heading> <div class=p15> <div class=\"row mb5 mt0\"> <div class=col-xs-3><b translate>Code:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeFunction.code }}</div> </div> {{$ctrl.function}} <div class=\"row mb5\"> <div class=col-xs-3><b translate>Description:</b></div> <div class=col-xs-9>{{ $ctrl.nmbrsEmployeeFunction.description }}</div> </div> </div> </uib-tab>  </uib-tabset> </div> </div>";

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Shift</h4> </div> <div class=modal-body> <form class=form role=form id=shiftForm ng-submit=$ctrl.submitShift()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': shiftForm.name.$touched && shiftForm.name.$invalid || shiftForm.$submitted && shiftForm.name.$invalid }\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.shift.name required> <div ng-messages=shiftForm.name.$error ng-show=\"shiftForm.name.$touched || shiftForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <div class=\"dropdown form-group dropdown-start-parent col-md-6\"> <label>Start</label> <a class=dropdown-toggle id=dropdownStart role=button data-toggle=dropdown data-target=.dropdown-start-parent href=#> <div class=\"input-group date\"> <input class=form-control data-date-time-input=\"DD-MM-YYYY HH:mm\" data-ng-model=$ctrl.shift.start /> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=$ctrl.shift.start data-datetimepicker-config=\"{ dropdownSelector: '#dropdownStart', renderOn: 'end-date-changed' }\" data-on-set-time=$ctrl.dataFilledIn() data-before-render=$ctrl.startDateBeforeRender($dates)></datetimepicker> </ul> </div> <div class=\"dropdown form-group dropdown-end-parent col-md-6\"> <label>End</label> <a class=dropdown-toggle id=dropdownEnd role=button data-toggle=dropdown data-target=.dropdown-end-parent href=#> <div class=\"input-group date\"> <input class=form-control data-date-time-input=\"DD-MM-YYYY HH:mm\" data-ng-model=$ctrl.shift.end /> <span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> </div> </a> <ul class=dropdown-menu role=menu aria-labelledby=dLabel> <datetimepicker data-ng-model=$ctrl.shift.end data-datetimepicker-config=\"{ dropdownSelector: '#dropdownEnd', renderOn: 'start-date-changed' }\" data-on-set-time=$ctrl.dataFilledIn() data-before-render=\"$ctrl.endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)\"></datetimepicker> </ul> </div> </div> <div class=\"form-group col-md-12\"> <label translate>Comment</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.comment></textarea> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=shiftForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-click=$ctrl.delete(); ng-if=\"$ctrl.shift.id != ''\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=\"panel-body p15 employee-history-cta\"> <uib-accordion close-others=true> <div uib-accordion-group class=\"panel-default accordion-group\" is-open=isOpen ng-repeat=\"account in $ctrl.history | orderBy: 'accountName'\"> <uib-accordion-heading> <span class=bold>{{ account.accountName }}</span> - {{ account.locationCount }} <span translate>locations</span> <div class=row> <div class=col-md-3><span translate>Shifts count</span>:</div> <div class=col-md-1>{{ account.shiftCount }}</div> <div class=col-md-3><span translate>Hours sum</span>:</div> <div class=col-md-2>{{ account.shiftSum | number : 2 }} <span translate>hours</span></div> </div> <div class=row> <div class=col-md-3><span translate>Declarations count</span>:</div> <div class=col-md-1>{{ account.declarationCount }}</div> <div class=col-md-3><span translate>Declared hours sum</span>:</div> <div class=col-md-2>{{ account.declarationSum | number : 2 }} <span translate>hours</span></div> </div> <i class=\"glyphicon accordion-carat valign-center no-margin\" ng-class=\"{'glyphicon-chevron-down': isOpen, 'glyphicon-chevron-right': !isOpen}\"></i> </uib-accordion-heading> <uib-accordion close-others=true> <div uib-accordion-group class=\"panel-default accordion-group sub-group\" is-open=false ng-repeat=\"location in account.byLocation | orderBy: 'locationName'\"> <uib-accordion-heading> {{ location.locationName }} - {{ location.teamCount }} <span translate>teams</span> </uib-accordion-heading> <div class=team-line ng-repeat=\"team in location.byTeam | orderBy: 'teamName'\"> {{ team.teamName }} </div> </div> </uib-accordion> </div> </uib-accordion> </div> </div>";

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Skill</h4> </div> <div class=modal-body> <form class=form role=form id=skillForm ng-submit=$ctrl.submitSkill()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': skillForm.skill.$touched && skillForm.skill.$invalid || skillForm.$submitted && skillForm.skill.$invalid }\"> <label translate>Name</label> <select class=\"form-control chosen\" chosen data-placeholder=\"Add skill\" name=skill ng-model=$ctrl.employeeSkill.skillId ng-options=\"item.id as item.name for item in $ctrl.skills\"> </select> <div ng-messages=skillForm.skill.$error ng-show=\"skillForm.skill.$touched || skillForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group> <div class=\"form-group col-md-6\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.employeeSkill.start max-date=$ctrl.employeeSkill.end time=false></date-time-picker-component> </div> <div class=\"form-group col-md-6\"> <label translate>End</label> <date-time-picker-component date=$ctrl.employeeSkill.end time=false></date-time-picker-component> </div> <div class=\"form-group col-md-12\"> <label translate>Comment</label> <textarea class=form-control name=comment ng-model=$ctrl.employeeSkill.comment></textarea> </div> <div class=\"form-group col-md-12\"> <label translate>Document of proof</label> <file name=document ng-model=$ctrl.uploadfile accept=* /> <div ng-if=$ctrl.file class=mt20> <table class=table> <tr> <td>{{$ctrl.file.filenameWithExtention}}</td> <td> <button class=\"btn btn-xs pull-right btn-info\" ng-click=$ctrl.downloadFile($ctrl.file.id)>Download</button></td> </tr> </table> </div> </div> </div> </div></form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5 btn-sm\" type=submit form=skillForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-danger btn-icon mr5 btn-sm\" type=button ng-click=$ctrl.delete(); ng-if=$ctrl.employeeSkill><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-info btn-icon mr5 btn-sm\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-heading> <div class=panel-controls> <button type=button class=\"btn btn-info btn-sm btn-icon mr5\" ui-sref=\".skill({employeeSkillId: ''})\"> <i class=\"fa fa-plus mr5\"></i><span translate>Add skill</span> </button> </div> </div> <div class=\"panel-body p15\"> <table class=\"table table-hover\"> <thead> <tr> <th style=width:40% translate>Name</th> <th translate>Start</th> <th translate>End</th> </tr> </thead> <tbody> <tr ui-sref=\".skill({employeeSkillId: item.id})\" ng-repeat=\"item in $ctrl.employeeSkills | orderBy: parseDate: true | limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <td>{{item.skillName}}</td> <td>{{item.start | date : \"dd-MM-yyyy\"}}</td> <td>{{item.end | date : \"dd-MM-yyyy\"}}</td> </tr> </tbody> </table> <div class=datatable-bottom> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.employeeSkills.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=3 direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last ng-if=\"$ctrl.employeeSkills.length > 0\"></ul> </div> </div> </div>";

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div> ";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Notes</a> </li> </ol> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control name=search ng-model=$ctrl.search placeholder=\"{{'search' | translate}}\"/> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.selectedTag ng-options=\"item.name as item.name for item in $ctrl.noteTags\" ng-change=$ctrl.filter()> <option value=\"\">Filter by tag</option> </select> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:10%> <span>Bedrijf/Medewerker </span></th> <th style=width:65%> <a href=# ng-click=\"$ctrl.sortType = 'description'; sortReverse = !sortReverse\"> <span translate>Description</span> <span ng-show=\"$ctrl.sortType == 'description' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'description' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:10%> <a href=# ng-click=\"$ctrl.sortType = 'date'; sortReverse = !sortReverse\"> <span translate>Date</span> <span ng-show=\"$ctrl.sortType == 'date' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'date' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:15%> <span translate>Tags</span> </th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.filteredNotes | filter : $ctrl.search | orderBy:$ctrl.sortType:sortReverse\"> <td style=width:10%>{{ $ctrl.getNoteAuthorName(item) }}</td> <td style=width:65%>{{ item.description }}</td> <td style=width:10%>{{ item.date | date : \"dd-MM-yyyy\" }}</td> <td style=width:15%> <div class=\"type bold pull-right\"><span ng-repeat=\"tag in item.tags\" class=\"chip transparant\">{{ tag }}</span></div> </td> </tr> </tbody> </table> </div> </div> ";

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row mb0\"> <div class=col-md-9> <h3 class=\"mt0 mb20\">{{ $ctrl.invoice.description }}</h3> </div> <div class=col-md-3> <h4 class=\"mt0 bold pull-right\">{{ $ctrl.invoice.totalAmount | currency : \"€\": 2 }}</h4> </div> </div> <div class=\"row mb10\"> <div class=col-md-7> {{$ctrl.invoice.account.name}} <br ng-if=\"$ctrl.invoice.account.visitingAddress.street || $ctrl.invoice.account.visitingAddress.number || $ctrl.invoice.account.vistingAddress.numberSuffix\"> {{$ctrl.invoice.account.visitingAddress.street}} {{$ctrl.invoice.account.visitingAddress.number}} {{$ctrl.invoice.account.vistingAddress.numberSuffix}} <br ng-if=\"$ctrl.invoice.account.visitingAddress.zip || $ctrl.invoice.account.visitingAddress.city\"> {{$ctrl.invoice.account.visitingAddress.zip}} {{$ctrl.invoice.account.visitingAddress.city}} </div> <div class=col-md-5 ng-if=!$ctrl.proformaInvoicesOnly> <button class=\"btn btn-sm btn-danger btn-icon pull-right\" type=button ng-click=$ctrl.deleteInvoice() ng-disabled=$ctrl.invoice.twinfieldNumber> <i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-sm btn-info btn-icon pull-right mr10\" type=button ng-click=$ctrl.sendToTwinfield() ng-disabled=$ctrl.invoice.twinfieldNumber> <i class=\"fa fa-plane mr5\"></i> <span translate>Send to Twinfield</span> </button> </div> </div> <div class=invoice-details> <div class=row> <div class=\"col-md-6 bold\" translate>Description</div> <div class=\"col-md-2 bold align-right\" translate>Count</div> <div class=\"col-md-2 bold align-right\" translate>Amount</div> <div class=\"col-md-2 bold align-right\" translate>Total</div> </div> <div class=detail-lines-cta> <div class=row ng-repeat=\"item in $ctrl.invoice.lines | filter:$ctrl.searchLine | orderBy: $ctrl.sortTypeDetails: sortReverseDetails\" ng-class=\"{'heading-line': item.count == 0, 'zero-rate': (item.count > 0 && (item.amountPerUnit == 0 || item.totalAmount == 0))}\"> <div ng-class=\"{'col-md-12': item.count == 0, 'col-md-6': item.count != 0}\">{{ item.description }}</div> <div class=\"col-md-2 align-right\"><span ng-if=\"item.count != 0\">{{ item.count }}</span></div> <div class=\"col-md-2 align-right\"><span ng-if=\"item.count != 0\">{{ item.amountPerUnit | currency : \"€\": 2 }}</span></div> <div class=\"col-md-2 align-right\"><span ng-if=\"item.count != 0\">{{ item.totalAmount | currency : \"€\": 2 }}</span></div> </div> </div> </div>";

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar quotations-header-bar\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <span translate>Uren doorsturen naar cootje</span> </li> </ol> </div> <div class=search> <form class=form ng-submit=$ctrl.getCootje()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"dropdown form-group dropdown-start-parent date-input\"> <label>Start</label> <date-time-picker-component date=$ctrl.startDate time=false></date-time-picker-component> </div> <div class=\"dropdown form-group dropdown-end-parent date-input\"> <label>End</label> <date-time-picker-component date=$ctrl.endDate time=false></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon-right\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=submit><i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> </div> </form> </div> </div> <div class=\"eq-col quotations-eq-col mt0\" ng-if=\"$ctrl.list.length > 0\"> <div class=\"relative full-height\"> <div class=display-row> <div class=\"messages-lister col bg-white br\"> <div class=scrollable-list> <div class=list-line ng-click=$ctrl.selectInvoice(item) ng-class=\"{active : $ctrl.currentItem.employeeId === item.employeeId}\" ng-repeat=\"item in $ctrl.list | filter:$ctrl.searchInvoice | orderBy:$ctrl.sortType:sortReverse| limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <ng-letter-avatar data=\"{{ item.employee.displayName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.employee.displayName}}</span><br/> <div style=margin-left:53px> Aantal diensten: {{ item.numberOfDiensten }}, Aantal declaraties: {{ item.numberOfDeclarations }}, Aantal uren: {{ item.numberOfHours }}, Aantal uren verstuurd: {{ item.numberOfHoursSend }} </div> <div style=margin-left:53px> <span class=\"chip chip-success\" ng-if=\"item.numberOfHoursSend == item.numberOfHours\" translate>Verstuurd</span> </div> </div> </div> </div> </div> </div> </div> <div class=\"panel scrollable\" ng-if=$ctrl.currentItem> <div class=\"row mb0 mt10\"> <div class=col-md-9> <h3 class=\"mt0 mb20\">{{ $ctrl.currentItem.employee.displayName }}</h3> </div> <div class=col-md-3> <button class=\"btn btn-sm btn-info btn-icon pull-right mr10\" type=button ng-click=$ctrl.sendCootje() ng-if=\"$ctrl.currentItem.numberOfHoursSend != $ctrl.currentItem.numberOfHours\"> <i class=\"fa fa-plane mr5\"></i> <span translate>Verstuur naar Cootje</span> </button> </div> </div> <div class=scrollable-list style=padding-bottom:50px> <div class=list-line ng-repeat=\"dienst in $ctrl.currentItem.diensten\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <ng-letter-avatar data=\"{{ dienst.shift.teamName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ dienst.shift.start | date : \"HH:mm dd-MM-yyyy\" }} - {{ dienst.shift.teamLocationAccountName }} - {{ dienst.shift.teamLocationName }} - {{ dienst.shift.teamName }}</span><br/> <div style=margin-left:53px> <p>Declaraties:</p> <div ng-repeat=\"declaration in dienst.declarations\"> <div ng-if=\"declaration.registrationType == 1\"> <i class=\"fa fa-check check-big icon-success\" ng-if=\"declaration.sendToCootje == true\"></i> <i class=\"fa fa-close close-big icon-danger\" ng-if=\"declaration.sendToCootje == false\"></i> {{declaration.dateTimeFrom | date : \"HH:mm dd-MM-yyyy\"}} - {{declaration.dateTimeTo | date : \"HH:mm dd-MM-yyyy\"}} - Aantal uren: {{declaration.duration}} - Factuurnummer: {{declaration.zzpInvoiceNumber}} </div> <div ng-if=\"declaration.registrationType == 2\"> <i class=\"fa fa-check check-big icon-success\" ng-if=\"declaration.sendToCootje == true\"></i> <i class=\"fa fa-close close-big icon-danger\" ng-if=\"declaration.sendToCootje == false\"></i> {{declaration.wageCodeName}}: {{declaration.value}} - Factuurnummer: {{declaration.zzpInvoiceNumber}} </div> <span style=color:red ng-if=\"declaration.sendToCootje == false\"> {{declaration.errorCootje}} </span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=modal id=sendToCootjeModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-if=!$ctrl.loading><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Declaraties versturen</h4> </div> <div class=modal-body> <div class=row> <div class=col-md-12> Medewerker: {{$ctrl.currentItem.employee.displayName }} </div> <div class=col-md-12> Aantal diensten: {{$ctrl.currentItem.numberOfDiensten}} </div> <div class=col-md-12> Aantal declaraties: {{$ctrl.currentItem.numberOfDeclarations}} </div> <div class=col-md-12> Aantal gedeclareerde uren: {{$ctrl.currentItem.numberOfHours}} </div> </div> <div class=\"row mt10\" ng-if=$ctrl.loading> <div class=col-md-12> Gegevens versturen naar Cootje..... </div> </div> <div class=\"row mt10\" ng-if=!$ctrl.loading> <div class=col-md-12> Aantal verstuurd: {{$ctrl.repport.successCount + $ctrl.repport.failCount}} </div> <div class=col-md-12> Aantal geslaagd: {{$ctrl.repport.successCount}} <div class=col-md-12> <ul> <li ng-repeat=\"success in $ctrl.repport.success\"> <span><b>{{ success.shift.start | date : \"HH:mm dd-MM-yyyy\" }}</b> - {{ success.shift.teamLocationAccountName }} - {{ success.shift.teamLocationName }} - {{ success.shift.teamName }}</span><br/> </li> </ul> </div> </div> <div class=col-md-12> Aantal mislukt: {{$ctrl.repport.failCount}} <ul> <li ng-repeat=\"fail in $ctrl.repport.fail\"> <span><b>{{ fail.shift.start | date : \"HH:mm dd-MM-yyyy\" }}</b> - {{ fail.shift.teamLocationAccountName }} - {{ fail.shift.teamLocationName }} - {{ fail.shift.teamName }}</span><br/> <span style=color:red>{{fail.responseMessage}}</span> </li> </ul> </div> </div> </div> <div class=modal-footer ng-if=!$ctrl.loading> <button class=\"btn btn-info btn-icon mr5\" data-dismiss=modal><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div> </div> </div> </div> ";

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar quotations-header-bar\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <span ng-if=!$ctrl.proformaInvoicesOnly translate>Invoices</span> <span ng-if=$ctrl.proformaInvoicesOnly translate>Pro forma invoices</span> </li> </ol> </div> <div class=search> <form class=form ng-submit=$ctrl.getInvoices()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"dropdown form-group dropdown-start-parent date-input\"> <label>Start</label> <date-time-picker-component date=$ctrl.startDate time=false></date-time-picker-component> </div> <div class=\"dropdown form-group dropdown-end-parent date-input\"> <label>End</label> <date-time-picker-component date=$ctrl.endDate time=false></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon-right\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=submit><i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> </div> </form> </div> </div> <h4 class=\"mt0 bold\"> <span translate>Count</span>: {{ $ctrl.invoices.length || 0 }} -- <span translate>Total amount</span>: {{ $ctrl.invoicesTotalAmount || 0 | currency : \"€\": 2 }} -- <span translate>Twinfield amount</span>: {{ $ctrl.twinfieldTotalAmount || 0 | currency : \"€\": 2 }} </h4> <div class=\"eq-col quotations-eq-col\" ng-if=\"$ctrl.invoices.length > 0\"> <div class=\"relative full-height\"> <div class=display-row> <div class=\"messages-lister col bg-white br\"> <div class=scrollable-list> <div class=list-line ng-click=$ctrl.selectInvoice(item) ng-class=\"{active : $ctrl.currentInvoice === item}\" ng-repeat=\"item in $ctrl.invoices | filter:$ctrl.searchInvoice | orderBy:$ctrl.sortType:sortReverse| limitTo: $ctrl.itemsPerPage : ($ctrl.currentPage-1)*$ctrl.itemsPerPage\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <ng-letter-avatar data=\"{{ item.account.name }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <div class=\"bold pull-right\">{{ item.totalAmount | currency : \"€\": 2 }}</div> <span style=margin-left:20px;font-weight:700>{{ item.account.name }}</span><br/> <div style=margin-left:53px> {{ item.description }} <div> <span class=\"chip chip-success\" ng-if=\"item.id && !$ctrl.proformaInvoicesOnly\" translate>Saved</span> <span class=\"chip chip-success\" ng-if=\"item.twinfieldNumber && !$ctrl.proformaInvoicesOnly\">Twinfield - {{item.twinfieldNumber}}</span> <span class=\"chip chip-danger\" ng-if=item.hasUnpaid>Unpaid</span> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"messages-viewer col\" ng-if=$ctrl.currentInvoice> <div class=detail-cta> <invoice-details-component invoice=$ctrl.currentInvoice on-update=$ctrl.updateInvoice(action) proforma-invoices-only=$ctrl.proformaInvoicesOnly></invoice-details-component> </div> </div> </div> </div> </div>";

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar shift-calendar-header-cta\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Schedule</a> </li> </ol> </div> <div class=buttons> <div class=pull-right ng-if=\"!$ctrl.screenSize.is('xs, sm')\"> <a type=button class=\"pull-right btn btn-info btn-sm btn-icon\" ui-sref=schedule.calendar.availability><i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span></a> <a type=button class=\"pull-right btn btn-info btn-sm btn-icon mr10\" ui-sref=\"schedule.list.item.edit({'id': '', 'status': 6})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></a> </div> <a class=\"pull-right btn btn-info btn-icon btn-sm mr10\" ui-sref=schedule.list> <i class=\"fa fa-list mr5\"></i><span translate>List</span> </a> </div> <div class=search ng-if=\"$ctrl.screenSize.is('xs, sm')\"> <button class=\"btn btn-primary btn-sm dropdown-toggle dropdown-menu-right\" type=button data-toggle=dropdown><span translate>Actions</span><span class=\"caret ml10\"></span></button> <ul class=dropdown-menu> <li><a type=button class=\"\" ui-sref=schedule.calendar.availability><i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span></a></li> <li class=divider></li> <li><a type=button class=\"\" ui-sref=\"schedule.list.item.edit({'id': '', 'status': 6})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></a></li> </ul> </div> </div> <div class=row> <div class=col-sm-12> <div class=calendar-viewer style=padding:5px> <div ui-calendar=$ctrl.uiConfig.calendar class=fullcalendar calendar=scheduleCalendar ng-model=$ctrl.eventSources></div> </div> </div> </div>";

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=\"title col-sm-5\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Declarations</a> </li> </ol> </div> <div class=search ng-if=\"!$ctrl.screenSize.is('xs, sm')\"> <form class=form ng-submit=$ctrl.getShiftsByDate()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"form-group disabled-date-input\"> <label translate>Start</label> <div class=\"input-prepend input-group\"> <span class=\"add-on input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=date class=form-control name=startDate ng-model=$ctrl.startDate disabled=disabled> </div> </div> <div class=\"form-group disabled-date-input\"> <label translate>End</label> <div class=\"input-prepend input-group\"> <span class=\"add-on input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=date class=form-control name=endDate ng-model=$ctrl.endDate disabled=disabled> </div> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </form> </div> <div class=search ng-if=\"$ctrl.screenSize.is('xs, sm') && !$ctrl.isMessageOpen\"> <form class=form ng-submit=$ctrl.getShiftsByDate()> <div class=row> <div class=col-xs-6> <div class=\"input-prepend input-group\"> <span class=\"add-on input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=date class=form-control name=startDate ng-model=$ctrl.startDate disabled=disabled> </div> </div> <div class=col-xs-6> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getShiftsByDate() add-class=\"['input-sm']\" disabled=disabled></date-time-picker-component> </div> </div> <div class=\"row no-margin\"> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm pull-right\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body style=\"\" ng-if=\"$ctrl.isZZP && $ctrl.declarationstoSend.count > 0\"> <div class=col-md-12> <button class=\"btn btn-info btn-sm pull-right\" type=button ng-click=$ctrl.sendZPPDeclarations()><span translate>Verstuur declaraties</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </div> <div class=panel> <div class=panel-body style=padding:0> <div ng-if=$ctrl.employeeSummary style=\"\"> <timesheet-details-component timesheet=$ctrl.employeeSummary calendar-start-date=$ctrl.shift.start calendar-end-date=$ctrl.shift.end on-change=$ctrl.refresh()></timesheet-details-component> </div> </div> </div> <div class=panel> <div class=panel-body style=\"\" ng-if=\"$ctrl.isZZP && $ctrl.declarationstoSend.count > 0\"> <div class=col-md-12> <button class=\"btn btn-info btn-sm pull-right\" type=button ng-click=$ctrl.sendZPPDeclarations()><span translate>Verstuur declaraties</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </div> <div class=modal id=sendDeclartionsFormModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Declaraties versturen</h4> </div> <div class=modal-body> <div class=row ng-if=$ctrl.invoiceMonthly> <div class=col-md-12> Je gaat nu een alle declaraties van een maand versturen. Controleer goed of alle declaraties goed zijn ingevuld. </div> </div> <div class=row> <div class=col-md-12> Aantal diensten: {{$ctrl.declarationstoSend.countShifts}} </div> <div class=col-md-12> Aantal declaraties: {{$ctrl.declarationstoSend.count}} </div> <div class=col-md-12> Aantal gedeclareerde uren: {{$ctrl.declarationstoSend.totalHours}} </div> <div class=col-md-12> Gewerkt bij {{$ctrl.declarationstoSend.teams.length }} teams. </div> </div> <div class=row> <form class=form role=form id=sendDeclartionsForm name=sendDeclartionsForm ng-submit=\"sendDeclartionsForm.$valid && $ctrl.postConfirm()\"> <div class=\"form-group col-md-12\" ng-repeat=\"item in $ctrl.declarationstoSend.teams track by $index\"> <label translate>Eigen factuurnummer ({{item.account}} - {{item.location}} - {{item.name}}):</label> <input type=text class=form-control name=invoicenumber[$index] ng-model=item.invoiceNumber maxlength=12 minlength=2 required> <div ng-messages=sendDeclartionsForm.invoicenumber[$index].$error ng-show=\"sendDeclartionsForm.invoicenumber[$index].$touched || sendDeclartionsForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> <div>Minimaal 2 tekens, maximaal 12 tekens.</div> </div> </form> </div> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=sendDeclartionsForm><i class=\"fa fa-save mr5\"></i> <span translate>Versturen</span> </button> <button class=\"btn btn-info btn-icon mr5\" data-dismiss=modal><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div> </div> </div> </div> ";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div>";

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-body> <h3 class=\"mt0 mb20\">{{ $ctrl.shift.teamLocationAccountName }} - {{ $ctrl.shift.teamLocationName }} - {{ $ctrl.shift.teamName }}</h3> <div class=\"row mb0\"> <div class=col-md-2> Opdrachtgever: </div> <div class=col-md-10> {{ $ctrl.shift.teamLocationAccountName }} </div> </div> <div class=\"row mb0\"> <div class=col-md-2> <span translate>Location</span>: </div> <div class=col-md-10> {{ $ctrl.shift.teamLocationName }} </div> </div> <div class=\"row mb0\"> <div class=col-md-2> <span translate>Address</span>: </div> <div class=col-md-10> {{ $ctrl.location.address.street }} {{ $ctrl.location.address.number }} {{ $ctrl.location.address.numberSuffix}} <br ng-if=$ctrl.location.address.street> {{ $ctrl.location.address.zip }} {{$ctrl.location.address.city}} <br ng-if=\"$ctrl.location.address.zip || $ctrl.location.address.city\"> {{ $ctrl.location.address.country}} </div> </div> <div class=\"row mb0\"> <div class=col-md-2> <span translate>Team</span>: </div> <div class=col-md-10> {{ $ctrl.shift.teamName }} </div> </div> <div class=\"row mb0\"> <div class=col-md-2> <span translate>Time</span>: </div> <div class=col-md-10> {{ $ctrl.shift.start | date :\"dd-MM-yyyy HH:mm\" }} - {{ $ctrl.shift.end | date :\"dd-MM-yyyy HH:mm\" }} </div> </div> <div class=\"row mb0\"> <div class=col-md-2> <span translate>Comment</span>: </div> <div class=col-md-10> <p style=white-space:pre> {{ $ctrl.shift.employeeComment }}</p> </div> </div> <hr/> <a class=\"btn btn-info\" ui-sref=\"schedule.list.item.edit({'id' : $ctrl.shift.id})\" translate ng-if=$ctrl.shift.createdByEmployee>Edit</a> </div> </div>";

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=\"title col-sm-5\"> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Shifts</a> </li> </ol> </div> <div class=buttons> <div class=pull-right ng-if=\"!$ctrl.screenSize.is('xs, sm')\"> <a type=button class=\"pull-right btn btn-info btn-sm btn-icon\" ui-sref=schedule.calendar.availability><i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span></a> <a type=button class=\"pull-right btn btn-info btn-sm btn-icon mr10\" ui-sref=\"schedule.list.item.edit({'id': '', 'status': 6})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></a> </div> <button type=button class=\"btn btn-info btn-icon btn-sm pull-right mr10\" ui-sref=schedule.calendar> <i class=\"fa fa-calendar\"></i><span translate>Calendar</span> </button> </div> <div class=search ng-if=\"!$ctrl.screenSize.is('xs, sm')\"> <form class=form ng-submit=$ctrl.getShiftsByDate()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"form-group date-input\"> <date-time-picker-component date=$ctrl.startDate time=false on-change=$ctrl.getShiftsByDate() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=date-input> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getShiftsByDate() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </form> </div> <div class=search ng-if=\"$ctrl.screenSize.is('xs, sm') && !$ctrl.isMessageOpen\"> <form class=form ng-submit=$ctrl.getShiftsByDate()> <div class=row> <div class=col-xs-6> <date-time-picker-component date=$ctrl.startDate time=false on-change=$ctrl.getShiftsByDate() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=col-xs-6> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getShiftsByDate() add-class=\"['input-sm']\"></date-time-picker-component> </div> </div> <div class=\"row no-margin\"> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm pull-right\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> </div> </form> </div> <div class=search ng-if=\"$ctrl.screenSize.is('xs, sm')\"> <div class=\"row no-margin\"> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm dropdown-toggle dropdown-menu-right\" type=button data-toggle=dropdown><span translate>Actions</span><span class=\"caret ml10\"></span></button> <ul class=dropdown-menu> <li><a type=button class=\"\" ui-sref=schedule.calendar.availability><i class=\"fa fa-plus mr5\"></i><span translate>Add availability</span></a></li> <li class=divider></li> <li><a type=button class=\"\" ui-sref=\"schedule.list.item.edit({'id': '', 'status': 6})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></a></li> </ul> </div> </div> </div> </div> <div class=row> <div style=overflow:hidden class=\"col-md-4 col-xs-12\" fixed-height ng-show=\"!$ctrl.screenSize.is('xs, sm') || ( $ctrl.screenSize.is('xs, sm') && !$ctrl.isMessageOpen)\"> <div class=panel style=height:100%> <div class=panel-body style=height:100%;overflow:auto;padding:0> <div ng-repeat=\"(key, shifts) in $ctrl.groupedShifts\" class=shift-list> <div class=\"list-line heading-line\"> {{ key }} </div> <div class=list-line id=s-{{item.id}} ui-sref-active=active ng-repeat=\"item in shifts track by $index\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\" ui-sref=\"schedule.list.item({ 'id': item.id })\"> <div class=\"row no-margin\"> <div class=\"bold col-xs-8\" style=line-height:2em>{{ item.teamLocationAccountName }} - {{ item.teamLocationName }} - {{ item.teamName }}</div> <div class=col-xs-4 style=line-height:2em> <span class=\"pull-right label label-default\" ng-if=\"item.status == 6 && item.declaredHours > 0\" ng-class=\"item.declarationStatus == 3 ? 'label-success' : 'label-warning'\">Gedeclareerd</span> <span class=\"pull-right label label-info\" ng-if=\"item.status == 6 && item.declaredHours == 0\"> Ingevuld </span> <span class=\"pull-right label label-warning\" ng-if=\"item.status == 5\"> Voorstel </span> <span class=\"pull-right label label-danger\" ng-if=\"item.status == 7\"> Geannuleerd </span> </div> </div> <div class=\"row no-margin shift-summary\"> <div class=col-xs-12 style=line-height:2em> <span ng-if=\"!$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm\" }}</span> <span translate>to</span> {{ item.end | date :\"HH:mm dd-MM-yyyy\" }} </div> </div> <div class=\"row no-margin\" style=vertical-align:middle> <div class=col-xs-12 style=line-height:2em> <span class=bold>{{ item.employeeDisplayName }}</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div fixed-height class=\"col-md-8 col-xs-12\" ng-show=\"!$ctrl.screenSize.is('xs, sm') || ( $ctrl.screenSize.is('xs, sm') && $ctrl.isMessageOpen)\"> <div class=panel> <div class=panel-body> <button class=\"btn btn-sm\" ng-click=\"$ctrl.isMessageOpen = false;\" ng-if=\"$ctrl.screenSize.is('xs, sm')\"><i class=\"fa fa-arrow-left\" aria-hidden=true></i></button> <a class=\"btn btn-sm btn-info btn-icon ml10 pull-right\" ui-sref=schedule.declarations> <i class=\"fa fa-money mr5\"></i><span translate>Declarations</span> </a> </div> </div> <div class=panel style=\"height:calc(100% - 74px);overflow:none;border:0 solid red;margin-bottom:0\"> <div class=panel-body style=height:100%;padding:0> <div ui-view=shiflistitem on-change=\"$ctrl.handleChildChange(type, data)\" style=height:100%></div> </div> </div> </div> </div>";

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Subscription</h4> </div> <div class=modal-body> <form class=form role=form id=subscriptionForm ng-submit=$ctrl.submitSubscription()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label translate>Shift</label> <input class=form-control name=title ng-model=$ctrl.subscription.shift.name> </div> <div class=\"form-group col-md-12\"> <label translate>Comment</label> <textarea class=form-control name=description ng-model=$ctrl.subscription.comment></textarea> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-sm btn-success btn-icon mr5\" type=submit form=subscriptionForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-sm btn-danger btn-icon mr5\" type=button ng-click=$ctrl.delete() ng-if=$ctrl.subscription.id><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span> </button> <button class=\"btn btn-sm btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></button> </div>";

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-lg-12> <div class=\"panel mb25\"> <div class=\"panel-heading border\"> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings.company>Company</a> </li> </ol> </div> <div class=panel-body> <form class=\"\" role=form name=companySettingsForm ng-submit=\"companySettingsForm.$valid && $ctrl.submitSettings()\"> <div class=form-group> <label>Naam</label> <input class=form-control ng-model=$ctrl.company.name required> </div> <div class=form-group> <label>SCA Registratie nummer</label> <input class=form-control ng-model=$ctrl.company.scaRegistrationNumber> </div> <div class=form-group> <label translate>Street</label> <input class=form-control ng-model=$ctrl.company.street> </div> <div class=form-group> <label translate>Number</label> <input class=form-control ng-model=$ctrl.company.number> </div> <div class=form-group> <label translate>Zip</label> <input class=form-control ng-model=$ctrl.company.zip> </div> <div class=form-group> <label translate>City</label> <input class=form-control ng-model=$ctrl.company.city> </div> <div class=form-group> <label>Procescertificaat nummer</label> <input class=form-control ng-model=$ctrl.company.processCertificateNumber> </div> <hr/> <button class=\"btn btn-success\" type=submit>Opslaan</button> </form> </div> </div> </div> </div>";

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings.employees>Employees</a> </li> <li class=active> <a>{{$ctrl.employee.name}}</a> </li> </ol> </div> </div> <div class=panel> <div class=panel-body> <form class=\"\" role=form ng-submit=$ctrl.save()> <div class=form-group> <label translate>Name</label> <input class=form-control ng-model=$ctrl.employee.name required> </div> <div class=form-group> <label translate>Phone</label> <input class=form-control ng-model=$ctrl.employee.phoneNumber> </div> <div class=form-group> <label translate>Email</label> <input class=form-control ng-model=$ctrl.employee.email> </div> <div class=form-group> <label>Ascert-code</label> <input class=form-control ng-model=$ctrl.employee.ascertCode> </div> <hr/> <button class=\"btn btn-success\" type=submit>Opslaan</button> </form> </div> </div>";

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=customers>Employees</a> </li> </ol> </div> <div class=buttons> <a class=pull-right ui-sref=\"settings.employees.item({'id': 0})\"><i class=\"fa fa-plus\"></i></a> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-6> <div class=form-group> <input class=form-control name=search ng-model=$ctrl.search placeholder=search /> </div> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=accounts-table class=\"table table-hover\"> <thead> <tr> <th translate>Name</th> </tr> </thead> <tbody> <tr ui-sref=\"settings.employees.item({'id': item.id})\" ng-repeat=\"item in $ctrl.employees | filter : $ctrl.search\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{item.name}}</span> </td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div> ";

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <button type=button class=close ng-click=$ctrl.closeModal() aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title>Uurcode basis informatie</h4> </div> <div class=modal-body> <form class=form role=form id=hourCodeBasicInfoForm ng-submit=$ctrl.submitHourCode()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>CAO <span class=text-danger>*</span></label> <select class=\"form-control chosen\" chosen name=salaryScaleGroup ng-model=$ctrl.hourCode.salaryScaleGroupId ng-options=\"item.id as item.name for item in $ctrl.salaryScaleGroups | orderBy: 'name'\" required> <option value=\"\">Selecteer CAO</option> </select> </div> <div class=\"form-group col-md-12\"> <label>Type <span class=text-danger>*</span></label> <select class=form-control name=type ng-model=$ctrl.typeSelect required> <option value=\"\">Selecteer type</option> <option value=0>Looncomponent</option> <option value=1>Onkosten</option> </select> </div> <div class=\"form-group col-md-12\"> <label>Code <span class=text-danger>*</span></label> <input type=text class=form-control name=code ng-model=$ctrl.hourCode.code required maxlength=50> </div> <div class=\"form-group col-md-12\"> <label>Naam <span class=text-danger>*</span></label> <input type=text class=form-control name=name ng-model=$ctrl.hourCode.name required maxlength=200> </div> <div class=\"form-group col-md-12\"> <label>Beschrijving</label> <textarea class=form-control name=description ng-model=$ctrl.hourCode.description rows=3 maxlength=1000></textarea> </div> <div class=\"form-group col-md-12\"> <label>Twinfield Code</label> <input type=text class=form-control name=twinfieldCode ng-model=$ctrl.hourCode.twinfieldCode maxlength=50> </div> <div class=\"form-group col-md-6\"> <label>Waarde</label> <input type=number step=any class=form-control name=value ng-model=$ctrl.hourCode.value> </div> <div class=\"form-group col-md-6\"> <label>Waarde 2</label> <input type=number step=any class=form-control name=value2 ng-model=$ctrl.hourCode.value2> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-danger btn-icon\" ng-click=$ctrl.deleteHourCode() ng-if=$ctrl.hourCode.id><i class=\"fa fa-trash\"></i><span translate>Verwijderen</span></button> <button class=\"btn btn-success btn-icon mr5\" type=submit form=hourCodeBasicInfoForm><i class=\"fa fa-save mr5\"></i><span>Opslaan</span></button> <button class=\"btn btn-info btn-icon mr5\" ng-click=$ctrl.closeModal()><i class=\"fa fa-close mr5\"></i><span>Sluiten</span></button> </div> ";

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings.hourcodes translate>Uurcodes</a> </li> <li class=active> {{ $ctrl.hourCode.name }} </li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-danger btn-icon btn-sm\" ng-click=$ctrl.deleteHourCode() ng-if=$ctrl.hourCode.id><i class=\"fa fa-trash\"></i><span translate>Verwijderen</span></a> </div> </div> <div class=row> <div class=col-md-4> <div class=\"panel panel-primary\"> <div class=panel-heading> <div class=pull-left translate>Basis informatie</div> <div class=panel-controls> <a ui-sref=\"settings.hourcodes.list.item({'id': $ctrl.hourCode.id})\"><i class=\"fa fa-edit\"></i></a> </div> </div> <div class=\"panel-body p25\"> <div class=\"row mb5\"> <div class=col-xs-5><b>CAO:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.salaryScaleGroupName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b>Type:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.type === 0 ? 'Looncomponent' : 'Onkosten'}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b>Code:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.code}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b>Naam:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.name}}</div> </div> <div class=\"row mb5\" ng-if=$ctrl.hourCode.description> <div class=col-xs-5><b>Beschrijving:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.description}}</div> </div> <div class=\"row mb5\" ng-if=$ctrl.hourCode.twinfieldCode> <div class=col-xs-5><b>Twinfield Code:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.twinfieldCode}}</div> </div> <div class=\"row mb5\" ng-if=$ctrl.hourCode.value> <div class=col-xs-5><b>Waarde:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.value}}</div> </div> <div class=\"row mb5\" ng-if=$ctrl.hourCode.value2> <div class=col-xs-5><b>Waarde 2:</b></div> <div class=col-xs-7>{{$ctrl.hourCode.value2}}</div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings>Instellingen</a> </li> <li> <a>Uurcodes</a> </li> </ol> </div> </div> <div class=panel> <div class=panel-body> <div class=form-group style=margin-bottom:20px> <label for=caoSelect style=font-weight:700;margin-bottom:10px;display:block>Selecteer CAO:</label> <div class=row> <div class=col-md-6> <select id=caoSelect class=form-control ng-model=$ctrl.selectedGroup ng-options=\"group as (group.name + (group.description ? ' - ' + group.description : '')) for group in $ctrl.salaryScaleGroups | orderBy:'name'\" ng-change=$ctrl.onGroupChange($ctrl.selectedGroup)> <option value=\"\">-- Selecteer een CAO --</option> </select> </div> <div class=col-md-6 ng-if=$ctrl.selectedGroup> <button ng-click=$ctrl.clearSelection() class=\"btn btn-default btn-sm\"> <i class=\"fa fa-times mr5\"></i> <span>Selectie wissen</span> </button> </div> </div> </div> <div ng-if=$ctrl.selectedGroup class=\"panel panel-primary\" style=margin-top:20px> <div class=panel-heading> <h4> <strong>{{ $ctrl.selectedGroup.name }}</strong> <span ng-if=$ctrl.selectedGroup.description class=text-muted> - {{ $ctrl.selectedGroup.description }}</span> <button ng-click=$ctrl.addHourCode() class=\"btn btn-xs btn-success pull-right mr5\"> <i class=\"fa fa-plus mr5\"></i> <span>Uurcode toevoegen</span> </button> </h4> </div> <div class=panel-body> <div class=search style=margin-bottom:15px> <input class=form-control style=\"font-family:FontAwesome,'Open Sans'\" name=search ng-model=$ctrl.search placeholder=\"&#xf002; Zoeken in uurcodes\"/> </div> <table id=hourcodes-table class=\"table table-hover\"> <thead> <tr> <th> <a href=# ng-click=\"$ctrl.sortType = 'code'; sortReverse = !sortReverse\"> <span>Code</span> <span ng-show=\"$ctrl.sortType == 'code' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'code' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'name'; sortReverse = !sortReverse\"> <span>Naam</span> <span ng-show=\"$ctrl.sortType == 'name' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'name' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'type'; sortReverse = !sortReverse\"> <span>Type</span> <span ng-show=\"$ctrl.sortType == 'type' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'type' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'twinfieldCode'; sortReverse = !sortReverse\"> <span>Twinfield Code</span> <span ng-show=\"$ctrl.sortType == 'twinfieldCode' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'twinfieldCode' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'value'; sortReverse = !sortReverse\"> <span>Waarde</span> <span ng-show=\"$ctrl.sortType == 'value' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'value' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"settings.hourcodes.list.item({'id': item.id})\" ng-repeat=\"item in $ctrl.hourCodes | filter : $ctrl.search | orderBy:$ctrl.sortType:sortReverse\"> <td>{{ item.code }}</td> <td>{{ item.name }}</td> <td>{{ item.type === 0 ? 'Looncomponent' : 'Onkosten' }}</td> <td>{{ item.twinfieldCode || '-' }}</td> <td>{{ item.value || '-' }}</td> </tr> <tr ng-if=\"!$ctrl.hourCodes || ($ctrl.hourCodes | filter : $ctrl.search).length === 0\"> <td colspan=5 class=\"text-center text-muted\"> <span>Geen uurcodes gevonden</span> </td> </tr> </tbody> </table> </div> </div> <div ng-if=\"!$ctrl.selectedGroup && $ctrl.salaryScaleGroups && $ctrl.salaryScaleGroups.length > 0\" class=\"text-center text-muted\" style=padding:40px> <i class=\"fa fa-info-circle fa-3x\" style=margin-bottom:15px></i> <p>Selecteer een CAO om de bijbehorende uurcodes te bekijken</p> </div> <div ng-if=\"!$ctrl.salaryScaleGroups || $ctrl.salaryScaleGroups.length === 0\" class=\"text-center text-muted\" style=padding:40px> <span>Geen CAO groepen gevonden</span> </div> </div> </div> ";

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a type=button class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Masterdata edit</h4> </div> <div class=modal-body> <form class=form role=form id=masterDataForm ng-submit=$ctrl.save()> <div class=form-group ng-class=\"{ 'has-error': masterDataForm.code.$touched && masterDataForm.code.$invalid || masterDataForm.$submitted && masterDataForm.code.$invalid}\"> <label translate>Code</label> <input class=form-control name=code ng-model=$ctrl.item.code> <div ng-messages=masterDataForm.code.$error ng-show=\"masterDataForm.code.$touched || masterDataForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-if=\"$ctrl.type == 'HourCodes'\"> <label translate>Opslitsen (NMBRS code)</label> <input class=form-control name=nmbrsSplitCode ng-model=$ctrl.item.nmbrsSplitCode> </div> <div class=form-group ng-class=\"{ 'has-error': masterDataForm.name.$touched && masterDataForm.name.$invalid || masterDataForm.$submitted && masterDataForm.name.$invalid}\"> <label translate>Name</label> <input class=form-control name=name ng-model=$ctrl.item.name required> <div ng-messages=masterDataForm.name.$error ng-show=\"masterDataForm.name.$touched || masterDataForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-if=\"$ctrl.type == 'HourCodes'\"> <label translate>Value</label> <input type=number step=.01 class=form-control name=value ng-model=$ctrl.item.value> </div> <div class=form-group ng-if=\"$ctrl.type == 'HourCodes'\"> <label translate>Twinfieldcode (KMVERG | OVKOST)</label> <input class=form-control name=twinfieldCode ng-model=$ctrl.item.twinfieldCode> </div> <div class=form-group> <label translate>Description</label> <textarea class=form-control name=description ng-model=$ctrl.item.description />\r\n        </div>\r\n    </form>\r\n\r\n</div>\r\n\r\n<div class=modal-footer>\r\n    <button class=\"btn btn-danger btn-sm btn-icon\" type=button ng-click=$ctrl.delete() ng-if=$ctrl.item.id><i class=\"fa fa-trash\"></i> <span translate>Delete</span></button>\r\n    <button class=\"btn btn-success btn-sm btn-icon\" type=submit form=masterDataForm><i class=\"fa fa-save\"></i> <span translate>Save</span></button>\r\n    <a class=\"btn btn-warning btn-sm btn-icon\" ui-sref=^><i class=\"fa fa-close\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings translate>Settings</a> </li> <li class=active> Masterdata </li> </ol> </div> </div> <div class=panel> <div class=panel-body> <uib-tabset active=$ctrl.activePill vertical=false type=pills> <uib-tab index=\"$index + 1\" ng-repeat=\"type in $ctrl.types\" heading={{type.name}} select=\"$ctrl.setTab($index + 1)\"> <div class=panel> <div class=panel-heading> <div class=panel-controls> <a ui-sref=\"settings.masterdata.list.edit({'id': null, 'type': type.id })\"><i class=\"fa fa-plus\"></i></a> </div> </div> <div class=panel-body> <table id=option-sets-table class=\"table table-hover\"> <thead> <tr> <th translate>Code</th> <th translate>Name</th> <th ng-if=\"type.id == 'HourCodes'\" translate>Value</th> <th translate>Description</th> </tr> </thead> <tbody> <tr ui-sref=\"settings.masterdata.list.edit({'id': item.id, 'type': type.id })\" ng-repeat=\"item in type.data\"> <td>{{ item.code }}</td> <td>{{ item.name }}</td> <td ng-if=\"type.id == 'HourCodes'\">{{ item.value }}</td> <td>{{ item.description }}</td> </tr> </tbody> </table> </div> </div> </uib-tab> </uib-tabset> </div> </div>";

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-default\"> <div class=panel-heading> <h3 class=panel-title translate>Nmbrs API Test</h3> </div> <div class=panel-body> <div class=row> <div class=col-md-4> <h4 translate>Available Endpoints</h4> <div class=list-group> <a ng-repeat=\"endpoint in $ctrl.endpoints\" ng-click=$ctrl.selectEndpoint(endpoint) class=list-group-item ng-class=\"{'active': $ctrl.selectedEndpoint === endpoint}\" href=javascript:void(0)> <h5 class=list-group-item-heading>{{endpoint.name}}</h5> <p class=\"list-group-item-text text-muted small\">{{endpoint.description}}</p> <small class=text-muted>{{endpoint.method}} {{endpoint.path}}</small> </a> </div> </div> <div class=col-md-8> <div ng-if=$ctrl.selectedEndpoint> <h4>{{$ctrl.selectedEndpoint.name}}</h4> <p class=text-muted>{{$ctrl.selectedEndpoint.description}}</p> <div class=form-horizontal ng-if=\"$ctrl.selectedEndpoint.params && $ctrl.selectedEndpoint.params.length > 0\"> <div class=form-group ng-repeat=\"param in $ctrl.selectedEndpoint.params\"> <label class=\"col-sm-3 control-label\">{{param.label}}:</label> <div class=col-sm-9> <input type={{param.type}} class=form-control ng-model=$ctrl.endpointParams[param.key] placeholder={{param.label}}> </div> </div> </div> <div class=form-group> <button class=\"btn btn-primary\" ng-click=$ctrl.callEndpoint() ng-disabled=$ctrl.loading> <i class=fa ng-class=\"{'fa-spinner fa-spin': $ctrl.loading, 'fa-play': !$ctrl.loading}\"></i> <span translate>Call Endpoint</span> </button> </div> <div ng-if=$ctrl.error class=\"alert alert-danger\"> <strong translate>Error:</strong> {{$ctrl.error}} </div> <div ng-if=$ctrl.result> <h5 translate>Result:</h5> <pre class=pre-scrollable style=max-height:600px;background-color:#f5f5f5;padding:15px;border-radius:4px;white-space:pre-wrap;word-wrap:break-word>{{$ctrl.formatJson($ctrl.result)}}</pre> </div> </div> <div ng-if=!$ctrl.selectedEndpoint class=\"alert alert-info\"> <i class=\"fa fa-info-circle\"></i> <span translate>Select an endpoint from the list to test it</span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <button type=button class=close ui-sref=^ ng-if=\"($ctrl.salaryScaleGroup && $ctrl.salaryScaleGroup.id !== undefined) || ($ctrl.salaryScale && $ctrl.salaryScale.id !== undefined)\" aria-label=Close><span aria-hidden=true>&times;</span></button> <button type=button class=close ui-sref=^.^ ng-if=\"($ctrl.salaryScaleGroup && $ctrl.salaryScaleGroup.id === undefined) || ($ctrl.salaryScale && $ctrl.salaryScale.id === undefined)\" aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title ng-if=$ctrl.salaryScaleGroup>CAO details</h4> <h4 class=modal-title ng-if=$ctrl.salaryScale>Loonschaal details</h4> </div> <div class=modal-body> <form class=form role=form id=salaryScaleGroupForm ng-if=$ctrl.salaryScaleGroup ng-submit=$ctrl.submitSalaryScaleGroup()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>Naam</label> <input type=text class=form-control name=name ng-model=$ctrl.salaryScaleGroup.name required> </div> <div class=\"form-group col-md-12\"> <label>Omschrijving</label> <input type=text class=form-control name=description ng-model=$ctrl.salaryScaleGroup.description> </div> <div class=\"form-group col-md-12\"> <div class=checkbox> <label> <input type=checkbox ng-model=$ctrl.salaryScaleGroup.isDefaultNmbrsCao ng-change=$ctrl.onDefaultNmbrsCaoChange()> <strong>Default Nmbrs CAO</strong> <small class=text-muted style=display:block;margin-top:5px> Deze CAO wordt gebruikt bij het synchroniseren van employees vanuit Nmbrs wanneer er geen exacte match wordt gevonden. </small> </label> </div> </div> </div> </form> <form class=form role=form id=salaryScaleForm ng-if=$ctrl.salaryScale ng-submit=$ctrl.submitSalaryScale()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>Code</label> <input type=text class=form-control name=code ng-model=$ctrl.salaryScale.code required> </div> <div class=\"form-group col-md-12\"> <label>Naam</label> <input type=text class=form-control name=name ng-model=$ctrl.salaryScale.name required> </div> <div class=\"form-group col-md-12\"> <label>Uurloon</label> <input type=number step=0.01 class=form-control name=hourlyWage ng-model=$ctrl.salaryScale.hourlyWage required> </div> <div class=\"form-group col-md-12\"> <label>Omrekenfactor</label> <input type=number step=0.01 class=form-control name=conversionFactor ng-model=$ctrl.salaryScale.conversionFactor required> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=salaryScaleGroupForm ng-if=$ctrl.salaryScaleGroup> <i class=\"fa fa-save mr5\"></i><span>Opslaan</span> </button> <button class=\"btn btn-success btn-icon mr5\" type=submit form=salaryScaleForm ng-if=$ctrl.salaryScale> <i class=\"fa fa-save mr5\"></i><span>Opslaan</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-if=\"$ctrl.salaryScaleGroup && $ctrl.salaryScaleGroup.id\" ng-click=$ctrl.deleteSalaryScaleGroup()> <i class=\"fa fa-trash mr5\"></i><span>Verwijderen</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-if=\"$ctrl.salaryScale && $ctrl.salaryScale.id\" ng-click=$ctrl.deleteSalaryScale()> <i class=\"fa fa-trash mr5\"></i><span>Verwijderen</span> </button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^> <i class=\"fa fa-close mr5\"></i><span>Sluiten</span> </button> </div> ";

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings translate>Settings</a> </li> <li> <a>Loonschalen</a> </li> </ol> </div> <div class=buttons> <button ui-sref=\"settings.salaryscales.edit({'id': ''})\" class=\"btn btn-primary btn-sm btn-icon pull-right mr5\"> <i class=\"fa fa-plus mr5\"></i> <span>CAO toevoegen</span> </button> </div> </div> <div class=panel> <div class=panel-body> <div class=form-group style=margin-bottom:20px> <label for=caoSelect style=font-weight:700;margin-bottom:10px;display:block>Selecteer CAO:</label> <div class=row> <div class=col-md-6> <select id=caoSelect class=form-control ng-model=$ctrl.selectedGroup ng-options=\"group as ((group.isDefaultNmbrsCao ? '⭐ ' : '') + group.name + (group.description ? ' - ' + group.description : '') + (group.isDefaultNmbrsCao ? ' (Default Nmbrs CAO)' : '')) for group in $ctrl.salaryScaleGroups | orderBy:'name'\" ng-change=$ctrl.onGroupChange($ctrl.selectedGroup)> <option value=\"\">-- Selecteer een CAO --</option> </select> </div> <div class=col-md-6 ng-if=$ctrl.selectedGroup> <button ng-click=$ctrl.clearSelection() class=\"btn btn-default btn-sm\"> <i class=\"fa fa-times mr5\"></i> <span>Selectie wissen</span> </button> </div> </div> </div> <div ng-if=$ctrl.selectedGroup class=\"panel panel-primary\" style=margin-top:20px> <div class=panel-heading> <h4> <strong> <span ng-if=$ctrl.selectedGroup.isDefaultNmbrsCao class=text-warning title=\"Default Nmbrs CAO\">⭐</span> {{ $ctrl.selectedGroup.name }} </strong> <span ng-if=$ctrl.selectedGroup.description class=text-muted> - {{ $ctrl.selectedGroup.description }}</span> <span ng-if=$ctrl.selectedGroup.isDefaultNmbrsCao class=\"label label-warning\" style=margin-left:10px>Default Nmbrs CAO</span> <button ui-sref=\"settings.salaryscales.edit({'id': $ctrl.selectedGroup.id})\" class=\"btn btn-xs btn-default pull-right\"> <i class=\"fa fa-edit mr5\"></i> <span>Bewerken</span> </button> <button ng-click=$ctrl.openAddScaleModal() class=\"btn btn-xs btn-success pull-right mr5\"> <i class=\"fa fa-plus mr5\"></i> <span>Schaal toevoegen</span> </button> </h4> </div> <div class=panel-body> <div class=search style=margin-bottom:15px> <input class=form-control style=\"font-family:FontAwesome,'Open Sans'\" name=search ng-model=$ctrl.search placeholder=\"&#xf002; Zoeken in loonschalen\"/> </div> <table class=\"table table-hover\"> <thead> <tr> <th> <span>Code</span> </th> <th> <span>Naam</span> </th> <th> <span>Uurloon</span> </th> <th> <span>Omrekenfactor</span> </th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"scale in $ctrl.selectedGroup.salaryScales | filter : $ctrl.search | orderBy:'code'\"> <td>{{ scale.code }}</td> <td>{{ scale.name }}</td> <td>{{ scale.hourlyWage }}</td> <td>{{ scale.conversionFactor }}</td> <td> <button ng-click=$ctrl.openEditScaleModal(scale) class=\"btn btn-xs btn-primary\"> <i class=\"fa fa-edit\"></i> </button> </td> </tr> <tr ng-if=\"!$ctrl.selectedGroup.salaryScales || $ctrl.selectedGroup.salaryScales.length === 0\"> <td colspan=5 class=\"text-center text-muted\"> <span>Geen loonschalen gevonden</span> </td> </tr> </tbody> </table> </div> </div> <div ng-if=\"!$ctrl.selectedGroup && $ctrl.salaryScaleGroups && $ctrl.salaryScaleGroups.length > 0\" class=\"text-center text-muted\" style=padding:40px> <i class=\"fa fa-info-circle fa-3x\" style=margin-bottom:15px></i> <p>Selecteer een CAO om de bijbehorende loonschalen te bekijken</p> </div> <div ng-if=\"!$ctrl.salaryScaleGroups || $ctrl.salaryScaleGroups.length === 0\" class=\"text-center text-muted\" style=padding:40px> <span>Geen CAO groepen gevonden</span> </div> </div> </div> <div class=\"modal fade\" id=salaryScaleModal tabindex=-1 role=dialog> <div class=modal-dialog role=document> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close> <span aria-hidden=true>&times;</span> </button> <h4 class=modal-title>Loonschaal details</h4> </div> <div class=modal-body> <form class=form role=form id=salaryScaleForm ng-submit=$ctrl.submitSalaryScale()> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>Code</label> <input type=text class=form-control name=code ng-model=$ctrl.currentSalaryScale.code required> </div> <div class=\"form-group col-md-12\"> <label>Naam</label> <input type=text class=form-control name=name ng-model=$ctrl.currentSalaryScale.name required> </div> <div class=\"form-group col-md-12\"> <label>Uurloon</label> <input type=number step=0.01 class=form-control name=hourlyWage ng-model=$ctrl.currentSalaryScale.hourlyWage required> </div> <div class=\"form-group col-md-12\"> <label>Omrekenfactor</label> <input type=number step=0.01 class=form-control name=conversionFactor ng-model=$ctrl.currentSalaryScale.conversionFactor required> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=salaryScaleForm> <i class=\"fa fa-save mr5\"></i><span>Opslaan</span> </button> <button class=\"btn btn-danger btn-icon mr5\" type=button ng-if=\"$ctrl.currentSalaryScale && $ctrl.currentSalaryScale.id\" ng-click=$ctrl.deleteSalaryScale()> <i class=\"fa fa-trash mr5\"></i><span>Verwijderen</span> </button> <button class=\"btn btn-info btn-icon mr5\" data-dismiss=modal> <i class=\"fa fa-close mr5\"></i><span>Sluiten</span> </button> </div> </div> </div> </div> ";

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <button type=button class=close ui-sref=^ ui-sref-opts=\"{reload: true, notify: true}\" aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Kantoorpersoneel</h4> </div> <div class=modal-body> <form class=form role=form id=staffBasicInfoForm name=staffBasicInfoForm ng-submit=$ctrl.save() novalidate> <div class=row style=padding:15px> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': staffBasicInfoForm.name.$dirty && staffBasicInfoForm.name.$invalid || staffBasicInfoForm.$submitted && staffBasicInfoForm.name.$invalid}\"> <label translate>Name</label> <input type=text class=form-control name=name ng-model=$ctrl.staff.name required> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': staffBasicInfoForm.email.$dirty && staffBasicInfoForm.email.$invalid || staffBasicInfoForm.$submitted && staffBasicInfoForm.email.$invalid}\"> <label translate>E-mail</label> <input type=text class=form-control name=email ng-model=$ctrl.staff.email required> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': staffBasicInfoForm.phoneNumber.$dirty && staffBasicInfoForm.phoneNumber.$invalid || staffBasicInfoForm.$submitted && staffBasicInfoForm.phoneNumber.$invalid}\"> <label translate>Telefoonnummer</label> <input type=text class=form-control name=phoneNumber ng-model=$ctrl.staff.phoneNumber required> </div> </div> <div class=row style=padding:15px ng-if=$ctrl.staff.id> <div class=\"form-group col-md-12\" ng-if=$ctrl.user> <label translate>Username</label> <input type=text class=form-control name=userName ng-model=$ctrl.user.userName disabled=disabled> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': staffBasicInfoForm.password.$dirty && staffBasicInfoForm.password.$invalid || staffBasicInfoForm.$submitted && staffBasicInfoForm.password.$invalid}\"> <label>Wachtwoord</label> <input type=password name=password ng-model=$ctrl.password class=form-control placeholder=\"\" password-validation> <div ng-messages=staffBasicInfoForm.password.$error ng-show=\"staffBasicInfoForm.password.$dirty || staffBasicInfoForm.$submitted\"> <div ng-message=required translate>This field is required</div> <div ng-message=validation translate>A password has to have at least 8 characters with minimal one uppercase, number and non alphanumeric character </div> </div> </div> <div class=\"form-group col-md-12\" ng-class=\"{ 'has-error': staffBasicInfoForm.confirmPassword.$dirty && staffBasicInfoForm.confirmPassword.$invalid || staffBasicInfoForm.$submitted && staffBasicInfoForm.confirmPassword.$invalid}\"> <label translate>Herhaal wachtwoord</label> <input type=password name=confirmPassword compare-to=$ctrl.password class=\"col-md-4 form-control\" ng-model=$ctrl.confirmPassword> <div ng-messages=staffBasicInfoForm.confirmPassword.$error ng-show=\"(staffBasicInfoForm.confirmPassword.$dirty || staffBasicInfoForm.$submitted) && userAccountForm.password.$valid\"> <div ng-message=required translate>This field is required</div> <div ng-message=compareTo translate>Your passwords did not match</div> </div> </div> <div class=\"form-group col-md-12\" ng-if=$ctrl.user> <label translate>Roles</label> <select class=\"form-control chosen\" multiple=multiple chosen=$ctrl.rolesList multiple=multiple ng-model=$ctrl.roles name=tag ng-options=\"item as item for item in $ctrl.rolesList\"> <option value=\"\"></option> </select> </div> <div class=col-md-12> <button class=\"btn btn-danger btn-icon\" type=button ng-click=$ctrl.deleteUser() ng-if=$ctrl.user.id><i class=\"fa fa-trash\"></i><span translate>Delete user</span></button> </div> <div class=col-md-12> <button class=\"btn btn-info\" type=button ng-click=$ctrl.createuser() ng-if=\"!$ctrl.user.id && $ctrl.staff.id\"><span translate>Gebruiker aanmaken</span></button> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-danger btn-icon\" ng-click=$ctrl.delete() ng-if=$ctrl.staff.id><i class=\"fa fa-trash\"></i><span translate>Delete</span></button> <button class=\"btn btn-success btn-icon mr5\" type=submit form=staffBasicInfoForm><i class=\"fa fa-save mr5\" ng-disabled=\"staffBasicInfoForm.$dirty && staffBasicInfoForm.$invalid\"></i><span translate>Save</span></button> <button class=\"btn btn-info btn-icon mr5\" ui-sref=^ ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-close mr5\"></i><span translate>Close</span></button> </div>";

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings translate>Settings</a> </li> <li> <a translate>Kantoorpersoneel</a> </li> </ol> </div> <div class=buttons> <button ui-sref=\"settings.staff.list.item({'id': ''})\" class=\"btn btn-primary btn-sm btn-icon pull-right mr5\"> <i class=\"fa fa-plus mr5\"></i> <span translate>Voeg personeel toe</span> </button> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control style=\"font-family:FontAwesome,'Open Sans'\" name=search ng-model=$ctrl.search placeholder=\"&#xf002; search\"/> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=accounts-table class=\"table table-hover\"> <thead> <tr> <th translate>Name</th> </tr> </thead> <tbody> <tr ui-sref=\"settings.staff.list.item({'id': item.id})\" ng-repeat=\"item in $ctrl.staff | filter : $ctrl.search\"> <td> <ng-letter-avatar data=\"{{ item.name }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{item.name}}</span> </td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a ui-sref=customers>Templates</a> </li> </ol> </div> <div class=search> <div class=\"row no-margin\"> <div class=col-md-6> <select class=\"form-control chosen\" chosen ng-model=$ctrl.currentTemplateName placeholder=\"choose a company\" ng-options=\"item for item in $ctrl.templatesNames\" ng-change=$ctrl.getTemplate()> <option value=\"\">Choose a template</option> </select> </div> <div class=col-md-6> <button class=\"pull-right btn btn-success btn-icon mr5\" ng-click=$ctrl.saveTemplate()><i class=\"fa fa-save mr5\"></i><span translate>Save</span></button> </div> </div> </div> </div> <div id=container class=template-editor-cta></div>";

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <button type=button class=close ng-click=$ctrl.closeModal() aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title>ORT basis informatie</h4> </div> <div class=modal-body> <form class=form role=form id=timezoneBasicInfoForm ng-submit=$ctrl.submitTimezone()> <div class=\"form-group col-md-12\"> <label translate>Type (selecteer of de toeslag elke dag, vaste datum of een terugkerende datum is ( bijvoorbeeld kerst ))</label> <select class=form-control name=type ng-model=$ctrl.type ng-options=\"item for item in $ctrl.types\"> </select> </div> <div class=col-md-12> <div> <div class=col-md-12> <b>Van:</b> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[1]\"> <label translate>Weekdag</label> <select class=form-control ng-model=$ctrl.from.weekDay ng-options=\"item for item in $ctrl.weekDays\"> </select> </div> <div class=\"form-group col-sm-2\" ng-if=\"$ctrl.type == $ctrl.types[2] || $ctrl.type == $ctrl.types[3]\"> <label translate>Dag (datum)</label> <input type=number min=0 max=31 step=1 class=form-control ng-model=$ctrl.from.day> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[2] || $ctrl.type == $ctrl.types[3]\"> <label translate>Maand</label> <select class=form-control ng-model=$ctrl.from.month ng-options=\"item for item in $ctrl.months\"> </select> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[3]\"> <label translate>Jaar</label> <select class=form-control ng-model=$ctrl.from.year> <option value=2020>2020</option> <option value=2021>2021</option> <option value=2022>2022</option> <option value=2023>2023</option> <option value=2024>2024</option> <option value=2025>2025</option> <option value=2026>2026</option> <option value=2027>2027</option> <option value=2028>2028</option> <option value=2029>2029</option> <option value=2030>2030</option> </select> </div> <div class=\"form-group col-sm-2\"> <label translate>Tijd</label> <div class=\"input-group bootstrap-timepicker timepicker\"> <input id=timepicker ng-model=$ctrl.from.time class=form-control data-provide=timepicker data-template=modal data-minute-step=1 data-modal-backdrop=true data-show-meridian=false data-default-time={{$ctrl.from.time}} type=text /> </div> </div> </div> <div> <div class=col-md-12> <b>Tot:</b> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[1]\"> <label translate>Weekdag</label> <select class=form-control ng-model=$ctrl.from.weekDay ng-options=\"item for item in $ctrl.weekDays\"> </select> </div> <div class=\"form-group col-sm-2\" ng-if=\"$ctrl.type == $ctrl.types[2] || $ctrl.type == $ctrl.types[3]\"> <label translate>Dag (datum)</label> <input type=number min=0 max=31 step=1 class=form-control ng-model=$ctrl.till.day> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[2] || $ctrl.type == $ctrl.types[3]\"> <label translate>Maand</label> <select class=form-control ng-model=$ctrl.till.month ng-options=\"item for item in $ctrl.months\"> </select> </div> <div class=\"form-group col-sm-4\" ng-if=\"$ctrl.type == $ctrl.types[3]\"> <label translate>Jaar</label> <select class=form-control ng-model=$ctrl.till.year> <option value=2020>2020</option> <option value=2021>2021</option> <option value=2022>2022</option> <option value=2023>2023</option> <option value=2024>2024</option> <option value=2025>2025</option> <option value=2026>2026</option> <option value=2027>2027</option> <option value=2028>2028</option> <option value=2029>2029</option> <option value=2030>2030</option> </select> </div> <div class=\"form-group col-sm-2\"> <label translate>Tijd</label> <div class=\"input-group bootstrap-timepicker timepicker\"> <input id=timepicker ng-model=$ctrl.till.time class=form-control data-provide=timepicker data-template=modal data-minute-step=1 data-modal-backdrop=true data-show-meridian=false data-default-time={{$ctrl.till.time}} type=text /> </div> </div> </div> </div> <div class=row style=padding:15px> <div class=\"form-group col-md-12\"> <label>Uurcode</label> <select class=\"form-control chosen\" chosen name=hourCode ng-model=$ctrl.timezone.hourCodeId ng-options=\"item.id as item.name for item in $ctrl.hourCodes | orderBy: 'name'\"> <option value=\"\">Selecteer uurcode</option> </select> </div> <div class=\"form-group col-md-12\"> <label>CAO</label> <select class=\"form-control chosen\" chosen name=salaryScaleGroup ng-model=$ctrl.timezone.salaryScaleGroupId ng-change=$ctrl.watchSalaryScaleGroup() ng-options=\"item.id as item.name for item in $ctrl.salaryScaleGroups | orderBy: 'name'\" required> <option value=\"\">Selecteer CAO</option> </select> </div> <div class=\"form-group col-md-12\"> <label translate>Percentage</label> <input type=number min=0 step=any class=form-control name=name ng-model=$ctrl.timezone.percentage> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-danger btn-icon\" ng-click=$ctrl.deleteTimezone() ng-if=$ctrl.timezone.id><i class=\"fa fa-trash\"></i><span translate>Delete slot</span></button> <button class=\"btn btn-success btn-icon mr5\" type=submit form=timezoneBasicInfoForm><i class=\"fa fa-save mr5\"></i><span>Opslaan</span></button> <button class=\"btn btn-info btn-icon mr5\" ng-click=$ctrl.closeModal()><i class=\"fa fa-close mr5\"></i><span>Sluiten</span></button> </div>";

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings.timezones translate>Timezones</a> </li> <li class=active> {{ $ctrl.timezone.name }} </li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-danger btn-icon btn-sm\" ng-click=$ctrl.deleteTimezone() ng-if=$ctrl.timezone.id><i class=\"fa fa-trash\"></i><span translate>Delete timezone</span></a> </div> </div> <div class=row> <div class=col-md-4> <div class=\"panel panel-primary\"> <div class=panel-heading> <div class=pull-left translate>Basic info</div> <div class=panel-controls> <a ui-sref=\"settings.timezones.item.basic({'id': $ctrl.timezone.id})\"><i class=\"fa fa-edit\"></i></a> </div> </div> <div class=\"panel-body p25\"> <div ng-if=$ctrl.timezone.fixedDateWithoutYear> <b>Van {{$ctrl.timezone.from | date : \"dd-MM HH:mm\"}} tot {{$ctrl.timezone.till | date : \"dd-MM HH:mm\"}}</b> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>HourCodeName:</b></div> <div class=col-xs-7>{{$ctrl.timezone.hourCodeName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b>CAO:</b></div> <div class=col-xs-7>{{$ctrl.timezone.salaryScaleGroupName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Percentage:</b></div> <div class=col-xs-7>{{$ctrl.timezone.percentage}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Amount:</b></div> <div class=col-xs-7>{{$ctrl.timezone.amount}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Priority:</b></div> <div class=col-xs-7>{{$ctrl.timezone.priority}}</div> </div> </div> </div> </div> </div>";

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=settings>Instellingen</a> </li> <li> <a>ORT</a> </li> </ol> </div> </div> <div class=panel> <div class=panel-body> <div class=form-group style=margin-bottom:20px> <label for=caoSelect style=font-weight:700;margin-bottom:10px;display:block>Selecteer CAO:</label> <div class=row> <div class=col-md-6> <select id=caoSelect class=form-control ng-model=$ctrl.selectedGroup ng-options=\"group as (group.name + (group.description ? ' - ' + group.description : '')) for group in $ctrl.salaryScaleGroups | orderBy:'name'\" ng-change=$ctrl.onGroupChange($ctrl.selectedGroup)> <option value=\"\">-- Selecteer een CAO --</option> </select> </div> <div class=col-md-6 ng-if=$ctrl.selectedGroup> <button ng-click=$ctrl.clearSelection() class=\"btn btn-default btn-sm\"> <i class=\"fa fa-times mr5\"></i> <span>Selectie wissen</span> </button> </div> </div> </div> <div ng-if=$ctrl.selectedGroup class=\"panel panel-primary\" style=margin-top:20px> <div class=panel-heading> <h4> <strong>{{ $ctrl.selectedGroup.name }}</strong> <span ng-if=$ctrl.selectedGroup.description class=text-muted> - {{ $ctrl.selectedGroup.description }}</span> <button ng-click=$ctrl.addTimezone() class=\"btn btn-xs btn-success pull-right mr5\"> <i class=\"fa fa-plus mr5\"></i> <span>Timezone toevoegen</span> </button> </h4> </div> <div class=panel-body> <div class=search style=margin-bottom:15px> <input class=form-control style=\"font-family:FontAwesome,'Open Sans'\" name=search ng-model=$ctrl.search placeholder=\"&#xf002; Zoeken in timezones\"/> </div> <table id=timezones-table class=\"table table-hover\"> <thead> <tr> <th> <a href=# ng-click=\"$ctrl.sortType = 'from'; sortReverse = !sortReverse\"> <span>Van</span> <span ng-show=\"$ctrl.sortType == 'from' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'from' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'till'; sortReverse = !sortReverse\"> <span>Tot</span> <span ng-show=\"$ctrl.sortType == 'till' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'till' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'hourCodeName'; sortReverse = !sortReverse\"> <span>Uurcode</span> <span ng-show=\"$ctrl.sortType == 'hourCodeName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'hourCodeName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th> <a href=# ng-click=\"$ctrl.sortType = 'percentage'; sortReverse = !sortReverse\"> <span>Percentage</span> <span ng-show=\"$ctrl.sortType == 'percentage' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'percentage' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"settings.timezones.list.item({'id': item.id})\" ng-repeat=\"item in $ctrl.timezones | filter : $ctrl.search | filter : $ctrl.caoFilter | orderBy:$ctrl.sortType:sortReverse\"> <td> <span ng-if=\"item.fixedDate && !item.fixedDateWithoutYear\">{{ item.from | date : \"dd-MM-yyyy HH:mm\" }}</span> <span ng-if=item.fixedDateWithoutYear>{{ item.from | date : \"dd-MM HH:mm\" }}</span> <span ng-if=\"!item.fixedDate && !item.fixedDateWithoutYear\">{{ item.dayOfWeek != null ? $ctrl.weekDays[item.dayOfWeek] : 'Elke dag'}} - {{ item.from | date : \"HH:mm\" }}</span> </td> <td> <span ng-if=\"item.fixedDate && !item.fixedDateWithoutYear\">{{ item.till | date : \"dd-MM-yyyy HH:mm\" }}</span> <span ng-if=item.fixedDateWithoutYear>{{ item.till | date : \"dd-MM HH:mm\" }}</span> <span ng-if=!item.fixedDate>{{ item.dayOfWeek != null ? $ctrl.weekDays[item.dayOfWeek] : 'Elke dag'}} - {{ item.till | date : \"HH:mm\" }}</span> </td> <td>{{ item.hourCodeName }}</td> <td>{{ item.percentage }}</td> </tr> <tr ng-if=\"!$ctrl.timezones || ($ctrl.timezones | filter : $ctrl.search | filter : $ctrl.caoFilter).length === 0\"> <td colspan=4 class=\"text-center text-muted\"> <span>Geen timezones gevonden</span> </td> </tr> </tbody> </table> </div> </div> <div ng-if=\"!$ctrl.selectedGroup && $ctrl.salaryScaleGroups && $ctrl.salaryScaleGroups.length > 0\" class=\"text-center text-muted\" style=padding:40px> <i class=\"fa fa-info-circle fa-3x\" style=margin-bottom:15px></i> <p>Selecteer een CAO om de bijbehorende timezones te bekijken</p> </div> <div ng-if=\"!$ctrl.salaryScaleGroups || $ctrl.salaryScaleGroups.length === 0\" class=\"text-center text-muted\" style=padding:40px> <span>Geen CAO groepen gevonden</span> </div> </div> </div> ";

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row no-margin\"> <div class=\"\" ng-class=\"$ctrl.time ? 'col-md-6 col-xs-12' : 'col-md-12'\"> <div class=\"input-group date\"> <input class=\"form-control datepicker\" ng-class=$ctrl.classes ng-model=$ctrl.dateformat ng-change=$ctrl.setDate(); ng-disabled=$ctrl.disabled /> <span class=\"input-group-addon open-datetimepicker\"><i class=\"fa fa-calendar\"></i></span> </div> </div> <div class=\"col-md-6 col-xs-12\" ng-if=$ctrl.time> <div class=\"input-group bootstrap-timepicker timepicker\"> <input class=\"form-control timepickerinput\" ng-class=$ctrl.classes ng-model=$ctrl.timeformat ng-blur=$ctrl.setTime(); ng-disabled=$ctrl.disabled /> <span class=input-group-addon><i class=\"fa fa-clock-o\"></i></span> </div> </div> </div>";

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "<div class=list-line ng-repeat=\"item in $ctrl.list.slice((($ctrl.currentPage-1)*$ctrl.itemsPerPage), (($ctrl.currentPage)*$ctrl.itemsPerPage))\" ng-if=\"$ctrl.list.length > 0\"> <div class=media> <div class=\"row link\" ng-click=$ctrl.edit(item)> <div class=\"comment col-md-8 ellipsis\"> <span>{{ item[$ctrl.setFields.description] }}</span> </div> <div class=\"meta h6 col-md-4 no-margin\"> <div class=row> <div class=col-md-12> <div class=\"type bold pull-right\"><span ng-repeat=\"tag in item[$ctrl.setFields.tags]\" class=\"chip transparant\">{{ tag }}</span></div> </div> <div class=col-md-12> <div class=\"date small pull-right\"><b>{{ item[$ctrl.setFields.date] | date : \"dd-MM-yyyy HH:mm\" }}</b> <span ng-if=item[$ctrl.setFields.endDate]><span translate>until</span> <b>{{ item[$ctrl.setFields.endDate] | date : \"dd-MM-yyyy\" }}</b></span> </div> </div> </div> <i ng-if=!$ctrl.hideDelete class=\"fa fa-trash remove-btn-left link\" style=color:red ng-click=\"$ctrl.delete($event, item)\"></i> </div> </div> </div> </div> <div class=list-line ng-if=\"$ctrl.list.length === 0\"> <div class=media> <div class=row> <div class=\"comment col-md-9 ellipsis link\"> <span translate>No items found</span> </div> <div class=\"meta h6 col-md-3 no-margin\"> </div> </div> </div> </div> <div class=datatable-bottom ng-if=\"$ctrl.list.length > $ctrl.itemsPerPage\"> <ul uib-pagination class=\"pagination-sm pull-right\" total-items=$ctrl.list.length ng-model=$ctrl.currentPage items-per-page=$ctrl.itemsPerPage max-size=$ctrl.maxSize direction-links=true boundary-links=true boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; first-text=First last-text=Last></ul> </div>";

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "<div class=form-group ng-if=\"!($ctrl.single && $ctrl.uploader.queue.length > 0)\"> <input type=file class=form-control nv-file-select uploader=$ctrl.uploader options=$ctrl.uploadOptions multiple=multiple /> </div> <div class=row ng-show=$ctrl.uploader.queue.length> <div class=col-md-12> <p class=ng-binding ng-if=!$ctrl.single>Queue length: {{ $ctrl.uploader.queue.length }}</p> <table class=\"table table-bordered table-hover table-condensed align-middle bl br\"> <thead> <tr> <th width=50%>Name</th> <th ng-show=$ctrl.uploader.isHTML5>Size</th> <th ng-show=$ctrl.uploader.isHTML5>Progress</th> <th ng-if=!$ctrl.single>Status</th> <th>Actions</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.uploader.queue\"> <td>{{item.file.name}}</td> <td>{{item.file.size | bytes}}</td> <td> <div class=progress style=margin-bottom:0> <div class=progress-bar role=progressbar ng-style=\"{ 'width': item.progress + '%' }\" style=width:0></div> </div> </td> <td ng-if=!$ctrl.single> <span ng-show=item.isSuccess style=display:none><i class=\"glyphicon glyphicon-ok\"></i></span> <span ng-show=item.isCancel style=display:none><i class=\"glyphicon glyphicon-ban-circle\"></i></span> <span ng-show=item.isError style=display:none><i class=\"glyphicon glyphicon-remove\"></i></span> </td> <td nowrap=\"\"> <button type=button class=\"btn btn-success btn-xs\" ng-click=item.upload() ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\"> <span class=\"glyphicon glyphicon-upload\"></span> Upload </button> <button type=button class=\"btn btn-warning btn-xs\" ng-click=item.cancel() ng-disabled=!item.isUploading disabled=disabled> <span class=\"glyphicon glyphicon-ban-circle\"></span> Cancel </button> <button type=button class=\"btn btn-danger btn-xs\" ng-click=item.remove()> <span class=\"glyphicon glyphicon-trash\"></span> Remove </button> </td> </tr> </tbody> </table> <div ng-if=!$ctrl.single> <p>Queue progress:</p> <div class=progress> <div class=progress-bar role=progressbar ng-style=\"{ 'width': $ctrl.uploader.progress + '%' }\" style=width:0%></div> </div> </div> <button type=button class=\"btn btn-success btn-sm\" ng-click=$ctrl.uploader.uploadAll() ng-disabled=!$ctrl.uploader.getNotUploadedItems().length disabled=disabled ng-if=!$ctrl.single> <span class=\"glyphicon glyphicon-upload\"></span> Upload all </button> <button type=button class=\"btn btn-warning btn-sm\" ng-click=$ctrl.uploader.cancelAll() ng-disabled=!$ctrl.uploader.isUploading disabled=disabled ng-if=!$ctrl.single> <span class=\"glyphicon glyphicon-ban-circle\"></span> Cancel all </button> <button type=button class=\"btn btn-danger btn-sm\" ng-click=$ctrl.uploader.clearQueue() ng-disabled=!$ctrl.uploader.queue.length disabled=disabled ng-if=!$ctrl.single> <span class=\"glyphicon glyphicon-trash\"></span> Remove all </button> </div> </div>";

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel p15\"> <div class=panel-body> <form class=form role=form id=userAccountForm name=userAccountForm ng-submit=$ctrl.createUser() ng-if=$ctrl.newUser novalidate> <div class=row> <div class=form-group ng-class=\"{ 'has-error': userAccountForm.password.$dirty && userAccountForm.password.$invalid || userAccountForm.$submitted && userAccountForm.password.$invalid}\"> <label>Wachtwoord</label> <input type=password name=password ng-model=$ctrl.password class=form-control placeholder=\"\" password-validation required> <div ng-messages=userAccountForm.password.$error ng-show=\"userAccountForm.password.$dirty || userAccountForm.$submitted\"> <div ng-message=required translate>This field is required</div> <div ng-message=validation translate>A password has to have at least 8 characters with minimal one uppercase, number and non alphanumeric character </div> </div> </div> </div> <div class=row> <div class=form-group ng-class=\"{ 'has-error': userAccountForm.confirmPassword.$dirty && userAccountForm.confirmPassword.$invalid || userAccountForm.$submitted && userAccountForm.confirmPassword.$invalid}\"> <label translate>Herhaal wachtwoord</label> <input type=password name=confirmPassword compare-to=$ctrl.password class=\"col-md-4 form-control\" ng-model=$ctrl.confirmPassword required> <div ng-messages=userAccountForm.confirmPassword.$error ng-show=\"(userAccountForm.confirmPassword.$dirty || userAccountForm.$submitted) && userAccountForm.password.$valid\"> <div ng-message=required translate>This field is required</div> <div ng-message=compareTo translate>Your passwords did not match</div> </div> </div> </div> <div class=row> <div class=\"buttons pull-right\"> <button class=\"btn btn-success btn-icon\" type=submit form=userAccountForm ng-disabled=!userAccountForm.$valid> <i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> </div> </div> </form> <div ng-if=!$ctrl.newUser> <div class=row> {{ $ctrl.employee.displayName }} heeft een gebruikersaccount met gebruikersnaam {{ $ctrl.userAccount.userName }} </div> <div class=row> <button class=\"btn btn-danger btn-icon\" type=button ng-click=$ctrl.deleteUser($ctrl.employee)> <i class=\"fa fa-trash mr5\"></i> <span translate>Delete user</span> </button> </div> </div> </div> </div>";

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ng-click=$ctrl.closeModal() aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Shift</h4> </div> <div class=\"modal-body tabs\" id=checkAvailabilityModalBody> <form class=form id=shiftForm ng-submit=$ctrl.submitShift() style=height:100%> <div class=\"row no-margin selectors-cta\"> <div class=col-md-7> <div class=\"row mt0\"> <div class=\"dropdown form-group col-md-6 dropdown-start-parent\"> <label>Start</label> <date-time-picker-component date=$ctrl.shift.start></date-time-picker-component> </div> <div class=\"form-group col-md-6\"> <label translate>Account</label> <select class=\"form-control chosen\" chosen=$ctrl.accounts name=account ng-model=$ctrl.shift.teamLocationAccountId ng-options=\"account.id as account.name for account in $ctrl.accounts | orderBy:'name'\" ng-change=$ctrl.selectedAccount()></select> </div> </div> <div class=\"row mt0\"> <div class=\"dropdown form-group col-md-6 dropdown-end-parent\"> <label>End</label> <date-time-picker-component date=$ctrl.shift.end></date-time-picker-component> </div> <div class=\"form-group col-md-6\" ng-if=$ctrl.shift.teamLocationAccountId> <label translate>Location</label> <select class=\"form-control chosen\" chosen=$ctrl.locations name=location ng-model=$ctrl.shift.teamLocationId ng-options=\"location.id as location.name for location in $ctrl.locations | orderBy:'name'\" ng-change=$ctrl.locationSelected()></select> </div> </div> <div class=\"row mt0\"> <div class=\"form-group col-md-6\"> <label translate>Customer reference</label> <input class=form-control name=name ng-model=$ctrl.shift.customerReference> </div> <div class=\"form-group col-md-6\" ng-if=$ctrl.shift.teamLocationId> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams name=team ng-model=$ctrl.shift.teamId ng-options=\"team.id as team.name for team in $ctrl.teams | orderBy:'name'\"></select> </div> </div> </div> <div class=\"form-group col-md-2 pl15\"> <label translate>Comment</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.comment></textarea> </div> <div class=col-md-3> <div class=panel> <div class=\"panel-body pt0\"> <div ng-if=\"$ctrl.accountNotes.length > 0\"> <div class=bold translate>Account notes</div> <div ng-repeat=\"note in $ctrl.accountNotes\"> {{ note.description }} </div> </div> </div> </div> </div> </div> <div class=\"row no-margin employee-picker-cta\" ng-if=$ctrl.employees style=\"height:calc(100% - 237px)\"> <employee-picker-component shift=$ctrl.shift employees=$ctrl.employees functions=$ctrl.functions is-embedded=true selected-employee=$ctrl.selectedEmployee active-employee=$ctrl.activeEmployee></employee-picker-component> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" type=submit form=shiftForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon mr5\" ng-click=$ctrl.closeModal()><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "<div class=row style=height:100%> <div class=col-md-2 style=\"height:100%;border:0 solid red\" ng-if=!$ctrl.disableFilter> <uib-accordion close-others=true> <div uib-accordion-group class=\"panel filters-panel\" is-open=true> <uib-accordion-heading> <b translate>Global filters</b> </uib-accordion-heading> <div> <label class=small> <input type=checkbox ng-model=$ctrl.subscription[0] ng-change=$ctrl.filterEmployees() /> <span translate>Subscribed</span> </label> </div> <div> <label class=small> <input type=checkbox ng-model=$ctrl.availabilities[0] ng-change=$ctrl.filterEmployees() /> <span translate>Available</span> </label> </div> <div> <label class=small> <input type=checkbox ng-model=$ctrl.history[0] ng-change=$ctrl.filterEmployees() /> <span translate>Previously at location</span> </label> </div> </div> <div uib-accordion-group class=\"panel filters-panel\"> <uib-accordion-heading> <b translate>Function</b> </uib-accordion-heading> <div ng-repeat=\"function in $ctrl.functions | orderBy:'name'\"> <label class=small> <input type=checkbox ng-model=function.value ng-change=$ctrl.filterEmployees() /> {{ function.name }}</label> </div> </div> <div uib-accordion-group class=\"panel filters-panel\"> <uib-accordion-heading> <b translate>Kilometers</b> </uib-accordion-heading> <div ng-repeat=\"range in $ctrl.ranges | orderBy:'min'\"> <label class=small> <input type=checkbox ng-model=range.value ng-change=$ctrl.filterEmployees() /> {{ range.name }}</label> </div> </div> </uib-accordion> </div> <div style=height:100% ng-class=\"$ctrl.disableFilter ? ( $ctrl.disableInfo ? 'col-md-12' : 'col-md-7' ) : ( $ctrl.disableInfo ?'col-md-10' : 'col-md-5')\"> <div class=col-md-12> <input class=form-control name=search ng-model=$ctrl.search placeholder=search /> </div> <div style=\"height:calc(100% - 40px);overflow:auto\" class=col-md-12> <div class=list-line ng-class=\"{'selected': employeeSummary.employee.id == $ctrl.shift.employeeId}\" ng-repeat=\"employeeSummary in $ctrl.employees | filter: $ctrl.search | orderBy: ['order', 'employee.name'] track by $index\" ng-click=$ctrl.employeeSelected(employeeSummary) ng-mouseover=$ctrl.employeeActive(employeeSummary) ng-if=\"employeeSummary.employee.name.length > 0\"> <div class=media> <div class=\"row no-margin\"> <div class=\"comment col-md-12\"> <div class=col-md-1> <i class=\"fa fa-circle avail-marker\" ng-class=\"{'icon-success': employeeSummary.isAvailable && !employeeSummary.conflictingShift && employeeSummary.availability, 'icon-danger': !employeeSummary.isAvailable, 'icon-warning': employeeSummary.conflictingShift}\"></i> </div> <div class=col-md-8> <span>{{ employeeSummary.employee.name }}</span> <br> <span> <i class=small>{{ employeeSummary.employee.function }}&nbsp;</i> </span> </div> <div class=col-md-3> <span class=pull-right> <i class=small>{{ employeeSummary.availability.name }}</i> </span> <br> <span class=pull-right ng-if=employeeSummary.employee.kilometers> <i class=small>{{ employeeSummary.employee.kilometers | number:1 }} km</i> </span> </div> </div> <div class=col-md-12 ng-if=employeeSummary.subscription> <div class=col-md-6 style=padding-top:5px><span class=\"label label-primary\" translate>Subscribed</span></div> <div class=col-md-6 style=padding-top:8px> <a><i class=\"fa fa-trash pull-right\" style=color:red;cursor:pointer ng-click=\"$ctrl.removeSubscription(employeeSummary.subscription, employeeSummary); $event.stopPropagation();\"></i></a> </div> <div class=col-md-12 ng-if=$ctrl.disableInfo> <i>{{employeeSummary.subscription.comment}}</i> </div> </div> </div> </div> </div> </div> </div> <div class=col-md-5 style=\"height:100%;border:0 solid red\" ng-if=!$ctrl.disableInfo> <div class=selected-employee-description> <div ng-if=$ctrl.selectedEmployee> <employee-summary-component employee-summary=$ctrl.selectedEmployee shift=$ctrl.shift is-embedded=$ctrl.isEmbedded></employee-summary-component> </div> </div> <div class=active-employee-description ng-if=$ctrl.activeEmployee> <div ng-if=$ctrl.activeEmployee> <employee-summary-component employee-summary=$ctrl.activeEmployee shift=$ctrl.shift is-embedded=$ctrl.isEmbedded></employee-summary-component> </div> </div> </div> </div>";

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=\"col-md-8 bold\"> {{$ctrl.employeeSummary.employee.name}} </div> <div class=\"col-md-4 bold align-right\"> {{$ctrl.employeeSummary.employee.function }} </div> </div> <div class=small ng-if=$ctrl.employeeSummary.subscription> <div class=row> <div class=\"col-md-5 bold\" translate>Subscribed</div> <div class=col-md-7> {{$ctrl.employeeSummary.subscription.comment}} </div> </div> </div> <div class=small> <div class=row> <div class=\"col-md-5 bold\" translate>Status:</div> <div class=col-md-7><span ng-if=$ctrl.employeeSummary.availability>{{ $ctrl.employeeSummary.availability.name }}</span><span ng-if=!$ctrl.employeeSummary.availability translate>Unknown</span></div> </div> <div class=\"row mt0\" ng-if=$ctrl.employeeSummary.availability> <div class=\"col-md-5 bold\" translate>Date:</div> <div class=col-md-7> {{ $ctrl.employeeSummary.availability.from | date : \"dd-MM-yyyy HH:mm\" }} <span> tot </span> {{ $ctrl.employeeSummary.availability.till | date : \"dd-MM-yyyy HH:mm\" }} </div> </div> </div> <div class=small ng-if=$ctrl.employeeSummary.conflictingShift> <div class=row style=color:red> <div class=\"col-md-5 bold\" translate>Conflicting shift:</div> <div class=col-md-7>{{ $ctrl.employeeSummary.conflictingShift.name}}</div> </div> <div class=\"row mt0\" style=color:red> <div class=\"col-md-5 bold\" translate>Date:</div> <div class=col-md-7> {{ $ctrl.employeeSummary.conflictingShift.start | date : \"dd-MM-yyyy HH:mm\" }} <span> tot </span> {{ $ctrl.employeeSummary.conflictingShift.end | date : \"dd-MM-yyyy HH:mm\" }} </div> </div> </div> <div class=small ng-if=$ctrl.employeeSummary.employee.kilometers> <div class=row> <div class=\"col-md-5 bold\" translate>Distance:</div> <div class=col-md-7>{{ $ctrl.employeeSummary.employee.kilometers | number:1 }} <span translate>km</span></div> </div> </div> <div class=small ng-if=$ctrl.employeeSummary.history> <div class=row> <div class=\"col-md-5 bold\" translate>Previously at location:</div> <div class=col-md-7>{{ $ctrl.employeeSummary.history.count }} <span translate>times</span></div> </div> <div class=\"row mt0\"> <div class=\"col-md-5 bold\" translate>Last shifts:</div> <div class=col-md-7> <span ng-repeat=\"date in $ctrl.employeeSummary.history.dates\"> {{ date | date : \"dd-MM-yyyy\" }} <span ng-if=!$last>,</span> </span> </div> </div> </div> <div class=small ng-if=\"$ctrl.employeeSummary.notes.length > 0\"> <div class=row> <div class=\"col-md-5 bold\" translate>Notes:</div> <div class=col-md-7> <div ng-repeat=\"(key, value) in $ctrl.employeeSummary.notes track by $index\"> {{ value }} </div> </div> </div> </div> <div class=\"col-md-6 small\" ng-if=\"$ctrl.employeeSummary.skills.length > 0\"> <div class=\"row mt10\"> <div class=\"col-md-12 bold\" translate>Skills</div> </div> <div ng-repeat=\"skill in $ctrl.employeeSummary.skills\"> <div class=\"row mt0\"> <div class=col-md-4 translate>Name:</div> <div class=col-md-8>{{ skill.name }}</div> </div> <div class=\"row mt0\"> <div class=col-md-4 translate>Comment:</div> <div class=col-md-8>{{ skill.comment }}</div> </div> </div> </div> ";

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar shift-calendar-header-cta\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Shifts</a> </li> </ol> </div> <div class=buttons> <button type=button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=shifts.list><i class=\"fa fa-list mr5\"></i><span translate>List</span></button> <button type=button class=\"pull-right btn btn-primary btn-icon btn-sm mr10\" ui-sref=\"shifts.list.item({'id': ''})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Shift</span></button> </div> </div> <div class=row> <div class=col-sm-12> <div class=calendar-viewer> <div ui-calendar=$ctrl.uiConfig.calendar class=fullcalendar calendar=shiftsCalendar ng-model=$ctrl.eventSources></div> </div> </div> </div>";

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div>";

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title translate>Shift</h4> </div> <div class=\"modal-body tabs\"> <div class=panel> <div class=panel-body> <form class=form id=shiftForm name=shiftForm ng-submit=\"shiftForm.$valid && $ctrl.submitShift()\"> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.shift.start max-date=$ctrl.shift.end></date-time-picker-component> </div> <div class=\"form-group col-md-6\" permission permission-only=\"['BACKOFFICE']\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen=$ctrl.statuses ng-model=$ctrl.shift.status ng-options=\"item.code*1 as item.name for item in $ctrl.statuses\"> </select> </div> <div class=\"form-group col-md-6\" permission permission-only=\"['EMPLOYEE', 'CUSTOMER']\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen=$ctrl.statuses ng-model=$ctrl.shift.status ng-options=\"item.code*1 as item.name for item in $ctrl.statuses\" disabled=disabled> </select> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\"> <label translate>End</label> <date-time-picker-component date=$ctrl.shift.end min-date=$ctrl.shift.start></date-time-picker-component> </div> <div class=\"form-group col-md-6\"> <label translate>Customer reference</label> <input class=form-control name=name ng-model=$ctrl.shift.customerReference> </div> </div> <div class=\"row no-margin\" permission permission-except=\"['CUSTOMER']\"> <div class=\"form-group col-md-6\"> <label translate>Function</label> <select class=\"form-control chosen\" chosen=$ctrl.functions name=function ng-model=$ctrl.shift.functionId ng-options=\"function.id as function.name for function in $ctrl.functions | orderBy:'name'\"></select> </div> <div class=\"form-group col-md-6\"> <label translate>Opdrachtgever</label> <select class=\"form-control chosen\" chosen=$ctrl.accounts name=account ng-model=$ctrl.shift.teamLocationAccountId ng-options=\"account.id as account.name for account in $ctrl.accounts | orderBy:'name'\" ng-change=$ctrl.selectedAccount() required></select> <div ng-messages=shiftForm.account.$error ng-show=\"shiftForm.account.$touched || shiftForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" permission permission-only=\"['BACKOFFICE']\"> <label translate>Employee</label> <select class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.shift.employeeId ng-options=\"employee.id as employee.displayName for employee in $ctrl.employees | orderBy:'displayName'\"></select> </div> <div class=\"form-group col-md-6\" permission permission-only=\"['CUSTOMER']\"> <label translate>Employee</label> <select class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.shift.employeeId ng-options=\"accountEmployee.employeeId as accountEmployee.employeeDisplayName for accountEmployee in $ctrl.employees | orderBy:'employeeDisplayName'\"></select> </div> <div class=\"form-group col-md-6\" ng-if=$ctrl.shift.teamLocationAccountId> <label translate>Location</label> <select class=\"form-control chosen\" chosen=$ctrl.locations name=location ng-model=$ctrl.shift.teamLocationId ng-options=\"location.id as location.name for location in $ctrl.locations | orderBy:'name'\" ng-change=$ctrl.locationSelected() required></select> <div ng-messages=shiftForm.location.$error ng-show=\"shiftForm.location.$touched || shiftForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> <div class=\"form-group col-md-6\" ng-if=$ctrl.shift.teamLocationId permission permission-only=\"['EMPLOYEE']\"> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams name=team ng-model=$ctrl.shift.teamId ng-options=\"team.id as team.name for team in $ctrl.teams | orderBy:'name'\" required></select> <div ng-messages=shiftForm.team.$error ng-show=\"shiftForm.team.$touched || shiftForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment internal</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.comment></textarea> </div> <div class=\"form-group col-md-6\" permission permission-only=\"['CUSTOMER']\"> <label translate>Comment customer</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.customerComment disabled=disabled></textarea> </div> <div class=\"form-group col-md-6\" ng-if=$ctrl.shift.teamLocationId permission permission-only=\"['BACKOFFICE', 'CUSTOMER']\"> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams name=team ng-model=$ctrl.shift.teamId ng-options=\"team.id as team.name for team in $ctrl.teams | orderBy:'name'\" required></select> <div ng-messages=shiftForm.team.$error ng-show=\"shiftForm.team.$touched || shiftForm.$submitted\"> <div ng-message=required translate>This field is required</div> </div> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-6\" permission permission-only=\"['BACKOFFICE', 'EMPLOYEE']\"> <label translate>Comment employee</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.employeeComment></textarea> </div> <div class=\"form-group col-md-6\" permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment customer</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.customerComment></textarea> </div> </div> </form> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-sm btn-success btn-icon mr5\" type=submit form=shiftForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-sm btn-success btn-icon mr5\" type=button form=shiftForm ng-click=\"$ctrl.submitShift('copy')\" permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-copy mr5\"></i> <span translate>Save and copy</span> </button> <button class=\"btn btn-sm btn-success btn-icon mr5\" type=button form=shiftForm ng-click=\"$ctrl.submitShift('new')\" permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-file-o mr5\"></i> <span translate>Save and new</span> </button> <button class=\"btn btn-sm btn-danger btn-icon mr5\" type=button ng-click=$ctrl.deleteShift() ng-if=$ctrl.shift.id><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span></button> <a class=\"btn btn-sm btn-info btn-icon mr5\" ui-sref=^><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<div class=panel style=\"height:calc(100% - 69px)\"> <div class=panel-body style=height:100%;overflow:none> <employee-picker-component shift=$ctrl.shift employees=$ctrl.employees selected-employee=$ctrl.selectedEmployee functions=$ctrl.functions></employee-picker-component> </div> </div> <div class=panel-footer> <button class=\"btn btn-success btn-sm btn-icon pull-right\" type=button ng-click=$ctrl.submitShift() ng-disabled=!$ctrl.shift.employeeId> <i class=\"fa fa-save mr5\"></i> <span translate>Assign</span> </button> <button class=\"btn btn-info btn-sm btn-icon pull-right mr10\" type=button ng-click=$ctrl.unassignEmployee() ng-disabled=!$ctrl.shift.employeeId> <i class=\"fa fa-close mr5\"></i> <span translate>Unassign</span> </button> </div>";

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=search> <form class=form ng-submit=$ctrl.getShiftsByDate()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()> <i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=date-input> <date-time-picker-component date=$ctrl.startDate time=false add-class=\"[ 'input-sm']\"></date-time-picker-component> </div> <div class=date-input style=width:auto;line-height:30px> tot </div> <div class=date-input> <date-time-picker-component date=$ctrl.endDate time=false add-class=\"[ 'input-sm']\"></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.nextWeek()> <span translate>Next</span> <i class=\"fa fa-angle-right ml5\"></i> </button> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=submit> <i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> <div class=\"form-group right-buttons\"> <button type=button class=\"btn btn-primary btn-icon mr5 btn-sm\" ui-sref=\".item({ 'id': ''})\"> <i class=\"fa fa-plus mr\"></i> <span translate>Add Shift</span> </button> <button type=button class=\"btn btn-primary btn-icon btn-sm\" ui-sref=^.calendar> <i class=\"fa fa-calendar\"></i> <span translate>Calendar</span> </button> </div> </div> </form> </div> </div> <div class=row> <div class=col-md-12> <div class=panel> <div class=panel-body> <div class=\"row no-margin\"> <div class=col-md-12> <table style=width:100%> <tr> <td style=width:275px permission permission-only=\"[ 'BACKOFFICE']\"> <form class=form-inline ng-submit=$ctrl.submitAction()> <select class=\"form-control input-sm\" ng-model=$ctrl.actionform.action> <option value=\"\" translate>Actions</option> <option value=setstatus translate>Set status</option> <option value=setemployee translate>Set employee</option> <option value=emailteam translate>Email team</option> <option value=emailemployee translate>Email employee</option> <option value=delete translate>Delete</option> </select> <select class=\"form-control input-sm\" ng-model=$ctrl.actionform.status ng-options=\"item.name for item in $ctrl.statuses\" ng-if=\"$ctrl.actionform.action=='setstatus'\" required> <option value=\"\" translate>Select status</option> </select> <select class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.actionform.employee ng-options=\"employee.displayName for employee in $ctrl.employees | orderBy: 'displayName'\r\n                \" ng-if=\"$ctrl.actionform.action=='setemployee'\"></select> <button class=\"btn btn-success btn-sm\" type=submit> <span translate>Apply</span> </button> </form> </td> <td class=\"pl10 pr10\" style=\"width:50px;border-left:1px solid #ccc\"> <b> <span translate class=\"\">Filters</span> </b> </td> <td class=pr10> <input class=\"form-control input-sm\" name=search ng-model=$ctrl.filter.search placeholder=search ng-change=$ctrl.setFilters() ng-model-options=\"{debounce: 750}\"/> </td> <td class=pr10> <select class=\"form-control input-sm\" ng-model=$ctrl.filter.status ng-options=\"item.code as item.name for item in $ctrl.statuses\" ng-change=$ctrl.setFilters()> <option value=\"\" translate>Filter by status</option> </select> </td> <td class=\"\" permission permission-only=\"['BACKOFFICE']\"> <select class=form-control ng-model=$ctrl.filter.createdby ng-change=$ctrl.setFilters()> <option value=\"\" translate>Filter created by</option> <option value={{$ctrl.user.userName}} translate>Created by me</option> </select> </td> <td> <button class=\"btn btn-info pull-right ml10 btn-sm\" type=button ng-click=$ctrl.resetFilters();> <span translate>Reset all</span> </button> </td> </tr> </table> </div> </div> </div> </div> </div> <div fixed-height style=overflow:hidden ng-class=\"$ctrl.isMessageOpen ? 'col-md-4' : 'col-md-12'\"> <div class=panel style=height:100%> <div class=panel-body style=height:100%;overflow:auto;padding:0 ng-if=!$ctrl.isMessageOpen> <table class=\"table table-hover\" infinite-scroll=$ctrl.nextPage() infinite-scroll-disabled=$ctrl.loading infinite-scroll-distance=1 infinite-scroll-parent> <thead> <tr> <th permission permission-only=\"[ 'BACKOFFICE']\"> <input type=checkbox ng-click=$ctrl.selectAllChange() ng-model=$ctrl.selectAll /> </th> <th translate>Startdatum</th> <th translate>Starttijd</th> <th translate>Eindtijd</th> <th translate>Organisatie</th> <th translate>Location</th> <th translate>Team</th> <th translate>Status</th> <th translate>Employee</th> <th translate>Function</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.shifts\"> <td permission permission-only=\"[ 'BACKOFFICE']\"> <input type=checkbox ng-model=item.$selected /> </td> <td> {{item.start | date :\"dd-MM-yyyy\"}} </td> <td> {{item.start | date :\"HH:mm\"}} </td> <td> {{item.end | date :\"HH:mm\"}} </td> <td> {{ item.teamLocationAccountName }} </td> <td> {{ item.teamLocationName }} </td> <td> {{ item.teamName }} </td> <td> <span ng-style=\"{background: item.statusColor}\" class=\"chip status-chip\" ng-if=\"item.status && item.status!=2\"> {{ item.statusName }} </span> <span class=\"chip status-chip\" style=cursor:pointer ng-style=\"{background: item.statusColor}\" ng-class=\"item.subscriptionsCount > 0 ? 'subscribed' : ''\" ng-if=\"item.status && item.status==2\" ui-sref=\"shifts.list.subscriptionsmodal({'id': item.id})\">{{ item.statusName }} <span ng-if=\"item.status==2\">({{ item.subscriptionsCount }})</span> </span> </td> <td> {{item.employeeDisplayName}} </td> <td> {{ item.functionName }} </td> <td> <a class=\"btn btn-info btn-icon btn-xs pull-right mr5\" ui-sref=\".item({ 'id': item.id})\" permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-edit\"></i> <span translate>Edit</span> </a> <a class=\"btn btn-info btn-icon btn-xs pull-right mr5\" ui-sref=\".item({ 'id': item.id})\" permission permission-only=\"[ 'CUSTOMER']\"> <i class=\"fa fa-edit\"></i> <span translate>Open</span> </a>  </td> </tr> <tr ng-if=\"$ctrl.loading && !$ctrl.endList\"> <td colspan=8>Loading...</td> </tr> </tbody> </table> </div> <div class=panel-body id=shiftsmalllist style=height:100%;overflow:auto;padding:0 ng-if=$ctrl.isMessageOpen> <div infinite-scroll=$ctrl.nextPage() infinite-scroll-disabled=$ctrl.loading infinite-scroll-distance=1 infinite-scroll-parent> <div ng-repeat=\"(key, shifts) in $ctrl.groupedShifts\" class=shift-list> <div class=\"list-line heading-line\"> {{ key }} </div> <div class=list-line id=s-{{item.id}} ui-sref-active=active ng-class=\"{ 'active': $ctrl.currentShift.id===item.id, 'assigned': item.employeeId, 'not-assigned': !item.employeeId}\" ng-repeat=\"item in shifts\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <div class=\"letter-avatar valign-center\"> <input type=checkbox ng-model=item.$selected class=selectshift /> </div> <div class=shift-item ui-sref=\"{ 'id': item.id}\"> <span class=bold>{{ item.teamLocationName }}</span> - <span class=bold>{{ item.teamName }}</span> <div class=shift-summary> <span ng-if=\"!$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm\" }}</span> <span translate>to</span> {{ item.end | date :\"HH:mm dd-MM-yyyy\" }} <span class=\"chip status-chip pull-right\" ng-style=\"{background: item.statusColor}\" ng-if=item.status> {{ item.statusName }} <span ng-if=\"item.status==2\">({{ item.subscriptionsCount }})</span> </span> </div> <span class=bold>{{ item.employeeDisplayName }}</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div fixed-height resize={{$ctrl.isMessageOpen}} class=col-md-8 ng-show=$ctrl.isMessageOpen> <div class=panel> <div class=panel-body> <a class=\"btn btn-sm btn-info btn-icon ml10\" ui-sref=shifts.list permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-list mr5\"></i> <span translate>List</span> </a> <a class=\"btn btn-sm btn-info btn-icon ml10\" ui-sref=customerShifts.list permission permission-only=\"[ 'CUSTOMER']\"> <i class=\"fa fa-list mr5\"></i> <span translate>List</span> </a> <a class=\"btn btn-sm btn-info btn-icon ml10\" ui-sref=\"shifts.list.item({ 'id': $ctrl.currentShift.id})\" permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-info mr5\"></i> <span translate>Shift data</span> </a> <button class=\"btn btn-sm btn-info btn-icon ml10\" ui-sref=\"shifts.list.item.employee({ 'id': $ctrl.currentShift.id})\" ng-disabled=!$ctrl.currentShift.id permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-user mr5\"></i> <span translate>Employee selector</span> </button> <button class=\"btn btn-info btn-sm btn-icon pull-right ml10\" type=button ng-click=$ctrl.notifyEmployee() ng-disabled=!$ctrl.currentShift.employeeId permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-paper-plane mr5\"></i> <span translate>Notify employee</span> </button> <button class=\"btn btn-info btn-sm btn-icon pull-right ml10\" type=button ng-click=$ctrl.notifyTeam() ng-disabled=!$ctrl.currentShift.teamId permission permission-only=\"[ 'BACKOFFICE']\"> <i class=\"fa fa-paper-plane mr5\"></i> <span translate>Notify team</span> </button> </div> </div> <div class=panel style=\"height:calc(100% - 68px);overflow:none;border:0 solid red;margin-bottom:0\"> <div class=panel-body style=height:100%;padding:0> <div ui-view=shiflistitem on-change=\"$ctrl.handleChildChange(type, data)\" style=height:100% class=no-animate></div> </div> </div> </div> </div>";

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<div class=panel style=\"height:calc(100% - 69px)\"> <div class=panel-body style=height:100%;overflow:auto> <form class=form id=shiftForm name=shiftForm> <div ng-if=$ctrl.shift.id> <h5 class=pull-left>{{$ctrl.shift.teamLocationName}} - {{$ctrl.shift.teamName}}</h5> <span ng-if=$ctrl.shift.createdByEmployee class=pull-right><b>Aangemaakt door medewerker</b></span> </div> <div ng-if=!$ctrl.shift.id> <h5 translate>New shift</h5> </div> <div class=clearfix></div> <hr> <div class=row> <div class=col-md-6> <div class=form-group permission permission-only=\"['BACKOFFICE', 'EMPLOYEE']\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.shift.start max-date=$ctrl.shift.end></date-time-picker-component> </div> <div class=form-group permission permission-only=\"['CUSTOMER']\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.shift.start min-date=$ctrl.currentDate max-date=$ctrl.shift.end disabled=\"$ctrl.shift.status > 5 && $ctrl.shift.id\"></date-time-picker-component> </div> <div class=form-group permission permission-only=\"['BACKOFFICE', 'EMPLOYEE']\"> <label translate>End</label> <date-time-picker-component date=$ctrl.shift.end min-date=$ctrl.shift.start></date-time-picker-component> </div> <div class=form-group permission permission-only=\"['CUSTOMER']\"> <label translate>End</label> <date-time-picker-component date=$ctrl.shift.end min-date=$ctrl.shift.start disabled=\"$ctrl.shift.status > 5 && $ctrl.shift.id\"></date-time-picker-component> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Employee</label> <select class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.shift.employeeId ng-options=\"employee.id as employee.displayName for employee in $ctrl.employees | orderBy:'displayName'\" ng-change=$ctrl.selectEmployee()></select> <div class=\"alert alert-warning\" ng-if=$ctrl.employeeCaoWarning style=margin-top:10px> <i class=\"fa fa-exclamation-triangle mr5\"></i> {{$ctrl.employeeCaoWarning}} </div> </div> <div class=form-group permission permission-only=\"['CUSTOMER']\"> <label translate>Employee</label> <select ng-if=!$ctrl.shift.id class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.shift.employeeId ng-options=\"employee.id as employee.displayName for employee in $ctrl.employees | orderBy:'displayName'\" ng-change=$ctrl.selectEmployee()></select> <select ng-if=\"$ctrl.shift.status > 5 && $ctrl.shift.id\" class=\"form-control chosen\" chosen=$ctrl.employees name=employee ng-model=$ctrl.shift.employeeId ng-options=\"employee.id as employee.displayName for employee in $ctrl.employees | orderBy:'displayName'\" ng-change=$ctrl.selectEmployee() disabled=disabled></select> <div class=\"alert alert-warning\" ng-if=$ctrl.employeeCaoWarning style=margin-top:10px> <i class=\"fa fa-exclamation-triangle mr5\"></i> {{$ctrl.employeeCaoWarning}} </div> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment internal</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.internalComment></textarea> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment employee</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.employeeComment></textarea> </div> <div class=form-group permission permission-only=\"['EMPLOYEE']\"> <label translate>Comment employee</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.employeeComment disabled=disabled></textarea> </div> <div class=form-group permission permission-only=\"['BACKOFFICE','CUSTOMER']\"> <label translate>Comment customer</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.customerComment></textarea> </div> </div> <div class=col-md-6> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen=$ctrl.statuses ng-model=$ctrl.shift.status ng-options=\"item.code*1 as item.name for item in $ctrl.statuses\" data-placeholder=\"Selecteer een status...\"> </select> </div> <div class=form-group permission permission-only=\"['EMPLOYEE', 'CUSTOMER']\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen=$ctrl.statuses ng-model=$ctrl.shift.status ng-options=\"item.code*1 as item.name for item in $ctrl.statuses\" data-placeholder=\"Selecteer een status...\" disabled=disabled> </select> </div> <div class=form-group permission permission-only=\"['BACKOFFICE', 'CUSTOMER']\" ng-class=\"{ 'has-error' : shiftForm.function.$invalid && (shiftForm.function.$touched || shiftForm.$submitted) }\"> <label>Functie</label> <select class=\"form-control chosen\" chosen=$ctrl.availableFunctions name=function ng-model=$ctrl.shift.functionId ng-options=\"function.id as function.name for function in $ctrl.availableFunctions | orderBy:'name'\" required data-placeholder=\"Selecteer een functie...\"></select> <div ng-messages=shiftForm.function.$error ng-show=\"shiftForm.function.$touched || shiftForm.$submitted\" style=color:red> <div ng-message=required>Dit veld is verplicht</div> </div> </div> <div class=form-group> <label translate>Customer reference</label> <input class=form-control name=name ng-model=$ctrl.shift.customerReference> </div> <div class=form-group permission permission-except=\"['CUSTOMER']\" ng-class=\"{ 'has-error' : shiftForm.account.$invalid && (shiftForm.account.$touched || shiftForm.$submitted) }\"> <label translate>Opdrachtgever</label> <select class=\"form-control chosen\" chosen=$ctrl.accounts name=account ng-model=$ctrl.shift.teamLocationAccountId ng-options=\"account.id as account.name for account in $ctrl.accounts | orderBy:'name'\" ng-change=$ctrl.selectedAccount() required></select> <div ng-messages=shiftForm.account.$error ng-show=\"shiftForm.account.$touched || shiftForm.$submitted\" style=color:red> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-if=$ctrl.shift.teamLocationAccountId ng-class=\"{ 'has-error' : shiftForm.location.$invalid && (shiftForm.location.$touched || shiftForm.$submitted) }\"> <label translate>Location</label> <select class=\"form-control chosen\" chosen=$ctrl.locations name=location ng-model=$ctrl.shift.teamLocationId ng-options=\"location.id as location.name for location in $ctrl.locations | orderBy:'name'\" ng-change=$ctrl.locationSelected() required></select> <div ng-messages=shiftForm.location.$error ng-show=\"shiftForm.location.$touched || shiftForm.$submitted\" style=color:red> <div ng-message=required translate>This field is required</div> </div> </div> <div ng-if=\"$ctrl.shift.teamLocationId && $ctrl.getUsedCaoName()\" class=text-muted style=margin-top:5px;font-size:12px> <i class=\"fa fa-info-circle mr5\"></i> <span translate>Te gebruiken CAO:</span> <strong>{{$ctrl.getUsedCaoName()}}</strong> </div> <div class=form-group ng-if=$ctrl.shift.teamLocationId permission permission-only=\"['EMPLOYEE']\" ng-class=\"{ 'has-error' : shiftForm.team.$invalid && (shiftForm.team.$touched || shiftForm.$submitted) }\"> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams name=team ng-model=$ctrl.shift.teamId ng-options=\"team.id as team.name for team in $ctrl.teams | orderBy:'name'\" required></select> <div ng-messages=shiftForm.team.$error ng-show=\"shiftForm.team.$touched || shiftForm.$submitted\" style=color:maroon> <div ng-message=required translate>This field is required</div> </div> </div> <div class=form-group ng-if=$ctrl.shift.teamLocationId permission permission-only=\"['BACKOFFICE', 'CUSTOMER']\" ng-class=\"{ 'has-error' : shiftForm.team.$invalid && (shiftForm.team.$touched || shiftForm.$submitted) }\"> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams name=team ng-model=$ctrl.shift.teamId ng-options=\"team.id as team.name for team in $ctrl.teams | orderBy:'name'\" required></select> <div ng-messages=shiftForm.team.$error ng-show=\"shiftForm.team.$touched || shiftForm.$submitted\" style=color:maroon> <div ng-message=required translate>This field is required</div> </div> </div> </div> </div> </form> </div> </div> <div class=\"panel-footer pull-right\"> <button class=\"btn btn-sm btn-success btn-icon\" type=button form=shiftForm ng-click=$ctrl.submitShift()><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <button class=\"btn btn-sm btn-success btn-icon\" type=button form=shiftForm ng-click=\"$ctrl.submitShift('copy')\" permission permission-only=\"['BACKOFFICE', 'CUSTOMER']\"><i class=\"fa fa-copy mr5\"></i> <span translate>Save and copy</span> </button> <button class=\"btn btn-sm btn-success btn-icon\" type=button form=shiftForm ng-click=\"$ctrl.submitShift('new')\" permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-file-o mr5\"></i> <span translate>Save and new</span> </button> <button class=\"btn btn-sm btn-danger btn-icon\" type=button ng-click=$ctrl.deleteShift() ng-if=$ctrl.shift.id permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span></button> <button class=\"btn btn-sm btn-danger btn-icon\" type=button ng-click=$ctrl.deleteShift() ng-if=\"$ctrl.shift.id && !$ctrl.shift.employeeId\" permission permission-only=\"['CUSTOMER']\"><i class=\"fa fa-trash mr5\"></i> <span translate>Delete</span></button> </div>";

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ng-click=$ctrl.closeModal() aria-label=Close> <span aria-hidden=true>&times;</span> </a> <h4 class=modal-title translate>Shift subscriptions</h4> </div> <div class=\"modal-body row\" id=checkAvailabilityModalBody> <div class=col-md-6 style=\"padding:14px 10px\"> <div id=employeelist> <span ng-if=\"!$ctrl.employees.length > 0\">Geen inschrijvingen gevonden!</span> <employee-picker-component shift=$ctrl.shift employees=$ctrl.employees selected-employee=$ctrl.selectedEmployee functions=$ctrl.functions disable-filter=true disable-info=true on-select-employee=$ctrl.onSelectEmployee() ng-if=\"$ctrl.employees.length > 0\"></employee-picker-component> </div> </div> <div class=col-md-6 style=\"padding:0 10px\"> <h4>{{$ctrl.employee.displayName}} &nbsp;</h4> <div class=form-group> <label translate>Start</label> <date-time-picker-component date=$ctrl.shift.start max-date=$ctrl.shift.end></date-time-picker-component> </div> <div class=form-group> <label translate>End</label> <date-time-picker-component date=$ctrl.shift.end min-date=$ctrl.shift.start></date-time-picker-component> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen=$ctrl.statuses ng-model=$ctrl.shift.status ng-options=\"item.code*1 as item.name for item in $ctrl.statuses\" data-placeholder=\"Selecteer een status...\"> </select> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment internal</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.internalComment></textarea> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment employee</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.employeeComment></textarea> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label translate>Comment customer</label> <textarea class=form-control name=comment ng-model=$ctrl.shift.customerComment></textarea> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label> <input type=checkbox ng-model=$ctrl.mailcustomer ng-disabled=\"$ctrl.shift.status != 6\"/> Mail team</label> </div> <div class=form-group permission permission-only=\"['BACKOFFICE']\"> <label> <input type=checkbox ng-model=$ctrl.mailemployee ng-disabled=\"$ctrl.shift.status != 6\"/> Mail Medewerker</label> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon mr5\" ng-click=$ctrl.save()> <i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon mr5\" ng-click=$ctrl.closeModal()> <i class=\"fa fa-close mr5\"></i> <span translate>Close</span> </a> </div>";

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Skills</a> </li> </ol> </div> </div> <skills-list-component employee-skills=$ctrl.employeeSkills></skills-list-component>";

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Sign up</a> </li> </ol> </div> <div class=search ng-if=\"!$ctrl.screenSize.is('xs, sm')\"> <form class=form ng-submit=$ctrl.getShifts()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()> <i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"form-group date-input\"> <date-time-picker-component date=$ctrl.startDate time=false on-change=$ctrl.getShifts() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=date-input> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getShifts() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.nextWeek()> <span translate>Next</span> <i class=\"fa fa-angle-right ml5\"></i> </button> </div> </div> </form> </div> <div class=search ng-if=\"$ctrl.screenSize.is('xs, sm') && !$ctrl.isMessageOpen\"> <form class=form ng-submit=$ctrl.getShifts()> <div class=row> <div class=col-xs-6> <date-time-picker-component date=$ctrl.startDate time=false on-change=$ctrl.getShifts() add-class=\"['input-sm']\"></date-time-picker-component> </div> <div class=col-xs-6> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getShifts() add-class=\"['input-sm']\"></date-time-picker-component> </div> </div> <div class=\"row no-margin\"> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm\" type=button ng-click=$ctrl.prevWeek()> <i class=\"fa fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=col-xs-6> <button class=\"btn btn-primary btn-sm pull-right\" type=button ng-click=$ctrl.nextWeek()> <span translate>Next</span> <i class=\"fa fa-angle-right ml5\"></i> </button> </div> </div> </form> </div> </div> <div class=panel ng-if=\"(!$ctrl.isMessageOpen && $ctrl.screenSize.is('xs, sm')) || !$ctrl.screenSize.is('xs, sm')\"> <div class=panel-body> <div class=\"row no-margin\"> <div class=col-md-4> <input class=form-control name=search ng-model=$ctrl.filter.search placeholder=zoeken ng-change=$ctrl.getShifts() /> </div> <div class=col-md-4> <select class=form-control ng-model=$ctrl.maxDistanceFilter ng-change=$ctrl.setFilters()> <option value=\"\" translate>Filter by max distance</option> <option value=5 translate>5 km</option> <option value=15 translate>15 km</option> <option value=50 translate>50 km</option> <option value=200 translate>200 km</option> </select> </div> <div class=col-md-4> <select class=form-control name=function ng-model=$ctrl.functionFilter ng-change=$ctrl.setFilters() ng-options=\"function.id as function.name for function in $ctrl.functions | orderBy:'name'\"> <option value=\"\" translate>Filter by function</option> </select> </div> </div> </div> </div> <div class=row> <div style=overflow:hidden class=\"col-md-4 col-xs-12\" fixed-height ng-show=\"!$ctrl.screenSize.is('xs, sm') || ( $ctrl.screenSize.is('xs, sm') && !$ctrl.isMessageOpen)\"> <div class=panel style=height:100%> <div class=panel-body style=height:100%;overflow:auto;padding:0> <div ng-repeat=\"(key, shifts) in $ctrl.groupedShifts\" class=shift-list> <div class=\"list-line heading-line\"> {{ key }} </div> <div class=list-line id=s-{{item.id}} ui-sref-active=active ng-repeat=\"item in shifts\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\" ui-sref=\"subscriptions.dashboard.item({ 'id': item.id })\"> <div class=\"row no-margin\"> <div class=\"bold col-xs-8\" style=line-height:2em>{{ item.teamLocationAccountName }} - {{ item.teamLocationName }} - {{ item.teamName }}</div> <div class=col-xs-4 style=line-height:2em> <span class=\"pull-right label label-info\" ng-if=\"item.subscriptionsCount > 0\" ng-class=\"item.declarationStatus == 3 ? 'label-success' : 'label-warning'\" translate>Subscribed</span> </div> </div> <div class=\"row no-margin\" style=vertical-align:middle> <div class=col-xs-12 style=line-height:2em> <span class=bold>{{ item.functionName }}</span> </div> </div> <div class=\"row no-margin shift-summary\"> <div class=col-xs-12 style=line-height:2em> <span ng-if=\"!$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(item.start, item.end)\">{{ item.start | date :\"HH:mm\" }}</span> <span translate>to</span> {{ item.end | date :\"HH:mm dd-MM-yyyy\" }} </div> </div> <div class=\"row no-margin\" style=vertical-align:middle> <div class=col-xs-12 style=line-height:2em> <span class=bold>{{ item.employeeDisplayName }}</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div fixed-height class=\"col-md-8 col-xs-12\" ng-show=\"!$ctrl.screenSize.is('xs, sm') || ( $ctrl.screenSize.is('xs, sm') && $ctrl.isMessageOpen)\"> <div class=panel style=min-height:60px ng-if=\"$ctrl.screenSize.is('xs, sm')\"> <div class=panel-body> <button class=\"btn btn-sm\" ng-click=\"$ctrl.isMessageOpen = false;\" ng-if=\"$ctrl.screenSize.is('xs, sm')\"> <i class=\"fa fa-arrow-left\" aria-hidden=true></i> </button> </div> </div> <div class=panel style=\"height:calc(100% - 74px);overflow:none;border:0 solid red;margin-bottom:0\" ng-if=\"$ctrl.screenSize.is('xs, sm') \"> <div class=panel-body style=height:100%;padding:0> <div ui-view=shiflistitem on-change=\"$ctrl.handleChildChange(type, data)\" style=height:100%></div> </div> </div> <div class=panel style=\"height:100%;overflow:none;border:0 solid red;margin-bottom:0\" ng-if=\"!$ctrl.screenSize.is('xs, sm') \"> <div class=panel-body style=height:100%;padding:0> <div ui-view=shiflistitem on-change=\"$ctrl.handleChildChange(type, data)\" style=height:100%></div> </div> </div> </div> </div>";

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div>";

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "<div class=panel> <div class=panel-body> <h4>{{ $ctrl.shift.teamLocationName }} - {{ $ctrl.shift.teamName }}</h4> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold>Location</span>: </div> <div class=col-xs-10> {{ $ctrl.shift.teamLocationName }} </div> </div> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold>Address</span>: </div> <div class=col-xs-10> {{ $ctrl.location.address.street }} {{ $ctrl.location.address.number }} {{ $ctrl.location.address.numberSuffix}} <br ng-if=$ctrl.location.address.street> {{ $ctrl.location.address.zip }} {{$ctrl.location.address.city}} <br ng-if=\"$ctrl.location.address.zip || $ctrl.location.address.city\"> {{ $ctrl.location.address.country}} </div> </div> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold>Team</span>: </div> <div class=col-xs-10> {{ $ctrl.shift.teamName }} </div> </div> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold></span> </div> <div class=col-xs-10> <i>{{ $ctrl.shift.teamDescription }}</i> </div> </div> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold>Time</span>: </div> <div class=col-xs-10> {{ $ctrl.shift.start | date :\"dd-MM-yyyy HH:mm\" }} tot {{ $ctrl.shift.end | date :\"dd-MM-yyyy HH:mm\" }} </div> </div> <div class=\"row mb0\"> <div class=col-xs-2> <span translate class=bold>Distance</span>: </div> <div class=col-xs-10> {{ $ctrl.shift.distance | number : 1 }}km </div> </div> <div ng-if=\"$ctrl.shift.status == 2\"> <hr> <h4 translate>Sign up</h4> <form role=form id=sign-up-form name=signUpForm ng-submit=$ctrl.signUp()> <div class=form-group> <label translate>Note</label> <textarea class=form-control name=description ng-model=$ctrl.subscription.comment></textarea> </div> <button type=submit class=\"btn btn-success\" translate ng-if=!$ctrl.shift.subscribed>Subscribe</button> <button type=submit class=\"btn btn-success\" translate ng-if=$ctrl.shift.subscribed>Wijzigen</button> <button type=button class=\"btn btn-danger\" translate ng-if=$ctrl.shift.subscribed ng-click=$ctrl.unsubscribe()>Unsubscribe</button> </form> </div> </div> </div>";

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Archive</a> </li> </ol> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control name=search ng-model=$ctrl.search placeholder=\"{{'search' | translate}}\"/> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:65%> <a href=# ng-click=\"$ctrl.sortType = 'description'; sortReverse = !sortReverse\"> <span translate>Description</span> <span ng-show=\"$ctrl.sortType == 'description' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'description' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:15%> <a href=# ng-click=\"$ctrl.sortType = 'date'; sortReverse = !sortReverse\"> <span translate>Date</span> <span ng-show=\"$ctrl.sortType == 'date' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'date' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:20%> <a href=# ng-click=\"$ctrl.sortType = 'userName'; sortReverse = !sortReverse\"> <span translate>User</span> <span ng-show=\"$ctrl.sortType == 'userName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'userName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:20%> <a href=# ng-click=\"$ctrl.sortType = 'taskStatusName'; sortReverse = !sortReverse\"> <span translate>Status</span> <span ng-show=\"$ctrl.sortType == 'taskStatusName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'taskStatusName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"tasks.item({'id': item.id, 'isArchive': true})\" ng-repeat=\"item in $ctrl.filteredTasks | filter : $ctrl.search | orderBy:$ctrl.sortType:sortReverse\"> <td style=width:50%>{{ item.description }}</td> <td style=width:15%>{{ item.date | date : \"dd-MM-yyyy\" }}</td> <td style=width:20%>{{ item.userName }}</td> <td style=width:15%>{{ item.taskStatusName }}</td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview></div>";

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <a class=close ui-sref=^.^ ng-if=!$ctrl.task.id aria-label=Close><span aria-hidden=true>&times;</span></a> <a class=close ui-sref=^ ng-if=$ctrl.task.id aria-label=Close><span aria-hidden=true>&times;</span></a> <h4 class=modal-title ng-if=!$ctrl.task.id translate>Create task</h4> <h4 class=modal-title ng-if=$ctrl.task.id translate>Edit task</h4> </div> <div class=modal-body> <form class=form role=form id=taskBasicInfoForm ng-submit=$ctrl.save()> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Description</label> <textarea class=form-control name=description ng-model=$ctrl.task.description></textarea> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Status</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.task.taskStatusId name=taskStatusId ng-options=\"item.id as item.name for item in $ctrl.taskStatuses\"> <option value=\"\"></option> </select> </div> </div> <div class=\"form-group col-md-12\"> <label translate>End date</label> <date-time-picker-component date=$ctrl.task.date time=false></date-time-picker-component> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>User</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.task.userId name=userId ng-options=\"item.id as item.userName for item in $ctrl.users\"> <option value=\"\"></option> </select> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Account</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.task.accountId name=accountId ng-options=\"item.id as item.name for item in $ctrl.accounts\" ng-change=$ctrl.accountSelected()> <option value=\"\"></option> </select> </div> </div> <div class=\"row no-margin\" ng-if=$ctrl.task.accountId> <div class=\"form-group col-md-12\"> <label translate>Location</label> <select class=\"form-control chosen\" chosen=$ctrl.locations ng-model=$ctrl.task.locationId name=locationId ng-options=\"item.id as item.name for item in $ctrl.locations\" ng-change=$ctrl.locationSelected()> <option value=\"\"></option> </select> </div> </div> <div class=\"row no-margin\" ng-if=$ctrl.task.locationId> <div class=\"form-group col-md-12\"> <label translate>Team</label> <select class=\"form-control chosen\" chosen=$ctrl.teams ng-model=$ctrl.task.teamId name=teamId ng-options=\"item.id as item.name for item in $ctrl.teams\"> <option value=\"\"></option> </select> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Contact</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.task.contactId name=contactId ng-options=\"item.id as item.name for item in $ctrl.contacts\"> <option value=\"\"></option> </select> </div> </div> <div class=\"row no-margin\"> <div class=\"form-group col-md-12\"> <label translate>Employee</label> <select class=\"form-control chosen\" chosen ng-model=$ctrl.task.employeeId name=employeeId ng-options=\"item.id as item.displayName for item in $ctrl.employees\"> <option value=\"\"></option> </select> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-success btn-icon btn-sm mr5\" type=submit form=taskBasicInfoForm><i class=\"fa fa-save mr5\"></i> <span translate>Save</span> </button> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^.^ ng-if=!$ctrl.task.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> <a class=\"btn btn-info btn-icon btn-sm mr5\" ui-sref=^ ng-if=$ctrl.task.id><i class=\"fa fa-close mr5\"></i> <span translate>Close</span></a> </div>";

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li> <a ui-sref=tasks ng-if=!$ctrl.isArchive translate>Tasks</a> <a ui-sref=tasks.archive ng-if=$ctrl.isArchive translate>Archive</a> </li> </ol> </div> <div class=buttons> <a class=\"pull-right btn btn-danger btn-icon btn-sm\" ng-click=$ctrl.deleteTask() ng-if=$ctrl.task.id><i class=\"fa fa-trash\"></i><span translate>Delete task</span></a> </div> </div> <div class=row> <div class=col-md-4> <div class=\"panel panel-primary\"> <div class=panel-heading> <div class=pull-left translate>Basic info</div> <div class=panel-controls> <a ui-sref=\"tasks.item.basic({'id': $ctrl.task.id})\"><i class=\"fa fa-edit\"></i></a> </div> </div> <div class=\"panel-body p25\"> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Description:</b></div> <div class=col-xs-7>{{$ctrl.task.description}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Status:</b></div> <div class=col-xs-7>{{$ctrl.task.taskStatusName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Date:</b></div> <div class=col-xs-7>{{$ctrl.task.date | date : \"dd-MM-yyyy\"}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>User:</b></div> <div class=col-xs-7>{{$ctrl.task.userName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Account:</b></div> <div class=col-xs-7>{{$ctrl.task.accountName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Location:</b></div> <div class=col-xs-7>{{$ctrl.task.locationName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Team:</b></div> <div class=col-xs-7>{{$ctrl.task.teamName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Contact:</b></div> <div class=col-xs-7>{{$ctrl.task.contactName}}</div> </div> <div class=\"row mb5\"> <div class=col-xs-5><b translate>Employee:</b></div> <div class=col-xs-7>{{$ctrl.task.employeeDisplayName}}</div> </div> </div> </div> </div> </div>";

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Tasks</a> </li> </ol> </div> <div class=buttons> <button class=\"pull-right btn btn-primary btn-icon btn-sm\" ui-sref=\"tasks.item.basic({'id': ''})\"><i class=\"fa fa-plus mr5\"></i><span translate>Add Task</span></button> </div> <div class=search> <form class=form> <div class=row> <div class=col-md-3> <input class=form-control name=search ng-model=$ctrl.search placeholder=\"{{'search' | translate}}\"/> </div> <div class=col-md-3> <select class=\"form-control chosen\" chosen ng-model=$ctrl.selectedStatus ng-options=\"item.name as item.name for item in $ctrl.taskStatuses\" ng-change=$ctrl.filter()> <option value=\"\">Filter by status</option> </select> </div> </div> </form> </div> </div> <div class=panel> <div class=panel-body> <table id=contacts-table class=\"table table-hover\"> <thead> <tr> <th style=width:65%> <a href=# ng-click=\"$ctrl.sortType = 'description'; sortReverse = !sortReverse\"> <span translate>Description</span> <span ng-show=\"$ctrl.sortType == 'description' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'description' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:15%> <a href=# ng-click=\"$ctrl.sortType = 'date'; sortReverse = !sortReverse\"> <span translate>Date</span> <span ng-show=\"$ctrl.sortType == 'date' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'date' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:20%> <a href=# ng-click=\"$ctrl.sortType = 'userName'; sortReverse = !sortReverse\"> <span translate>User</span> <span ng-show=\"$ctrl.sortType == 'userName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'userName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> <th style=width:20%> <a href=# ng-click=\"$ctrl.sortType = 'taskStatusName'; sortReverse = !sortReverse\"> <span translate>Status</span> <span ng-show=\"$ctrl.sortType == 'taskStatusName' && !sortReverse\" class=\"fa fa-caret-down\"></span> <span ng-show=\"$ctrl.sortType == 'taskStatusName' && sortReverse\" class=\"fa fa-caret-up\"></span> </a> </th> </tr> </thead> <tbody> <tr ui-sref=\"tasks.item({'id': item.id})\" ng-repeat=\"item in $ctrl.filteredTasks | filter : $ctrl.search | orderBy:$ctrl.sortType:sortReverse\"> <td style=width:50%>{{ item.description }}</td> <td style=width:15%>{{ item.date | date : \"dd-MM-yyyy\" }}</td> <td style=width:20%>{{ item.userName }}</td> <td style=width:15%>{{ item.taskStatusName }}</td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "<form class=form role=form id=declarationForm ng-submit=$ctrl.submitDeclaration()> <div class=modal-header> <button type=button class=close ui-sref=^ aria-label=Close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title> <span ng-if=\"$ctrl.declaration.registrationType == '1'\" translate>Time declaration</span> <span ng-if=\"$ctrl.declaration.registrationType == '2'\" translate>Expenses declaration</span> </h4> </div> <div class=modal-body> <div class=\"row mb0\" style=padding:15px> <div class=\"form-group col-md-12\" ng-if=\"$ctrl.declaration.registrationType == '2'\"> <label translate>Type</label> <select class=form-control name=type ng-model=$ctrl.selectedHourCodeId ng-options=\"item.id as item.name for item in $ctrl.wageCodes\" ng-change=$ctrl.wageCodeUpdated() required> </select> </div> <div class=\"form-group col-md-12\" ng-if=\"(($ctrl.declaration.hourCodeCode || $ctrl.declaration.wageCodeCode) == '5150') && $ctrl.declaration.registrationType == '2'\"> <label translate>Mileage</label> <input type=number class=form-control ng-model=$ctrl.declaration.value step=0.01> </div> <div class=\"form-group col-md-12\" ng-if=\"(($ctrl.declaration.hourCodeCode || $ctrl.declaration.wageCodeCode) != '5150' && ($ctrl.declaration.hourCodeCode || $ctrl.declaration.wageCodeCode) != '5091' && ($ctrl.declaration.hourCodeCode || $ctrl.declaration.wageCodeCode) != '5090') && $ctrl.declaration.registrationType == '2'\"> <label translate>Ammount</label> <input type=number class=form-control ng-model=$ctrl.declaration.value step=0.01> </div> <div class=form-group ng-if=\"$ctrl.declaration.registrationType == '1'\"> <div class=\"form-group col-md-6 col-xs-12\"> <label translate>Start</label> <date-time-picker-component date=$ctrl.declaration.dateTimeFrom max-date=$ctrl.declaration.dateTimeTo></date-time-picker-component> </div> <div class=\"form-group col-md-6 col-xs-12\"> <label translate>End</label> <date-time-picker-component date=$ctrl.declaration.dateTimeTo min-date=$ctrl.declaration.dateTimeFrom></date-time-picker-component> </div> </div> <div class=\"form-group col-md-12\" ng-if=$ctrl.employee.zzp permission permission-only=\"['BACKOFFICE']\"> <label translate>Factuurnummer</label> <input type=text class=form-control maxlength=12 minlength=2 ng-model=$ctrl.declaration.zzpInvoiceNumber> <div>Minimaal 2 tekens, maximaal 12 tekens.</div> </div> <div class=\"form-group col-md-12\"> <label translate>Description</label> <textarea class=form-control rows=5 ng-model=$ctrl.declaration.comment></textarea> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-success btn-sm btn-icon\" type=submit form=declarationForm ng-if=\"$ctrl.declaration.status != 3\" permission permission-only=\"['EMPLOYEE']\"><i class=\"fa fa-save mr5\"></i><span translate>Save</span></button> <button class=\"btn btn-danger btn-sm btn-icon\" ng-click=$ctrl.deleteDeclaration() ng-if=\"$ctrl.declaration.status != 3\" permission permission-only=\"['EMPLOYEE']\"><i class=\"fa fa-trash mr5\"></i><span translate>Delete</span></button> <button class=\"btn btn-success btn-sm btn-icon\" type=submit form=declarationForm permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-save mr5\"></i><span translate>Save</span></button> <button class=\"btn btn-danger btn-sm btn-icon\" ng-click=$ctrl.deleteDeclaration() permission permission-only=\"['BACKOFFICE']\"><i class=\"fa fa-trash mr5\"></i><span translate>Delete</span></button> <button class=\"btn btn-info btn-sm btn-icon\" ui-sref=^><i class=\"fa fa-close mr5\"></i><span translate>Close</span></button> </div> </form>";

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel scrollable\"> <div class=panel-body> <div class=\"ml10 mt10 mb30\" permission permission-except=\"['EMPLOYEE']\"> <div class=\"row mb0\"> <div class=col-md-8> <h3 class=\"mt0 mb20\">{{ $ctrl.timesheet.employeeName }}<span ng-if=$ctrl.timesheet.employeeInactive> (<span translate>Inactive</span>)</span></h3> </div> <div class=col-md-4> <div class=\"row mb0\"> <div class=\"col-md-12 align-right\"> <span translate>Number of services</span>: {{ $ctrl.timesheet.shiftCount - $ctrl.timesheet.shiftCanceledCount - $ctrl.timesheet.shiftSickCount }} </div> <div class=\"col-md-12 align-right\"> <span translate>Amount of hours</span>: {{ ($ctrl.timesheet.shiftHours - $ctrl.timesheet.shiftCanceledHours - $ctrl.timesheet.shiftSickHours ).toFixed(2) }} </div> <div class=\"col-md-12 align-right\"> <span translate>Number declared</span>: {{ $ctrl.timesheet.shiftDeclarationHours.toFixed(2) }} </div> </div> </div> </div> </div> <div class=timesheet-section ng-repeat=\"shift in $ctrl.timesheet.shifts | orderBy: 'start'\"> <uib-accordion close-others=false> <div uib-accordion-group class=\"panel-default accordion-group\" ng-init=\"isOpen = ($ctrl.openShift == shift.id)\" is-open=isOpen> <uib-accordion-heading> <span class=list-line-title> <b> {{ shift.start | date : \"dd-MM-yyyy HH:mm\" }} <span translate>to</span> <span ng-if=\"!$ctrl.isSameDay(shift.start, shift.end)\">{{ shift.end | date : \"dd-MM-yyyy HH:mm\" }}</span> <span ng-if=\"$ctrl.isSameDay(shift.start, shift.end)\">{{ shift.end | date : \"HH:mm\" }}</span> </b> - {{ shift.teamLocationAccountName }} - {{ shift.teamLocationName }} - {{shift.teamName}} <span style=color:red;margin-left:16px ng-if=\"shift.status == 7\">Geannuleerd 96 uur</span> </span> <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': isOpen, 'glyphicon-chevron-right': !isOpen}\"></i> <span class=\"chip pull-right\" ng-class=\"{'chip-success': shift.declarationsApproved, 'chip-danger': !shift.declarationsApproved}\"> <span translate>Planned:</span> {{ shift.plannedHours.toFixed(2) }} &lt;&gt; <span translate>Declared:</span> {{ shift.declaredHours.toFixed(2) }} </span> <span ng-if=shift.internalComment> <br/><b>Interne opmerkingen</b> <br/><i>{{shift.internalComment}}</i> </span> <span ng-if=shift.employeeComment> <br/><b>Medewerker opmerkingen</b> <br/><i>{{shift.employeeComment}}</i> </span> </uib-accordion-heading> <div class=\"list-line no-hover\" permission permission-except=\"['BACKOFFICE']\"> <div class=\"row mb0\"> <div class=col-md-4><span class=bold>Opdrachtgever:</span> {{ shift.teamLocationAccountName }}</div> <div class=\"col-md-1 bold\"><span translate>Location</span>:</div> <div class=col-md-3> {{ shift.teamLocationName }} <div ng-if=\"shift.team && shift.team.location && shift.team.location.address\"> {{ shift.team.location.address.street }} {{ shift.team.location.address.number }} {{ item.vistingAddress.numberSuffix }} <br> {{ shift.team.location.address.zip }} {{ shift.team.location.address.city }} </div> </div> <div class=\"col-md-1 bold\"> <span translate>Team</span>: <span ng-if=\"shift.team && shift.team.teamContacts && shift.team.teamContacts.length > 0\"> <br/><span translate>Contacts</span>: </span> </div> <div class=col-md-3> {{ shift.teamName }} <span ng-if=\"shift.team && shift.team.teamContacts && shift.team.teamContacts.length > 0\"> <span class=link ng-repeat=\"teamContact in shift.team.teamContacts\"> <br/><span tooltip-placement=left uib-tooltip=\"{{ teamContact.contactEmailAddress }} {{ teamContact.contactPhoneNumber }}\">{{ teamContact.contactName }}</span> </span> </span> </div> </div> </div> <div class=list-line ng-repeat=\"declaration in shift.declarations | orderBy: 'id'\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\" ui-sref=\".declaration({'employeeId': shift.employeeId, 'shiftId': shift.id, 'declarationId': declaration.id, 'type': declaration.registrationType, 'shiftStartDate': shift.start, 'shiftEndDate': shift.end})\" ng-if=\"!(shift.status === 7 || shift.status === 92)\" permission permission-only=\"['BACKOFFICE']\"> <span class=list-line-title> <span ng-if=\"declaration.registrationType == '1'\"> <span ng-if=\"!$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm\" }}</span> <span translate>to</span> {{ declaration.dateTimeTo | date : \"HH:mm dd-MM-yyyy\" }} </span> <span ng-if=\"declaration.registrationType == '2'\"><b>{{ declaration.hourCodeName || declaration.wageCodeName }}</b> > {{ declaration.value }}</span> </span> <span class=\"icon-btn pull-right link\" ng-click=\"$ctrl.deleteDeclaration($event, declaration, shift)\" ng-if=\"shift.status !== 7 && !declaration.invoiceId && declaration.status != 3\"> <i class=\"fa fa-trash icon-trash\"></i> </span> <span class=\"chip chip-success pull-right\" ng-if=\"declaration.status == 3\" translate>Approved</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 0\" translate>Open</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 1\" translate>In progress</span> <span class=\"chip chip-danger pull-right\" ng-if=\"declaration.status == 2\" translate>Rejected</span> <div class=list-line-content ng-if=declaration.comment> <span><i>{{ declaration.comment }}</i></span> </div> <div class=list-line-content ng-if=declaration.zzpInvoiceNumber> <span><i>ZZP factuurnummer: {{ declaration.zzpInvoiceNumber }}</i></span> </div> <div class=list-line-content ng-if=\"$ctrl.timesheet.employeeIsZZp && !declaration.zzpInvoiceNumber\"> <span style=color:red><i>Geen factuurnummer ingevuld!</i></span> </div> </div> <div class=\"comment col-md-12 link\" ui-sref=\".declaration({'employeeId': shift.employeeId, 'shiftId': shift.id, 'declarationId': declaration.id, 'type': declaration.registrationType, 'shiftStartDate': shift.start, 'shiftEndDate': shift.end})\" ng-if=\"!(shift.status === 7 || shift.status === 92 || declaration.status === 3)\" permission permission-only=\"['EMPLOYEE']\"> <span class=list-line-title> <span ng-if=\"declaration.registrationType == '1'\"> <span ng-if=\"!$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm\" }}</span> <span translate>to</span> {{ declaration.dateTimeTo | date : \"HH:mm dd-MM-yyyy\" }} </span> <span ng-if=\"declaration.registrationType == '2'\"><b>{{ declaration.hourCodeName || declaration.wageCodeName }}</b> > {{ declaration.value }}</span> </span> <span class=\"icon-btn pull-right link\" ng-click=\"$ctrl.deleteDeclaration($event, declaration, shift)\" ng-if=\"shift.status !== 7 && !declaration.invoiceId && declaration.status != 3\"> <i class=\"fa fa-trash icon-trash\"></i> </span> <span class=\"chip chip-success pull-right\" ng-if=\"declaration.status == 3\" translate>Approved</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 0\" translate>Open</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 1\" translate>In progress</span> <span class=\"chip chip-danger pull-right\" ng-if=\"declaration.status == 2\" translate>Rejected</span> <div class=list-line-content ng-if=declaration.comment> <span><i>{{ declaration.comment }}</i></span> </div> <div class=list-line-content ng-if=declaration.zzpInvoiceNumber> <span><i>ZZP factuurnummer: {{ declaration.zzpInvoiceNumber }}</i></span> </div> </div> <div class=\"comment col-md-12 link\" ng-if=\"declaration.status === 3\" permission permission-only=\"['EMPLOYEE']\"> <span class=list-line-title> <span ng-if=\"declaration.registrationType == '1'\"> <span ng-if=\"!$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm\" }}</span> <span translate>to</span> {{ declaration.dateTimeTo | date : \"HH:mm dd-MM-yyyy\" }} </span> <span ng-if=\"declaration.registrationType == '2'\"><b>{{ declaration.hourCodeName || declaration.wageCodeName }}</b> > {{ declaration.value }}</span> </span> <span class=\"icon-btn pull-right link\" ng-click=\"$ctrl.deleteDeclaration($event, declaration, shift)\" ng-if=\"shift.status !== 7 && !declaration.invoiceId && declaration.status != 3\"> <i class=\"fa fa-trash icon-trash\"></i> </span> <span class=\"chip chip-success pull-right\" ng-if=\"declaration.status == 3\" translate>Approved</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 0\" translate>Open</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 1\" translate>In progress</span> <span class=\"chip chip-danger pull-right\" ng-if=\"declaration.status == 2\" translate>Rejected</span> <div class=list-line-content ng-if=declaration.comment> <span><i>{{ declaration.comment }}</i></span> </div> <div class=list-line-content ng-if=declaration.zzpInvoiceNumber> <span><i>ZZP factuurnummer: {{ declaration.zzpInvoiceNumber }}</i></span> </div> </div> <div class=\"comment col-md-12 link\" uib-tooltip=\"Het is niet mogelijk om declaraties te bewerken, verwijderen of toe te voegen op diensten die geannuleerd zijn binnen 96 uur\" ng-if=\"shift.status === 7 || shift.status === 92\"> <span class=list-line-title> <span ng-if=\"declaration.registrationType == '1'\"> <span ng-if=\"!$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm dd-MM-yyyy\" }}</span> <span ng-if=\"$ctrl.isSameDay(declaration.dateTimeFrom, declaration.dateTimeTo)\">{{ declaration.dateTimeFrom | date : \"HH:mm\" }}</span> <span translate>to</span> {{ declaration.dateTimeTo | date : \"HH:mm dd-MM-yyyy\" }} </span> <span ng-if=\"declaration.registrationType == '2'\"><b>{{ declaration.hourCodeName || declaration.wageCodeName }}</b> > {{ declaration.value }}</span> </span> <span class=\"icon-btn pull-right link\" ng-click=\"$ctrl.deleteDeclaration($event, declaration, shift)\" ng-if=\"!(shift.status === 7 || shift.status === 92)\"> <i class=\"fa fa-trash icon-trash\"></i> </span> <span class=\"chip chip-success pull-right\" ng-if=\"declaration.status == 3\" translate>Approved</span> <span class=\"chip chip-warning pull-right\" ng-if=\"declaration.status == 0 || declaration.status == 1\" translate>In progress</span> <span class=\"chip chip-danger pull-right\" ng-if=\"declaration.status == 2\" translate>Rejected</span> <div class=list-line-content ng-if=declaration.comment> <span><i>{{ declaration.comment }}</i></span> </div> <div class=list-line-content ng-if=declaration.zzpInvoiceNumber> <span><i>ZZP factuurnummer: {{ declaration.zzpInvoiceNumber }}</i></span> </div> </div> </div> </div> </div> <div class=\"list-line footer-line\"> <div class=media> <div class=row> <div class=\"comment col-md-12\" ng-if=!$ctrl.isInvoiced(shift)> <div class=\"icon-btn composite-btn mr15 link\" ui-sref=\".declaration({'employeeId': shift.employeeId, 'shiftId': shift.id, 'declarationId': '', 'type': '1', 'shiftStartDate': shift.start, 'shiftEndDate': shift.end})\" ng-if=\"!(shift.status === 7 || shift.status === 92)\"> <i class=\"fa fa-plus icon-small top mrn3\"></i> <i class=\"fa fa-clock-o clock-big\"></i> </div> <div class=\"icon-btn composite-btn mr15 link\" ui-sref=\".declaration({'employeeId': shift.employeeId, 'shiftId': shift.id, 'declarationId': '', 'type': '2', 'shiftStartDate': shift.start, 'shiftEndDate': shift.end})\" ng-if=\"!(shift.status === 7 || shift.status === 92)\"> <i class=\"fa fa-plus icon-small top mrn5\"></i> <i class=\"fa fa-car car-big\"></i> </div> <div class=\"icon-btn mr15 pull-right link\" ng-click=$ctrl.approve(shift) ng-if=\"shift.declarations.length > 0\" permission permission-except=\"['EMPLOYEE']\"> <i class=\"fa fa-check check-big icon-success\"></i> </div> <div class=\"icon-btn mr15 pull-right icon-danger link\" ng-click=$ctrl.reject(shift) ng-if=\"shift.declarations.length > 0\" permission permission-except=\"['EMPLOYEE']\"> <i class=\"fa fa-close close-big\"></i> </div> </div> </div> </div> </div> </div> </uib-accordion> </div> </div> </div>";

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Timesheets</a> </li> </ol> </div> <div class=search> <form class=form ng-submit=$ctrl.getTimesheets()> <div class=search-bar> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=button ng-click=$ctrl.prevWeek()><i class=\"fa fa-angle-left mr5\"></i> <span translate>Prev</span> </button> </div> <div class=\"dropdown form-group dropdown-start-parent date-input\"> <label>Start</label> <date-time-picker-component date=$ctrl.startDate time=false on-change=$ctrl.getTimesheets()></date-time-picker-component> </div> <div class=\"dropdown form-group dropdown-end-parent date-input\"> <label>End</label> <date-time-picker-component date=$ctrl.endDate time=false on-change=$ctrl.getTimesheets()></date-time-picker-component> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon-right\" type=button ng-click=$ctrl.nextWeek()><span translate>Next</span><i class=\"fa fa-angle-right ml5\"></i></button> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon mr10\" type=submit><i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> <timesheets-summary-component employees=$ctrl.employees class=pull-right></timesheets-summary-component> </div> </form> </div> </div> <div class=\"eq-col timesheets-eq-col\" ng-if=$ctrl.employees> <div class=\"relative full-height\"> <div class=display-row> <div class=\"messages-lister col bg-white br\"> <div class=scrollable-list> <div class=list-line ng-click=$ctrl.selectEmployee(item) ng-class=\"{active : $ctrl.currentEmployee === item}\" ng-repeat=\"item in $ctrl.employees | filter: $ctrl.searchEmployee | orderBy: $ctrl.sortType:sortReverse\" ng-if=\"(item.shiftCount - item.shiftCanceledCount - item.shiftSickCount) > 0\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <ng-letter-avatar data=\"{{ item.employeeName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.employeeName }}<span ng-if=item.employeeInactive> (<span translate>Inactive</span>)</span></span> <span class=\"chip pull-right\" ng-class=\"{'chip-success': item.doneShiftCount == item.shiftCount, 'chip-danger': item.doneShiftCount != item.shiftCount}\"> {{ item.doneShiftCount }} / {{ item.shiftCount - item.shiftCanceledCount - item.shiftSickCount }} </span> <div style=margin-left:53px> <span class=chip ng-class=\"{'chip-success': item.declarationsApproved, 'chip-danger': !item.declarationsApproved}\"> <span translate>Planned:</span> {{ (item.shiftHours - item.shiftCanceledHours - item.shiftSickHours ).toFixed(2) }} &lt;&gt; <span translate>Declared:</span> {{ item.shiftDeclarationHours.toFixed(2) }} </span> </div> </div> </div> </div> </div> </div> </div> <div class=\"messages-viewer col\" ng-if=$ctrl.currentEmployee> <div class=detail-cta> <timesheet-details-component timesheet=$ctrl.currentEmployee calendar-start-date=$ctrl.startDate calendar-end-date=$ctrl.endDate></timesheet-details-component> </div> </div> </div> </div> </div>";

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main></div>";

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar quotations-header-bar\"> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <span translate>Overview</span> </li> </ol> </div> <div class=search ng-if=!$ctrl.proformaInvoicesOnly> <form class=form ng-submit=$ctrl.getTimesheets()> <div class=search-bar> <div class=form-group> <label translate>Periode</label> <select class=form-control ng-model=$ctrl.currentMonth ng-options=\"item as 'Periode ' + item.year + ' - ' + item.month for item in $ctrl.months\"> </select> </div> <div class=\"form-group disabled-date-input\"> <label translate>Start</label> <div class=\"input-prepend input-group\"> <span class=\"add-on input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=date class=form-control name=startDate ng-model=$ctrl.currentMonth.startDate disabled=disabled> </div> </div> <div class=\"form-group disabled-date-input\"> <label translate>End</label> <div class=\"input-prepend input-group\"> <span class=\"add-on input-group-addon\"><i class=\"fa fa-calendar\"></i></span> <input type=date class=form-control name=endDate ng-model=$ctrl.currentMonth.endDate disabled=disabled> </div> </div> <div class=form-group> <button class=\"btn btn-primary btn-icon\" type=submit><i class=\"fa fa-search mr5\"></i> <span translate>Search</span> </button> </div> <div class=form-group> <div class=progress style=margin-top:-5px;margin-bottom:0;z-index:50 ng-hide=!$ctrl.inprogress> <div class=progress-bar role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 style=width:{};> </div> </div> <button class=\"btn btn-danger btn-icon\" type=button ng-click=$ctrl.sendToNmbrs() permission permission-only=\"['FINANCE']\" ng-disabled=$ctrl.inprogress><i class=\"fa fa-paper-plane mr5\"></i> <span translate>Send to Nmbrs</span> </button> </div> <div class=\"form-group pull-right\" ng-if=$ctrl.summary style=margin-left:20px> <div class=timesheets-overview-summary> <table> <tr> <td class=summary-label><span translate>Number of scheduled shifts</span>:</td> <td class=summary-value>{{ $ctrl.summary.scheduledShiftsCount }}</td> </tr> <tr> <td class=summary-label><span translate>Number of scheduled hours</span>:</td> <td class=summary-value>{{ $ctrl.summary.scheduledHours }} <span translate>hours</span></td> </tr> <tr> <td class=summary-label><span translate>Number of declared shifts</span>:</td> <td class=summary-value>{{ $ctrl.summary.declaredShiftsCount }}</td> </tr> <tr> <td class=summary-label><span translate>Number of declared hours</span>:</td> <td class=summary-value>{{ $ctrl.summary.declaredHours }} <span translate>hours</span></td> </tr> <tr> <td class=summary-label><span translate>Number of approved shifts</span>:</td> <td class=summary-value>{{ $ctrl.summary.approvedShiftsCount }}</td> </tr> <tr> <td class=summary-label><span translate>Number of approved hours</span>:</td> <td class=summary-value>{{ $ctrl.summary.approvedHours }} <span translate>hours</span></td> </tr> </table> </div> </div> </div> </form> </div> </div> <div class=\"eq-col timesheets-eq-col\" ng-if=$ctrl.employees> <div class=\"relative full-height\"> <div class=display-row> <div class=\"messages-lister col bg-white br\"> <div class=scrollable-list> <div class=list-line ng-click=$ctrl.selectEmployee(item) ng-class=\"{active : $ctrl.currentEmployee === item}\" ng-repeat=\"item in $ctrl.employees | filter: $ctrl.searchEmployee | orderBy: $ctrl.sortType:sortReverse\" ng-if=\"(item.shiftCount - item.shiftCanceledCount - item.shiftSickCount) > 0\"> <div class=media> <div class=\"row mb0\"> <div class=\"comment col-md-12 link\"> <ng-letter-avatar data=\"{{ item.employeeName }}\" shape=round charcount=2 height=30px width=30px fontsize=15px></ng-letter-avatar> <span style=margin-left:20px;font-weight:700>{{ item.employeeName }}</span> <div class=pull-right style=display:flex;align-items:center;gap:10px> <span class=chip ng-class=\"{'chip-success': item.doneShiftCount == item.shiftCount, 'chip-danger': item.doneShiftCount != item.shiftCount}\"> {{ item.doneShiftCount }} / {{ item.shiftCount - item.shiftCanceledCount - item.shiftSickCount }} </span> </div> <div style=margin-left:53px;margin-top:5px> <span class=chip ng-class=\"{'chip-success': item.declarationsApproved, 'chip-danger': !item.declarationsApproved}\"> <span translate>Planned:</span> {{ item.shiftHours.toFixed(2) }} &lt;&gt; <span translate>Declared:</span> {{ item.shiftDeclarationHours.toFixed(2) }} </span> </div> </div> </div> </div> </div> </div> </div> <div class=\"messages-viewer col\" ng-if=\"$ctrl.currentEmployee && $ctrl.previewData\" permission permission-only=\"['FINANCE']\"> <div class=detail-cta style=padding:20px> <h4 translate>Nmbrs Preview - {{$ctrl.currentEmployee.employeeName}}</h4> <div class=row style=margin-top:15px> <div class=col-md-12> <strong translate>Period:</strong> {{$ctrl.previewData.year}} - {{$ctrl.previewData.period}}<br/> <strong translate>Number of Days:</strong> {{$ctrl.previewData.numberOfDays}} </div> </div> <div class=row style=margin-top:20px ng-if=\"$ctrl.previewData.hourComponents && $ctrl.previewData.hourComponents.length > 0\"> <div class=col-md-12> <h5 translate>Hour Components</h5> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th translate>Hour Code</th> <th translate>Hours</th> </tr> </thead> <tbody> <tr ng-repeat=\"hc in $ctrl.previewData.hourComponents\"> <td>{{hc.hourCode}}</td> <td>{{hc.hours | number:2}}</td> </tr> </tbody> </table> </div> </div> <div class=row style=margin-top:20px ng-if=\"$ctrl.previewData.wageComponents && $ctrl.previewData.wageComponents.length > 0\"> <div class=col-md-12> <h5 translate>Wage Components</h5> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th translate>Code</th> <th translate>Value</th> </tr> </thead> <tbody> <tr ng-repeat=\"wc in $ctrl.previewData.wageComponents\"> <td>{{wc.code}}</td> <td>{{wc.value | currency:\"€\":2}}</td> </tr> </tbody> </table> </div> </div> <div class=row style=margin-top:20px ng-if=\"(!$ctrl.previewData.hourComponents || $ctrl.previewData.hourComponents.length === 0) && (!$ctrl.previewData.wageComponents || $ctrl.previewData.wageComponents.length === 0)\"> <div class=col-md-12> <div class=\"alert alert-info\" translate>No data to send to Nmbrs for this employee in the selected period.</div> </div> </div> </div> </div> </div> </div> </div> <div class=modal id=notificationModal tabindex=-1 role=dialog aria-labelledby=myModalLabel> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <h4 class=modal-title translate>Send to Nmbrs</h4> </div> <div class=modal-body> <div>Bezig met versturen van medewerker {{$ctrl.progresscounter.currentValue}} van de {{$ctrl.progresscounter.totalValue}} medewerkers naar NMBRS.</div> <div class=progress style=margin-top:25px> <div class=progress-bar role=progressbar aria-valuenow=70 aria-valuemin=0 aria-valuemax=100 style=width:{};> <span class=sr-only>70% Complete</span> </div> </div> <div>{{$ctrl.currentNotification.message}}</div> </div> <div class=modal-footer> <button type=button class=\"btn btn-primary\" data-dismiss=modal ng-disabled=$ctrl.inprogress>Close</button> </div> </div> </div> </div> <div class=modal id=previewNmbrsModal tabindex=-1 role=dialog aria-labelledby=previewModalLabel> <div class=\"modal-dialog modal-lg\"> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=close><span aria-hidden=true>&times;</span></button> <h4 class=modal-title translate>Nmbrs Preview</h4> </div> <div class=modal-body ng-if=$ctrl.previewData> <div class=row> <div class=col-md-6> <strong translate>Employee:</strong> {{$ctrl.previewData.employeeName}}<br/> <strong translate>Period:</strong> {{$ctrl.previewData.year}} - {{$ctrl.previewData.period}}<br/> <strong translate>Number of Days:</strong> {{$ctrl.previewData.numberOfDays}} </div> </div> <div class=row style=margin-top:20px ng-if=\"$ctrl.previewData.hourComponents && $ctrl.previewData.hourComponents.length > 0\"> <div class=col-md-12> <h5 translate>Hour Components</h5> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th translate>Hour Code</th> <th translate>Hours</th> </tr> </thead> <tbody> <tr ng-repeat=\"hc in $ctrl.previewData.hourComponents\"> <td>{{hc.hourCode}}</td> <td>{{hc.hours | number:2}}</td> </tr> </tbody> </table> </div> </div> <div class=row style=margin-top:20px ng-if=\"$ctrl.previewData.wageComponents && $ctrl.previewData.wageComponents.length > 0\"> <div class=col-md-12> <h5 translate>Wage Components</h5> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th translate>Code</th> <th translate>Value</th> </tr> </thead> <tbody> <tr ng-repeat=\"wc in $ctrl.previewData.wageComponents\"> <td>{{wc.code}}</td> <td>{{wc.value | currency:\"€\":2}}</td> </tr> </tbody> </table> </div> </div> <div class=row style=margin-top:20px ng-if=\"(!$ctrl.previewData.hourComponents || $ctrl.previewData.hourComponents.length === 0) && (!$ctrl.previewData.wageComponents || $ctrl.previewData.wageComponents.length === 0)\"> <div class=col-md-12> <div class=\"alert alert-info\" translate>No data to send to Nmbrs for this employee in the selected period.</div> </div> </div> </div> <div class=modal-footer> <button type=button class=\"btn btn-primary\" data-dismiss=modal translate>Close</button> </div> </div> </div> </div> ";

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<div class=timesheets-dashboard-summary ng-if=$ctrl.summary> <span translate>Number of scheduled shifts</span>: {{ $ctrl.summary.scheduledShiftsCount - $ctrl.summary.canceledShiftsCount - $ctrl.summary.sickShiftsCount }}<br/> <span translate>Number of scheduled hours</span>: {{ $ctrl.summary.scheduledHours - $ctrl.summary.canceledShiftsHours - $ctrl.summary.sickShiftsHours }} <span translate>hours</span><br/> <span translate>Number of declared shifts</span>: {{ $ctrl.summary.declaredShiftsCount }}<br/> <span translate>Number of declared hours</span>: {{ $ctrl.summary.declaredHours }} <span translate>hours</span><br/> <span translate>Number of approved shifts</span>: {{ $ctrl.summary.approvedShiftsCount }}<br/> <span translate>Number of approved hours</span>: {{ $ctrl.summary.approvedHours }} <span translate>hours</span><br/> <span translate>Aantal geanuleerde diensten</span>: {{ $ctrl.summary.canceledShiftsCount }}<br/> <span translate>Aantal geanuleerde uren</span>: {{ $ctrl.summary.canceledShiftsHours }}<br/> <span translate>Aantal diensten ziek gemeld</span>: {{ $ctrl.summary.sickShiftsCount }}<br/> <span translate>Aantal uren ziek gemeld</span>: {{ $ctrl.summary.sickShiftsHours }} </div>";

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=main id=mainview> </div>";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 144,
	"./af.js": 144,
	"./ar": 151,
	"./ar-dz": 145,
	"./ar-dz.js": 145,
	"./ar-kw": 146,
	"./ar-kw.js": 146,
	"./ar-ly": 147,
	"./ar-ly.js": 147,
	"./ar-ma": 148,
	"./ar-ma.js": 148,
	"./ar-sa": 149,
	"./ar-sa.js": 149,
	"./ar-tn": 150,
	"./ar-tn.js": 150,
	"./ar.js": 151,
	"./az": 152,
	"./az.js": 152,
	"./be": 153,
	"./be.js": 153,
	"./bg": 154,
	"./bg.js": 154,
	"./bn": 155,
	"./bn.js": 155,
	"./bo": 156,
	"./bo.js": 156,
	"./br": 157,
	"./br.js": 157,
	"./bs": 158,
	"./bs.js": 158,
	"./ca": 159,
	"./ca.js": 159,
	"./cs": 160,
	"./cs.js": 160,
	"./cv": 161,
	"./cv.js": 161,
	"./cy": 162,
	"./cy.js": 162,
	"./da": 163,
	"./da.js": 163,
	"./de": 166,
	"./de-at": 164,
	"./de-at.js": 164,
	"./de-ch": 165,
	"./de-ch.js": 165,
	"./de.js": 166,
	"./dv": 167,
	"./dv.js": 167,
	"./el": 168,
	"./el.js": 168,
	"./en-au": 169,
	"./en-au.js": 169,
	"./en-ca": 170,
	"./en-ca.js": 170,
	"./en-gb": 171,
	"./en-gb.js": 171,
	"./en-ie": 172,
	"./en-ie.js": 172,
	"./en-nz": 173,
	"./en-nz.js": 173,
	"./eo": 174,
	"./eo.js": 174,
	"./es": 176,
	"./es-do": 175,
	"./es-do.js": 175,
	"./es.js": 176,
	"./et": 177,
	"./et.js": 177,
	"./eu": 178,
	"./eu.js": 178,
	"./fa": 179,
	"./fa.js": 179,
	"./fi": 180,
	"./fi.js": 180,
	"./fo": 181,
	"./fo.js": 181,
	"./fr": 184,
	"./fr-ca": 182,
	"./fr-ca.js": 182,
	"./fr-ch": 183,
	"./fr-ch.js": 183,
	"./fr.js": 184,
	"./fy": 185,
	"./fy.js": 185,
	"./gd": 186,
	"./gd.js": 186,
	"./gl": 187,
	"./gl.js": 187,
	"./gom-latn": 188,
	"./gom-latn.js": 188,
	"./he": 189,
	"./he.js": 189,
	"./hi": 190,
	"./hi.js": 190,
	"./hr": 191,
	"./hr.js": 191,
	"./hu": 192,
	"./hu.js": 192,
	"./hy-am": 193,
	"./hy-am.js": 193,
	"./id": 194,
	"./id.js": 194,
	"./is": 195,
	"./is.js": 195,
	"./it": 196,
	"./it.js": 196,
	"./ja": 197,
	"./ja.js": 197,
	"./jv": 198,
	"./jv.js": 198,
	"./ka": 199,
	"./ka.js": 199,
	"./kk": 200,
	"./kk.js": 200,
	"./km": 201,
	"./km.js": 201,
	"./kn": 202,
	"./kn.js": 202,
	"./ko": 203,
	"./ko.js": 203,
	"./ky": 204,
	"./ky.js": 204,
	"./lb": 205,
	"./lb.js": 205,
	"./lo": 206,
	"./lo.js": 206,
	"./lt": 207,
	"./lt.js": 207,
	"./lv": 208,
	"./lv.js": 208,
	"./me": 209,
	"./me.js": 209,
	"./mi": 210,
	"./mi.js": 210,
	"./mk": 211,
	"./mk.js": 211,
	"./ml": 212,
	"./ml.js": 212,
	"./mr": 213,
	"./mr.js": 213,
	"./ms": 215,
	"./ms-my": 214,
	"./ms-my.js": 214,
	"./ms.js": 215,
	"./my": 216,
	"./my.js": 216,
	"./nb": 217,
	"./nb.js": 217,
	"./ne": 218,
	"./ne.js": 218,
	"./nl": 220,
	"./nl-be": 219,
	"./nl-be.js": 219,
	"./nl.js": 220,
	"./nn": 221,
	"./nn.js": 221,
	"./pa-in": 222,
	"./pa-in.js": 222,
	"./pl": 223,
	"./pl.js": 223,
	"./pt": 225,
	"./pt-br": 224,
	"./pt-br.js": 224,
	"./pt.js": 225,
	"./ro": 226,
	"./ro.js": 226,
	"./ru": 227,
	"./ru.js": 227,
	"./sd": 228,
	"./sd.js": 228,
	"./se": 229,
	"./se.js": 229,
	"./si": 230,
	"./si.js": 230,
	"./sk": 231,
	"./sk.js": 231,
	"./sl": 232,
	"./sl.js": 232,
	"./sq": 233,
	"./sq.js": 233,
	"./sr": 235,
	"./sr-cyrl": 234,
	"./sr-cyrl.js": 234,
	"./sr.js": 235,
	"./ss": 236,
	"./ss.js": 236,
	"./sv": 237,
	"./sv.js": 237,
	"./sw": 238,
	"./sw.js": 238,
	"./ta": 239,
	"./ta.js": 239,
	"./te": 240,
	"./te.js": 240,
	"./tet": 241,
	"./tet.js": 241,
	"./th": 242,
	"./th.js": 242,
	"./tl-ph": 243,
	"./tl-ph.js": 243,
	"./tlh": 244,
	"./tlh.js": 244,
	"./tr": 245,
	"./tr.js": 245,
	"./tzl": 246,
	"./tzl.js": 246,
	"./tzm": 248,
	"./tzm-latn": 247,
	"./tzm-latn.js": 247,
	"./tzm.js": 248,
	"./uk": 249,
	"./uk.js": 249,
	"./ur": 250,
	"./ur.js": 250,
	"./uz": 252,
	"./uz-latn": 251,
	"./uz-latn.js": 251,
	"./uz.js": 252,
	"./vi": 253,
	"./vi.js": 253,
	"./x-pseudo": 254,
	"./x-pseudo.js": 254,
	"./yo": 255,
	"./yo.js": 255,
	"./zh-cn": 256,
	"./zh-cn.js": 256,
	"./zh-hk": 257,
	"./zh-hk.js": 257,
	"./zh-tw": 258,
	"./zh-tw.js": 258
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.loginState = {
    name: "login",
    url: "/login",
    component: 'login',
    resolve: { returnTo: returnTo }
};
exports.logoutState = {
    name: "logout",
    url: "/logout",
    component: 'logout'
};
exports.authorizedState = {
    name: "authorized",
    url: "/authorized",
    component: 'authorized'
};
exports.unauthorizedState = {
    name: "unauthorized",
    url: "/unauthorized",
    component: 'unauthorized'
};
/**
 * A resolve function for 'login' state which figures out what state to return to, after a successful login.
 *
 * If the user was initially redirected to login state (due to the requiresAuth redirect), then return the toState/params
 * they were redirected from.  Otherwise, if they transitioned directly, return the fromState/params.  Otherwise
 * return the main "home" state.
 */
returnTo.$inject = ['$transition$'];
function returnTo($transition$) {
    if ($transition$.redirectedFrom() !== null) {
        // The user was redirected to the login state (e.g., via the requiresAuth hook when trying to activate contacts)
        // Return to the original attempted target state (e.g., contacts)
        return $transition$.redirectedFrom().targetState();
    }
    var $state = $transition$.router.stateService;
    // The user was not redirected to the login state; they directly activated the login state somehow.
    // Return them to the state they came from.
    if ($transition$.from().name !== '') {
        return $state.target($transition$.from(), $transition$.params("from"));
    }
    // If the fromState's name is empty, then this was the initial transition. Just return them to the home state
    return $state.target('home');
}


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthorizedController = /** @class */ (function () {
    function AuthorizedController(authService, Restangular) {
        var _this = this;
        this.authService = authService;
        this.Restangular = Restangular;
        this.$onInit = function () {
            _this.authService.authorizeCallback();
            _this.authService.setTokenHeader();
        };
    }
    AuthorizedController.$inject = ['AuthService', 'Restangular'];
    return AuthorizedController;
}());
exports.authorized = {
    controller: AuthorizedController,
    template: __webpack_require__(378)
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LoginController = /** @class */ (function () {
    function LoginController(AuthService, $state, Restangular) {
        var _this = this;
        this.AuthService = AuthService;
        this.$state = $state;
        this.Restangular = Restangular;
        this.$onInit = function () {
            _this.AuthService.authorize();
            //console.log(this.returnTo)
        };
        this.returnToOriginalState = function () {
            var state = _this.returnTo.state();
            var params = _this.returnTo.params();
            var options = Object.assign({}, _this.returnTo.options(), { reload: true });
            if (state) {
                _this.$state.go(state, params, options);
            }
            else {
                _this.$state.go('app');
            }
        };
        this.login = function () {
            var data = {
                "grant_type": "client_credentials",
                "client_id": "TestClient",
                "client_secret": "TestClientSecret"
            };
            _this.Restangular.all('token').post(data)
                .then(function (response) {
                _this.AuthService.SetAuthorizationData(response.access_token, response.access_token).then(function () {
                    _this.AuthService.setTokenHeader();
                    _this.returnToOriginalState();
                });
            })
                .catch(function (response) { });
        };
    }
    LoginController.$inject = ['AuthService', '$state', 'Restangular'];
    return LoginController;
}());
exports.login = {
    bindings: { returnTo: '<' },
    controller: LoginController,
    template: __webpack_require__(379)
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LogoutController = /** @class */ (function () {
    function LogoutController(authService) {
        var _this = this;
        this.authService = authService;
        this.$onInit = function () {
            _this.authService.logout();
        };
    }
    LogoutController.$inject = ['AuthService'];
    return LogoutController;
}());
exports.logout = {
    controller: LogoutController,
    template: __webpack_require__(380)
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file contains a Transition Hook which protects a
 * route that requires authentication.
 *
 * This hook redirects to /login when both:
 * - The user is not authenticated
 * - The user is navigating to a state that requires authentication
 */
exports.authHookRunBlock = ['$transitions', 'AuthService', function ($transitions, AuthService) {
        AuthService.setTokenHeader();
        // Matches if the destination state's data property has a truthy 'requiresAuth' property
        var requiresAuthCriteria = {
            to: function (state) { return state.data && state.data.requiresAuth; }
        };
        // Function that returns a redirect for the current transition to the login state
        // if the user is not currently authenticated (according to the AuthService)
        var redirectToLogin = function (transition) {
            //let AuthService = transition.injector().get('AuthService');
            var $state = transition.router.stateService;
            AuthService.setTokenHeader();
            return AuthService.isAuthorized().catch(function () {
                return $state.target('login', undefined, { location: false });
            });
        };
        // Register the "requires auth" hook with the TransitionsService
        $transitions.onBefore(requiresAuthCriteria, redirectToLogin, { priority: 10 });
    }];


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __webpack_require__(13);
var AuthService = /** @class */ (function () {
    function AuthService(localStorageService, $window, $state, $q, $timeout, Restangular) {
        var _this = this;
        this.localStorageService = localStorageService;
        this.$window = $window;
        this.$state = $state;
        this.$q = $q;
        this.$timeout = $timeout;
        this.Restangular = Restangular;
        this.isAuthorized = function (role) {
            if (role === void 0) { role = null; }
            var deferred = _this.$q.defer();
            if (_this.localStorageService.get("authorizationData") != null && _this.localStorageService.get("authorizationData") != "") {
                if (role && !_this.hasRole(role)) {
                    deferred.reject({
                        code: 401, text: 'Insufficient roles'
                    });
                }
                deferred.resolve({ code: 200 });
            }
            else {
                deferred.reject({ code: 403 });
            }
            return deferred.promise;
        };
        this.setTokenHeader = function () {
            _this.Restangular.setDefaultHeaders({ 'Authorization': 'Bearer ' + _this.localStorageService.get("authorizationData") });
        };
        this.hasRole = function (role) {
            var roles = _this.getRoles();
            if (roles instanceof Array) {
                return (roles.indexOf(role) > -1);
            }
            else {
                return (roles == role);
            }
        };
        this.getRoles = function () {
            var data = _this.getDataFromToken(_this.GetAuthorizationData());
            return data.role;
        };
        this.getTokenData = function () {
            if (_this.GetAuthorizationData()) {
                var data = _this.getDataFromToken(_this.GetAuthorizationData());
                return data;
            }
            return false;
        };
        this.authorize = function () {
            // console.log("AuthorizedController time to log on");
            var authorizationUrl = config_1.default.AUTH_LOGIN_URL;
            var client_id = config_1.default.AUTH_CLIENT_ID;
            var redirect_uri = _this.$window.location.origin + '/authorized';
            var response_type = "id_token token";
            var scope = config_1.default.AUTH_SCOPES;
            var nonce = "N" + Math.random() + "" + Date.now();
            var state = Date.now() + "" + Math.random();
            _this.localStorageService.set("authNonce", nonce);
            _this.localStorageService.set("authStateControl", state);
            // console.log("AuthorizedController created. adding myautostate: " + this.localStorageService.get("authStateControl"));
            var url = authorizationUrl + "?" +
                "response_type=" + encodeURI(response_type) + "&" +
                "client_id=" + encodeURI(client_id) + "&" +
                "redirect_uri=" + encodeURI(redirect_uri) + "&" +
                "scope=" + encodeURI(scope) + "&" +
                "nonce=" + encodeURI(nonce) + "&" +
                "state=" + encodeURI(state);
            // console.log(url);
            _this.$window.location.href = url;
        };
        this.logout = function () {
            var id_token = _this.localStorageService.get("authorizationDataIdToken");
            var authorizationUrl = config_1.default.AUTH_LOGOUT_URL;
            var id_token_hint = id_token;
            var post_logout_redirect_uri = _this.$window.location.origin + '';
            var state = Date.now() + "" + Math.random();
            var url = authorizationUrl + "?" +
                "id_token_hint=" + id_token_hint + "&" +
                "post_logout_redirect_uri=" + encodeURI(post_logout_redirect_uri) + "&" +
                "state=" + encodeURI(state);
            _this.ResetAuthorizationData();
            _this.$window.location.href = url;
        };
        this.authorizeCallback = function () {
            // console.log("AuthorizedController created, has hash");
            var hash = window.location.hash.substr(1);
            var result = hash.split('&').reduce(function (result, item) {
                var parts = item.split('=');
                result[parts[0]] = parts[1];
                return result;
            }, {});
            var token = "";
            var id_token = "";
            var authResponseIsValid = false;
            if (!result.error) {
                if (result.state !== _this.localStorageService.get("authStateControl")) {
                    // console.log("AuthorizedCallback incorrect state");
                }
                else {
                    token = result.access_token;
                    id_token = result.id_token;
                    var dataIdToken = _this.getDataFromToken(id_token);
                    // console.log(dataIdToken);
                    // validate nonce
                    if (dataIdToken.nonce !== _this.localStorageService.get("authNonce")) {
                        // console.log("AuthorizedCallback incorrect nonce");
                    }
                    else {
                        _this.localStorageService.set("authNonce", "");
                        _this.localStorageService.set("authStateControl", "");
                        authResponseIsValid = true;
                        // console.log("AuthorizedCallback state and nonce validated, returning access token");
                    }
                }
            }
            if (authResponseIsValid) {
                var state = _this.$state;
                _this.SetAuthorizationData(token, id_token).then(function () {
                    //console.log(this.localStorageService.get("authorizationData"));
                    _this.$window.location.href = _this.$window.location.origin;
                });
            }
            else {
                _this.ResetAuthorizationData();
                _this.$state.go("unauthorized");
            }
        };
        this.ResetAuthorizationData = function () {
            _this.localStorageService.set("authorizationData", "");
            _this.localStorageService.set("authorizationDataIdToken", "");
        };
        this.GetAuthorizationData = function () {
            return _this.localStorageService.get("authorizationData");
        };
        this.SetAuthorizationData = function (token, id_token) {
            // console.log(token);
            var deferred = _this.$q.defer();
            _this.$timeout(function () {
                if (_this.localStorageService.get("authorizationData") !== "") {
                    _this.localStorageService.set("authorizationData", "");
                }
                _this.localStorageService.set("authorizationData", token);
                _this.localStorageService.set("authorizationDataIdToken", id_token);
                deferred.resolve();
            }, 3000);
            return deferred.promise;
        };
    }
    AuthService.prototype.getEmployeeId = function (token) {
        var data = this.getDataFromToken(token);
        // console.log(data);
        var userID = data.employeeId;
        return userID;
    };
    AuthService.prototype.getDataFromToken = function (token) {
        var data = {};
        if (typeof token !== 'undefined') {
            var encoded = token.split('.')[1];
            data = JSON.parse(this.urlBase64Decode(encoded));
        }
        return data;
    };
    AuthService.prototype.urlBase64Decode = function (str) {
        var output = str.replace('-', '+').replace('_', '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                throw 'Illegal base64url string!';
        }
        return window.atob(output);
    };
    AuthService.$inject = ['localStorageService', '$window', '$state', '$q', '$timeout', 'Restangular'];
    return AuthService;
}());
exports.AuthService = AuthService;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(533));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UnAuthorizedController = /** @class */ (function () {
    function UnAuthorizedController(authService) {
        this.authService = authService;
    }
    UnAuthorizedController.$inject = ['authService'];
    return UnAuthorizedController;
}());
exports.unauthorized = {
    controller: UnAuthorizedController,
    template: __webpack_require__(381)
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.authServiceRun = ['Restangular', function (Restangular) {
    }];


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.authSettingsState = {
    parent: "app",
    name: "authsettings",
    url: "/authsettings",
    //redirectTo: "authsettings.list",
    component: "authSettingsComponent",
    data: {
        permissions: {
            only: ['SUPERUSER'],
            redirectTo: 'schedule'
        }
    }
};
exports.authSettingsUsersState = {
    name: "authsettings.users",
    url: "/users",
    resolve: {
        authUsers: ["AuthUserService", function (AuthUserService) {
            'ngInject';
            return AuthUserService.all();
        }]
    },
    views: {
        "main": 'authSettingsUsersComponent'
    }
};
exports.authSettingsUsersItemState = {
    name: "authsettings.users.item",
    url: "/:id",
    resolve: {
        authUser: ["AuthUserService", "$stateParams", function (AuthUserService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != 0) {
                return AuthUserService.get($stateParams['id']);
            }
        }]
    },
    views: {
        "main@authsettings": 'authSettingsUsersItemComponent'
    }
};
exports.authSettingsServerState = {
    name: "authsettings.server",
    url: "/server",
    //redirectTo: "authsettings.list",
    views: {
        "main": 'authSettingsServerComponent'
    }
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthSettingsController = /** @class */ (function () {
    function AuthSettingsController() {
        'ngInject';
    }
    return AuthSettingsController;
}());
exports.authSettingsComponent = {
    controller: AuthSettingsController,
    template: __webpack_require__(382)
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthSettingsServerController = /** @class */ (function () {
    AuthSettingsServerController.$inject = ["AuthSettingsService"];
    function AuthSettingsServerController(AuthSettingsService) {
        'ngInject';
        var _this = this;
        this.AuthSettingsService = AuthSettingsService;
        this.$onInit = function () {
            _this.AuthSettingsService.all();
        };
    }
    return AuthSettingsServerController;
}());
exports.authSettingsServerComponent = {
    controller: AuthSettingsServerController,
    template: __webpack_require__(383)
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthSettingsUsersController = /** @class */ (function () {
    AuthSettingsUsersController.$inject = ["AuthUserService"];
    function AuthSettingsUsersController(AuthUserService) {
        'ngInject';
        this.AuthUserService = AuthUserService;
        this.$onInit = function () {
        };
    }
    return AuthSettingsUsersController;
}());
exports.authSettingsUsersComponent = {
    bindings: {
        authUsers: "<"
    },
    controller: AuthSettingsUsersController,
    template: __webpack_require__(384)
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(6);
var AuthSettingsUsersItemController = /** @class */ (function () {
    AuthSettingsUsersItemController.$inject = ["AuthUserService"];
    function AuthSettingsUsersItemController(AuthUserService) {
        'ngInject';
        var _this = this;
        this.AuthUserService = AuthUserService;
        this.$onInit = function () {
            _this.AuthUserService.getRoles(_this.authUser).then(function (roles) {
                _this.authUser.roles = roles;
            });
            _this.AuthUserService.getClaims(_this.authUser).then(function (claims) {
                _this.authUser.claims = new Object();
                for (var i = 0; i < claims.length; i++) {
                    var item = claims[i];
                    _this.authUser.claims[item.type] = item.value;
                }
                // console.log(this.authUser.claims);
            });
        };
        this.save = function () {
            _this.AuthUserService.post(_this.authUser).then(function (response) {
                // console.log(response);
            });
        };
        this.createAccount = function () {
            _this.authUser.userName = _this.authUser.email;
            _this.authUser.claims = {
                "displayName": _this.authUser.displayName,
            };
            _this.authUser.roles = ['employee'];
            _this.AuthUserService.post(_this.authUser).then(function (response) {
                // console.log('Account created');
            });
        };
        this.updateUser = function () {
            _this.AuthUserService.put(_this.authUser.id, _this.authUser).then(function (response) {
                // console.log('Account created')
            });
        };
        this.resetPassword = function () {
            //this.account = new IAuthUser();
            _this.AuthUserService.resetPassword(_this.authUser).then(function (response) {
                //this.accountError = response;
                // console.log('Password reset')
            });
        };
        this.editField = function (index, value) {
            if (index === void 0) { index = null; }
            if (value === void 0) { value = null; }
            _this.deleteField(index, value);
            _this.fieldedit.name = index;
            _this.fieldedit.value = value;
        };
        this.deleteField = function (index, value) {
            if (index === void 0) { index = null; }
            if (value === void 0) { value = null; }
            _.unset(_this.authUser.claims, index);
        };
        this.saveFields = function () {
            if (!_this.authUser.claims) {
                _this.authUser.claims = {};
            }
            _this.authUser.claims[_this.fieldedit.name] = _this.fieldedit.value;
            _this.fieldedit.name = null;
            _this.fieldedit.value = null;
        };
        this.editRole = function (index, value) {
            if (index === void 0) { index = null; }
            if (value === void 0) { value = null; }
            _this.deleteRole(index, value);
            _this.roleedit.name = value;
        };
        this.deleteRole = function (index, value) {
            if (index === void 0) { index = null; }
            if (value === void 0) { value = null; }
            _this.authUser.roles.splice(index, 1);
        };
        this.saveRole = function () {
            if (!_this.authUser.roles) {
                _this.authUser.roles = [];
            }
            _this.authUser.roles.push(_this.roleedit.name);
            _this.roleedit.name = null;
        };
    }
    return AuthSettingsUsersItemController;
}());
exports.authSettingsUsersItemComponent = {
    bindings: {
        authUser: "<"
    },
    controller: AuthSettingsUsersItemController,
    template: __webpack_require__(385)
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ResetPasswordController = /** @class */ (function () {
    ResetPasswordController.$inject = ["AuthUserService", "$state"];
    function ResetPasswordController(AuthUserService, $state) {
        'ngInject';
        var _this = this;
        this.AuthUserService = AuthUserService;
        this.$state = $state;
        this.$onInit = function () {
            if (!_this.authUser) {
                _this.AuthUserService.getCurrentUser().then(function (user) {
                    _this.authUser = user;
                });
            }
        };
        this.resetPassword = function () {
            _this.AuthUserService.resetPassword(_this.authUser).then(function (response) {
                $('#ResetPasswordModal').modal('hide');
            });
        };
    }
    return ResetPasswordController;
}());
exports.resetPasswordComponent = {
    bindings: {
        authUser: "<"
    },
    controller: ResetPasswordController,
    template: __webpack_require__(386)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __webpack_require__(13);
exports.AuthSettingsApi = ['Restangular', function (Restangular) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(config_1.default.AUTH_API_URL);
        });
    }];


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IAuthSettings = /** @class */ (function () {
    function IAuthSettings() {
    }
    return IAuthSettings;
}());
exports.IAuthSettings = IAuthSettings;
var AuthSettingsService = /** @class */ (function (_super) {
    __extends(AuthSettingsService, _super);
    AuthSettingsService.$inject = ["AuthSettingsApi", "AppService"];
    function AuthSettingsService(AuthSettingsApi, AppService) {
        'ngInject';
        var _this = _super.call(this, AuthSettingsApi, AppService, 'user') || this;
        _this.AppService = AppService;
        return _this;
    }
    return AuthSettingsService;
}(base_service_1.BaseService));
exports.AuthSettingsService = AuthSettingsService;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseAppService = /** @class */ (function () {
    function BaseAppService() {
        "ngInject";
    }
    return BaseAppService;
}());
exports.BaseAppService = BaseAppService;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var moment = __webpack_require__(0);
/** Set Moment defaults */
moment.locale('nl');
__webpack_require__(301);
__webpack_require__(25);
__webpack_require__(6);
__webpack_require__(26);
__webpack_require__(280);
__webpack_require__(300);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(287);
__webpack_require__(276);
__webpack_require__(282);
__webpack_require__(0);
__webpack_require__(297);
__webpack_require__(281);
__webpack_require__(275);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(291);
//import '@abosol/masterdata';
__webpack_require__(279);
__webpack_require__(278);
__webpack_require__(289);
__webpack_require__(286);
__webpack_require__(290);
// import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.js';
// import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.templates.js';
// import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';
// import 'angular-date-time-input/src/dateTimeInput.js';
__webpack_require__(283);
__webpack_require__(277);
__webpack_require__(288);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(296);
angular.element(document).ready(function () {
    angular.bootstrap(document.body, ['app'], {
        strictDi: true
    });
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TwinfieldController = /** @class */ (function () {
    /**
     * Constructor
     *
     * @return  {void}
     */
    TwinfieldController.$inject = ["TwinfieldService", "$scope", "$state", "localStorageService", "$location"];
    function TwinfieldController(TwinfieldService, $scope, $state, localStorageService, $location) {
        'ngInject';
        var _this = this;
        this.TwinfieldService = TwinfieldService;
        this.$scope = $scope;
        this.$state = $state;
        this.localStorageService = localStorageService;
        this.$location = $location;
        /**
         * Initiator
         *
         * @return  {void}
         */
        this.$onInit = function () {
            /** Set twinfield URI nonces */
            _this.$scope.nonce = _this.generateNonce();
            _this.$scope.twinfieldUrl = 'https://login.twinfield.com/auth/authentication/connect/authorize'
                + '?client_id=brainsweb'
                + '&response_type=code'
                + '&scope=openid+twf.user+twf.organisation+twf.organisationUser+offline_access'
                + '&redirect_uri=' + window.location.protocol + '//' + window.location.host + '/app/twinfield'
                + '&state=' + _this.generateNonce()
                + '&nonce=' + _this.generateNonce();
            /** Get status */
            _this.TwinfieldService.verifyToken().then(function (status) {
                _this.$scope.status = status;
                console.log('token: verify ' + _this.$scope.status);
            }).catch(function () {
                _this.$scope.status = false;
            });
        };
    }
    /**
     * Generate a nonces

     * @return  {string}  Nonce
     */
    TwinfieldController.prototype.generateNonce = function () {
        return (Math.floor((Math.random() * 6) + 1) * new Date().getTime()).toString();
    };
    /**
     * Redirect to Twinfield for oAuth2 code retrieval
     *
     * @return  {void}
     */
    TwinfieldController.prototype.authenticateTwinfield = function () {
        parent.location.href = this.$scope.twinfieldUrl;
    };
    return TwinfieldController;
}());
exports.twinfieldComponent = {
    controller: TwinfieldController,
    template: __webpack_require__(387)
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.compareTo = function () {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function (scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };
            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
    };
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.file = function () {
    return {
        restrict: 'E',
        template: '<input type="file" />',
        replace: true,
        require: 'ngModel',
        link: function (scope, element, attr, ctrl) {
            var listener = function () {
                scope.$apply(function () {
                    attr.multiple ? ctrl.$setViewValue(element[0].files) : ctrl.$setViewValue(element[0].files[0]);
                });
            };
            element.bind('change', listener);
        }
    };
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixedHeight = ["$window", "$timeout", "screenSize", function ($window, $timeout, screenSize) {
    'ngInject';
    return {
        restrict: 'AEC',
        scope: {
            resize: '@',
        },
        link: function (scope, element, $attrs) {
            function setheight() {
                var offset = $(element).offset();
                // console.log(offset)
                if (offset.top > 0) {
                    var offsetmain = $("#mainview").offset();
                    var offsettop = (offset.top - offsetmain.top);
                    var docHeight = $(window).height();
                    var height = docHeight - offsettop - 95;
                    $(element).height(height);
                }
            }
            if (!screenSize.is('xs, sm')) {
                $timeout(function () {
                    setheight();
                });
                $window.onresize = function (event) {
                    setheight();
                };
                $attrs.$observe('resize', function (resize) {
                    $timeout(function () {
                        setheight();
                    });
                });
            }
        }
    };
}];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordValidation = function () {
    return {
        restrict: 'A',
        require: "ngModel",
        scope: {},
        link: function (scope, element, attributes, mCtrl) {
            function myValidation(value) {
                var re = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}/;
                mCtrl.$setValidity('validation', re.test(value));
                return value;
            }
            mCtrl.$parsers.push(myValidation);
        }
    };
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.bytes = [function () {
        return function (bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes))
                return '-';
            if (typeof precision === 'undefined')
                precision = 1;
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
        };
    }];


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(756);
exports.isDay = [function () {
        return function (input, day) {
            var out = [];
            if (input && util_1.isArray(input)) {
                input.forEach(function (d) {
                    // console.log(d)
                    if (new Date(d.start).getDate() == day.getDate() &&
                        new Date(d.start).getMonth() == day.getMonth() &&
                        new Date(d.start).getFullYear() == day.getFullYear()) {
                        out.push(d);
                    }
                });
            }
            return out;
        };
    }];


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shifts_service_1 = __webpack_require__(15);
var moment = __webpack_require__(0);
var config_1 = __webpack_require__(13);
var AppController = /** @class */ (function () {
    AppController.$inject = ["AuthService", "$scope", "$window", "ThemeService", "AuthUserService"];
    function AppController(AuthService, $scope, $window, ThemeService, AuthUserService) {
        'ngInject';
        var _this = this;
        this.AuthService = AuthService;
        this.$scope = $scope;
        this.$window = $window;
        this.ThemeService = ThemeService;
        this.AuthUserService = AuthUserService;
        this.$onInit = function () {
            _this.version = config_1.default.VERSION;
            _this.ThemeService.setIsSmallSidebar(false);
            _this.AuthUserService.getCurrentUser().then(function (user) {
                _this.user = user;
            });
            // this.$scope.$on('getAdHocShiftsUp', (event, data) => {
            //     console.log('getAdHocShiftsUp'); 
            //     this.$scope.$broadcast('getAdHocShiftsDown', data);
            // });
        };
        this.menuItems = [
            { 'name': 'Dashboard', 'sref': 'dashboard', 'iconclass': 'fa fa-flask', 'role': 'BACKOFFICE' },
            { 'name': 'Diensten', 'sref': 'shifts', 'iconclass': 'fa fa-calendar-o', 'role': 'BACKOFFICE' },
            { 'name': 'Taken', 'sref': 'tasks', 'iconclass': 'fa fa-tasks', 'role': 'BACKOFFICE', 'submenu': [
                    { 'name': 'Actieve taken', 'sref': 'tasks.list' },
                    { 'name': 'Archief', 'sref': 'tasks.archive' },
                ] },
            { 'name': 'Urenregistratie', 'sref': 'timesheets', 'iconclass': 'fa fa-clock-o', 'role': 'TIMESHEETS', 'submenu': [
                    { 'name': 'Doorboeken', 'sref': 'timesheets.dashboard' },
                    { 'name': 'Overzicht', 'sref': 'timesheets.overview', 'role': 'FINANCE' },
                ] },
            { 'name': 'Financieel', 'sref': 'quotations', 'iconclass': 'fa fa-file-text-o', 'role': 'FINANCE', 'submenu': [
                    { 'name': 'Pro forma facturen', 'sref': 'quotations.proforma' },
                    { 'name': 'Facturatie', 'sref': 'quotations.dashboard' },
                    { 'name': 'Cootje', 'sref': 'quotations.cootje' },
                ] },
            { 'name': 'CRM', 'sref': 'crm', 'iconclass': 'fa fa-users', 'role': 'BACKOFFICE', 'submenu': [
                    { 'name': 'Bedrijven', 'sref': 'crm.accounts' },
                    { 'name': 'Contacten', 'sref': 'crm.contacts' },
                ] },
            { 'name': 'HR', 'sref': 'hr', 'iconclass': 'fa fa-user-o', 'role': 'BACKOFFICE', 'submenu': [
                    { 'name': 'Medewerkers', 'sref': 'hr.employees' },
                    { 'name': 'Beschikbaarheid', 'sref': 'hr.availability' },
                ] },
            { 'name': 'Recruitment', 'sref': 'hr.applicants', 'iconclass': 'fa fa-user-o', 'role': 'BACKOFFICE', 'submenu': [
                    { 'name': 'Sollicitanten', 'sref': 'hr.applicants.list' },
                    { 'name': 'Sollicitanten archief', 'sref': 'hr.applicants.archive' }
                ] },
            { 'name': 'Instellingen', 'sref': 'questions', 'iconclass': 'fa fa-gear', 'role': 'BACKOFFICE', 'submenu': [
                    { 'name': 'Accounts', 'sref': 'authsettings', 'role': 'SUPERUSER' },
                    { 'name': 'Kantoorpersoneel', 'sref': 'settings.staff', 'role': 'SUPERUSER' },
                    { 'name': 'Stamdata', 'sref': 'settings.masterdata', 'role': 'BACKOFFICE' },
                    { 'name': 'Salarischalen', 'sref': 'settings.salaryscales', 'role': 'BACKOFFICE' },
                    // {'name': 'Email-templates', 'sref': 'settings.templates', 'role': 'SUPERUSER' },
                    { 'name': 'ORT dagen', 'sref': 'settings.timezones', 'role': 'BACKOFFICE' },
                    { 'name': 'Uurcodes', 'sref': 'settings.hourcodes', 'role': 'BACKOFFICE' },
                    { 'name': 'Nmbrs API Test', 'sref': 'settings.nmbrsTest', 'role': 'BACKOFFICE' }
                ] },
            // {'name': 'Dashboard', 'sref': 'dashboard', 'iconclass': 'fa fa-flask', 'role': 'EMPLOYEE'},
            { 'name': 'Agenda', 'sref': 'schedule', 'iconclass': 'fa fa-calendar-o', 'role': 'EMPLOYEE' },
            { 'name': 'Declaraties', 'sref': 'schedule.declarations', 'iconclass': 'fa fa-clock-o', 'role': 'EMPLOYEE' },
            { 'name': 'Inschrijven', 'sref': 'subscriptions', 'iconclass': 'fa fa-list-ul', 'role': 'EMPLOYEE' },
            { 'name': 'Vaardigheden', 'sref': 'skills', 'iconclass': 'fa fa-wrench', 'role': 'EMPLOYEE' },
            { 'name': 'Documentatie', 'sref': 'documentation', 'iconclass': 'fa fa-book', 'role': 'EMPLOYEE' },
            { 'name': 'Diensten', 'sref': 'customerShifts', 'iconclass': 'fa fa-calendar', 'role': 'CUSTOMER' }
        ];
        this.currentShift = new shifts_service_1.IShift();
        this.currentShift.start = this.roundMinutes(new Date());
        this.currentShift.end = moment(this.currentShift.start).add(8, 'hour').toDate();
    }
    AppController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    return AppController;
}());
exports.app = {
    controller: AppController,
    template: __webpack_require__(388)
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __webpack_require__(13);
exports.otherwiseConfigBlock = ['$urlRouterProvider', function ($urlRouterProvider) {
        $urlRouterProvider.otherwise('/app');
    }];
exports.html5ConfigBlock = ['$locationProvider', function ($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }];
exports.themeConfigBlock = ['ThemeServiceProvider', '$animateProvider', function (ThemeServiceProvider, $animateProvider) {
        ThemeServiceProvider.setLogo(__webpack_require__(373));
        ThemeServiceProvider.setLogoDark(__webpack_require__(372));
        $animateProvider.classNameFilter(/ng-animate-enabled/);
    }];
exports.masterDataConfigBlock = ['MasterdataAService', function (MasterdataAService) {
        MasterdataAService.setType('Skills', 'SKILLS');
        MasterdataAService.setType('Functions', 'Functions');
        MasterdataAService.setType('Hour codes', 'HourCodes');
        MasterdataAService.setType('Availability status', 'AvalabilityStatus');
        MasterdataAService.setType('Transportation type', 'TransportationType');
        MasterdataAService.setType('Note Tags', 'NoteTags');
        MasterdataAService.setType('Contact Tags', 'ContactTags');
        MasterdataAService.setType('Task Status', 'TaskStatus');
        MasterdataAService.setType('Preferred target audience', 'PreferredTargetAudience');
        MasterdataAService.setType('Application status', 'ApplicationStatus');
        MasterdataAService.setApiItemName('masterdata');
    }];
exports.config = ['RestangularProvider', 'localStorageServiceProvider', function (RestangularProvider, localStorageServiceProvider) {
        RestangularProvider.setBaseUrl(config_1.default.API_URL);
        localStorageServiceProvider.setStorageType('sessionStorage');
    }];


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.run = ['Restangular', 'NotifyService', '$state', 'DTDefaultOptions', 'gettextCatalog', '$window', 'PermPermissionStore', 'PermRoleStore', 'deviceDetector', function (Restangular, notifyService, $state, DTDefaultOptions, gettextCatalog, $window, PermPermissionStore, PermRoleStore, deviceDetector) {
        //SET LANGUAGE
        var lang = $window.navigator.language;
        var lf = '';
        switch (lang) {
            case 'nl':
            case 'nl-NL':
                lf = 'nl_NL';
                break;
            default: lf = 'en_US';
        }
        gettextCatalog.setCurrentLanguage(lf);
        gettextCatalog.debug = false;
        //CHECK IF IE
        var browser = deviceDetector.browser;
        if (deviceDetector.browser == "ie") {
            $state.go('browser');
        }
        Restangular.setErrorInterceptor(function (response, deferred, responseHandler) {
            switch (response.status) {
                case 401:
                    notifyService.error(response.status.toString(), 'Unauthorized');
                    $state.go('login');
                    break;
                case 403:
                    $state.go('login');
                    break;
                default:
                    notifyService.error(response.status.toString());
                    break;
            }
        });
        Restangular.addResponseInterceptor(function (data, operation, what, url, response) {
            switch (response.status) {
                case 200:
                    return data;
                default:
                    return data;
            }
        });
        DTDefaultOptions.setLanguage({
            sUrl: '//cdn.datatables.net/plug-ins/1.10.12/i18n/Dutch.json'
        });
        PermRoleStore.defineRole('EMPLOYEE', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('SUPERUSER', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('BACKOFFICE', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('TIMESHEETS', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('FINANCE', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('ADMIN', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
        PermRoleStore.defineRole('CUSTOMER', ["roleName", "AuthService", function (roleName, AuthService) {
            'ngInject';
            return AuthService.hasRole(roleName.toLowerCase());
        }]);
    }];


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_app_service_1 = __webpack_require__(545);
var AppService = /** @class */ (function (_super) {
    __extends(AppService, _super);
    AppService.$inject = ["NotifyService", "SweetAlert"];
    function AppService(NotifyService, SweetAlert) {
        "ngInject";
        var _this = _super.call(this) || this;
        _this.NotifyService = NotifyService;
        _this.SweetAlert = SweetAlert;
        return _this;
    }
    return AppService;
}(base_app_service_1.BaseAppService));
exports.AppService = AppService;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//import { AuthService } from '../authorization/services/auth.service';
Object.defineProperty(exports, "__esModule", { value: true });
exports.appState = {
    name: 'app',
    url: '/app',
    redirectTo: 'dashboard',
    component: 'app',
    data: {
        requiresAuth: true
    }
};
exports.homeState = {
    name: 'home',
    url: '/home',
    component: 'home'
};
exports.browserState = {
    name: 'browser',
    url: '/browser',
    component: 'browserPageComponent'
};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BrowserPageController = /** @class */ (function () {
    BrowserPageController.$inject = ["deviceDetector"];
    function BrowserPageController(deviceDetector) {
        'ngInject';
        this.deviceDetector = deviceDetector;
        // console.log('CrmController');
    }
    return BrowserPageController;
}());
exports.browserPageComponent = {
    controller: BrowserPageController,
    template: __webpack_require__(389)
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var ChatPanelController = /** @class */ (function () {
    ChatPanelController.$inject = ["$state", "$scope", "ShiftService", "EmployeesService", "AccountsService"];
    function ChatPanelController($state, $scope, ShiftService, EmployeesService, AccountsService) {
        'ngInject';
        this.$state = $state;
        this.$scope = $scope;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.AccountsService = AccountsService;
        this.$onInit = function () {
            // this.$scope.$on('getAdHocShiftsDown', (event, data) => { 
            //     console.log('getAdHocShiftsDown'); 
            // });      
        };
    }
    ChatPanelController.prototype.isSameDay = function (start, end) {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        }
        else {
            return false;
        }
    };
    ChatPanelController.prototype.openShift = function (item) {
        this.currentShift = item;
        this.setLocations();
        this.setAccountNotes();
        this.setEmployees();
        $('#check-availability-modal').modal('show');
    };
    ChatPanelController.prototype.setLocations = function () {
        var _this = this;
        if (this.currentShift.teamLocationAccountId) {
            this.AccountsService.getChild(this.currentShift.teamLocationAccountId, 'locations').then(function (result) {
                _this.locations = result;
                _this.setTeams();
            });
        }
    };
    ChatPanelController.prototype.setAccountNotes = function () {
        var _this = this;
        if (this.currentShift.teamLocationAccountId) {
            this.AccountsService.getChild(this.currentShift.teamLocationAccountId, 'notes/?tag=planning').then(function (result) {
                _this.accountNotes = result;
            });
        }
    };
    ChatPanelController.prototype.setEmployees = function () {
        var _this = this;
        if (this.currentShift.start && this.currentShift.end) {
            var request = {
                accountId: this.currentShift.teamLocationAccountId,
                locationId: this.currentShift.teamLocationId,
                startDate: this.currentShift.start,
                endDate: this.currentShift.end,
                shiftId: this.currentShift.id
            };
            this.EmployeesService.customPost('availableEmployees', request, false).then(function (result) {
                _this.employees = result;
                _this.selectedEmployee = _this.employees.find(function (employeeSummary) { return employeeSummary.employee.id == _this.currentShift.employeeId; });
            });
        }
    };
    ChatPanelController.prototype.setTeams = function () {
        var _this = this;
        if (this.currentShift.teamLocationId) {
            this.teams = this.locations.find(function (item) { return item.id === _this.currentShift.teamLocationId; }).teams;
        }
    };
    ChatPanelController.prototype.approve = function (event, shift) {
        event.stopPropagation();
        shift.status = 6;
        this.updateShift(shift);
    };
    ChatPanelController.prototype.reject = function (event, shift) {
        event.stopPropagation();
        shift.status = 99;
        this.updateShift(shift);
    };
    ChatPanelController.prototype.updateShift = function (shift) {
        var _this = this;
        this.ShiftService.put(shift.id, shift).then(function (data) {
            _this.shifts = _this.shifts.filter(function (s) { return s.id !== shift.id; });
        });
    };
    return ChatPanelController;
}());
exports.chatPanelComponent = {
    bindings: {
        shifts: '=',
        currentShift: '=',
        locations: '=',
        teams: '=',
        accountNotes: '=',
        employees: '=',
        selectedEmployee: '='
    },
    controller: ChatPanelController,
    template: __webpack_require__(390)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var shifts_service_1 = __webpack_require__(15);
var moment = __webpack_require__(0);
var NavbarController = /** @class */ (function () {
    NavbarController.$inject = ["ThemeService", "ShiftService", "NewsService", "$scope", "$interval", "SweetAlert", "AuthService"];
    function NavbarController(ThemeService, ShiftService, NewsService, $scope, $interval, SweetAlert, AuthService) {
        'ngInject';
        var _this = this;
        this.ThemeService = ThemeService;
        this.ShiftService = ShiftService;
        this.NewsService = NewsService;
        this.$scope = $scope;
        this.$interval = $interval;
        this.SweetAlert = SweetAlert;
        this.AuthService = AuthService;
        this.isBackoffice = false;
        this.isCustomer = false;
        this.isEmployee = false;
        this.$onInit = function () {
            _this.logo = _this.ThemeService.getLogoDark();
            _this.isBackoffice = _this.AuthService.hasRole('backoffice');
            _this.isCustomer = _this.AuthService.hasRole('customer');
            _this.isEmployee = _this.AuthService.hasRole('employee');
            _this.unreadCnt = 0;
            _this.getNewsCount();
            var theInterval = _this.$interval(function () {
                this.getNewsCount();
            }.bind(_this), 60000);
        };
        this.toggleSidebar = function () {
            angular.element('.app').toggleClass('offscreen move-left');
        };
        this.toggleSlider = function () {
            angular.element('.app').toggleClass('layout-chat-open');
            if (angular.element('.app').hasClass('layout-chat-open')) {
                _this.ShiftService.customAll('getAdHoc').then(function (result) {
                    _this.shifts = result;
                });
            }
            // this.$scope.$emit('getAdHocShiftsUp', null);
        };
        this.toggleNewsSlider = function () {
            angular.element('.app').toggleClass('layout-news-open');
            if (angular.element('.app').hasClass('layout-news-open')) {
                _this.NewsService.all().then(function (result) {
                    _this.news = result;
                });
            }
        };
    }
    NavbarController.prototype.openResetPasswordModal = function () {
        $('#ResetPasswordModal').modal('show');
    };
    NavbarController.prototype.showAvailModal = function () {
        this.currentShift = new shifts_service_1.IShift();
        this.currentShift.start = this.roundMinutes(new Date());
        this.currentShift.end = moment(this.currentShift.start).add(8, 'hour').toDate();
        $('#check-availability-modal').modal('show');
    };
    NavbarController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    NavbarController.prototype.getNewsCount = function () {
        var _this = this;
        if (this.isEmployee || this.isCustomer) {
            this.NewsService.getUnread().then(function (result) {
                var newitems = _this.unreadCnt < result.size;
                _this.unreadCnt = result.size;
                if (_this.unreadCnt > 0) {
                    if (_this.unreadCnt == 1) {
                        var text = "Er staat " + _this.unreadCnt + " nieuw bericht voor je klaar.";
                    }
                    else {
                        var text = "Er staan " + _this.unreadCnt + " nieuwe berichten voor je klaar.";
                    }
                    if (newitems) {
                        _this.SweetAlert.swal({
                            title: 'Er zijn nieuwe nieuwsberichten',
                            text: text,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Nu lezen',
                            cancelButtonText: 'Ik lees ze later',
                        }, function (isConfirm) {
                            if (isConfirm) {
                                _this.readLater = true;
                                _this.toggleNewsSlider();
                            }
                            else {
                                _this.readLater = true;
                            }
                        });
                    }
                }
            });
        }
    };
    return NavbarController;
}());
;
exports.operandoNavbar = {
    bindings: {
        userName: '<',
        shifts: '=',
        news: '=',
        currentShift: '='
    },
    controller: NavbarController,
    template: __webpack_require__(391)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NewsPanelController = /** @class */ (function () {
    NewsPanelController.$inject = ["NewsService", "$state", "$scope"];
    function NewsPanelController(NewsService, $state, $scope) {
        'ngInject';
        this.NewsService = NewsService;
        this.$state = $state;
        this.$scope = $scope;
        this.$onInit = function () {
        };
    }
    NewsPanelController.prototype.setRead = function (id) {
        var _this = this;
        this.NewsService.customPut(id + '/read', {}).then(function (result) {
            _this.NewsService.getList().then(function (result) {
                _this.news = result.value;
            });
        });
    };
    return NewsPanelController;
}());
exports.newsPanelComponent = {
    bindings: {
        news: '<'
    },
    controller: NewsPanelController,
    template: __webpack_require__(392)
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, $) {
Object.defineProperty(exports, "__esModule", { value: true });
var AccountBasicInfoController = /** @class */ (function () {
    AccountBasicInfoController.$inject = ["$state", "EnumService", "SalaryScaleGroupService", "$timeout"];
    function AccountBasicInfoController($state, EnumService, SalaryScaleGroupService, $timeout) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.EnumService = EnumService;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.$timeout = $timeout;
        this.$onInit = function () {
            _this.salaryScaleGroups = [];
            _this.SalaryScaleGroupService.all().then(function (result) {
                _this.salaryScaleGroups = result || [];
                // Als account een salaryScaleGroup object heeft, maar het is niet hetzelfde referentie object
                // Zoek het juiste object op basis van ID en gebruik die referentie (belangrijk voor ng-options)
                if (_this.account && _this.account.salaryScaleGroup && _this.account.salaryScaleGroup.id) {
                    var foundGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.account.salaryScaleGroup.id; });
                    if (foundGroup) {
                        // Gebruik het object uit de array zodat de referentie overeenkomt met ng-options
                        _this.account.salaryScaleGroup = foundGroup;
                    }
                }
                else if (_this.account && _this.account.salaryScaleGroupId && !_this.account.salaryScaleGroup) {
                    // Als account alleen een salaryScaleGroupId heeft maar geen object, zoek het object op
                    var foundGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.account.salaryScaleGroupId; });
                    if (foundGroup) {
                        _this.account.salaryScaleGroup = foundGroup;
                    }
                }
                // Trigger chosen update after data is loaded
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('.chosen').trigger('chosen:updated');
                    }
                }, 200);
            }).catch(function (error) {
                console.error('Error loading salary scale groups:', error);
                _this.salaryScaleGroups = [];
            });
        };
        // console.log('AccountBasicInfoController');
    }
    AccountBasicInfoController.prototype.submitAccountBasicInfo = function () {
        // console.log('update AccountBasicInfo');
        // Zorg dat salaryScaleGroupId wordt gezet op basis van het geselecteerde object
        if (this.account.salaryScaleGroup && this.account.salaryScaleGroup.id) {
            this.account.salaryScaleGroupId = this.account.salaryScaleGroup.id;
        }
        else {
            this.account.salaryScaleGroupId = null;
            this.account.salaryScaleGroup = null;
        }
        this.onUpdate({ account: this.account });
        $('#accountBasicInfoModal').modal('hide');
    };
    return AccountBasicInfoController;
}());
exports.accountBasicInfoComponent = {
    bindings: {
        type: '<',
        account: '<',
        onUpdate: "&"
    },
    controller: AccountBasicInfoController,
    template: __webpack_require__(393)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccountsController = /** @class */ (function () {
    function AccountsController() {
        'ngInject';
        // console.log('AccountsController');
    }
    return AccountsController;
}());
exports.accountsComponent = {
    controller: AccountsController,
    template: __webpack_require__(394)
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(7);
var AccountsItemController = /** @class */ (function () {
    AccountsItemController.$inject = ["AccountsService", "NotesService", "TeamService", "$state", "$stateParams", "MasterdataAService", "SweetAlert", "$filter"];
    function AccountsItemController(AccountsService, NotesService, TeamService, $state, $stateParams, MasterdataAService, SweetAlert, $filter) {
        'ngInject';
        var _this = this;
        this.AccountsService = AccountsService;
        this.NotesService = NotesService;
        this.TeamService = TeamService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.MasterdataAService = MasterdataAService;
        this.SweetAlert = SweetAlert;
        this.$filter = $filter;
        this.$onInit = function () {
            _this.activeTabIndex = 0;
            if (_this.$stateParams['tab']) {
                _this.activeTabIndex = _this.$stateParams['tab'];
            }
            if (!_this.account) {
                _this.account = new services_1.IAccount();
                _this.isNew = true;
                $('#accountBasicInfoModal').modal('show');
            }
            else {
            }
            _this.locations.forEach(function (location) {
                _this.TeamService.customAll('location/' + location.id).then(function (result) {
                    location.teams = result;
                    // console.log(result);
                });
            });
            _this.reminderIntervals = _this.reminderIntervals.reminderIntervals;
            _this.reminderIntervals.forEach(function (item, index) {
                item.index = index;
            });
            _this.MasterdataAService.getItems('NoteTags').then(function (res) {
                _this.tags = res;
            });
            _this.filterNotes();
        };
        this.openProject = function (item, action) {
            _this.$state.go('project.item', { 'id': item.id });
        };
        // console.log('AccountsItemController');
        this.accountsService = AccountsService;
        this.notesService = NotesService;
        this.sweetAlert = SweetAlert;
    }
    AccountsItemController.prototype.filterNotes = function () {
        var _this = this;
        this.filteredNotes = this.$filter('filter')(this.notes, function (note) {
            if (!!_this.selectedTag) {
                return note.tags.indexOf(_this.selectedTag) !== -1;
            }
            else {
                return true;
            }
        });
    };
    AccountsItemController.prototype.submitAccount = function () {
        // console.log('update account');
        if (this.account.id == null) {
            if (this.account.name == null) {
                this.sweetAlert.swal('Please fill in the account name and save in order to create the account.');
            }
            else {
                this.saveAccount();
            }
        }
        else {
            this.accountsService.put(this.account.id, this.account);
        }
    };
    AccountsItemController.prototype.saveAccount = function () {
        var _this = this;
        this.accountsService.post(this.account).then(function (result) {
            _this.$state.go('crm.accounts.item', { 'id': result.id });
        });
    };
    AccountsItemController.prototype.deleteAccount = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + this.account.name + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.accountsService.delete(_this.account.id).then(function () {
                    _this.$state.go('^.list').then(function () { _this.$state.reload(); });
                });
            }
            else {
            }
        });
    };
    AccountsItemController.prototype.editAccountBasicInfoModal = function () {
        $('#accountBasicInfoModal').modal('show');
    };
    AccountsItemController.prototype.editContactInfoModal = function () {
        $('#contactInfoModal').modal('show');
    };
    AccountsItemController.prototype.editFinancialInfoModal = function () {
        this.account.deliveryDay = new Date(Date.parse(this.account.deliveryDay));
        $('#financialInfoModal').modal('show');
    };
    AccountsItemController.prototype.updateNote = function (item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    };
    AccountsItemController.prototype.addNoteModal = function () {
        this.currentNote = null;
        $('#noteModal').modal('show');
    };
    AccountsItemController.prototype.updateNoteModal = function (item) {
        this.currentNote = item;
        $('#noteModal').modal('show');
    };
    AccountsItemController.prototype.submitNote = function (item) {
        var _this = this;
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.accountId = this.account.id;
        if (newNote.id == null) {
            this.notesService.post(newNote).then(function (result) {
                _this.notes.push(result);
            });
        }
        else {
            this.notesService.put(newNote.id, newNote);
        }
        $('#noteModal').modal('hide');
    };
    AccountsItemController.prototype.deleteNote = function (item) {
        this.notes = this.notes.filter(function (note) { return note.id !== item.id; });
        this.notesService.delete(item.id);
    };
    AccountsItemController.prototype.goBack = function () {
        window.history.go(-1);
    };
    AccountsItemController.prototype.submitReminderInterval = function (reminderInterval) {
        var _this = this;
        var itemToEdit = this.reminderIntervals.find(function (i) { return i.index === reminderInterval.index; });
        if (!!itemToEdit) {
            itemToEdit = reminderInterval;
        }
        else {
            reminderInterval.index = this.reminderIntervals.length;
            this.reminderIntervals.push(reminderInterval);
        }
        this.accountsService.customPut(this.account.id + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(function (result) {
            _this.currentReminderInterval = null;
        });
    };
    AccountsItemController.prototype.deleteReminderInterval = function (reminderInterval) {
        this.reminderIntervals = this.reminderIntervals.filter(function (i) { return i.index !== reminderInterval.index; });
        this.accountsService.customPut(this.account.id + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(function (result) {
        });
    };
    return AccountsItemController;
}());
exports.accountsItemComponent = {
    bindings: {
        account: '<',
        contacts: '<',
        notes: '<',
        locations: '<',
        agreements: '<',
        accountEmployees: '<',
        reminderIntervals: '<'
    },
    controller: AccountsItemController,
    template: __webpack_require__(395)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccountsListController = /** @class */ (function () {
    function AccountsListController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.sortType = 'name';
            _this.menu = 'list';
        };
        // console.log('AccountsListController');
    }
    return AccountsListController;
}());
exports.accountsListComponent = {
    bindings: {
        accounts: '<'
    },
    controller: AccountsListController,
    template: __webpack_require__(396)
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ContactInfoController = /** @class */ (function () {
    ContactInfoController.$inject = ["$state"];
    function ContactInfoController($state) {
        'ngInject';
        this.$state = $state;
        // console.log('ContactInfoController');
    }
    ContactInfoController.prototype.submitContactInfo = function () {
        // console.log('update ContactInfo');
        this.onUpdate({ account: this.account });
        $('#contactInfoModal').modal('hide');
    };
    return ContactInfoController;
}());
exports.contactInfoComponent = {
    bindings: {
        account: '<',
        onUpdate: "&"
    },
    controller: ContactInfoController,
    template: __webpack_require__(397)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var FinancialInfoController = /** @class */ (function () {
    FinancialInfoController.$inject = ["$state"];
    function FinancialInfoController($state) {
        'ngInject';
        this.$state = $state;
        // console.log('FinancialInfoController');
    }
    FinancialInfoController.prototype.submitFinancialInfo = function () {
        // console.log('update FinancialInfo');
        this.onUpdate({ account: this.account });
        $('#financialInfoModal').modal('hide');
    };
    return FinancialInfoController;
}());
exports.financialInfoComponent = {
    bindings: {
        account: '<',
        onUpdate: "&"
    },
    controller: FinancialInfoController,
    template: __webpack_require__(398)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReminderIntervalController = /** @class */ (function () {
    ReminderIntervalController.$inject = ["$state", "$stateParams", "AccountsService"];
    function ReminderIntervalController($state, $stateParams, AccountsService) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AccountsService = AccountsService;
        this.$onInit = function () {
            _this.reminderIntervals = _this.resolve.reminderIntervals.reminderIntervals;
            if (_this.$stateParams['index']) {
                _this.reminderInterval = _this.reminderIntervals.find(function (s) { return s.index == _this.$stateParams['index']; });
            }
            else {
                _this.reminderInterval = {};
            }
        };
        // console.log('ReminderIntervalController');
    }
    ReminderIntervalController.prototype.submit = function () {
        var _this = this;
        if (!this.reminderInterval.index) {
            this.reminderInterval.index = this.reminderIntervals.length;
            this.reminderIntervals.push(this.reminderInterval);
        }
        this.AccountsService.customPut(this.$stateParams['id'] + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(function (result) {
            _this.closeModal();
        });
    };
    ReminderIntervalController.prototype.delete = function () {
        var _this = this;
        this.reminderIntervals = this.reminderIntervals.filter(function (i) { return i.index !== _this.reminderInterval.index; });
        this.AccountsService.customPut(this.$stateParams['id'] + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(function (result) {
            _this.closeModal();
        });
    };
    ReminderIntervalController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 6 }, { reload: true });
    };
    return ReminderIntervalController;
}());
exports.reminderIntervalComponent = {
    bindings: {
        resolve: '<'
    },
    controller: ReminderIntervalController,
    template: __webpack_require__(399)
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var _ = __webpack_require__(6);
var moment = __webpack_require__(0);
var AgreementsItemController = /** @class */ (function () {
    AgreementsItemController.$inject = ["AgreementService", "$state", "$stateParams"];
    function AgreementsItemController(AgreementService, $state, $stateParams) {
        'ngInject';
        var _this = this;
        this.AgreementService = AgreementService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.account = _this.resolve.account;
            _this.employees = _this.resolve.employees;
            _this.salaryScales = _this.resolve.salaryScales;
            _this.perCompany = true;
            var agreementId = _this.$stateParams['agreementId'];
            if (agreementId) {
                _this.agreement = _.find(_this.resolve.agreements, { "id": agreementId });
            }
            else {
                _this.agreement = new index_1.IAgreement();
            }
            if (_this.agreement.employeeId) {
                _this.byEmployee = true;
                _this.perCompany = false;
            }
            if (_this.agreement.salaryScaleId) {
                _this.bySalaryScale = true;
                _this.perCompany = false;
            }
            if (_this.agreement.ort) {
                _this.perCompany = false;
            }
        };
        this.handleCheckboxChange = function (selected) {
            switch (selected) {
                case 'perCompany':
                    this.byEmployee = false;
                    this.bySalaryScale = false;
                    this.agreement.ort = false;
                    break;
                case 'byEmployee':
                    this.bySalaryScale = false;
                    this.agreement.ort = false;
                    this.perCompany = false;
                    break;
                case 'bySalaryScale':
                    this.byEmployee = false;
                    this.agreement.ort = false;
                    this.perCompany = false;
                    break;
                case 'ort':
                    this.byEmployee = false;
                    this.bySalaryScale = false;
                    this.perCompany = false;
                    break;
            }
        };
    }
    AgreementsItemController.prototype.startDateBeforeRender = function ($dates) {
        // console.log('startDateBeforeRender');
        var todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    };
    AgreementsItemController.prototype.endDateBeforeRender = function ($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.agreement.dateTimeFrom) {
            var activeDate = moment(this.agreement.dateTimeFrom).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    AgreementsItemController.prototype.submitAgreement = function () {
        var _this = this;
        this.agreement.dateTimeFrom = moment(this.agreement.dateTimeFrom).format("YYYY-MM-DD HH:mm");
        this.agreement.dateTimeTo = moment(this.agreement.dateTimeTo).format("YYYY-MM-DD HH:mm");
        if (this.byEmployee) {
            this.agreement.salaryScaleId = null;
            this.agreement.calculationIndex = null;
        }
        else if (this.bySalaryScale) {
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
            this.agreement.fee = null;
        }
        else if (this.agreement.ort) {
            this.agreement.salaryScaleId = null;
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
            this.agreement.fee = null;
        }
        else {
            this.agreement.salaryScaleId = null;
            this.agreement.employeeId = null;
            this.agreement.grossHourlyWageValue = null;
        }
        if (this.agreement.id === undefined) {
            this.agreement.accountId = this.account.id;
            this.AgreementService.post(this.agreement).then(function (data) {
                _this.closeModal();
            });
        }
        else {
            this.AgreementService.put(this.agreement.id, this.agreement).then(function (data) {
                _this.closeModal();
            });
        }
    };
    AgreementsItemController.prototype.delete = function () {
        var _this = this;
        this.AgreementService.delete(this.agreement.id).then(function (data) {
            _this.closeModal();
        });
    };
    AgreementsItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 4 }, { reload: true });
    };
    return AgreementsItemController;
}());
exports.agreementsItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: AgreementsItemController,
    template: __webpack_require__(400)
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AgreementsListController = /** @class */ (function () {
    function AgreementsListController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.currentPage = 1;
            _this.itemsPerPage = 12;
        };
        this.$onChanges = function () {
        };
    }
    AgreementsListController.prototype.parseDate = function (item) {
        var date = new Date(item.start);
        return date;
    };
    return AgreementsListController;
}());
exports.agreementsListComponent = {
    bindings: {
        agreements: "<"
    },
    controller: AgreementsListController,
    template: __webpack_require__(401)
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ContactBasicInfoController = /** @class */ (function () {
    ContactBasicInfoController.$inject = ["$state", "AccountsService", "LocationService", "MasterdataAService", "EnumService"];
    function ContactBasicInfoController($state, AccountsService, LocationService, MasterdataAService, EnumService) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.AccountsService = AccountsService;
        this.LocationService = LocationService;
        this.MasterdataAService = MasterdataAService;
        this.EnumService = EnumService;
        this.$onInit = function () {
            _this.AccountsService.all().then(function (accounts) {
                _this.accounts = accounts;
            });
            if (_this.contact.accountId) {
                _this.getLocations();
            }
            _this.getMasterdata();
        };
        // console.log('ContactBasicInfoController');
    }
    ContactBasicInfoController.prototype.submitContactBasicInfo = function () {
        // console.log('update ContactBasicInfo');
        this.onUpdate({ contact: this.contact });
        $('#contactBasicInfoModal').modal('hide');
    };
    ContactBasicInfoController.prototype.accountSelected = function () {
        this.getLocations();
    };
    ContactBasicInfoController.prototype.getLocations = function () {
        var _this = this;
        this.AccountsService.getChild(this.contact.accountId, 'locations').then(function (result) {
            _this.locations = result;
        });
    };
    ContactBasicInfoController.prototype.getMasterdata = function () {
        var _this = this;
        this.MasterdataAService.getItems('ContactTags').then(function (res) {
            _this.contactTags = res;
        });
    };
    return ContactBasicInfoController;
}());
exports.contactBasicInfoComponent = {
    bindings: {
        contact: '<',
        onUpdate: "&"
    },
    controller: ContactBasicInfoController,
    template: __webpack_require__(402)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var ContactSocialController = /** @class */ (function () {
    ContactSocialController.$inject = ["$state"];
    function ContactSocialController($state) {
        'ngInject';
        this.$state = $state;
        // console.log('ContactBasicInfoController');
    }
    ContactSocialController.prototype.submitSocialForm = function () {
        // console.log('update ContactBasicInfo');
        this.onUpdate({ contact: this.contact });
        $('#contactSocialModal').modal('hide');
    };
    return ContactSocialController;
}());
exports.contactSocialComponent = {
    bindings: {
        contact: '<',
        onUpdate: "&"
    },
    controller: ContactSocialController,
    template: __webpack_require__(403)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactsController = /** @class */ (function () {
    function ContactsController() {
        'ngInject';
        // console.log('ContactsController');
    }
    return ContactsController;
}());
exports.contactsComponent = {
    controller: ContactsController,
    template: __webpack_require__(404)
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var services_1 = __webpack_require__(7);
var ContactsItemController = /** @class */ (function () {
    ContactsItemController.$inject = ["ContactsService", "NotesService", "AccountsService", "$state", "SweetAlert", "$stateParams"];
    function ContactsItemController(ContactsService, NotesService, AccountsService, $state, SweetAlert, $stateParams) {
        'ngInject';
        var _this = this;
        this.ContactsService = ContactsService;
        this.NotesService = NotesService;
        this.AccountsService = AccountsService;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            if (_this.contact == null) {
                _this.contact = new services_1.IContact();
                _this.isNew = true;
                $('#contactBasicInfoModal').modal('show');
                if (_this.accountId) {
                    _this.contact.accountId = _this.accountId;
                    _this.AccountsService.get(_this.contact.accountId).then(function (account) {
                        _this.account = account;
                    });
                }
            }
            else {
                _this.setFullName();
                // console.log(this.fullName);
                if (_this.contact.accountId) {
                    _this.AccountsService.get(_this.contact.accountId).then(function (account) {
                        _this.account = account;
                    });
                }
            }
        };
        this.setFullName = function () {
            _this.fullName = [_this.contact.firstName, _this.contact.middleName, _this.contact.lastName].join(' ');
        };
        // console.log('ContactsItemController');
        this.contactsService = ContactsService;
        this.notesService = NotesService;
        this.accountId = $stateParams['accountId'];
        angular.element(document).ready(function () {
            $('#notes-table').dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }
    ContactsItemController.prototype.submitContact = function () {
        var _this = this;
        if (this.contact.id == null) {
            this.saveContact();
        }
        else {
            this.contactsService.put(this.contact.id, this.contact).then(function (data) {
                _this.contact = data;
                _this.setFullName();
            });
        }
    };
    ContactsItemController.prototype.saveContact = function () {
        var _this = this;
        if (this.accountId) {
            this.contact.accountId = this.accountId;
        }
        this.contactsService.post(this.contact).then(function (result) {
            _this.$state.go('crm.contacts.item', { 'id': result.id }, { location: "replace" });
        });
    };
    ContactsItemController.prototype.deleteContact = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + this.fullName + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.contactsService.delete(_this.contact.id).then(function () {
                    _this.goBack();
                });
            }
            else {
            }
        });
    };
    ContactsItemController.prototype.editContactBasicInfoModal = function () {
        $('#contactBasicInfoModal').modal('show');
    };
    ContactsItemController.prototype.editContactSocialModal = function () {
        $('#contactSocialModal').modal('show');
    };
    ContactsItemController.prototype.updateNote = function (item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    };
    ContactsItemController.prototype.addNoteModal = function () {
        this.currentNote = null;
        $('#noteModal').modal('show');
    };
    ContactsItemController.prototype.updateNoteModal = function (item) {
        this.currentNote = item;
        $('#noteModal').modal('show');
    };
    ContactsItemController.prototype.submitNote = function (item) {
        var _this = this;
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.contactId = this.contact.id;
        if (newNote.id == null) {
            this.notesService.post(newNote).then(function (result) {
                _this.notes.push(result);
            });
        }
        else {
            this.notesService.put(newNote.id, newNote);
        }
        $('#noteModal').modal('hide');
    };
    ContactsItemController.prototype.deleteNote = function (item) {
        this.notes = this.notes.filter(function (note) { return note.id !== item.id; });
        this.notesService.delete(item.id);
    };
    ContactsItemController.prototype.goBack = function () {
        window.history.go(-1);
    };
    return ContactsItemController;
}());
exports.contactsItemComponent = {
    bindings: {
        contact: '<',
        notes: '<',
    },
    controller: ContactsItemController,
    template: __webpack_require__(405)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactsListController = /** @class */ (function () {
    ContactsListController.$inject = ["ContactsService", "MasterdataAService", "EnumService", "$stateParams"];
    function ContactsListController(ContactsService, MasterdataAService, EnumService, $stateParams) {
        'ngInject';
        var _this = this;
        this.ContactsService = ContactsService;
        this.MasterdataAService = MasterdataAService;
        this.EnumService = EnumService;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.getMasterdata();
        };
        // console.log('ContactsListController');
        this.contactsService = ContactsService;
    }
    ContactsListController.prototype.getMasterdata = function () {
        var _this = this;
        this.MasterdataAService.getItems('ContactTags').then(function (res) {
            _this.contactTags = res;
        });
    };
    ContactsListController.prototype.emailToClipboard = function () {
        var _this = this;
        var emailsList = [];
        this.contacts.forEach(function (e) {
            if (e.emailAddress &&
                ((_this.search && e.name.toUpperCase().indexOf(_this.search.toUpperCase()) !== -1) || !_this.search) &&
                ((_this.tag && e.tags.indexOf(_this.tag) !== -1) || !_this.tag) &&
                ((_this.company && e.accountName.toUpperCase().indexOf(_this.company.toUpperCase()) !== -1) || !_this.company)) {
                emailsList.push(e.emailAddress);
            }
        });
        // console.log(emailsList.join(';'));
        window.prompt("Ctrl+C to copy to clipboard, then paste in the BCC field of an email:", emailsList.join(';'));
    };
    ContactsListController.prototype.resetFilter = function () {
        this.company = '';
        this.search = '';
        this.tag = '';
    };
    return ContactsListController;
}());
exports.contactsListComponent = {
    bindings: {
        contacts: '<',
        accounts: '<'
    },
    controller: ContactsListController,
    template: __webpack_require__(406)
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CrmController = /** @class */ (function () {
    function CrmController() {
        'ngInject';
        // console.log('CrmController');
    }
    return CrmController;
}());
exports.crmComponent = {
    controller: CrmController,
    template: __webpack_require__(408)
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var CrmDashboardController = /** @class */ (function () {
    CrmDashboardController.$inject = ["NotesService", "$state"];
    function CrmDashboardController(NotesService, $state) {
        'ngInject';
        this.$state = $state;
        // console.log('AccountsItemController');
        this.notesService = NotesService;
        this.sortType = 'name';
        this.sortTypeContacts = 'lastName';
    }
    CrmDashboardController.prototype.updateNote = function (item, action) {
        switch (action) {
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    };
    CrmDashboardController.prototype.updateNoteModal = function (item) {
        this.currentNote = item;
        $('#noteModal').modal('show');
    };
    CrmDashboardController.prototype.submitNote = function (item) {
        var _this = this;
        var newNote = item;
        newNote.date = new Date(Date.now());
        if (newNote.id == null) {
            this.notesService.post(newNote).then(function (result) {
                _this.notes.push(result);
            });
        }
        else {
            this.notesService.put(newNote.id, newNote);
        }
        $('#noteModal').modal('hide');
    };
    CrmDashboardController.prototype.deleteNote = function (item) {
        this.notes = this.notes.filter(function (note) { return note.id !== item.id; });
        this.notesService.delete(item.id);
    };
    return CrmDashboardController;
}());
exports.crmDashboardComponent = {
    bindings: {
        accounts: '<',
        contacts: '<',
        summary: '<',
        notes: '<'
    },
    controller: CrmDashboardController,
    template: __webpack_require__(407)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.crmState = {
    parent: "app",
    name: "crm",
    url: "/crm",
    redirectTo: "crm.dashboard",
    component: "crmComponent",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.crmDashboardState = {
    name: "crm.dashboard",
    url: "/dashboard",
    resolve: {
        accounts: ["AccountsService", function (AccountsService) {
            'ngInject';
            return AccountsService.all();
        }],
        contacts: ["ContactsService", function (ContactsService) {
            'ngInject';
            return ContactsService.all();
        }],
        summary: ["DashboardService", function (DashboardService) {
            'ngInject';
            return DashboardService.one();
        }],
        notes: ["NotesService", function (NotesService) {
            'ngInject';
            return NotesService.all({ sortfield: 'date' });
        }],
    },
    views: {
        "main": 'crmDashboardComponent'
    }
};
exports.accountsState = {
    name: "crm.accounts",
    url: "/accounts",
    redirectTo: "crm.accounts.list",
    views: {
        "main": "accountsComponent"
    }
};
exports.accountsListState = {
    name: "crm.accounts.list",
    url: "/list",
    resolve: {
        accounts: ["AccountsService", function (AccountsService) {
            'ngInject';
            return AccountsService.all();
        }],
    },
    views: {
        "main": 'accountsListComponent'
    }
};
exports.accountsItemState = {
    name: "crm.accounts.item",
    url: "/:id",
    params: {
        "tab": null
    },
    resolve: {
        account: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.get($stateParams['id']);
            }
        }],
        contacts: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.getChild($stateParams['id'], 'contacts');
            }
        }],
        notes: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.getChild($stateParams['id'], 'notes');
            }
        }],
        locations: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.getChild($stateParams['id'], 'locations');
            }
        }],
        agreements: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.customGet($stateParams['id'] + '/agreements');
            }
        }],
        accountEmployees: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.customGet($stateParams['id'] + '/employees');
            }
        }],
        reminderIntervals: ["AccountsService", "$stateParams", function (AccountsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return AccountsService.customGet($stateParams['id'] + '/nomatchfoundemailsettings');
            }
        }],
    },
    views: {
        "main": 'accountsItemComponent'
    }
};
exports.locationsItemState = {
    name: "crm.accounts.item.location",
    url: "/location/:locationId",
    params: {
        "locationId": null
    },
    modal: ['account', 'locations'],
    resolve: {},
    component: 'locationsItemComponent'
};
exports.teamsItemState = {
    name: "crm.accounts.item.team",
    url: "/team/:locationId/:teamId",
    params: {
        "locationId": null,
        "teamId": null
    },
    modal: ['locations', 'contacts'],
    resolve: {},
    component: 'teamsItemComponent'
};
exports.agreementsItemState = {
    name: "crm.accounts.item.agreement",
    url: "/agreement/:agreementId",
    params: {
        "agreementId": null
    },
    modal: ['account', 'agreements'],
    resolve: {
        employees: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.getEmployeesByStatus();
        }],
        salaryScales: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('WageCodes');
        }]
    },
    component: 'agreementsItemComponent'
};
exports.accountEmployeesItemState = {
    name: "crm.accounts.item.employee",
    url: "/employee/:accountEmployeeId",
    params: {
        "accountEmployeeId": null
    },
    modal: ['account', 'accountEmployees'],
    resolve: {
        employees: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.getEmployeesByStatus();
        }]
    },
    component: 'accountEmployeesItemComponent'
};
exports.contactsState = {
    name: "crm.contacts",
    url: "/contacts",
    redirectTo: "crm.contacts.list",
    views: {
        "main": "contactsComponent"
    }
};
exports.contactsListState = {
    name: "crm.contacts.list",
    url: "/list",
    params: {
        accountId: null,
    },
    resolve: {
        accounts: ["AccountsService", function (AccountsService) {
            'ngInject';
            return AccountsService.all();
        }],
        contacts: ["ContactsService", function (ContactsService) {
            'ngInject';
            return ContactsService.all();
        }],
    },
    views: {
        "main": 'contactsListComponent'
    }
};
exports.contactsItemState = {
    name: "crm.contacts.item",
    url: "/:id",
    params: {
        accountId: null,
    },
    resolve: {
        contact: ["ContactsService", "$stateParams", function (ContactsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ContactsService.get($stateParams['id']);
            }
        }],
        notes: ["ContactsService", "$stateParams", function (ContactsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return ContactsService.getChild($stateParams['id'], 'notes');
            }
        }],
    },
    views: {
        "main": 'contactsItemComponent'
    }
};
exports.leadsState = {
    name: "crm.leads",
    url: "/leads",
    redirectTo: "crm.leads.list",
    views: {
        "main": "leadsComponent"
    }
};
exports.leadsListState = {
    name: "crm.leads.list",
    url: "/list",
    resolve: {
        leads: ["LeadsService", function (LeadsService) {
            'ngInject';
            return LeadsService.all();
        }]
    },
    views: {
        "main": 'leadsListComponent'
    }
};
exports.leadsItemState = {
    name: "crm.leads.item",
    url: "/:id",
    resolve: {
        lead: ["LeadsService", "$stateParams", function (LeadsService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return LeadsService.get($stateParams['id']);
            }
        }]
    },
    views: {
        "main": 'leadsItemComponent'
    }
};
exports.reminderItemState = {
    name: "crm.accounts.item.reminder",
    url: "/reminder/:index",
    params: {
        "index": null
    },
    modal: ['reminderIntervals'],
    resolve: {},
    component: 'reminderIntervalComponent'
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(6);
var moment = __webpack_require__(0);
var AccountEmployeesItemController = /** @class */ (function () {
    AccountEmployeesItemController.$inject = ["$state", "$stateParams", "AccountEmployeeService"];
    function AccountEmployeesItemController($state, $stateParams, AccountEmployeeService) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AccountEmployeeService = AccountEmployeeService;
        this.$onInit = function () {
            _this.account = _this.resolve.account;
            _this.employees = _this.resolve.employees;
            _this.accountEmployees = _this.resolve.accountEmployees;
            var accountEmployeeId = _this.$stateParams['accountEmployeeId'];
            if (accountEmployeeId) {
                _this.accountEmployee = _.find(_this.resolve.accountEmployees, { "id": accountEmployeeId });
            }
            else {
                _this.accountEmployee = {};
                // console.log('new accountEmployee');
            }
        };
    }
    AccountEmployeesItemController.prototype.endDateBeforeRender = function ($dates) {
        // console.log('endDateBeforeRender');
        var todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
        // console.log($dates);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    };
    AccountEmployeesItemController.prototype.submitAccountEmployee = function () {
        var _this = this;
        this.accountEmployee.dateTimeTo = moment(this.accountEmployee.dateTimeTo).format("YYYY-MM-DD HH:mm");
        if (this.accountEmployee.id === undefined) {
            this.accountEmployee.accountId = this.account.id;
            this.AccountEmployeeService.post(this.accountEmployee).then(function (data) {
                _this.closeModal();
            });
        }
        else {
            this.AccountEmployeeService.put(this.accountEmployee.id, this.accountEmployee).then(function (data) {
                _this.closeModal();
            });
        }
    };
    AccountEmployeesItemController.prototype.delete = function () {
        var _this = this;
        this.AccountEmployeeService.delete(this.accountEmployee.id).then(function (data) {
            _this.closeModal();
        });
    };
    AccountEmployeesItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 5 }, { reload: true });
    };
    return AccountEmployeesItemController;
}());
exports.accountEmployeesItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: AccountEmployeesItemController,
    template: __webpack_require__(409)
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AccountEmployeesListController = /** @class */ (function () {
    function AccountEmployeesListController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.currentPage = 1;
            _this.itemsPerPage = 12;
        };
    }
    AccountEmployeesListController.prototype.parseDate = function (item) {
        var date = new Date(item.start);
        return date;
    };
    return AccountEmployeesListController;
}());
exports.accountEmployeesListComponent = {
    bindings: {
        accountEmployees: "<"
    },
    controller: AccountEmployeesListController,
    template: __webpack_require__(410)
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var agreements_item_component_1 = __webpack_require__(570);
var agreements_list_component_1 = __webpack_require__(571);
var agreements_service_1 = __webpack_require__(262);
var team_service_1 = __webpack_require__(269);
var services_1 = __webpack_require__(7);
var contactSocialModal_component_1 = __webpack_require__(573);
var leadsInfoModal_component_1 = __webpack_require__(586);
var contactBasicInfoModal_component_1 = __webpack_require__(572);
var financialInfoModal_component_1 = __webpack_require__(568);
var contactInfoModal_component_1 = __webpack_require__(567);
var accountBasicInfoModal_component_1 = __webpack_require__(563);
var note_component_1 = __webpack_require__(589);
var leads_item_component_1 = __webpack_require__(584);
var leads_list_component_1 = __webpack_require__(585);
var leads_component_1 = __webpack_require__(583);
var crm_dashboard_component_1 = __webpack_require__(578);
var contacts_item_component_1 = __webpack_require__(575);
var contacts_list_component_1 = __webpack_require__(576);
var contacts_component_1 = __webpack_require__(574);
var accounts_item_component_1 = __webpack_require__(565);
var accounts_list_component_1 = __webpack_require__(566);
var accounts_component_1 = __webpack_require__(564);
var crm_component_1 = __webpack_require__(577);
var crm_states_1 = __webpack_require__(579);
var ngmodule_1 = __webpack_require__(4);
var list_component_1 = __webpack_require__(674);
var locations_list_component_1 = __webpack_require__(588);
var locations_item_component_1 = __webpack_require__(587);
var teams_list_component_1 = __webpack_require__(591);
var teams_item_component_1 = __webpack_require__(590);
var user_account_component_1 = __webpack_require__(676);
var employees_list_component_1 = __webpack_require__(581);
var employees_item_component_1 = __webpack_require__(580);
var accountEmployee_service_1 = __webpack_require__(715);
var reminderIntervalModal_component_1 = __webpack_require__(569);
var crmAppModule = {
    components: {
        crmComponent: crm_component_1.crmComponent, crmDashboardComponent: crm_dashboard_component_1.crmDashboardComponent,
        accountsComponent: accounts_component_1.accountsComponent, accountsListComponent: accounts_list_component_1.accountsListComponent, accountsItemComponent: accounts_item_component_1.accountsItemComponent,
        accountBasicInfoComponent: accountBasicInfoModal_component_1.accountBasicInfoComponent, contactInfoComponent: contactInfoModal_component_1.contactInfoComponent, financialInfoComponent: financialInfoModal_component_1.financialInfoComponent,
        contactsComponent: contacts_component_1.contactsComponent, contactsListComponent: contacts_list_component_1.contactsListComponent, contactsItemComponent: contacts_item_component_1.contactsItemComponent,
        contactBasicInfoComponent: contactBasicInfoModal_component_1.contactBasicInfoComponent,
        leadsComponent: leads_component_1.leadsComponent, leadsListComponent: leads_list_component_1.leadsListComponent, leadsItemComponent: leads_item_component_1.leadsItemComponent,
        crmNoteComponent: note_component_1.crmNoteComponent, leadsInfoComponent: leadsInfoModal_component_1.leadsInfoComponent, contactSocialComponent: contactSocialModal_component_1.contactSocialComponent,
        listComponent: list_component_1.listComponent, locationsListComponent: locations_list_component_1.locationsListComponent, locationsItemComponent: locations_item_component_1.locationsItemComponent,
        teamsListComponent: teams_list_component_1.teamsListComponent, teamsItemComponent: teams_item_component_1.teamsItemComponent, userAccountComponent: user_account_component_1.userAccountComponent,
        agreementsListComponent: agreements_list_component_1.agreementsListComponent, agreementsItemComponent: agreements_item_component_1.agreementsItemComponent,
        accountEmployeesListComponent: employees_list_component_1.accountEmployeesListComponent, accountEmployeesItemComponent: employees_item_component_1.accountEmployeesItemComponent,
        reminderIntervalComponent: reminderIntervalModal_component_1.reminderIntervalComponent
    },
    states: [crm_states_1.crmState, crm_states_1.crmDashboardState,
        crm_states_1.accountsState, crm_states_1.accountsListState, crm_states_1.accountsItemState,
        crm_states_1.contactsState, crm_states_1.contactsListState, crm_states_1.contactsItemState,
        crm_states_1.leadsState, crm_states_1.leadsListState, crm_states_1.leadsItemState,
        crm_states_1.locationsItemState, crm_states_1.teamsItemState, crm_states_1.agreementsItemState, crm_states_1.accountEmployeesItemState,
        crm_states_1.reminderItemState],
    services: { ContactsService: services_1.ContactsService, DashboardService: services_1.DashboardService, AccountsService: services_1.AccountsService, NotesService: services_1.NotesService, TasksService: services_1.TasksService, LeadsService: services_1.LeadsService, TeamService: team_service_1.TeamService, AgreementService: agreements_service_1.AgreementService, AccountEmployeeService: accountEmployee_service_1.AccountEmployeeService }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, crmAppModule);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LeadsController = /** @class */ (function () {
    function LeadsController() {
        'ngInject';
        // console.log('LeadsController');
    }
    return LeadsController;
}());
exports.leadsComponent = {
    controller: LeadsController,
    template: __webpack_require__(411)
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LeadsItemController = /** @class */ (function () {
    LeadsItemController.$inject = ["LeadsService", "$state"];
    function LeadsItemController(LeadsService, $state) {
        'ngInject';
        this.$state = $state;
        // console.log('LeadsItemController');
        this.leadsService = LeadsService;
    }
    LeadsItemController.prototype.submitLead = function () {
        // console.log('update lead');
        if (this.lead.id == null) {
            this.saveLead();
        }
        else {
            this.leadsService.put(this.lead.id, this.lead);
        }
    };
    LeadsItemController.prototype.saveLead = function () {
        var _this = this;
        this.leadsService.post(this.lead).then(function (result) {
            _this.$state.go('crm.leads.item', { 'id': result.id });
        });
    };
    LeadsItemController.prototype.deleteLead = function () {
        var _this = this;
        // console.log('delete lead');
        this.leadsService.delete(this.lead.id);
        this.$state.go('^.list').then(function () { _this.$state.reload(); });
    };
    return LeadsItemController;
}());
exports.leadsItemComponent = {
    bindings: {
        lead: '<'
    },
    controller: LeadsItemController,
    template: __webpack_require__(412)
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LeadsListController = /** @class */ (function () {
    LeadsListController.$inject = ["LeadsService"];
    function LeadsListController(LeadsService) {
        "ngInject";
        var _this = this;
        this.LeadsService = LeadsService;
        this.submitLead = function () {
            _this.LeadsService.all().then(function (leads) {
                _this.leads = leads;
            });
        };
    }
    return LeadsListController;
}());
;
exports.leadsListComponent = {
    bindings: {
        leads: '<'
    },
    controller: LeadsListController,
    template: __webpack_require__(413)
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var LeadsInfoController = /** @class */ (function () {
    LeadsInfoController.$inject = ["LeadsService", "$state"];
    function LeadsInfoController(LeadsService, $state) {
        'ngInject';
        this.$state = $state;
        // console.log('LeadsInfoController');
        this.leadsService = LeadsService;
    }
    LeadsInfoController.prototype.submitLead = function () {
        // console.log('update lead');
        if (this.lead.id == null) {
            this.saveLead();
        }
        else {
            this.leadsService.put(this.lead.id, this.lead);
        }
    };
    LeadsInfoController.prototype.saveLead = function () {
        var _this = this;
        this.leadsService.post(this.lead).then(function (result) {
            _this.onUpdate();
            $('#leadsModal').modal('hide');
            //this.$state.go('crm.leads.list').then(() => { this.$state.reload(); });
        });
    };
    LeadsInfoController.prototype.deleteLead = function () {
        var _this = this;
        // console.log('delete lead');
        this.leadsService.delete(this.lead.id);
        this.$state.go('^.list').then(function () { _this.$state.reload(); });
    };
    return LeadsInfoController;
}());
exports.leadsInfoComponent = {
    bindings: {
        lead: '<',
        onUpdate: "&"
    },
    controller: LeadsInfoController,
    template: __webpack_require__(414)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var _ = __webpack_require__(6);
var LocationsItemController = /** @class */ (function () {
    LocationsItemController.$inject = ["LocationService", "$state", "$stateParams", "SweetAlert", "SalaryScaleGroupService", "$timeout"];
    function LocationsItemController(LocationService, $state, $stateParams, SweetAlert, SalaryScaleGroupService, $timeout) {
        'ngInject';
        var _this = this;
        this.LocationService = LocationService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.SweetAlert = SweetAlert;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.$timeout = $timeout;
        this.$onInit = function () {
            _this.account = _this.resolve.account;
            var locationId = _this.$stateParams['locationId'];
            if (locationId != '') {
                _this.location = _.find(_this.resolve.locations, { 'id': locationId });
            }
            else {
                _this.location = new index_1.ILocation();
            }
            _this.salaryScaleGroups = [];
            _this.SalaryScaleGroupService.all().then(function (result) {
                _this.salaryScaleGroups = result || [];
                // Als location een salaryScaleGroup object heeft, maar het is niet hetzelfde referentie object
                // Zoek het juiste object op basis van ID en gebruik die referentie (belangrijk voor ng-options)
                if (_this.location && _this.location.salaryScaleGroup && _this.location.salaryScaleGroup.id) {
                    var foundGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.location.salaryScaleGroup.id; });
                    if (foundGroup) {
                        // Gebruik het object uit de array zodat de referentie overeenkomt met ng-options
                        _this.location.salaryScaleGroup = foundGroup;
                    }
                }
                else if (_this.location && _this.location.salaryScaleGroupId && !_this.location.salaryScaleGroup) {
                    // Als location alleen een salaryScaleGroupId heeft maar geen object, zoek het object op
                    var foundGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.location.salaryScaleGroupId; });
                    if (foundGroup) {
                        _this.location.salaryScaleGroup = foundGroup;
                    }
                }
                // Trigger chosen update after data is loaded
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('.chosen').trigger('chosen:updated');
                    }
                }, 200);
            }).catch(function (error) {
                console.error('Error loading salary scale groups:', error);
                _this.salaryScaleGroups = [];
            });
        };
    }
    LocationsItemController.prototype.submitLocation = function () {
        var _this = this;
        // Zorg dat salaryScaleGroupId wordt gezet op basis van het geselecteerde object
        if (this.location.salaryScaleGroup && this.location.salaryScaleGroup.id) {
            this.location.salaryScaleGroupId = this.location.salaryScaleGroup.id;
        }
        else {
            this.location.salaryScaleGroupId = null;
            this.location.salaryScaleGroup = null;
        }
        if (this.location.id === undefined) {
            this.location.accountId = this.account.id;
            this.LocationService.post(this.location).then(function (data) {
                _this.closeModal();
            });
            // this.locations.push(this.location);
        }
        else {
            this.LocationService.put(this.location.id, this.location).then(function (data) {
                _this.closeModal();
            });
        }
    };
    LocationsItemController.prototype.delete = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + this.location.name + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.LocationService.delete(_this.location.id).then(function (data) {
                    _this.closeModal();
                });
            }
            else {
            }
        });
    };
    LocationsItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 3 }, { reload: true });
    };
    return LocationsItemController;
}());
exports.locationsItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: LocationsItemController,
    template: __webpack_require__(415)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LocationsListController = /** @class */ (function () {
    function LocationsListController() {
        'ngInject';
        this.$onInit = function () {
        };
        this.$onChanges = function () {
        };
    }
    return LocationsListController;
}());
exports.locationsListComponent = {
    bindings: {
        locations: "<"
    },
    controller: LocationsListController,
    template: __webpack_require__(416)
};


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var NoteController = /** @class */ (function () {
    NoteController.$inject = ["MasterdataAService", "$state", "NotesService"];
    function NoteController(MasterdataAService, $state, NotesService) {
        'ngInject';
        var _this = this;
        this.MasterdataAService = MasterdataAService;
        this.$state = $state;
        this.NotesService = NotesService;
        this.$onInit = function () {
            _this.MasterdataAService.getItems('NoteTags').then(function (res) {
                _this.tags = res;
            });
        };
    }
    NoteController.prototype.focusInput = function () {
        document.getElementById('input').focus();
    };
    NoteController.prototype.submitNote = function () {
        this.note.endDate = moment(this.note.endDate).format("YYYY-MM-DD HH:mm");
        this.onUpdate({ note: this.note });
    };
    NoteController.prototype.endDateBeforeRender = function ($dates) {
        var todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
    };
    return NoteController;
}());
exports.crmNoteComponent = {
    bindings: {
        note: '<',
        onUpdate: "&",
    },
    controller: NoteController,
    template: __webpack_require__(417)
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var _ = __webpack_require__(6);
var TeamsItemController = /** @class */ (function () {
    TeamsItemController.$inject = ["TeamService", "$state", "$stateParams", "$timeout", "SweetAlert"];
    function TeamsItemController(TeamService, $state, $stateParams, $timeout, SweetAlert) {
        'ngInject';
        var _this = this;
        this.TeamService = TeamService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            _this.contacts = _this.resolve.contacts;
            var locationId = _this.$stateParams['locationId'];
            var teamId = _this.$stateParams['teamId'];
            _this.location = _.find(_this.resolve.locations, { 'id': locationId });
            _this.$timeout(function () {
                if (teamId != '') {
                    _this.TeamService.get(teamId).then(function (result) {
                        _this.team = result;
                    });
                    // this.team =  _.find(this.location.teams, { 'id': teamId });
                }
                else {
                    _this.team = new index_1.ITeam();
                }
                // console.log(this.location);
                // console.log(this.location.teams);
                // console.log(teamId);
            });
        };
    }
    TeamsItemController.prototype.submitTeam = function () {
        var _this = this;
        if (this.team.id === undefined) {
            this.team.locationId = this.location.id.toString();
            this.TeamService.post(this.team).then(function (data) {
                _this.closeModal();
            });
            // this.teams.push(this.team);
        }
        else {
            this.TeamService.put(this.team.id, this.team).then(function (data) {
                _this.closeModal();
            });
        }
    };
    TeamsItemController.prototype.delete = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + this.team.name + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.TeamService.delete(_this.team.id).then(function (data) {
                    _this.closeModal();
                });
            }
            else {
            }
        });
    };
    TeamsItemController.prototype.addContact = function () {
        var _this = this;
        // console.log(this.newContact);
        var teamContact = { teamId: this.team.id, contactId: this.newContact.id };
        this.TeamService.postChild(teamContact, this.team.id, 'teamContacts').then(function (result) {
            _this.$state.go('.', { tab: 2 }, { reload: true });
            // teamContact = result;
            // teamContact.contactName = this.newContact.name;
            // this.team.teamContacts.push(teamContact);
        });
    };
    TeamsItemController.prototype.deleteContact = function (event, item) {
        var _this = this;
        event.stopPropagation();
        this.TeamService.deleteChild(item.id, this.team.id, 'teamContacts').then(function () {
            _this.$state.go('.', { tab: 2 }, { reload: true });
            // this.team.teamContacts = this.team.teamContacts.filter(tc => tc.id != item.id);
        });
    };
    TeamsItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 3 }, { reload: true });
    };
    TeamsItemController.prototype.copyGuid = function () {
        window.navigator['clipboard'].writeText(this.team.id.toString());
        alert("De Guid van " + this.team.name + "is gekopieerd");
    };
    return TeamsItemController;
}());
exports.teamsItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: TeamsItemController,
    template: __webpack_require__(418)
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TeamsListController = /** @class */ (function () {
    function TeamsListController() {
        'ngInject';
        this.$onInit = function () {
        };
        this.$onChanges = function () {
        };
    }
    return TeamsListController;
}());
exports.teamsListComponent = {
    bindings: {
        teams: "<",
        locationId: "<"
    },
    controller: TeamsListController,
    template: __webpack_require__(419)
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var shift_component_1 = __webpack_require__(594);
var shift_calendar_component_1 = __webpack_require__(593);
var shift_states_1 = __webpack_require__(595);
var applicationsAppModule = {
    components: { customerShiftComponent: shift_component_1.customerShiftComponent, customerShiftCalendarComponent: shift_calendar_component_1.customerShiftCalendarComponent },
    states: [shift_states_1.customerShiftState, shift_states_1.customerShiftCalendarState, shift_states_1.customerShiftCalendarItemState, shift_states_1.customerShiftListState, shift_states_1.customerShiftListItemState],
    services: {}
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, applicationsAppModule);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var calendar_service_1 = __webpack_require__(18);
var moment = __webpack_require__(0);
var ShiftCalendarController = /** @class */ (function () {
    ShiftCalendarController.$inject = ["ShiftService", "CalendarService", "$state", "uiCalendarConfig", "$scope", "$compile", "$sce"];
    function ShiftCalendarController(ShiftService, CalendarService, $state, uiCalendarConfig, $scope, $compile, $sce) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.CalendarService = CalendarService;
        this.$state = $state;
        this.uiCalendarConfig = uiCalendarConfig;
        this.$scope = $scope;
        this.$compile = $compile;
        this.$sce = $sce;
        this.eventSources = [];
        this.$onInit = function () {
            // console.log('Customer ShiftCalendarController');
            _this.eventSources = [_this.getEvents];
            _this.uiConfig = {
                calendar: {
                    height: 700,
                    locale: 'nl',
                    header: {
                        left: 'title',
                        right: ' prev,next month,agendaWeek,agendaDay'
                    },
                    buttonIcons: {
                        prev: ' fa fa-caret-left',
                        next: ' fa fa-caret-right',
                    },
                    displayEventEnd: true,
                    axisFormat: 'h:mm',
                    allDaySlot: false,
                    timeFormat: 'H:mm',
                    eventLimit: true,
                    eventClick: _this.openItem,
                    //eventDrop: $scope.alertOnDrop,
                    //eventResize: $scope.alertOnResize,
                    eventRender: _this.eventRender
                }
            };
            _this.ShiftService.subscribe('ShiftCalendarController', function (type) {
                var newShift;
                var calendarItem;
                switch (type) {
                    case 'post': {
                        newShift = _this.ShiftService.item;
                        calendarItem = new calendar_service_1.ICalendarShift();
                        calendarItem.start = newShift.start;
                        calendarItem.end = newShift.end;
                        calendarItem.status = newShift.status.toString();
                        calendarItem.statusColor = newShift.statusColor;
                        calendarItem.title = newShift.teamLocationName;
                        calendarItem.shift = newShift;
                        _this.shifts.push(calendarItem);
                        break;
                    }
                    case 'put': {
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== newShift.id; });
                        if (_this.ShiftService.item.status !== 99) {
                            newShift = _this.ShiftService.item;
                            calendarItem = new calendar_service_1.ICalendarShift();
                            calendarItem.start = newShift.start;
                            calendarItem.end = newShift.end;
                            calendarItem.status = newShift.status.toString();
                            calendarItem.statusColor = newShift.statusColor;
                            calendarItem.title = newShift.teamLocationName;
                            calendarItem.shift = newShift;
                            _this.shifts.push(calendarItem);
                        }
                        break;
                    }
                    case 'delete': {
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== _this.ShiftService.itemId; });
                        break;
                    }
                }
                _this.uiCalendarConfig.calendars['shiftsCalendar'].fullCalendar('refetchEvents');
            });
        };
        this.openItem = function (event) {
            //this.$state.go('.item', { 'id': event.shift.id });
            _this.$state.go('customerShifts.list.item', { 'id': event.shift.id, 'start': event.shift.start });
        };
        // private eventRender = (event, element, view) => {
        //     element.attr({
        //         'uib-tooltip': event.title,
        //         'tooltip-append-to-body': true
        //     });
        //     if (moment().isBefore(event.start)) {
        //         element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor });
        //     } else {
        //         element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor, 'opacity': 0.7 });
        //     }
        //     this.$compile(element)(this.$scope);
        // }
        this.eventRender = function (event, element, view) {
            // var status : any = _.find(this.statuses, {code: event.status.toString()});
            // var statusName = status ? status.name :  "";
            // var eventTitle = event.title + " - " + event.shift.teamName + "<br /><b>" + statusName + "</b>";
            var color = event.statusColor;
            if (moment().isBefore(event.start)) {
                element.css({ 'background-color': color, 'border-color': color });
            }
            else {
                element.css({ 'background-color': color, 'border-color': color, 'opacity': 0.7 });
            }
            element.attr({
                'uib-tooltip': event.title,
                'tooltip-append-to-body': true
            });
            // element.tooltip({container: "body", title: eventTitle, placement: "top", html:true }); 
            // var title = element.find('.fc-title, .fc-list-item-title');          
            // title.html(eventTitle);
            _this.$compile(element)(_this.$scope);
        };
        this.getEvents = function (start, end, timezone, callback) {
            _this.CalendarService.all({ 'start': start.toDate(), 'end': end.toDate() }).then(function (events) {
                _this.shifts = events;
                var employeeName;
                _this.shifts.forEach(function (s) {
                    employeeName = s.shift.employeeDisplayName || '-';
                    s.title = s.title + '\n' + employeeName;
                });
                callback(events);
            });
        };
        this.$onDestroy = function () {
            _this.ShiftService.unsubscribe('ShiftCalendarController');
        };
    }
    ShiftCalendarController.prototype.statuses = function (arg0, arg1) {
        throw new Error("Method not implemented.");
    };
    return ShiftCalendarController;
}());
exports.customerShiftCalendarComponent = {
    controller: ShiftCalendarController,
    bindings: {
        statuses: "<"
    },
    template: __webpack_require__(420)
};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ShiftController = /** @class */ (function () {
    function ShiftController() {
        'ngInject';
    }
    return ShiftController;
}());
exports.customerShiftComponent = {
    controller: ShiftController,
    template: __webpack_require__(421)
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.customerShiftState = {
    parent: 'app',
    name: "customerShifts",
    url: "/customerShifts",
    component: 'customerShiftComponent',
    redirectTo: 'customerShifts.calendar',
    data: {
        permissions: {
            only: ['CUSTOMER'],
            redirectTo: 'shifts'
        }
    }
};
exports.customerShiftCalendarState = {
    name: "customerShifts.calendar",
    url: "/calendar",
    resolve: {
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }]
    },
    views: {
        "main": 'customerShiftCalendarComponent'
    }
};
exports.customerShiftCalendarItemState = {
    name: "customerShifts.calendar.item",
    url: "/item/:id",
    modal: true,
    size: "lg",
    component: 'shiftItemComponent',
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        employees: ["AccountsService", "AuthService", function (AccountsService, AuthService) {
            'ngInject';
            return AccountsService.customGet('employees');
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }]
    }
};
exports.customerShiftListState = {
    name: "customerShifts.list",
    url: "/list",
    views: {
        "main": 'shiftListComponent'
    },
    resolve: {
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        employees: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
    },
    data: {
        contentClasses: 'no-padding'
    }
};
exports.customerShiftListItemState = {
    name: "customerShifts.list.item",
    url: "/item/:id",
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
    },
    views: {
        "shiflistitem@customerShifts.list": 'shiftListItemComponent'
    },
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardAvailableEmployeesController = /** @class */ (function () {
    DashboardAvailableEmployeesController.$inject = ["EmployeeAvailabilityService"];
    function DashboardAvailableEmployeesController(EmployeeAvailabilityService) {
        "ngInject";
        var _this = this;
        this.EmployeeAvailabilityService = EmployeeAvailabilityService;
        this.$onInit = function () {
            _this.getEmployeeAvailability();
        };
        this.getEmployeeAvailability = function () {
            var params = {
                limit: 10,
                sortfield: 'createdOn',
                sortorder: 'desc'
            };
            _this.EmployeeAvailabilityService.all(params).then(function (employeeAvailability) {
                _this.employeeAvailability = employeeAvailability;
            });
        };
    }
    return DashboardAvailableEmployeesController;
}());
exports.dashboardAvailableEmployeesComponent = {
    controller: DashboardAvailableEmployeesController,
    template: __webpack_require__(422)
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var DashboardBirthdayController = /** @class */ (function () {
    DashboardBirthdayController.$inject = ["EmployeesService"];
    function DashboardBirthdayController(EmployeesService) {
        "ngInject";
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$onInit = function () {
            _this.getEmployees();
        };
        this.getEmployees = function () {
            _this.EmployeesService.getEmployeesByStatus().then(function (employees) {
                _this.employees = employees;
                var now = moment();
                var currentYear = moment().year();
                _this.employees.forEach(function (employee) {
                    var b = moment(employee.birthday).year(currentYear);
                    if (moment().isAfter(b)) {
                        employee.birthday = moment(employee.birthday).year(currentYear + 1).format('YYYY-MM-DD');
                    }
                    else {
                        employee.birthday = moment(employee.birthday).year(currentYear).format('YYYY-MM-DD');
                    }
                });
                _this.employees = _.remove(_this.employees, function (value, index) {
                    if (value.displayName) {
                        return value.displayName.length;
                    }
                });
                _this.employees = _.orderBy(_this.employees, ['birthday'], ['asc']);
            });
        };
    }
    return DashboardBirthdayController;
}());
exports.dashboardBirthdayComponent = {
    controller: DashboardBirthdayController,
    template: __webpack_require__(423)
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardController = /** @class */ (function () {
    function DashboardController() {
        "ngInject";
        this.$onInit = function () {
            // console.log('DashboardController');
        };
    }
    return DashboardController;
}());
exports.dashboard = {
    controller: DashboardController,
    template: __webpack_require__(424)
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var DashboardOpenshiftsController = /** @class */ (function () {
    DashboardOpenshiftsController.$inject = ["ShiftService"];
    function DashboardOpenshiftsController(ShiftService) {
        "ngInject";
        var _this = this;
        this.ShiftService = ShiftService;
        this.$onInit = function () {
            _this.getShift();
        };
        this.getShift = function () {
            var params = {
                from: moment().format('YYYY-MM-DD'),
                till: moment().add(1, 'w').format('YYYY-MM-DD'),
                includeSubscriptions: false,
            };
            _this.ShiftService.getFilter(params).then(function (shifts) {
                _this.shifts = shifts;
                // this.shifts.forEach((shift) => {
                // })
                _this.shifts = _.remove(_this.shifts, function (value, index) {
                    if (value.status) {
                        return value.status < 6;
                    }
                });
            });
        };
        this.isSameDay = function (start, end) {
            if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
                return true;
            }
            else {
                return false;
            }
        };
    }
    return DashboardOpenshiftsController;
}());
exports.dashboardOpenshiftsComponent = {
    controller: DashboardOpenshiftsController,
    template: __webpack_require__(425)
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var DashboardSkillsController = /** @class */ (function () {
    DashboardSkillsController.$inject = ["EmployeeSkillsService"];
    function DashboardSkillsController(EmployeeSkillsService) {
        "ngInject";
        var _this = this;
        this.EmployeeSkillsService = EmployeeSkillsService;
        this.$onInit = function () {
            _this.getShift();
        };
        this.getShift = function () {
            _this.EmployeeSkillsService.getList({ sortfield: 'end', sortorder: 'ASC' }).then(function (skills) {
                _this.skills = skills.value;
            });
        };
        this.isExpired = function (date) {
            if (moment(date) <= moment()) {
                return true;
            }
            else {
                return false;
            }
        };
    }
    return DashboardSkillsController;
}());
exports.dashboardSkillsComponent = {
    controller: DashboardSkillsController,
    template: __webpack_require__(426)
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardState = {
    parent: 'app',
    name: "dashboard",
    url: "/dashboard?:newsall",
    params: {
        "newsall": { dynamic: true },
    },
    component: 'dashboard',
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'customerShifts'
        }
    }
};
exports.newsItemBasicState = {
    name: "dashboard.newsitem",
    url: "/newsitem/:id",
    params: {
        "id": null
    },
    modal: [],
    resolve: {},
    component: 'newsItemBasicComponent'
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dashboard_birthday_component_1 = __webpack_require__(597);
var ngmodule_1 = __webpack_require__(4);
var dashboard_component_1 = __webpack_require__(598);
var dashboard_states_1 = __webpack_require__(601);
var dashboard_openshifts_component_1 = __webpack_require__(599);
var dashboard_skills_component_1 = __webpack_require__(600);
var dashboardNotes_component_1 = __webpack_require__(605);
var dashboardAvailableEmployees_component_1 = __webpack_require__(596);
var dashboardTimesheetsSummary_component_1 = __webpack_require__(607);
var dashboardTasks_component_1 = __webpack_require__(606);
var employeeAvailability_service_1 = __webpack_require__(22);
var news_service_1 = __webpack_require__(266);
var dashboardNews_component_1 = __webpack_require__(603);
var news_item_basic_component_1 = __webpack_require__(604);
var dashboardAppModule = {
    components: {
        dashboard: dashboard_component_1.dashboard,
        dashboardBirthdayComponent: dashboard_birthday_component_1.dashboardBirthdayComponent,
        dashboardOpenshiftsComponent: dashboard_openshifts_component_1.dashboardOpenshiftsComponent,
        dashboardSkillsComponent: dashboard_skills_component_1.dashboardSkillsComponent,
        dashboardNotesComponent: dashboardNotes_component_1.dashboardNotesComponent,
        dashboardAvailableEmployeesComponent: dashboardAvailableEmployees_component_1.dashboardAvailableEmployeesComponent,
        dashboardTimesheetsSummaryComponent: dashboardTimesheetsSummary_component_1.dashboardTimesheetsSummaryComponent,
        dashboardTasksComponent: dashboardTasks_component_1.dashboardTasksComponent,
        dashboardNewsComponent: dashboardNews_component_1.dashboardNewsComponent,
        newsItemBasicComponent: news_item_basic_component_1.newsItemBasicComponent
    },
    states: [
        dashboard_states_1.dashboardState,
        dashboard_states_1.newsItemBasicState
    ],
    services: { EmployeeAvailabilityService: employeeAvailability_service_1.EmployeeAvailabilityService, NewsService: news_service_1.NewsService }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, dashboardAppModule);


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardNewsController = /** @class */ (function () {
    DashboardNewsController.$inject = ["NewsService", "$state", "$stateParams"];
    function DashboardNewsController(NewsService, $state, $stateParams) {
        "ngInject";
        var _this = this;
        this.NewsService = NewsService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.newsItemTypes = [
            {
                id: 2,
                name: 'Intern'
            },
            {
                id: 4,
                name: 'Klant'
            },
            {
                id: 1,
                name: 'Medewerker'
            },
        ];
        this.$onInit = function () {
            if (_this.$stateParams['newsall']) {
                _this.all = _this.$stateParams['newsall'] == 'true' ? true : false;
            }
            _this.getNews();
            //this.all = false;
        };
        this.getType = function (id) {
            return _this.newsItemTypes.find(function (t) { return t.id == id; }).name;
        };
        this.setAll = function () {
            _this.$state.go(".", { "newsall": _this.all }, { notify: false });
            _this.getNews();
        };
        this.getNews = function () {
            var params = {
                limit: _this.all ? 100 : 10,
                sortfield: 'createdDate',
                sortorder: 'desc',
                all: _this.all
            };
            _this.NewsService.all(params).then(function (news) {
                _this.news = news;
            });
        };
    }
    DashboardNewsController.prototype.addNewsItem = function () {
    };
    return DashboardNewsController;
}());
exports.dashboardNewsComponent = {
    controller: DashboardNewsController,
    template: __webpack_require__(427)
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var NewsItemBasicController = /** @class */ (function () {
    NewsItemBasicController.$inject = ["NewsService", "$state", "$stateParams", "SweetAlert"];
    function NewsItemBasicController(NewsService, $state, $stateParams, SweetAlert) {
        'ngInject';
        var _this = this;
        this.NewsService = NewsService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            _this.newsItemTypes = [
                {
                    id: 2,
                    name: 'Intern'
                },
                {
                    id: 4,
                    name: 'Klant'
                },
                {
                    id: 1,
                    name: 'Medewerker'
                },
            ];
            if (_this.$stateParams['id']) {
                _this.get();
            }
        };
        this.save = function () {
            _this.newsItem.createdDate = moment(_this.newsItem.createdDate).format('YYYY-MM-DD') + ' 00:00:00';
            _this.newsItem.expireDate = moment(_this.newsItem.expireDate).format('YYYY-MM-DD') + ' 23:59:59';
            if (_this.newsItem.id != undefined) {
                _this.NewsService.put(_this.newsItem.id, _this.newsItem).then(function (res) {
                    _this.closeModal();
                });
            }
            else {
                _this.NewsService.post(_this.newsItem).then(function (res) {
                    _this.closeModal();
                });
            }
        };
        this.delete = function () {
            _this.SweetAlert.swal({
                title: 'Weet je het zeker?',
                text: "Je verwijdert het nieuws item '" + _this.newsItem.title + "'. Dit kan niet meer ongedaan gemaakt worden!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Verwijderen',
                cancelButtonText: 'Annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.NewsService.delete(_this.newsItem.id).then(function () {
                        _this.closeModal();
                    });
                }
                else {
                }
            });
        };
    }
    NewsItemBasicController.prototype.get = function () {
        var _this = this;
        this.NewsService.get(this.$stateParams['id']).then(function (res) {
            _this.newsItem = res;
        });
    };
    NewsItemBasicController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return NewsItemBasicController;
}());
exports.newsItemBasicComponent = {
    bindings: {
        close: "&"
    },
    controller: NewsItemBasicController,
    template: __webpack_require__(428)
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardNotesController = /** @class */ (function () {
    DashboardNotesController.$inject = ["NotesService"];
    function DashboardNotesController(NotesService) {
        "ngInject";
        var _this = this;
        this.NotesService = NotesService;
        this.$onInit = function () {
            _this.getNotes();
        };
        this.getNotes = function () {
            var params = {
                limit: 5000,
                sortfield: 'createdOn',
                sortorder: 'desc'
            };
            _this.NotesService.all(params)
                .then(function (notes) {
                _this.notes = notes.filter(function (note) { return !note.applicantId; }).slice(0, 10);
            });
        };
    }
    DashboardNotesController.prototype.getNoteAuthorName = function (note) {
        if (note.accountName)
            return note.accountName;
        if (note.employeeDisplayName)
            return note.employeeDisplayName;
        if (note.applicantName)
            return note.applicantName;
        return '';
    };
    return DashboardNotesController;
}());
exports.dashboardNotesComponent = {
    controller: DashboardNotesController,
    template: __webpack_require__(429)
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardTasksController = /** @class */ (function () {
    DashboardTasksController.$inject = ["TasksService"];
    function DashboardTasksController(TasksService) {
        "ngInject";
        var _this = this;
        this.TasksService = TasksService;
        this.$onInit = function () {
            _this.getTasks();
        };
        this.getTasks = function () {
            var params = {
                limit: 10,
                sortfield: 'createdOn',
                sortorder: 'desc'
            };
            _this.TasksService.all(params).then(function (tasks) {
                _this.tasks = tasks;
            });
        };
    }
    return DashboardTasksController;
}());
exports.dashboardTasksComponent = {
    controller: DashboardTasksController,
    template: __webpack_require__(430)
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardTimesheetsSummaryController = /** @class */ (function () {
    DashboardTimesheetsSummaryController.$inject = ["EmployeesService"];
    function DashboardTimesheetsSummaryController(EmployeesService) {
        "ngInject";
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$onInit = function () {
            _this.moment = __webpack_require__(0);
            _this.getTimesheetsWeek1();
            _this.getTimesheetsWeek2();
        };
        this.getTimesheetsWeek1 = function () {
            _this.EmployeesService.customAll('employeeSummary', { from: _this.moment().startOf('isoweek').format("YYYY-MM-DD"), till: _this.moment().endOf('isoweek').format("YYYY-MM-DD") })
                .then(function (result) {
                _this.timesheetsWeek1 = result;
            });
        };
        this.getTimesheetsWeek2 = function () {
            _this.EmployeesService.customAll('employeeSummary', { from: _this.moment().startOf('isoweek').add(1, 'week').format("YYYY-MM-DD"), till: _this.moment().endOf('isoweek').add(1, 'week').format("YYYY-MM-DD") })
                .then(function (result) {
                _this.timesheetsWeek2 = result;
            });
        };
    }
    return DashboardTimesheetsSummaryController;
}());
exports.dashboardTimesheetsSummaryComponent = {
    controller: DashboardTimesheetsSummaryController,
    template: __webpack_require__(431)
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DocumentationController = /** @class */ (function () {
    function DocumentationController() {
        'ngInject';
        // console.log('DocumentationController');
    }
    ;
    return DocumentationController;
}());
exports.documentationComponent = {
    controller: DocumentationController,
    template: __webpack_require__(432)
};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.documentationState = {
    parent: "app",
    name: "documentation",
    url: "/documentation",
    component: "documentationComponent",
    data: {
        permissions: {
            only: ['BACKOFFICE', 'EMPLOYEE'],
        }
    }
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var documentation_states_1 = __webpack_require__(609);
var documentation_component_1 = __webpack_require__(608);
var documentationAppModule = {
    components: { documentationComponent: documentation_component_1.documentationComponent },
    states: [documentation_states_1.documentationState],
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, documentationAppModule);


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApplicantsController = /** @class */ (function () {
    function ApplicantsController() {
        'ngInject';
        // console.log('ApplicantsController');
    }
    return ApplicantsController;
}());
exports.applicantsComponent = {
    controller: ApplicantsController,
    template: __webpack_require__(433)
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var ApplicantsItemBasicController = /** @class */ (function () {
    ApplicantsItemBasicController.$inject = ["EnumService", "ApplicantsService", "$state"];
    function ApplicantsItemBasicController(EnumService, ApplicantsService, $state) {
        'ngInject';
        var _this = this;
        this.EnumService = EnumService;
        this.ApplicantsService = ApplicantsService;
        this.$state = $state;
        this.$onInit = function () {
            _this.applicant = _this.resolve.applicant;
            _this.preferredTargetAudiences = _this.resolve.preferredTargetAudiences;
            _this.applicationStatuses = _this.resolve.applicationStatuses;
            _this.functions = _this.resolve.functions;
            _this.users = _this.resolve.users;
            _this.users.forEach(function (user) {
                user.id = user.id.toLowerCase();
            });
            _this.applicant.userId = _this.applicant.userId.toLowerCase();
        };
        this.save = function () {
            _this.applicant.date = moment(_this.applicant.date).format("YYYY-MM-DD HH:mm");
            if (_this.applicant.id != undefined) {
                _this.ApplicantsService.put(_this.applicant.id, _this.applicant).then(function (applicant) {
                    _this.closeModal();
                });
            }
            else {
                _this.ApplicantsService.post(_this.applicant).then(function (applicant) {
                    _this.$state.go('^', { 'id': applicant.id });
                });
            }
        };
    }
    ApplicantsItemBasicController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return ApplicantsItemBasicController;
}());
exports.applicantsItemBasicComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: ApplicantsItemBasicController,
    template: __webpack_require__(434)
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var config_1 = __webpack_require__(13);
var ApplicantsItemController = /** @class */ (function () {
    ApplicantsItemController.$inject = ["localStorageService", "ApplicantsService", "$stateParams", "$state", "NotesService", "ApplicantStatusHistoryService", "AuthService", "SweetAlert", "FileSaver", "MasterdataAService", "$filter"];
    function ApplicantsItemController(localStorageService, ApplicantsService, $stateParams, $state, NotesService, ApplicantStatusHistoryService, AuthService, SweetAlert, FileSaver, MasterdataAService, $filter) {
        'ngInject';
        var _this = this;
        this.localStorageService = localStorageService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.NotesService = NotesService;
        this.AuthService = AuthService;
        this.SweetAlert = SweetAlert;
        this.FileSaver = FileSaver;
        this.MasterdataAService = MasterdataAService;
        this.$filter = $filter;
        this.archive = false;
        this.$onInit = function () {
            if (_this.$state.current.params.archive) {
                _this.archive = true;
            }
            if (_this.$stateParams['tab']) {
                _this.activeTabIndex = _this.$stateParams['tab'];
            }
            if (_this.applicant.userId) {
                var user = _this.users.find(function (u) { return u.id.toLowerCase() == _this.applicant.userId.toLowerCase(); });
                if (user) {
                    _this.applicant.userName = user.userName;
                }
            }
            _this.getFiles(_this.applicant.id);
            _this.MasterdataAService.getItems('NoteTags').then(function (res) {
                _this.tags = res;
            });
            _this.filterNotes();
        };
        this.postFile = function (id) {
            return _this.applicantsService.postBlob(id, _this.uploadfile);
        };
        this.getFiles = function (id) {
            _this.applicantsService.getBlobs(id).then(function (files) {
                _this.files = files.value;
            });
        };
        this.deleteFile = function (blobid) {
            _this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Weet u zeker dat u dit bestand wilt verwijderen?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Nee, annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.applicantsService.deleteBlob(_this.applicant.id, blobid).then(function (res) {
                        _this.$state.go('.', { tab: 1 }, { reload: true });
                    });
                }
                else {
                }
            });
        };
        this.downloadFile = function (file) {
            // this.applicantsService.getBlob(this.applicant.id, file.id).then((blob) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var url = URL.createObjectURL(xhr.response);
                    var aLink = document.createElement('a');
                    document.body.appendChild(aLink);
                    aLink.href = url;
                    aLink.download = file.filenameWithExtention;
                    aLink.click();
                }
            };
            var token = _this.localStorageService.get("authorizationData");
            var url = config_1.default.API_URL;
            xhr.open('GET', url + '/hr/applicant/' + _this.applicant.id + '/blobs/' + file.id);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            // xhr.setRequestHeader('Dropbox-API-Arg', JSON.stringify({"path": "/"+filename}));
            xhr.send();
            // })
        };
        this.notesService = NotesService;
        this.applicantStatusHistoryService = ApplicantStatusHistoryService;
        this.applicantsService = ApplicantsService;
        angular.element(document).ready(function () {
            $('#notes-table').dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }
    ApplicantsItemController.prototype.submitApplicant = function () {
        if (this.applicant.id == null) {
            this.saveApplicant();
        }
        else {
            this.applicantsService.put(this.applicant.id, this.applicant);
        }
    };
    ApplicantsItemController.prototype.saveApplicant = function () {
        var _this = this;
        this.applicantsService.post(this.applicant).then(function (result) {
            _this.$state.go('hr.applicants.item', { 'id': result.id });
        });
    };
    ApplicantsItemController.prototype.archiveApplicant = function () {
        var _this = this;
        this.applicant.inactive = true;
        this.applicantsService.put(this.applicant.id, this.applicant).then(function (result) {
            _this.$state.go('hr.applicants.archiveitem', { 'id': result.id });
        });
    };
    ApplicantsItemController.prototype.unarchiveApplicant = function () {
        var _this = this;
        this.applicant.inactive = false;
        this.applicantsService.put(this.applicant.id, this.applicant).then(function (result) {
            _this.$state.go('hr.applicants.item', { 'id': result.id });
        });
    };
    ApplicantsItemController.prototype.deleteApplicant = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + this.applicant.name + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.applicantsService.delete(_this.applicant.id);
                _this.$state.go('^.list').then(function () { _this.$state.reload(); });
            }
            else {
            }
        });
    };
    ApplicantsItemController.prototype.addNoteModal = function () {
        this.currentNote = null;
        $('#noteModal').modal('show');
    };
    ApplicantsItemController.prototype.updateNoteModal = function (item) {
        this.currentNote = item;
        $('#noteModal').modal('show');
    };
    ApplicantsItemController.prototype.filterNotes = function () {
        var _this = this;
        this.filteredNotes = this.$filter('filter')(this.notes, function (note) {
            if (!!_this.selectedTag) {
                return note.tags.indexOf(_this.selectedTag) !== -1;
            }
            else {
                return true;
            }
        });
    };
    ApplicantsItemController.prototype.submitNote = function (item) {
        var _this = this;
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.applicantId = this.applicant.id;
        if (newNote.id == null) {
            this.notesService.post(newNote).then(function (result) {
                _this.notes.push(result);
            });
        }
        else {
            this.notesService.put(newNote.id, newNote);
        }
        $('#noteModal').modal('hide');
    };
    ApplicantsItemController.prototype.deleteNote = function (item) {
        this.notes = this.notes.filter(function (note) { return note.id !== item.id; });
        this.notesService.delete(item.id);
    };
    ApplicantsItemController.prototype.updateNote = function (item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    };
    ApplicantsItemController.prototype.deleteHistory = function (item) {
        this.applicationStatusHistories = this.applicationStatusHistories.filter(function (x) { return x.id !== item.id; });
        this.applicantStatusHistoryService.delete(item.id);
    };
    ApplicantsItemController.prototype.updateHistory = function (item, action) {
        switch (action) {
            case 'delete':
                this.deleteHistory(item);
                break;
        }
    };
    ApplicantsItemController.prototype.uploadAll = function () {
        var _this = this;
        if (this.uploadfile) {
            this.postFile(this.applicant.id).then(function () {
                _this.$state.go('.', { tab: 1 }, { reload: true });
            });
        }
    };
    ApplicantsItemController.prototype.clickUpload = function () {
        angular.element('#myUploader').trigger('click');
    };
    ;
    return ApplicantsItemController;
}());
exports.applicantsItemComponent = {
    bindings: {
        applicant: '<',
        notes: '<',
        applicationStatusHistories: '<',
        preferredTargetAudiences: '<',
        applicationStatuses: '<',
        functions: '<',
        users: '<'
    },
    controller: ApplicantsItemController,
    template: __webpack_require__(436)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApplicantsItemEmployeeController = /** @class */ (function () {
    ApplicantsItemEmployeeController.$inject = ["EnumService", "ApplicantsService", "EmployeesService", "$state"];
    function ApplicantsItemEmployeeController(EnumService, ApplicantsService, EmployeesService, $state) {
        'ngInject';
        var _this = this;
        this.EnumService = EnumService;
        this.ApplicantsService = ApplicantsService;
        this.EmployeesService = EmployeesService;
        this.$state = $state;
        this.$onInit = function () {
            _this.applicant = _this.resolve.applicant;
            _this.functions = _this.resolve.functions;
            _this.applicationStatuses = _this.resolve.applicationStatuses;
            _this.employee = {};
            _this.employee.homeAddress = {};
            _this.employee.firstName = _this.applicant.name.split(' ')[0];
            var names = _this.applicant.name.split(' ');
            names.shift();
            _this.employee.lastName = names.join(' ');
            _this.employee.telephoneMobilePrivate = _this.applicant.phoneNumber;
            _this.employee.emailPrivate = _this.applicant.email;
            _this.employee.homeAddress.city = _this.applicant.city;
            _this.employee.functionId = _this.applicant.functionId;
            _this.employee.zzp = _this.applicant.zzp;
        };
        this.save = function () {
            _this.EmployeesService.post(_this.employee).then(function (employee) {
                _this.applicant.employeeId = employee.id;
                _this.applicant.applicationStatusId = _this.applicationStatuses.find(function (s) { return s.code == 'accepted'; }).id;
                _this.ApplicantsService.put(_this.applicant.id, _this.applicant).then(function (applicant) {
                    _this.$state.go('hr.employees.item', { 'id': applicant.employeeId });
                });
            });
        };
    }
    ApplicantsItemEmployeeController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return ApplicantsItemEmployeeController;
}());
exports.applicantsItemEmployeeComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: ApplicantsItemEmployeeController,
    template: __webpack_require__(435)
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApplicantsListController = /** @class */ (function () {
    ApplicantsListController.$inject = ["ApplicantsService", "$filter", "$stateParams", "$state"];
    function ApplicantsListController(ApplicantsService, $filter, $stateParams, $state) {
        'ngInject';
        var _this = this;
        this.ApplicantsService = ApplicantsService;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.archive = false;
        this.$onInit = function () {
            if (_this.$state.current.params.archive) {
                _this.archive = true;
            }
            _this.currentPage = 1;
            _this.itemsPerPage = 11;
            _this.getApplicants();
            _this.statusFilter = '';
            if (_this.$stateParams['status']) {
                if (_this.$stateParams['status'] == 'all') {
                    _this.statusFilter = '';
                }
                else {
                    _this.statusFilter = _this.applicationStatuses.find(function (s) { return s.code == _this.$stateParams['status']; }).id;
                }
            }
            if (_this.$stateParams['recruiter']) {
                _this.userFilter = _this.$stateParams['recruiter'];
            }
            if (_this.$stateParams['function']) {
                _this.functionFilter = _this.$stateParams['function'];
            }
            if (_this.$stateParams['targetaudiance']) {
                _this.targetAudienceFilter = _this.$stateParams['targetaudiance'];
            }
            // if(this.$stateParams['search']) {
            //     this.search = decodeURI(this.$stateParams['search']);
            // }
        };
        this.filter = function () {
            var status = _this.statusFilter ? _this.applicationStatuses.find(function (s) { return s.id == _this.statusFilter; }).code : 'all';
            if (_this.archive) {
                _this.$state.go('hr.applicants.archive', {
                    'recruiter': _this.userFilter,
                    'status': status,
                    'function': _this.functionFilter,
                    'targetaudiance': _this.targetAudienceFilter,
                    'search': encodeURI(_this.search)
                });
            }
            else {
                _this.$state.go('hr.applicants.list', {
                    'recruiter': _this.userFilter,
                    'status': status,
                    'function': _this.functionFilter,
                    'targetaudiance': _this.targetAudienceFilter,
                    'search': encodeURI(_this.search)
                });
            }
        };
        this.getApplicants = function () {
            if (_this.archive) {
                _this.ApplicantsService.getArchive().then(function (res) {
                    _this.applicants = res;
                    _this.applicants.forEach(function (applicant) {
                        if (applicant.userId) {
                            var user = _this.users.find(function (u) { return u.id == applicant.userId; });
                            applicant.userName = user ? user.userName : '';
                        }
                    });
                    _this.applyFilters();
                });
            }
            else {
                _this.ApplicantsService.all().then(function (res) {
                    _this.applicants = res;
                    _this.applicants.forEach(function (applicant) {
                        if (applicant.userId) {
                            var user = _this.users.find(function (u) { return u.id == applicant.userId; });
                            applicant.userName = user ? user.userName : '';
                        }
                    });
                    _this.applyFilters();
                });
            }
        };
        this.sortType = 'displayName';
        //console.log('ApplicantsListController');
    }
    ApplicantsListController.prototype.applyFilters = function () {
        this.filteredApplicants = this.$filter('filterBy')(this.applicants, ['name', 'city'], this.search);
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['functionId'], this.functionFilter);
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['preferredTargetAudienceId'], this.targetAudienceFilter);
        if (this.statusFilter) {
            this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['applicationStatusId'], this.statusFilter);
        }
        this.filteredApplicants = this.$filter('filterBy')(this.filteredApplicants, ['userId'], this.userFilter);
        this.filteredApplicants = this.$filter('orderBy')(this.filteredApplicants, this.sortType);
    };
    return ApplicantsListController;
}());
exports.applicantsListComponent = {
    bindings: {
        functions: "<",
        preferredTargetAudiences: "<",
        applicationStatuses: "<",
        users: "<"
    },
    controller: ApplicantsListController,
    template: __webpack_require__(437)
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var AvailabilityListController = /** @class */ (function () {
    AvailabilityListController.$inject = ["$state", "EmployeesService"];
    function AvailabilityListController($state, EmployeesService) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.EmployeesService = EmployeesService;
        this.$onInit = function () {
            var date = moment();
            _this.startDate = date.format("YYYY-MM-DD");
            _this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
            _this.getAvailabilityByDate();
        };
        this.prevWeek = function () {
            _this.startDate = moment(_this.startDate).add(-7, 'day').toDate();
            _this.endDate = moment(_this.endDate).add(-7, 'day').toDate();
        };
        this.nextWeek = function () {
            _this.startDate = moment(_this.startDate).add(7, 'day').toDate();
            _this.endDate = moment(_this.endDate).add(7, 'day').toDate();
        };
    }
    AvailabilityListController.prototype.getAvailabilityByDate = function () {
        var _this = this;
        this.EmployeesService.getAvailabilityByRange(this.startDate, this.endDate).then(function (result) {
            result.forEach(function (a) {
                a.startDate = moment(a.start);
            });
            result = _.sortBy(result, 'startDate');
            _this.availabilities = result;
        });
    };
    return AvailabilityListController;
}());
exports.availabilityListComponent = {
    bindings: {
        avalabilityStatuses: '<'
    },
    controller: AvailabilityListController,
    template: __webpack_require__(438)
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var AvailabilityCalendarController = /** @class */ (function () {
    AvailabilityCalendarController.$inject = ["EmployeesService", "$state", "uiCalendarConfig", "$scope", "$compile", "$timeout"];
    function AvailabilityCalendarController(EmployeesService, $state, uiCalendarConfig, $scope, $compile, $timeout) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$state = $state;
        this.uiCalendarConfig = uiCalendarConfig;
        this.$scope = $scope;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.eventSources = [];
        this.$onInit = function () {
            // console.log('init AvailabilityCalendarController')
            _this.eventSources = [_this.getEvents];
            // this.getEvents(moment().fromNow, '2016-07-13 23:00:00.0000000'.toDate(), null, function() {});
            _this.uiConfig = {
                calendar: {
                    height: 537,
                    locale: 'nl',
                    header: {
                        left: 'title',
                        right: ' prev,next month,agendaWeek,agendaDay'
                    },
                    buttonIcons: {
                        prev: ' fa fa-caret-left',
                        next: ' fa fa-caret-right',
                    },
                    displayEventEnd: true,
                    axisFormat: 'h:mm',
                    allDaySlot: false,
                    timeFormat: 'H:mm',
                    eventLimit: true,
                    eventClick: _this.openItem,
                    //eventDrop: $scope.alertOnDrop,
                    //eventResize: $scope.alertOnResize,
                    eventRender: _this.eventRender
                }
            };
            _this.$timeout(function () {
                _this.renderCalendar();
            });
        };
        this.renderCalendar = function () {
            _this.uiCalendarConfig.calendars['employeeCalendar'].fullCalendar('render');
            _this.uiCalendarConfig.calendars['employeeCalendar'].fullCalendar('rerenderEvents');
        };
        this.getEvents = function (start, end, timezone, callback) {
            // console.log('getEvents');
            // console.log(start);
            _this.EmployeesService.customAll(_this.employeeId + '/availabilityByRange', { 'start': start.toDate(), 'end': end.toDate() }).then(function (events) {
                _this.availabilities = events;
                // console.log(events);
                callback(events);
            });
        };
        this.openItem = function (event) {
            _this.$state.go('hr.employees.item.availability', { 'employeeId': _this.employeeId, 'availabilityId': event.id });
        };
        this.eventRender = function (event, element, view) {
            element.attr({
                'uib-tooltip': event.comment,
                'tooltip-append-to-body': true
            });
            //var employee = '';
            // if (event.shift.Employee) {
            //     var employee = '<br /><i>' + event.shift.Employee.DisplayName + '</i>';
            // }
            // element.append('<span>' + event.status.Name + employee + '</span>');
            if (!event.status) {
                event.status = "???";
            }
            var color;
            if (event.status.toLowerCase() == 'available') {
                color = '#2ECC71'; // @brand-success
            }
            else {
                color = '#d96557'; // @brand-danger
            }
            if (moment().isBefore(event.from)) {
                element.css({ 'background-color': color, 'border-color': color });
            }
            else {
                element.css({ 'background-color': color, 'border-color': color, 'opacity': 0.7 });
            }
            _this.$compile(element)(_this.$scope);
        };
    }
    return AvailabilityCalendarController;
}());
exports.availabilityCalendarComponent = {
    controller: AvailabilityCalendarController,
    bindings: {
        employeeId: "<"
    },
    template: __webpack_require__(439)
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var employeeAvailability_service_1 = __webpack_require__(22);
var AvailabilityItemController = /** @class */ (function () {
    AvailabilityItemController.$inject = ["EmployeesService", "$stateParams", "$state", "$timeout", "SweetAlert", "$scope"];
    function AvailabilityItemController(EmployeesService, $stateParams, $state, $timeout, SweetAlert, $scope) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.SweetAlert = SweetAlert;
        this.$scope = $scope;
        this.$onInit = function () {
            // console.log('AvailabilityItemController onInit');
            _this.statuses = _this.resolve.statuses;
            _this.employeeId = _this.$stateParams["employeeId"];
            if (_this.$stateParams["availabilityId"]) {
                _this.EmployeesService.customGet('availability/' + _this.$stateParams["availabilityId"]).then(function (result) {
                    _this.availability = result;
                    // console.log(this.availability);
                    if (_this.availability) {
                        _this.availability.start = new Date(_this.availability.start);
                        _this.availability.end = new Date(_this.availability.end);
                    }
                });
            }
            else {
                _this.availability = new employeeAvailability_service_1.IEmployeeAvailability();
                _this.availability.start = _this.roundMinutes(new Date());
                _this.availability.end = moment(_this.availability.start).add(8, 'hour').toDate();
            }
        };
    }
    AvailabilityItemController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    AvailabilityItemController.prototype.submitAvailability = function () {
        var _this = this;
        this.$scope.availabilityForm.$setSubmitted();
        this.availability.start = moment(this.availability.start).format("YYYY-MM-DD HH:mm");
        this.availability.end = moment(this.availability.end).format("YYYY-MM-DD HH:mm");
        if (!this.availability.availabilityStatusId) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Vul een status in!',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                }
            });
        }
        else if (moment(this.availability.start).isAfter(this.availability.end)) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Eindtijd ligt voor starttijd!',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                }
            });
        }
        else {
            if (this.availability.id === undefined) {
                this.EmployeesService.customPost(this.employeeId + '/availability', this.availability).then(function (data) {
                    _this.closeModal();
                });
            }
            else {
                this.EmployeesService.customPut('availability/' + this.availability.id, this.availability).then(function (data) {
                    _this.closeModal();
                });
            }
        }
    };
    AvailabilityItemController.prototype.delete = function () {
        var _this = this;
        this.EmployeesService.customDelete('availability/' + this.availability.id).then(function () {
            _this.closeModal();
        });
    };
    AvailabilityItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 3 }, { reload: true });
    };
    return AvailabilityItemController;
}());
exports.availabilityItemComponent = {
    bindings: {
        resolve: '<'
    },
    controller: AvailabilityItemController,
    template: __webpack_require__(440)
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmployeesController = /** @class */ (function () {
    function EmployeesController() {
        'ngInject';
        // console.log('EmployeesController');
    }
    return EmployeesController;
}());
exports.employeesComponent = {
    controller: EmployeesController,
    template: __webpack_require__(441)
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EmployeesItemBasicController = /** @class */ (function () {
    EmployeesItemBasicController.$inject = ["EnumService", "EmployeesService", "SalaryScaleGroupService", "SalaryScaleService", "$state"];
    function EmployeesItemBasicController(EnumService, EmployeesService, SalaryScaleGroupService, SalaryScaleService, $state) {
        'ngInject';
        var _this = this;
        this.EnumService = EnumService;
        this.EmployeesService = EmployeesService;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.SalaryScaleService = SalaryScaleService;
        this.$state = $state;
        this.employeeSalaryScales = [];
        this.salaryScaleGroups = [];
        this.availableScalesByGroup = {};
        this.errorMessages = {};
        this.$onInit = function () {
            _this.employee = _this.resolve.employee;
            _this.functions = _this.resolve.functions;
            _this.transportationTypes = _this.resolve.transportationTypes;
            _this.salaryScales = _this.resolve.salaryScales;
            // Initialize altijd 3 lege schalen
            _this.initializeSalaryScales();
            if (_this.employee && _this.employee.id) {
                _this.loadEmployeeSalaryScales();
            }
            _this.loadSalaryScaleGroups();
        };
        this.initializeSalaryScales = function () {
            // Maak altijd 3 schalen aan (ook als leeg)
            _this.employeeSalaryScales = [];
            for (var i = 1; i <= 3; i++) {
                _this.employeeSalaryScales.push({
                    id: null,
                    employeeId: (_this.employee && _this.employee.id) || null,
                    salaryScaleId: null,
                    order: i - 1,
                    scaleNumber: i,
                    salaryScale: null,
                    newSalaryScaleGroupId: null,
                    newSalaryScaleId: null
                });
            }
        };
        this.loadEmployeeSalaryScales = function () {
            _this.EmployeesService.getSalaryScales(_this.employee.id).then(function (scales) {
                // Zorg dat er altijd 3 schalen zijn (1, 2, 3)
                var scalesMap = {};
                if (scales && scales.length > 0) {
                    scales.forEach(function (scale) {
                        if (scale.scaleNumber) {
                            scalesMap[scale.scaleNumber] = scale;
                        }
                    });
                }
                // Vul de array met bestaande schalen of lege schalen
                for (var i = 1; i <= 3; i++) {
                    if (scalesMap[i]) {
                        _this.employeeSalaryScales[i - 1] = __assign({}, scalesMap[i], { newSalaryScaleGroupId: null, newSalaryScaleId: null });
                    }
                    else {
                        // Zorg dat scaleNumber altijd is ingesteld
                        _this.employeeSalaryScales[i - 1] = {
                            id: null,
                            employeeId: _this.employee.id,
                            salaryScaleId: null,
                            order: i - 1,
                            scaleNumber: i,
                            salaryScale: null,
                            newSalaryScaleGroupId: null,
                            newSalaryScaleId: null
                        };
                    }
                }
            });
        };
        this.loadSalaryScaleGroups = function () {
            _this.SalaryScaleGroupService.all().then(function (groups) {
                _this.salaryScaleGroups = groups.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Load scales for each group
                _this.salaryScaleGroups.forEach(function (group) {
                    if (group.id) {
                        _this.SalaryScaleService.getBySalaryScaleGroupId(group.id).then(function (scales) {
                            _this.availableScalesByGroup[group.id] = scales;
                        });
                    }
                });
            });
        };
        this.onGroupChange = function (groupId, scaleNumber) {
            var scale = _this.employeeSalaryScales[scaleNumber - 1];
            scale.newSalaryScaleId = null;
            if (groupId && !_this.availableScalesByGroup[groupId]) {
                _this.SalaryScaleService.getBySalaryScaleGroupId(groupId).then(function (scales) {
                    _this.availableScalesByGroup[groupId] = scales;
                });
            }
        };
        this.getSalaryScaleGroupName = function (groupId) {
            if (!groupId || !_this.salaryScaleGroups || _this.salaryScaleGroups.length === 0) {
                return '';
            }
            var group = _this.salaryScaleGroups.find(function (g) { return g.id === groupId; });
            return group ? group.name : '';
        };
        this.getAvailableGroupsForScale = function (scaleNumber) {
            if (!_this.salaryScaleGroups || _this.salaryScaleGroups.length === 0) {
                return [];
            }
            // Haal de ingevulde CAO's op van andere schalen
            var usedGroupIds = _this.employeeSalaryScales
                .filter(function (es, index) { return index !== (scaleNumber - 1); }) // Exclude huidige schaal
                .filter(function (es) { return es.salaryScale && es.salaryScale.salaryScaleGroupId; })
                .map(function (es) { return es.salaryScale.salaryScaleGroupId; });
            return _this.salaryScaleGroups.filter(function (group) { return usedGroupIds.indexOf(group.id) === -1; });
        };
        this.addSalaryScale = function (scaleNumber) {
            _this.errorMessages[scaleNumber] = null;
            var scale = _this.employeeSalaryScales[scaleNumber - 1];
            if (!scale.newSalaryScaleGroupId || !scale.newSalaryScaleId) {
                _this.errorMessages[scaleNumber] = 'Selecteer zowel een CAO als een loonschaal';
                return;
            }
            // Check if group already exists in other scales
            var existingGroupIds = _this.employeeSalaryScales
                .filter(function (es, index) { return index !== (scaleNumber - 1); })
                .filter(function (es) { return es.salaryScale && es.salaryScale.salaryScaleGroupId; })
                .map(function (es) { return es.salaryScale.salaryScaleGroupId; });
            if (existingGroupIds.indexOf(scale.newSalaryScaleGroupId) !== -1) {
                _this.errorMessages[scaleNumber] = 'Deze CAO is al toegevoegd aan een andere schaal. Elke CAO kan slechts één keer worden toegevoegd.';
                return;
            }
            _this.EmployeesService.addSalaryScaleToScaleNumber(_this.employee.id, scale.newSalaryScaleId, scaleNumber).then(function () {
                _this.loadEmployeeSalaryScales();
                scale.newSalaryScaleGroupId = null;
                scale.newSalaryScaleId = null;
                _this.errorMessages[scaleNumber] = null;
            }).catch(function (error) {
                _this.errorMessages[scaleNumber] = error.data || error.message || 'Fout bij toevoegen salary scale';
            });
        };
        this.removeSalaryScale = function (scaleNumber) {
            _this.EmployeesService.removeSalaryScaleFromScaleNumber(_this.employee.id, scaleNumber).then(function () {
                _this.loadEmployeeSalaryScales();
            }).catch(function (error) {
                _this.errorMessages[scaleNumber] = error.data || error.message || 'Fout bij verwijderen salary scale';
            });
        };
        this.save = function () {
            _this.employee.userName = _this.employee.emailPrivate;
            if (_this.employee.id != undefined) {
                _this.EmployeesService.put(_this.employee.id, _this.employee).then(function (employee) {
                    _this.closeModal();
                });
            }
            else {
                _this.EmployeesService.post(_this.employee).then(function (employee) {
                    _this.$state.go('^', { 'id': employee.id });
                });
            }
        };
    }
    EmployeesItemBasicController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return EmployeesItemBasicController;
}());
exports.employeesItemBasicComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: EmployeesItemBasicController,
    template: __webpack_require__(442)
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var EmployeesItemController = /** @class */ (function () {
    EmployeesItemController.$inject = ["EmployeesService", "$stateParams", "$state", "NotesService", "NmbrsService", "AuthService", "SweetAlert", "MasterdataAService", "$filter", "SalaryScaleGroupService"];
    function EmployeesItemController(EmployeesService, $stateParams, $state, NotesService, NmbrsService, AuthService, SweetAlert, MasterdataAService, $filter, SalaryScaleGroupService) {
        'ngInject';
        var _this = this;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.NotesService = NotesService;
        this.NmbrsService = NmbrsService;
        this.AuthService = AuthService;
        this.SweetAlert = SweetAlert;
        this.MasterdataAService = MasterdataAService;
        this.$filter = $filter;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.$onInit = function () {
            if (_this.AuthService.hasRole("finance")) {
                _this.activeTabIndex = 0;
            }
            else {
                _this.activeTabIndex = 1;
            }
            if (_this.$stateParams['tab']) {
                _this.activeTabIndex = _this.$stateParams['tab'];
            }
            if (_this.employee && _this.employee.nmbrsId) {
                _this.NmbrsService.customGet('employee/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployee = result;
                }));
                _this.NmbrsService.customGet('employeeAddress/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployeeAddress = result[0];
                }));
                _this.NmbrsService.customGet('employeeBankAccount/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployeeBankAccount = result[0];
                }));
                _this.NmbrsService.customGet('employeeFunction/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployeeFunction = result;
                }));
                _this.NmbrsService.customGet('employeeSalary/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployeeSalary = result;
                }));
                _this.NmbrsService.customGet('employeeContract/' + _this.employee.nmbrsId).then((function (result) {
                    _this.nmbrsEmployeeContract = result.employeeContracts[0];
                }));
            }
            _this.MasterdataAService.getItems('NoteTags').then(function (res) {
                _this.tags = res;
            });
            _this.filterNotes();
            // Load employee salary scales
            if (_this.employee && _this.employee.id) {
                _this.loadEmployeeSalaryScales();
            }
            // Load salary scale groups
            _this.loadSalaryScaleGroups();
        };
        this.loadEmployeeSalaryScales = function () {
            _this.employeesService.getSalaryScales(_this.employee.id).then(function (scales) {
                _this.employeeSalaryScales = scales || [];
            });
        };
        this.loadSalaryScaleGroups = function () {
            _this.SalaryScaleGroupService.all().then(function (groups) {
                _this.salaryScaleGroups = groups || [];
            });
        };
        this.getSalaryScaleGroupName = function (groupId) {
            if (!_this.salaryScaleGroups || !groupId)
                return '';
            for (var i = 0; i < _this.salaryScaleGroups.length; i++) {
                if (_this.salaryScaleGroups[i].id === groupId) {
                    return _this.salaryScaleGroups[i].name;
                }
            }
            return '';
        };
        this.notesService = NotesService;
        this.employeesService = EmployeesService;
        this.employeeId = $stateParams['employeeId'];
        angular.element(document).ready(function () {
            $('#notes-table').dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }
    EmployeesItemController.prototype.filterNotes = function () {
        var _this = this;
        this.filteredNotes = this.$filter('filter')(this.notes, function (note) {
            if (!!_this.selectedTag) {
                return note.tags.indexOf(_this.selectedTag) !== -1;
            }
            else {
                return true;
            }
        });
    };
    EmployeesItemController.prototype.submitEmployee = function () {
        if (this.employee.id == null) {
            this.saveEmployee();
        }
        else {
            this.employeesService.put(this.employee.id, this.employee);
        }
    };
    EmployeesItemController.prototype.saveEmployee = function () {
        var _this = this;
        this.employeesService.post(this.employee).then(function (result) {
            _this.$state.go('hr.employees.item', { 'id': result.id });
        });
    };
    EmployeesItemController.prototype.deleteEmployee = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze medewerker wilt verwijderen?\n Diensten en declaraties van de medewerker blijven onveranderd!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.employee.inactive = true;
                _this.employeesService.put(_this.employee.id, _this.employee);
                _this.$state.go('^.list').then(function () { _this.$state.reload(); });
            }
            else {
            }
        });
    };
    EmployeesItemController.prototype.restoreEmployee = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u de medewerker wilt herstellen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.employee.inactive = false;
                _this.employeesService.put(_this.employee.id, _this.employee);
                _this.$state.reload();
            }
            else {
            }
        });
    };
    EmployeesItemController.prototype.addNoteModal = function () {
        this.currentNote = null;
        $('#noteModal').modal('show');
    };
    EmployeesItemController.prototype.updateNoteModal = function (item) {
        this.currentNote = item;
        $('#noteModal').modal('show');
    };
    EmployeesItemController.prototype.submitNote = function (item) {
        var _this = this;
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.employeeId = this.employee.id;
        if (newNote.id == null) {
            this.notesService.post(newNote).then(function (result) {
                _this.notes.unshift(result);
            });
        }
        else {
            this.notesService.put(newNote.id, newNote);
        }
        $('#noteModal').modal('hide');
    };
    EmployeesItemController.prototype.deleteNote = function (item) {
        this.notes = this.notes.filter(function (note) { return note.id !== item.id; });
        this.notesService.delete(item.id);
    };
    EmployeesItemController.prototype.updateNote = function (item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    };
    EmployeesItemController.prototype.refreshEmployeeNmbrs = function () {
        var _this = this;
        this.employeesService.refresh(this.employee.id).then(function () {
            _this.$state.reload();
        });
    };
    EmployeesItemController.prototype.copyGuid = function () {
        window.navigator['clipboard'].writeText(this.employee.id);
        alert("De Guid van " + this.employee.displayName + "is gekopieerd");
    };
    return EmployeesItemController;
}());
exports.employeesItemComponent = {
    bindings: {
        notes: '<',
        userAccount: '<',
        employee: '<',
        history: '<',
        employeeSkills: '<',
        functions: '<'
    },
    controller: EmployeesItemController,
    template: __webpack_require__(443)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var EmployeesListController = /** @class */ (function () {
    EmployeesListController.$inject = ["EmployeesService", "EnumService", "$stateParams", "$scope", "$filter", "$state", "TwinfieldService"];
    function EmployeesListController(EmployeesService, EnumService, $stateParams, $scope, $filter, $state, TwinfieldService) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.EnumService = EnumService;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$state = $state;
        this.TwinfieldService = TwinfieldService;
        this.sortReverse = false;
        this.$onInit = function () {
            /** Set return URI */
            _this.TwinfieldService.setTwinfieldRedirectUri();
            _this.currentPage = 1;
            _this.itemsPerPage = 11;
            _this.getEmployees();
            // this.$scope.$watch(() => {
            //     return this.filteredEmployees;
            // }, () => {
            //     this.emailToClipboard();
            // });
        };
        this.onCopySuccess = function (e) {
            alert('Gegevens gekopieerd naar plakbord!');
        };
        this.getEmployees = function () {
            if (_this.statusFilter === 'inactive') {
                _this.EmployeesService.getEmployeesByStatus(false).then(function (res) {
                    _this.employees = res;
                    _this.applyFilters();
                });
            }
            else {
                _this.EmployeesService.getEmployeesByStatus().then(function (res) {
                    _this.employees = res;
                    _this.applyFilters();
                });
            }
        };
        //console.log(EnumService);
        this.sortType = 'displayName';
        //console.log('EmployeesListController');
    }
    EmployeesListController.prototype.applyFilters = function () {
        console.log(this.sortType);
        this.filteredEmployees = this.$filter('filter')(this.employees, this.tag);
        this.filteredEmployees = this.$filter('filterBy')(this.filteredEmployees, ['displayName', 'functionName', 'homeAddressCity'], this.search);
        this.filteredEmployees = this.$filter('orderBy')(this.filteredEmployees, this.sortType);
        if (this.accountingFilter === 'nmbrs') {
            this.filteredEmployees = this.filteredEmployees.filter(function (e) { return e.nmbrsId; });
        }
        if (this.accountingFilter === 'zzp') {
            this.filteredEmployees = this.filteredEmployees.filter(function (e) { return !e.nmbrsId; });
        }
        // ($ctrl.employees | filter: $ctrl.tag | filterBy : ['displayName', 'functionName', 'emailPrivate']: $ctrl.search | orderBy:$ctrl.sortType:sortReverse)
        this.emailToClipboard();
    };
    EmployeesListController.prototype.emailToClipboard = function () {
        if (this.filteredEmployees.length > 0) {
            var emailsList = [];
            this.filteredEmployees.forEach(function (e, i) {
                if (e.emailPrivate) {
                    emailsList.push(e.emailPrivate);
                }
            });
            this.emailaddresses = emailsList.join(';');
        }
        //console.log(emailsList.join(';'));
        //window.prompt("Ctrl+C to copy to clipboard, then paste in the BCC field of an email:", emailsList.join(';'));
    };
    EmployeesListController.prototype.refreshEmployeesNmbrs = function () {
        var _this = this;
        $('#notificationModal').modal('show');
        this.inProgress = true;
        this.EmployeesService.refreshAll().then(function () {
            $('#notificationModal').modal('hide');
            _this.inProgress = false;
            _this.$state.reload();
        });
    };
    return EmployeesListController;
}());
exports.employeesListComponent = {
    bindings: {},
    controller: EmployeesListController,
    template: __webpack_require__(444)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HrController = /** @class */ (function () {
    function HrController() {
        // console.log('HrController');
    }
    HrController.$inject = [];
    return HrController;
}());
exports.hrComponent = {
    controller: HrController,
    template: __webpack_require__(446)
};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HrDashboardController = /** @class */ (function () {
    function HrDashboardController() {
        'ngInject';
    }
    return HrDashboardController;
}());
exports.hrDashboardComponent = {
    controller: HrDashboardController,
    template: __webpack_require__(445)
};


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var employeeSkills_service_1 = __webpack_require__(264);
var employees_item_component_1 = __webpack_require__(621);
var employees_list_component_1 = __webpack_require__(622);
var employees_component_1 = __webpack_require__(619);
var hr_dashboard_component_1 = __webpack_require__(624);
var hr_component_1 = __webpack_require__(623);
var hr_states_1 = __webpack_require__(260);
var hr_states_2 = __webpack_require__(260);
var ngmodule_1 = __webpack_require__(4);
var index_1 = __webpack_require__(7);
var salaryScaleGroup_service_1 = __webpack_require__(24);
var employees_item_basic_component_1 = __webpack_require__(620);
var shifts_list_component_1 = __webpack_require__(628);
var shifts_item_component_1 = __webpack_require__(627);
var availability_calendar_component_1 = __webpack_require__(617);
var availability_item_component_1 = __webpack_require__(618);
var skills_list_component_1 = __webpack_require__(630);
var skills_item_component_1 = __webpack_require__(629);
var uploader_component_1 = __webpack_require__(675);
var nmbrs_component_1 = __webpack_require__(626);
var availabilityList_component_1 = __webpack_require__(616);
var applicants_item_component_1 = __webpack_require__(613);
var applicants_list_component_1 = __webpack_require__(615);
var applicants_component_1 = __webpack_require__(611);
var applicants_item_basic_component_1 = __webpack_require__(612);
var applicants_item_employee_component_1 = __webpack_require__(614);
var hrAppModule = {
    components: { hrComponent: hr_component_1.hrComponent, hrDashboardComponent: hr_dashboard_component_1.hrDashboardComponent,
        employeesComponent: employees_component_1.employeesComponent, employeesListComponent: employees_list_component_1.employeesListComponent, employeesItemComponent: employees_item_component_1.employeesItemComponent,
        employeesItemBasicComponent: employees_item_basic_component_1.employeesItemBasicComponent, shiftsListComponent: shifts_list_component_1.shiftsListComponent, shiftsItemComponent: shifts_item_component_1.shiftsItemComponent,
        availabilityCalendarComponent: availability_calendar_component_1.availabilityCalendarComponent, availabilityItemComponent: availability_item_component_1.availabilityItemComponent,
        skillsListComponent: skills_list_component_1.skillsListComponent, skillsItemComponent: skills_item_component_1.skillsItemComponent, uploaderComponent: uploader_component_1.uploaderComponent,
        nmbrsComponent: nmbrs_component_1.nmbrsComponent,
        availabilityListComponent: availabilityList_component_1.availabilityListComponent,
        applicantsComponent: applicants_component_1.applicantsComponent, applicantsListComponent: applicants_list_component_1.applicantsListComponent, applicantsItemComponent: applicants_item_component_1.applicantsItemComponent, applicantsItemBasicComponent: applicants_item_basic_component_1.applicantsItemBasicComponent, applicantsItemEmployeeComponent: applicants_item_employee_component_1.applicantsItemEmployeeComponent
    },
    states: [hr_states_1.hrState, hr_states_1.hrDashboardState,
        hr_states_1.employeesState, hr_states_1.employeesListState, hr_states_1.employeesItemState,
        hr_states_2.employeesItemBasicState, hr_states_2.shiftsItemState, hr_states_2.availabilityItemState,
        hr_states_2.skillsItemState,
        hr_states_1.availabilityListState,
        hr_states_1.applicantsState, hr_states_1.applicantsListState, hr_states_1.applicantsItemState, hr_states_1.applicantsItemBasicState, hr_states_1.applicantsItemEmployeeState, hr_states_1.applicantsArchiveState, hr_states_1.applicantsArchiveItemState, hr_states_1.applicantsArchiveItemBasicState
    ],
    services: { EmployeesService: index_1.EmployeesService, ShiftService: index_1.ShiftService, DeclarationService: index_1.DeclarationService, EmployeeSkillsService: employeeSkills_service_1.EmployeeSkillsService, NmbrsService: index_1.NmbrsService, ApplicantsService: index_1.ApplicantsService, ApplicantStatusHistoryService: index_1.ApplicantStatusHistoryService, SalaryScaleGroupService: salaryScaleGroup_service_1.SalaryScaleGroupService, SalaryScaleService: salaryScaleGroup_service_1.SalaryScaleService }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, hrAppModule);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(6);
var NmbrsController = /** @class */ (function () {
    function NmbrsController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.activeTabIndex = 0;
        };
        this.$onChange = function () {
            if (_this.nmbrsEmployeeFunction) {
                _this.function = _.find(_this.functions, { code: _this.nmbrsEmployeeFunction.code });
            }
        };
    }
    return NmbrsController;
}());
exports.nmbrsComponent = {
    bindings: {
        nmbrsEmployee: "<",
        nmbrsEmployeeAddress: "<",
        nmbrsEmployeeBankAccount: "<",
        nmbrsEmployeeFunction: "<",
        nmbrsEmployeeSalary: "<",
        nmbrsEmployeeContract: "<",
        functions: "<"
    },
    controller: NmbrsController,
    template: __webpack_require__(447)
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var _ = __webpack_require__(6);
var moment = __webpack_require__(0);
var ShiftsItemController = /** @class */ (function () {
    ShiftsItemController.$inject = ["ShiftService", "$state", "$stateParams"];
    function ShiftsItemController(ShiftService, $state, $stateParams) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.employee = _this.resolve.employee;
            var shiftId = _this.$stateParams['shiftId'];
            if (shiftId != '') {
                _this.shift = _.find(_this.resolve.shifts, { "id": shiftId });
            }
            else {
                _this.shift = new index_1.IShift();
            }
        };
    }
    ShiftsItemController.prototype.startDateBeforeRender = function ($dates) {
        // console.log('startDateBeforeRender');
        var todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    };
    ShiftsItemController.prototype.endDateBeforeRender = function ($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    ShiftsItemController.prototype.submitShift = function () {
        var _this = this;
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.id === undefined) {
            this.shift.employeeId = this.employee.id;
            this.ShiftService.post(this.shift).then(function (data) {
                _this.closeModal();
            });
        }
        else {
            this.ShiftService.put(this.shift.id, this.shift).then(function (data) {
                _this.closeModal();
            });
        }
    };
    ShiftsItemController.prototype.delete = function () {
        var _this = this;
        this.ShiftService.delete(this.shift.id).then(function (data) {
            _this.closeModal();
        });
    };
    ShiftsItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 0 }, { reload: true });
    };
    return ShiftsItemController;
}());
exports.shiftsItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: ShiftsItemController,
    template: __webpack_require__(448)
};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ShiftsListController = /** @class */ (function () {
    function ShiftsListController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.currentPage = 1;
            _this.itemsPerPage = 12;
        };
        this.$onChanges = function () {
        };
    }
    ShiftsListController.prototype.parseDate = function (item) {
        var date = new Date(item.start);
        return date;
    };
    return ShiftsListController;
}());
exports.shiftsListComponent = {
    bindings: {
        history: "<"
    },
    controller: ShiftsListController,
    template: __webpack_require__(449)
};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var moment = __webpack_require__(0);
var SkillsItemController = /** @class */ (function () {
    SkillsItemController.$inject = ["EmployeeSkillsService", "$state", "$stateParams", "FileSaver"];
    function SkillsItemController(EmployeeSkillsService, $state, $stateParams, FileSaver) {
        'ngInject';
        var _this = this;
        this.EmployeeSkillsService = EmployeeSkillsService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.FileSaver = FileSaver;
        this.$onInit = function () {
            _this.employee = _this.resolve.employee;
            _this.skills = _this.resolve.skills;
            if (_this.$stateParams['employeeSkillId']) {
                _this.employeeSkill = _this.resolve.employeeSkills.find(function (s) { return s.id == _this.$stateParams['employeeSkillId']; });
                _this.getFiles(_this.$stateParams['employeeSkillId']);
            }
            else {
                _this.employeeSkill = new index_1.IEmployeeSkill();
            }
        };
        this.postFile = function (id) {
            return _this.EmployeeSkillsService.postBlob(id, _this.uploadfile);
        };
        this.getFiles = function (id) {
            _this.EmployeeSkillsService.getBlobs(id).then(function (files) {
                _this.file = files.value[files.value.length - 1];
            });
        };
        this.downloadFile = function (id) {
            _this.EmployeeSkillsService.getBlob(_this.employeeSkill.id, id).then(function (blob) {
                _this.FileSaver.saveAs(blob, _this.file.filenameWithExtention);
            });
        };
    }
    SkillsItemController.prototype.startDateBeforeRender = function ($dates) {
    };
    SkillsItemController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.employeeSkill.start) {
            var activeDate = moment(this.employeeSkill.start).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    SkillsItemController.prototype.startDateSelected = function () {
        this.employeeSkill.end = moment(this.employeeSkill.start).add(1, 'year').toDate();
    };
    SkillsItemController.prototype.submitSkill = function () {
        var _this = this;
        this.employeeSkill.start = moment(this.employeeSkill.start).format("YYYY-MM-DD HH:mm");
        this.employeeSkill.end = moment(this.employeeSkill.end).format("YYYY-MM-DD HH:mm");
        if (this.employeeSkill.id === undefined) {
            if (this.employee) {
                this.employeeSkill.employeeId = this.employee.id;
            }
            this.EmployeeSkillsService.post(this.employeeSkill).then(function (data) {
                if (_this.uploadfile) {
                    _this.postFile(data.id).then(function () {
                        _this.closeModal();
                    });
                }
                else {
                    _this.closeModal();
                }
            });
        }
        else {
            this.EmployeeSkillsService.put(this.employeeSkill.id, this.employeeSkill).then(function (data) {
                if (_this.uploadfile) {
                    _this.postFile(data.id).then(function () {
                        _this.closeModal();
                    });
                }
                else {
                    _this.closeModal();
                }
            });
        }
    };
    SkillsItemController.prototype.delete = function () {
        var _this = this;
        this.EmployeeSkillsService.delete(this.employeeSkill.id).then(function (data) {
            _this.closeModal();
        });
    };
    SkillsItemController.prototype.closeModal = function () {
        this.$state.go('^', { tab: 4 }, { reload: true });
    };
    return SkillsItemController;
}());
exports.skillsItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: SkillsItemController,
    template: __webpack_require__(450)
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SkillsListController = /** @class */ (function () {
    function SkillsListController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            _this.currentPage = 1;
            _this.itemsPerPage = 12;
        };
        this.$onChanges = function () {
        };
    }
    SkillsListController.prototype.parseDate = function (item) {
        var date = new Date(item.start);
        return date;
    };
    return SkillsListController;
}());
exports.skillsListComponent = {
    bindings: {
        employeeSkills: "<"
    },
    controller: SkillsListController,
    template: __webpack_require__(451)
};


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var note_component_1 = __webpack_require__(632);
var note_list_component_1 = __webpack_require__(633);
var notes_states_1 = __webpack_require__(634);
// import { noteItemComponent } from "./note.item.component";
// import { noteItemBasicComponent } from "./note.item.basic.component";
// import { noteArchiveComponent } from "./note.archive.component";
var subscriptionAppModule = {
    components: {
        noteComponent: note_component_1.noteComponent,
        noteListComponent: note_list_component_1.noteListComponent
        // , noteItemComponent
        // , noteItemBasicComponent
        // , noteArchiveComponent
    },
    states: [notes_states_1.noteState, notes_states_1.noteListState, notes_states_1.noteItemState, notes_states_1.noteItemBasicState
        // , noteArchiveState
    ],
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, subscriptionAppModule);


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NoteController = /** @class */ (function () {
    function NoteController() {
        'ngInject';
    }
    return NoteController;
}());
exports.noteComponent = {
    controller: NoteController,
    template: __webpack_require__(452)
};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NoteListController = /** @class */ (function () {
    NoteListController.$inject = ["$filter", "NotesService"];
    function NoteListController($filter, NotesService) {
        'ngInject';
        var _this = this;
        this.$filter = $filter;
        this.NotesService = NotesService;
        this.$onInit = function () {
            _this.sortType = 'createdOn';
            _this.filter();
        };
        this.notesService = NotesService;
    }
    NoteListController.prototype.filter = function () {
        var _this = this;
        this.filteredNotes = this.$filter('filter')(this.notes, function (note) {
            if (!!_this.selectedTag) {
                return note.tags.indexOf(_this.selectedTag) !== -1;
            }
            else {
                return true;
            }
        });
    };
    NoteListController.prototype.getNoteAuthorName = function (note) {
        if (note.accountName)
            return note.accountName;
        if (note.employeeDisplayName)
            return note.employeeDisplayName;
        if (note.applicantName)
            return note.applicantName;
        return '';
    };
    return NoteListController;
}());
exports.noteListComponent = {
    bindings: {
        notes: '<',
        noteTags: '<'
    },
    controller: NoteListController,
    template: __webpack_require__(453)
};


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.noteState = {
    parent: 'app',
    name: "notes",
    url: "/notes",
    component: 'noteComponent',
    redirectTo: "notes.list",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.noteListState = {
    name: "notes.list",
    url: "/list",
    resolve: {
        notes: ["NotesService", function (NotesService) {
            "ngInject";
            return NotesService.all().then(function (notes) { return notes.filter(function (note) { return !note.applicantId; }); });
        }],
        noteTags: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('NoteTags');
        }]
    },
    views: {
        "main": 'noteListComponent'
    },
};
exports.noteItemState = {
    name: "notes.item",
    url: "/:id",
    params: {
        "isArchive": null
    },
    resolve: {
        note: ["NotesService", "$stateParams", function (NotesService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return NotesService.get($stateParams['id']);
            }
        }]
    },
    views: {
        "main": 'noteItemComponent'
    }
};
exports.noteItemBasicState = {
    name: "notes.item.basic",
    url: "/basic",
    modal: ['note'],
    resolve: {
        // users: (EmployeesService: EmployeesService) => { 'ngInject'; return EmployeesService.gatBackoffice(); },
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        // contacts: (ContactsService: ContactsService) => { 'ngInject'; return ContactsService.all(); }, 
        employees: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
    },
    component: 'noteItemBasicComponent'
};
// export const noteArchiveState: aboTheme.IState = {
//     name: "notes.archive",
//     url: "/archive",
//     resolve: {
//         notes: (NotesService: NotesService) => { "ngInject"; return NotesService.getArchive(); },
//     },
//     views: {
//         "main": 'noteArchiveComponent'
//     },
// }; 


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var quotations_states_1 = __webpack_require__(640);
var quotations_component_1 = __webpack_require__(637);
var quotations_dashboard_component_1 = __webpack_require__(639);
var ngmodule_1 = __webpack_require__(4);
var index_1 = __webpack_require__(7);
var invoiceDetails_component_1 = __webpack_require__(636);
var quotations_cootje_component_1 = __webpack_require__(638);
var cootje_service_1 = __webpack_require__(263);
var quotationsAppModule = {
    components: { quotationsComponent: quotations_component_1.quotationsComponent, quotationsDashboardComponent: quotations_dashboard_component_1.quotationsDashboardComponent, invoiceDetailsComponent: invoiceDetails_component_1.invoiceDetailsComponent, quotationsCootjeComponent: quotations_cootje_component_1.quotationsCootjeComponent },
    states: [quotations_states_1.quotationsState, quotations_states_1.quotationDashboardState, quotations_states_1.quotationProformaState, quotations_states_1.quotationCootjeState],
    services: { InvoicesService: index_1.InvoicesService, TwinfieldService: index_1.TwinfieldService, CootjeService: cootje_service_1.CootjeService }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, quotationsAppModule);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InvoiceDetailsController = /** @class */ (function () {
    InvoiceDetailsController.$inject = ["$state"];
    function InvoiceDetailsController($state) {
        'ngInject';
        this.$state = $state;
        // console.log('InvoiceDetailController');
    }
    InvoiceDetailsController.prototype.deleteInvoice = function () {
        // console.log('delete invoice');
        this.onUpdate({ action: 'delete' });
    };
    InvoiceDetailsController.prototype.sendToTwinfield = function () {
        // console.log('sendToTwinfield');
        this.onUpdate({ action: 'send' });
    };
    return InvoiceDetailsController;
}());
exports.invoiceDetailsComponent = {
    bindings: {
        invoice: '<',
        proformaInvoicesOnly: '<',
        onUpdate: '&'
    },
    controller: InvoiceDetailsController,
    template: __webpack_require__(454)
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuotationsController = /** @class */ (function () {
    function QuotationsController() {
        'ngInject';
    }
    return QuotationsController;
}());
exports.quotationsComponent = {
    controller: QuotationsController,
    template: __webpack_require__(457)
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var QuotationsCootjeController = /** @class */ (function () {
    QuotationsCootjeController.$inject = ["CootjeService", "$stateParams", "$scope"];
    function QuotationsCootjeController(CootjeService, $stateParams, $scope) {
        'ngInject';
        var _this = this;
        this.CootjeService = CootjeService;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.loading = false;
        this.hasKM = false;
        this.$onInit = function () {
            /** Set return URI */
            // this.TwinfieldService.setTwinfieldRedirectUri();
            // this.proformaInvoicesOnly = this.$stateParams['proformaInvoicesOnly'];
            _this.sortType = 'account.name';
            _this.moment = __webpack_require__(0);
            _this.startDate = _this.moment().startOf('isoweek').toDate();
            _this.endDate = _this.moment().endOf('isoweek').toDate();
            _this.getCootje();
        };
    }
    QuotationsCootjeController.prototype.startDateBeforeRender = function ($dates) {
    };
    QuotationsCootjeController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    QuotationsCootjeController.prototype.prevWeek = function () {
        this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
    };
    QuotationsCootjeController.prototype.nextWeek = function () {
        this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
    };
    QuotationsCootjeController.prototype.getCootje = function () {
        var _this = this;
        this.CootjeService.customGet('', { from: this.startDate, till: this.endDate }).then(function (result) {
            _this.list = result;
            if (_this.currentItem) {
                _this.selectInvoice(_this.list.find(function (i) { return i.employeeId == _this.currentItem.employeeId; }));
            }
        });
    };
    QuotationsCootjeController.prototype.selectInvoice = function (item) {
        var _this = this;
        this.currentItem = item;
        this.hasKM = false;
        this.currentItem.diensten.forEach(function (dienst) {
            dienst.declarations.forEach(function (declaration) {
                if (declaration.registrationType == 2) {
                    _this.hasKM = true;
                }
            });
        });
    };
    QuotationsCootjeController.prototype.sendCootje = function () {
        var _this = this;
        this.loading = true;
        $('#sendToCootjeModal').modal('show');
        console.log(this.currentItem);
        this.CootjeService.sendToCootje(this.currentItem.diensten).then(function (result) {
            _this.repport = { 'failCount': 0, 'successCount': 0, 'fail': [], 'success': [] };
            console.log(result.message);
            _this.repport.failCount = result.message.fail != null ? result.message.fail.length : 0;
            _this.repport.successCount = result.message.succes != null ? result.message.succes.length : 0;
            _this.repport.fail = result.message.fail;
            _this.repport.fail.forEach(function (fail) {
                fail.shift = _this.currentItem.diensten.find(function (i) { return i.shiftId == fail.dienstGUID; }).shift;
            });
            _this.repport.success = result.message.succes;
            _this.repport.success.forEach(function (success) {
                success.shift = _this.currentItem.diensten.find(function (i) { return i.shiftId == success.dienstGUID; }).shift;
            });
            _this.getCootje();
            _this.loading = false;
        });
    };
    return QuotationsCootjeController;
}());
exports.quotationsCootjeComponent = {
    controller: QuotationsCootjeController,
    template: __webpack_require__(455)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var QuotationsDashboardController = /** @class */ (function () {
    QuotationsDashboardController.$inject = ["InvoicesService", "$stateParams", "$scope", "TwinfieldService"];
    function QuotationsDashboardController(InvoicesService, $stateParams, $scope, TwinfieldService) {
        'ngInject';
        var _this = this;
        this.InvoicesService = InvoicesService;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.TwinfieldService = TwinfieldService;
        this.$onInit = function () {
            /** Set return URI */
            _this.TwinfieldService.setTwinfieldRedirectUri();
            _this.proformaInvoicesOnly = _this.$stateParams['proformaInvoicesOnly'];
            _this.sortType = 'account.name';
            _this.moment = __webpack_require__(0);
            _this.startDate = _this.moment().startOf('isoweek').toDate();
            _this.endDate = _this.moment().endOf('isoweek').toDate();
            if (_this.proformaInvoicesOnly) {
                _this.getInvoices();
            }
        };
    }
    QuotationsDashboardController.prototype.startDateBeforeRender = function ($dates) {
    };
    QuotationsDashboardController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    QuotationsDashboardController.prototype.prevWeek = function () {
        this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
    };
    QuotationsDashboardController.prototype.nextWeek = function () {
        this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
    };
    QuotationsDashboardController.prototype.getInvoices = function () {
        var _this = this;
        this.InvoicesService.customGet('makeinvoices', { from: this.startDate, till: this.endDate, proformaInvoicesOnly: this.proformaInvoicesOnly }).then(function (result) {
            _this.invoices = result;
            _this.checkForUnpaid();
            _this.getTotalAmount();
        });
    };
    QuotationsDashboardController.prototype.selectInvoice = function (item) {
        this.currentInvoice = item;
    };
    QuotationsDashboardController.prototype.checkForUnpaid = function () {
        this.invoices.forEach(function (invoice) {
            invoice.lines.forEach(function (line) {
                if (line.count > 0 && (line.totalAmount == 0 || line.totalAmount == undefined || line.amountPerUnit == 0 || line.amountPerUnit == undefined)) {
                    invoice.hasUnpaid = true;
                }
            });
        });
    };
    QuotationsDashboardController.prototype.getTotalAmount = function () {
        var _this = this;
        this.invoicesTotalAmount = 0;
        this.twinfieldTotalAmount = 0;
        this.invoices.forEach(function (i) {
            _this.invoicesTotalAmount += i.totalAmount;
            if (i.twinfieldNumber) {
                _this.twinfieldTotalAmount += i.totalAmount;
            }
        });
    };
    QuotationsDashboardController.prototype.updateInvoice = function (action) {
        var _this = this;
        switch (action) {
            case 'delete': {
                this.InvoicesService.delete(this.currentInvoice.id).then(function () {
                    _this.invoices = _this.invoices.filter(function (i) { return i.id != _this.currentInvoice.id; });
                    _this.currentInvoice = null;
                });
                break;
            }
            case 'send': {
                this.InvoicesService.customPost(this.currentInvoice.id + '/send', null).then(function (data) {
                    //this.currentInvoice = data;
                    _.find(_this.invoices, { "id": _this.currentInvoice.id }).twinfieldNumber = data.twinfieldNumber;
                });
                break;
            }
        }
    };
    return QuotationsDashboardController;
}());
exports.quotationsDashboardComponent = {
    controller: QuotationsDashboardController,
    template: __webpack_require__(456)
};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.quotationsState = {
    parent: "app",
    name: "quotations",
    url: "/quotations",
    redirectTo: "quotations.proforma",
    component: "quotationsComponent",
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'schedule'
        }
    }
};
exports.quotationProformaState = {
    name: "quotations.proforma",
    url: "/proforma",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};
exports.quotationCootjeState = {
    name: "quotations.cootje",
    url: "/cootje",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsCootjeComponent'
    }
};
exports.quotationDashboardState = {
    name: "quotations.dashboard",
    url: "/dashboard",
    params: {
        proformaInvoicesOnly: false
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var schedule_declaration_component_1 = __webpack_require__(644);
var schedule_item_component_1 = __webpack_require__(645);
var ngmodule_1 = __webpack_require__(4);
var schedule_states_1 = __webpack_require__(647);
var schedule_component_1 = __webpack_require__(643);
var schedule_calendar_component_1 = __webpack_require__(642);
var schedule_list_component_1 = __webpack_require__(646);
var subscription_component_1 = __webpack_require__(648);
var scheduleAppModule = {
    components: { scheduleComponent: schedule_component_1.scheduleComponent, scheduleCalendarComponent: schedule_calendar_component_1.scheduleCalendarComponent, scheduleListComponent: schedule_list_component_1.scheduleListComponent, subscriptionItemComponent: subscription_component_1.subscriptionItemComponent, scheduleItemComponent: schedule_item_component_1.scheduleItemComponent, scheduleDeclarationComponent: schedule_declaration_component_1.scheduleDeclarationComponent },
    states: [schedule_states_1.scheduleState, schedule_states_1.scheduleCalendarState, schedule_states_1.scheduleListState,
        schedule_states_1.scheduleDeclarationState, schedule_states_1.scheduleAvailabilityState, schedule_states_1.scheduleSubscriptionState,
        schedule_states_1.scheduleShiftItemState, schedule_states_1.scheduleListItemState, schedule_states_1.scheduleListItemDeclarationState],
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, scheduleAppModule);


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var calendar_service_1 = __webpack_require__(18);
var ScheduleCalendarController = /** @class */ (function () {
    ScheduleCalendarController.$inject = ["CalendarService", "AuthService", "ShiftService", "$state", "uiCalendarConfig", "$scope", "$compile", "$sce", "screenSize"];
    function ScheduleCalendarController(CalendarService, AuthService, ShiftService, $state, uiCalendarConfig, $scope, $compile, $sce, screenSize) {
        "ngInject";
        var _this = this;
        this.CalendarService = CalendarService;
        this.AuthService = AuthService;
        this.ShiftService = ShiftService;
        this.$state = $state;
        this.uiCalendarConfig = uiCalendarConfig;
        this.$scope = $scope;
        this.$compile = $compile;
        this.$sce = $sce;
        this.screenSize = screenSize;
        this.eventSources = [];
        this.$onInit = function () {
            // this.employeeId = this.AuthService.getEmployeeId(this.AuthService.GetAuthorizationData());
            _this.eventSources = [_this.getEvents];
            _this.uiConfig = {
                calendar: {
                    height: 700,
                    locale: 'nl',
                    header: {
                        left: 'title',
                        right: ' prev,next month,agendaWeek,agendaDay'
                    },
                    buttonIcons: {
                        prev: ' fa fa-caret-left',
                        next: ' fa fa-caret-right',
                    },
                    displayEventEnd: false,
                    axisFormat: 'h:mm',
                    allDaySlot: false,
                    timeFormat: 'H:mm',
                    eventLimit: false,
                    eventClick: _this.openItem,
                    //eventDrop: $scope.alertOnDrop,
                    //eventResize: $scope.alertOnResize,
                    eventRender: _this.eventRender
                }
            };
            _this.ShiftService.subscribe('ScheduleCalendarController', function (type) {
                var newShift;
                var calendarItem;
                switch (type) {
                    case 'post': {
                        newShift = _this.ShiftService.item;
                        calendarItem = new calendar_service_1.ICalendarShift();
                        calendarItem.start = newShift.start;
                        calendarItem.end = newShift.end;
                        calendarItem.status = newShift.status.toString();
                        calendarItem.statusColor = newShift.statusColor;
                        calendarItem.title = newShift.teamLocationName;
                        calendarItem.shift = newShift;
                        _this.shifts.push(calendarItem);
                        break;
                    }
                    case 'put': {
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== newShift.id; });
                        if (_this.ShiftService.item.status !== 99) {
                            newShift = _this.ShiftService.item;
                            calendarItem = new calendar_service_1.ICalendarShift();
                            calendarItem.start = newShift.start;
                            calendarItem.end = newShift.end;
                            calendarItem.status = newShift.status.toString();
                            calendarItem.statusColor = newShift.statusColor;
                            calendarItem.title = newShift.teamLocationName;
                            calendarItem.shift = newShift;
                            _this.shifts.push(calendarItem);
                        }
                        break;
                    }
                    case 'delete': {
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== _this.ShiftService.itemId; });
                        break;
                    }
                }
                _this.uiCalendarConfig.calendars['scheduleCalendar'].fullCalendar('refetchEvents');
            });
            if (_this.AuthService.hasRole("employee")) {
                _this.isEmployee = true;
            }
            else {
                _this.isEmployee = false;
            }
        };
        this.openItem = function (event, jsEvent) {
            $(jsEvent.currentTarget).tooltip('hide');
            switch (event.type) {
                case 'shift':
                    if (event.item.comment == "Aangemaakt door gebruiker!") {
                        _this.$state.go('schedule.list.item', { 'id': event.item.id, 'start': event.item.start });
                    }
                    else {
                        _this.$state.go('schedule.list.item', { 'id': event.item.id, 'start': event.item.start });
                    }
                    break;
                case 'availability':
                    _this.$state.go('schedule.calendar.availability', { 'availabilityId': event.item.id });
                    break;
                case 'subscription':
                    _this.$state.go('schedule.calendar.subscription', { 'employeeId': '', 'subscriptionId': event.item.id });
                    break;
            }
        };
        this.eventRender = function (event, element, view) {
            var status = _.find(_this.statuses, { code: event.status });
            var statusName = status ? status.name : "";
            var eventTitle = event.title + " - " + event.item.teamName + "<br /><b>" + statusName + "</b>";
            var color;
            switch (event.type) {
                case 'shift':
                    if (_this.isEmployee && event.item.declarations.length > 0) {
                        color = '#165B68'; // @brand-info darker shade
                        eventTitle = event.title + " - " + event.item.teamName + "<br /><b>Gedeclareerd</b>";
                    }
                    else {
                        color = '#4cc3d9'; // @brand-info
                    }
                    break;
                case 'availability':
                    if (event.title.toLowerCase() == 'beschikbaar') {
                        color = '#2ECC71'; // @brand-success
                        eventTitle = event.title + "<br /><b>Beschikbaar</b>";
                    }
                    else {
                        color = '#d96557'; // @brand-danger
                        eventTitle = event.title + "<br /><b>Niet beschikbaar</b>";
                    }
                    break;
                case 'subscription':
                    eventTitle = event.title + "<br /><b>Ingeschreven</b>";
                    color = '#ffc65d'; // @brand-warning
                    //element.hide();
                    break;
            }
            if (moment().isBefore(event.start)) {
                element.css({ 'background-color': color, 'border-color': color });
            }
            else {
                element.css({ 'background-color': color, 'border-color': color, 'opacity': 0.7 });
            }
            element.tooltip({ container: "body", title: eventTitle, placement: "top", html: true });
            var title = element.find('.fc-title, .fc-list-item-title');
            title.html(eventTitle);
            _this.$compile(element)(_this.$scope);
        };
        this.getEvents = function (start, end, timezone, callback) {
            // console.log('getEvents');
            _this.CalendarService.customAll('employee', { 'start': start.toDate(), 'end': end.toDate() }).then(function (events) {
                //filter out canceld shifts
                events = _.reject(events, { "status": "92" });
                events = _.reject(events, { "title": null });
                _this.shifts = events;
                callback(events);
            });
        };
    }
    return ScheduleCalendarController;
}());
exports.scheduleCalendarComponent = {
    bindings: {
        statuses: "<"
    },
    controller: ScheduleCalendarController,
    template: __webpack_require__(458)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScheduleController = /** @class */ (function () {
    function ScheduleController() {
        'ngInject';
    }
    return ScheduleController;
}());
exports.scheduleComponent = {
    controller: ScheduleController,
    template: __webpack_require__(460)
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var IShiftTeam = /** @class */ (function () {
    function IShiftTeam() {
    }
    return IShiftTeam;
}());
var ScheduleDeclarationController = /** @class */ (function () {
    ScheduleDeclarationController.$inject = ["DeclarationService", "EmployeesService", "$stateParams"];
    function ScheduleDeclarationController(DeclarationService, EmployeesService, $stateParams) {
        'ngInject';
        var _this = this;
        this.DeclarationService = DeclarationService;
        this.EmployeesService = EmployeesService;
        this.$stateParams = $stateParams;
        this.isZZP = false;
        this.invoiceMonthly = false;
        this.$onInit = function () {
            _this.EmployeesService.getIsZZP().then(function (value) {
                _this.isZZP = value.zzp;
                _this.invoiceMonthly = value.invoiceMonthly;
                _this.moment = __webpack_require__(0);
                if (_this.$stateParams["start"]) {
                    if (_this.invoiceMonthly) {
                        _this.startDate = _this.moment(_this.$stateParams["start"]).startOf('month').toDate();
                        _this.endDate = _this.moment(_this.$stateParams["start"]).endOf('month').toDate();
                    }
                    else {
                        _this.startDate = _this.moment(_this.$stateParams["start"]).startOf('isoweek').toDate();
                        _this.endDate = _this.moment(_this.$stateParams["start"]).endOf('isoweek').toDate();
                    }
                }
                else {
                    if (_this.invoiceMonthly) {
                        _this.startDate = _this.moment().startOf('month').toDate();
                        _this.endDate = _this.moment().endOf('month').toDate();
                    }
                    else {
                        _this.startDate = _this.moment().startOf('isoweek').toDate();
                        _this.endDate = _this.moment().endOf('isoweek').toDate();
                    }
                }
                _this.getDeclartions();
            });
        };
        this.getDeclartions = function () {
            _this.EmployeesService.customAll('employeeSummary', { from: moment(_this.startDate).format("YYYY-MM-DD HH:mm"), till: moment(_this.endDate).format("YYYY-MM-DD HH:mm") }).then(function (employeeSummary) {
                _this.employeeSummary = employeeSummary[0];
                _this.declarationstoSend = { 'count': 0, 'totalHours': 0, 'countShifts': 0, 'teams': [] };
                _this.employeeSummary.shifts.forEach(function (shift) {
                    _this.declarationstoSend.countShifts++;
                    shift.declarations.forEach(function (declaration) {
                        if (declaration.status <= 1) {
                            _this.declarationstoSend.count++;
                            _this.declarationstoSend.totalHours = _this.declarationstoSend.totalHours + declaration.duration;
                            if (!_this.declarationstoSend.teams.find(function (t) { return t.id == shift.teamId; })) {
                                _this.declarationstoSend.teams.push({
                                    id: shift.teamId,
                                    name: shift.teamName,
                                    location: shift.teamLocationName,
                                    account: shift.teamLocationAccountName,
                                    invoiceNumber: ''
                                });
                            }
                        }
                    });
                });
            });
        };
        this.postConfirm = function () {
            _this.DeclarationService.confirm({ teams: _this.declarationstoSend.teams, from: moment(_this.startDate).format("YYYY-MM-DD HH:mm"), till: moment(_this.endDate).format("YYYY-MM-DD HH:mm") }).then(function (data) {
                _this.getDeclartions();
                $('#sendDeclartionsFormModal').modal('hide');
            });
        };
    }
    ScheduleDeclarationController.prototype.prevWeek = function () {
        if (this.invoiceMonthly) {
            this.startDate = this.moment(this.startDate).add(-1, 'month').startOf('month').toDate();
            console.log(this.startDate);
            this.endDate = this.moment(this.endDate).add(-1, 'month').endOf('month').toDate();
            console.log(this.endDate);
        }
        else {
            this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
            this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
        }
        this.getDeclartions();
    };
    ScheduleDeclarationController.prototype.nextWeek = function () {
        if (this.invoiceMonthly) {
            this.startDate = this.moment(this.startDate).add(1, 'month').startOf('month').toDate();
            this.endDate = this.moment(this.endDate).add(1, 'month').endOf('month').toDate();
        }
        else {
            this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
            this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
        }
        this.getDeclartions();
    };
    ScheduleDeclarationController.prototype.sendZPPDeclarations = function () {
        $('#sendDeclartionsFormModal').modal('show');
    };
    return ScheduleDeclarationController;
}());
exports.scheduleDeclarationComponent = {
    bindings: {
        onChange: '&',
    },
    controller: ScheduleDeclarationController,
    template: __webpack_require__(459)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var ScheduleItemController = /** @class */ (function () {
    ScheduleItemController.$inject = ["ShiftService", "EmployeesService", "$stateParams", "LocationService"];
    function ScheduleItemController(ShiftService, EmployeesService, $stateParams, LocationService) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.$stateParams = $stateParams;
        this.LocationService = LocationService;
        this.$onInit = function () {
            if (_this.$stateParams['id']) {
                _this.getShift();
            }
            if (_this.$stateParams['id']) {
                _this.onChange({ type: 'init', data: _this.$stateParams['id'] });
            }
        };
        this.getShift = function () {
            _this.ShiftService.get(_this.$stateParams['id']).then(function (shift) {
                _this.shift = shift;
                _this.EmployeesService.customAll('employeeSummary', { from: moment(_this.shift.start).subtract(1, 'h').toDate(), till: moment(_this.shift.start).add(1, 'h').toDate() }).then(function (employeeSummary) {
                    _this.employeeSummary = employeeSummary[0];
                });
                _this.LocationService.get(_this.shift.teamLocationId).then(function (location) {
                    _this.location = location;
                });
            });
        };
    }
    return ScheduleItemController;
}());
exports.scheduleItemComponent = {
    bindings: {
        // shift: '<',
        // employees: '<',
        // statuses: '<',
        // accounts: '<',
        // functions: '<',
        onChange: '&',
    },
    controller: ScheduleItemController,
    template: __webpack_require__(461)
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var angular = __webpack_require__(5);
var ScheduleListController = /** @class */ (function () {
    ScheduleListController.$inject = ["EmployeesService", "DeclarationService", "ShiftService", "$state", "$stateParams", "$timeout", "$filter", "screenSize"];
    function ScheduleListController(EmployeesService, DeclarationService, ShiftService, $state, $stateParams, $timeout, $filter, screenSize) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.DeclarationService = DeclarationService;
        this.ShiftService = ShiftService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.screenSize = screenSize;
        this.$onInit = function () {
            _this.shiftsGrouping = 'date';
            _this.filter = {
                status: null
            };
            _this.moment = __webpack_require__(0);
            if (_this.$stateParams["start"]) {
                _this.startDate = _this.moment.utc(_this.$stateParams["start"]).startOf('isoweek').format();
                _this.endDate = _this.moment.utc(_this.$stateParams["start"]).endOf('isoweek').format();
            }
            else {
                _this.startDate = _this.moment().startOf('isoweek').format();
                _this.endDate = _this.moment().endOf('isoweek').format();
            }
            _this.isMessageOpen = false;
            _this.getShifts();
            //this.getAvailibility();
            // this.getShiftsByDate();
            // this.DeclarationService.subscribe('ScheduleListController', (type) => {
            //     var currentShift: IShift;
            //     switch (type) {
            //         case 'post': {
            //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
            //             // console.log(this.currentEmployee)
            //             // console.log(this.DeclarationService.item)
            //             // console.log(currentShift)
            //             currentShift.declarations.push(this.DeclarationService.item);
            //             this.updateShiftDeclarationsSummary(currentShift);
            //             break;
            //         }
            //         case 'put': {
            //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
            //             currentShift.declarations = currentShift.declarations.filter(s => s.id !== this.DeclarationService.item.id);
            //             currentShift.declarations.push(this.DeclarationService.item);
            //             this.updateShiftDeclarationsSummary(currentShift);
            //             break;
            //         }
            //         case 'delete': {            
            //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
            //             // console.log(this.currentEmployee)
            //             // console.log(this.DeclarationService.item)
            //             // console.log(currentShift)
            //             this.updateShiftDeclarationsSummary(currentShift);
            //             break;
            //         }
            //     }
            // });
        };
        this.$onDestroy = function () {
            //this.DeclarationService.unsubscribe('ScheduleListController');
        };
        // updateShiftDeclarationsSummary(currentShift) {
        //     console.log('updateShiftDeclarationsSummary')
        //     this.ShiftService.customGet(this.DeclarationService.item.shiftId + '/shiftDeclarations').then((result) => {
        //         currentShift.plannedHours = result.plannedHours;
        //         currentShift.declaredHours = result.declaredHours;
        //         currentShift.hoursDifference = result.hoursDifference;
        //         // this.EmployeesService.customGet(this.DeclarationService.item.employeeId + '/employeeSummary', {from: this.startDate, till: this.endDate}).then((result) => {
        //         //     this.employee.shiftHours = result.shiftHours;
        //         //     this.employee.shiftDeclarationHours = result.shiftDeclarationHours;
        //         // });
        //     });
        // }
        this.getShifts = function (scrollTo) {
            if (scrollTo === void 0) { scrollTo = true; }
            _this.ShiftService.getByCurrentEmployee(_this.startDate, _this.endDate).then(function (result) {
                _this.shifts = result;
                _this.filterShifts(scrollTo);
            });
        };
        this.getAvailibility = function (scrollTo) {
            if (scrollTo === void 0) { scrollTo = true; }
            _this.EmployeesService.getAvailabilityByRange(_this.startDate, _this.endDate).then(function (result) {
                _this.availibility = result;
                _this.availibility.forEach(function (item) {
                    var dates = _this.getDateBetween(item.start, item.end);
                    dates.forEach(function (date) {
                        //console.log(moment(date).format("YYYY-MM-DD"));
                        var n = angular.copy(item);
                        n.start = moment(date).format("YYYY-MM-DD");
                        n.end = moment(date).format("YYYY-MM-DD");
                        _this.shifts.push(n);
                        //console.log(this.availibility);
                    });
                    if (dates.length > 0) {
                        item.end = moment(item.start).format("YYYY-MM-DD");
                        _this.shifts.push(item);
                    }
                    else {
                        _this.shifts.push(item);
                    }
                });
                //this.shifts = //_.merge(this.shifts, this.availibility);
                _this.filterShifts(scrollTo);
            });
        };
        this.getDateBetween = function (start, end) {
            var dates = [];
            var startdate = moment(start).startOf('day');
            var lastDate = moment(end).startOf('day');
            while (startdate.add(1, 'days').diff(lastDate) < 0) {
                //console.log(startdate.toDate());
                dates.push(startdate.clone().toDate());
            }
            return (dates);
        };
        this.filterShifts = function (scrollTo) {
            if (scrollTo === void 0) { scrollTo = true; }
            if (_this.shiftsGrouping && _this.shiftsGrouping == 'date') {
                _this.groupedShifts = _.groupBy(_this.shifts, function (item) {
                    return moment(item.start).format('dd DD-MM-YYYY');
                });
            }
        };
        this.handleChildChange = function (type, data) {
            // console.log(type);
            switch (type) {
                case 'init':
                    _this.isMessageOpen = true;
                    break;
                default:
                    break;
            }
        };
        this.months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    }
    ScheduleListController.prototype.prevWeek = function () {
        this.startDate = this.moment.utc(this.startDate).add(-7, 'day').format();
        this.endDate = this.moment.utc(this.endDate).add(-7, 'day').format();
        this.getShifts();
    };
    ScheduleListController.prototype.nextWeek = function () {
        this.startDate = this.moment.utc(this.startDate).add(7, 'day').format();
        this.endDate = this.moment.utc(this.endDate).add(7, 'day').format();
        this.getShifts();
    };
    // getShiftsByDate() {
    //     this.EmployeesService.customAll('employeeSummary', { from: this.startDate, till: this.endDate }).then((result: any) => {
    //         this.employee = result[0];
    //     });
    // }
    ScheduleListController.prototype.startDateBeforeRender = function ($dates) {
    };
    ScheduleListController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    return ScheduleListController;
}());
exports.scheduleListComponent = {
    bindings: {},
    controller: ScheduleListController,
    template: __webpack_require__(462)
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleState = {
    parent: 'app',
    name: "schedule",
    url: "/schedule",
    component: 'scheduleComponent',
    redirectTo: 'schedule.calendar',
    data: {
        permissions: {
            only: ['EMPLOYEE']
        }
    }
};
exports.scheduleCalendarState = {
    name: "schedule.calendar",
    url: "/calendar",
    views: {
        "main": 'scheduleCalendarComponent'
    },
    resolve: {
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }]
    }
};
exports.scheduleListState = {
    name: "schedule.list",
    url: "/list?start",
    params: {
        shiftId: null,
        start: null
    },
    views: {
        "main": 'scheduleListComponent'
    },
    resolve: {},
    data: {
        contentClasses: 'no-padding'
    }
};
exports.scheduleListItemState = {
    name: "schedule.list.item",
    url: "/item/:id",
    resolve: {},
    views: {
        "shiflistitem@schedule.list": 'scheduleItemComponent'
    },
};
exports.scheduleListItemDeclarationState = {
    name: "schedule.declarations",
    url: "/declaration?openShiftId",
    params: {
        openShiftId: null,
    },
    resolve: {},
    views: {
        "main": 'scheduleDeclarationComponent'
    },
};
exports.scheduleDeclarationState = {
    name: "schedule.declarations.declaration",
    url: "/declaration/:declarationId?employeeId&shiftId&type&shiftStartDate&shiftEndDate",
    params: {
        employeeId: null,
        shiftId: null,
        type: null,
        shiftStartDate: null,
        shiftEndDate: null,
    },
    modal: [],
    resolve: {
        wageCodes: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('HourCodes');
        }],
        declaration: ["DeclarationService", "$stateParams", function (DeclarationService, $stateParams) {
            "ngInject";
            if ($stateParams['declarationId']) {
                return DeclarationService.get($stateParams['declarationId']);
            }
        }],
        refresh: function () { return true; }
    },
    component: 'declarationComponent'
};
exports.scheduleAvailabilityState = {
    name: "schedule.calendar.availability",
    url: "/availability/:availabilityId",
    params: {
        "availabilityId": null
    },
    modal: [],
    resolve: {
        statuses: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('AvalabilityStatus');
        }]
    },
    component: 'availabilityItemComponent'
};
exports.scheduleShiftItemState = {
    name: "schedule.list.item.edit",
    url: "/edit",
    params: {
        "status": null
    },
    modal: true,
    size: "lg",
    resolve: {
        shift: ["ShiftService", "$stateParams", function (ShiftService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return ShiftService.get($stateParams['id']);
            }
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        employees: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
        statuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('ShiftStatus');
        }],
        refresh: function () { return true; }
    },
    component: 'shiftItemComponent'
};
exports.scheduleSubscriptionState = {
    name: "schedule.calendar.subscription",
    url: "/subscription/:employeeId/:subscriptionId",
    params: {
        "subscriptionId": null
    },
    modal: [],
    resolve: {},
    component: 'subscriptionItemComponent'
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionItemController = /** @class */ (function () {
    SubscriptionItemController.$inject = ["EmployeesService", "$stateParams", "$state", "$timeout"];
    function SubscriptionItemController(EmployeesService, $stateParams, $state, $timeout) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$onInit = function () {
            _this.employeeId = _this.$stateParams["employeeId"];
            _this.EmployeesService.getChild(_this.employeeId, 'subscriptions').then(function (result) {
                var subscriptions = result;
                _this.subscription = subscriptions.find(function (s) { return s.id == _this.$stateParams["subscriptionId"]; });
            });
        };
    }
    SubscriptionItemController.prototype.submitSubscription = function () {
        var _this = this;
        if (this.subscription.id === undefined) {
            this.EmployeesService.postChild(this.subscription, this.employeeId, 'subscriptions').then(function (data) {
                _this.closeModal();
            });
        }
        else {
            this.EmployeesService.putChild(this.subscription, this.employeeId, 'subscriptions', this.subscription.id).then(function (data) {
                _this.closeModal();
            });
        }
    };
    SubscriptionItemController.prototype.delete = function () {
        var _this = this;
        this.EmployeesService.deleteChild(this.subscription.id, this.employeeId, 'subscriptions').then(function (data) {
            _this.closeModal();
        });
    };
    SubscriptionItemController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return SubscriptionItemController;
}());
exports.subscriptionItemComponent = {
    bindings: {
        resolve: '<'
    },
    controller: SubscriptionItemController,
    template: __webpack_require__(463)
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SettingsCompanyController = /** @class */ (function () {
    SettingsCompanyController.$inject = ["SettingsService"];
    function SettingsCompanyController(SettingsService) {
        "ngInject";
        this.settingsService = SettingsService;
    }
    SettingsCompanyController.prototype.submitSettings = function () {
        // console.log('submitSettings');
        this.settingsService.customPost('CompanySettings', this.company);
    };
    return SettingsCompanyController;
}());
exports.settingsCompanyComponent = {
    bindings: {
        company: "<"
    },
    controller: SettingsCompanyController,
    template: __webpack_require__(464)
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmployeeItemController = /** @class */ (function () {
    EmployeeItemController.$inject = ["PersonService"];
    function EmployeeItemController(PersonService) {
        "ngInject";
        var _this = this;
        this.PersonService = PersonService;
        this.save = function () {
            if (_this.employee.id && _this.employee.id > 0) {
                _this.PersonService.put(_this.employee.id, _this.employee).then(function () {
                });
            }
            else {
                _this.PersonService.post(_this.employee).then(function () {
                });
            }
        };
    }
    return EmployeeItemController;
}());
exports.employeeItemComponent = {
    bindings: {
        employee: "<"
    },
    controller: EmployeeItemController,
    template: __webpack_require__(465)
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmployeeListController = /** @class */ (function () {
    function EmployeeListController() {
        "ngInject";
    }
    return EmployeeListController;
}());
exports.employeeListComponent = {
    bindings: {
        employees: "<"
    },
    controller: EmployeeListController,
    template: __webpack_require__(466)
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HourCodesController = /** @class */ (function () {
    function HourCodesController() {
        'ngInject';
        this.$onInit = function () {
            console.log('HourCodesController initialized');
        };
    }
    return HourCodesController;
}());
exports.hourCodesComponent = {
    controller: HourCodesController,
    template: __webpack_require__(467)
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {
Object.defineProperty(exports, "__esModule", { value: true });
var HourCodesItemBasicController = /** @class */ (function () {
    HourCodesItemBasicController.$inject = ["HourCodeService", "SalaryScaleGroupService", "$state", "$stateParams", "$timeout", "SweetAlert"];
    function HourCodesItemBasicController(HourCodeService, SalaryScaleGroupService, $state, $stateParams, $timeout, SweetAlert) {
        'ngInject';
        var _this = this;
        this.HourCodeService = HourCodeService;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.SweetAlert = SweetAlert;
        this.salaryScaleGroups = [];
        this.$onInit = function () {
            if (_this.resolve.hourCode) {
                _this.hourCode = _this.resolve.hourCode;
                // Convert type to string for AngularJS select
                if (_this.hourCode.type !== undefined && _this.hourCode.type !== null) {
                    _this.typeSelect = String(_this.hourCode.type);
                }
                else {
                    _this.typeSelect = '0'; // Default to Looncomponent
                    _this.hourCode.type = 0;
                }
            }
            else {
                // Get caoId from state params if available (for new hourcodes)
                var caoId = _this.$stateParams['caoId'];
                _this.hourCode = {
                    code: '',
                    name: '',
                    description: '',
                    twinfieldCode: '',
                    value: null,
                    value2: null,
                    salaryScaleGroupId: caoId || null,
                    type: 0,
                };
                _this.typeSelect = '0'; // Default for select
            }
            // Load salary scale groups
            _this.SalaryScaleGroupService.all().then(function (result) {
                // Sort alphabetically by name
                _this.salaryScaleGroups = result.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Trigger chosen update after data is loaded
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('select[name="salaryScaleGroup"]').trigger('chosen:updated');
                    }
                }, 0);
            });
        };
        this.closeModal = function () {
            // Preserve selected CAO when closing modal
            var selectedCaoId = _this.hourCode.salaryScaleGroupId || _this.$stateParams['caoId'];
            // Navigate back to list with selected CAO preserved
            _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId || null }, { reload: false });
        };
    }
    HourCodesItemBasicController.prototype.submitHourCode = function () {
        var _this = this;
        // Convert typeSelect string to number before submitting
        this.hourCode.type = parseInt(this.typeSelect, 10);
        if (this.hourCode.id === undefined) {
            this.HourCodeService.post(this.hourCode).then(function (result) {
                // Preserve selected CAO when navigating back
                var selectedCaoId = _this.hourCode.salaryScaleGroupId || _this.$stateParams['caoId'];
                _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, { reload: true });
            });
        }
        else {
            this.HourCodeService.put(this.hourCode.id, this.hourCode).then(function (result) {
                // Preserve selected CAO when navigating back
                var selectedCaoId = _this.hourCode.salaryScaleGroupId;
                _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, { reload: true });
            });
        }
    };
    HourCodesItemBasicController.prototype.deleteHourCode = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je kunt dit niet ongedaan maken!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, verwijderen!',
            cancelButtonText: 'Nee, annuleren!',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.HourCodeService.delete(_this.hourCode.id).then(function () {
                    var selectedCaoId = _this.hourCode.salaryScaleGroupId;
                    _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, { reload: true });
                });
            }
        });
    };
    return HourCodesItemBasicController;
}());
exports.hourCodesItemBasicComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: HourCodesItemBasicController,
    template: __webpack_require__(468)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HourCodesItemController = /** @class */ (function () {
    HourCodesItemController.$inject = ["HourCodeService", "$state", "SweetAlert"];
    function HourCodesItemController(HourCodeService, $state, SweetAlert) {
        'ngInject';
        this.HourCodeService = HourCodeService;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
    }
    HourCodesItemController.prototype.deleteHourCode = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je kunt dit niet ongedaan maken!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, verwijderen!',
            cancelButtonText: 'Nee, annuleren!',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.HourCodeService.delete(_this.hourCode.id).then(function () {
                    _this.$state.go('^', { reload: true });
                });
            }
        });
    };
    return HourCodesItemController;
}());
exports.hourCodesItemComponent = {
    controller: HourCodesItemController,
    bindings: {
        hourCode: '<'
    },
    template: __webpack_require__(469)
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HourCodesListController = /** @class */ (function () {
    HourCodesListController.$inject = ["SalaryScaleGroupService", "HourCodeService", "$state", "$stateParams"];
    function HourCodesListController(SalaryScaleGroupService, HourCodeService, $state, $stateParams) {
        'ngInject';
        var _this = this;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.HourCodeService = HourCodeService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.hourCodes = [];
        this.$onInit = function () {
            console.log('HourCodesListController initialized');
            // Reset hourCodes array to ensure it's empty initially
            _this.hourCodes = [];
            _this.loadSalaryScaleGroups();
        };
        this.loadSalaryScaleGroups = function () {
            console.log('Loading salary scale groups...');
            _this.SalaryScaleGroupService.all().then(function (result) {
                console.log('Salary scale groups loaded:', result);
                // Sort alphabetically by name
                _this.salaryScaleGroups = result.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Restore selectedGroup from state params if available
                var selectedGroupId = _this.$stateParams['selectedCaoId'];
                if (selectedGroupId) {
                    var group = _this.salaryScaleGroups.find(function (g) { return g.id === selectedGroupId; });
                    if (group) {
                        _this.selectedGroup = group;
                        _this.loadHourCodes(group.id);
                    }
                    else {
                        // Group not found, clear selection
                        _this.selectedGroup = null;
                        _this.hourCodes = [];
                    }
                }
                else {
                    // No group selected, ensure hourCodes is empty
                    _this.selectedGroup = null;
                    _this.hourCodes = [];
                }
            });
        };
        this.loadHourCodes = function (salaryScaleGroupId) {
            _this.HourCodeService.getBySalaryScaleGroupId(salaryScaleGroupId).then(function (result) {
                _this.hourCodes = result || [];
            });
        };
        this.clearSelection = function () {
            _this.selectedGroup = null;
            _this.hourCodes = [];
            // Clear selected CAO ID from state params
            _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
        };
        this.onGroupChange = function (selectedGroup) {
            _this.selectedGroup = selectedGroup;
            if (selectedGroup && selectedGroup.id) {
                _this.loadHourCodes(selectedGroup.id);
                // Save selected CAO ID to state params
                _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedGroup.id }, { location: 'replace', notify: false });
            }
            else {
                _this.hourCodes = [];
                _this.$state.go('settings.hourcodes.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
            }
        };
        this.addHourCode = function () {
            if (!_this.selectedGroup || !_this.selectedGroup.id) {
                alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een uurcode toe te voegen.');
                return;
            }
            _this.$state.go('settings.hourcodes.list.item', { 'id': '', 'caoId': _this.selectedGroup.id });
        };
        this.sortType = 'name';
    }
    return HourCodesListController;
}());
exports.hourCodesListComponent = {
    controller: HourCodesListController,
    bindings: {},
    template: __webpack_require__(470)
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var employee_item_component_1 = __webpack_require__(650);
var person_service_1 = __webpack_require__(268);
var staff_service_1 = __webpack_require__(729);
var employee_list_component_1 = __webpack_require__(651);
var settings_states_1 = __webpack_require__(664);
var settings_company_component_1 = __webpack_require__(649);
var settings_component_1 = __webpack_require__(663);
var ngmodule_1 = __webpack_require__(4);
var index_1 = __webpack_require__(7);
var salaryScaleGroup_service_1 = __webpack_require__(24);
var templatesEditor_component_1 = __webpack_require__(668);
var timezone_service_1 = __webpack_require__(270);
var timezones_component_1 = __webpack_require__(669);
var timezones_list_component_1 = __webpack_require__(672);
var timezones_item_component_1 = __webpack_require__(671);
var timezones_item_basic_component_1 = __webpack_require__(670);
var hourCode_service_1 = __webpack_require__(23);
var hourCodes_component_1 = __webpack_require__(652);
var hourCodes_list_component_1 = __webpack_require__(655);
var hourCodes_item_component_1 = __webpack_require__(654);
var hourCodes_item_basic_component_1 = __webpack_require__(653);
var salaryScale_list_component_1 = __webpack_require__(662);
var salaryScale_dialog_component_1 = __webpack_require__(661);
var staff_component_1 = __webpack_require__(665);
var staff_list_component_1 = __webpack_require__(667);
var staff_item_component_1 = __webpack_require__(666);
var masterdata_component_1 = __webpack_require__(657);
var masterdata_list_component_1 = __webpack_require__(659);
var masterdata_edit_component_1 = __webpack_require__(658);
var nmbrsTest_component_1 = __webpack_require__(660);
var nmbrs_service_1 = __webpack_require__(267);
var settingsAppModule = {
    components: {
        settingsComponent: settings_component_1.settingsComponent,
        settingsCompanyComponent: settings_company_component_1.settingsCompanyComponent,
        employeeListComponent: employee_list_component_1.employeeListComponent,
        employeeItemComponent: employee_item_component_1.employeeItemComponent,
        templatesEditorComponent: templatesEditor_component_1.templatesEditorComponent,
        timezonesComponent: timezones_component_1.timezonesComponent,
        timezonesListComponent: timezones_list_component_1.timezonesListComponent,
        timezonesItemComponent: timezones_item_component_1.timezonesItemComponent,
        timezonesItemBasicComponent: timezones_item_basic_component_1.timezonesItemBasicComponent,
        salaryScaleListComponent: salaryScale_list_component_1.salaryScaleListComponent,
        salaryScalesDialogComponent: salaryScale_dialog_component_1.salaryScalesDialogComponent,
        staffComponent: staff_component_1.staffComponent,
        staffListComponent: staff_list_component_1.staffListComponent,
        staffItemComponent: staff_item_component_1.staffItemComponent,
        masterdataComponent: masterdata_component_1.masterdataComponent,
        masterdataListComponent: masterdata_list_component_1.masterdataListComponent,
        masterdataEditComponent: masterdata_edit_component_1.masterdataEditComponent,
        nmbrsTestComponent: nmbrsTest_component_1.nmbrsTestComponent,
        hourCodesComponent: hourCodes_component_1.hourCodesComponent,
        hourCodesListComponent: hourCodes_list_component_1.hourCodesListComponent,
        hourCodesItemComponent: hourCodes_item_component_1.hourCodesItemComponent,
        hourCodesItemBasicComponent: hourCodes_item_basic_component_1.hourCodesItemBasicComponent
    },
    states: [
        settings_states_1.settingsState,
        settings_states_1.settingsCompanyState,
        settings_states_1.settingsEmployeeState,
        settings_states_1.settingsEmployeeListState,
        settings_states_1.settingsEmployeeItemState,
        settings_states_1.templatesState,
        settings_states_1.timezonesState,
        settings_states_1.timezonesListState,
        settings_states_1.timezonesItemState,
        settings_states_1.settingsSalaryScaleState,
        settings_states_1.settingsSalaryScaleEditState,
        settings_states_1.staffState,
        settings_states_1.staffListState,
        settings_states_1.staffItemState,
        settings_states_1.masterdataListEditState,
        settings_states_1.masterdataState,
        settings_states_1.masterdataListState,
        settings_states_1.nmbrsTestState,
        settings_states_1.hourCodesState,
        settings_states_1.hourCodesListState,
        settings_states_1.hourCodesItemState
    ],
    services: {
        PersonService: person_service_1.PersonService, TemplatesService: index_1.TemplatesService, TimezonesService: timezone_service_1.TimezonesService, MasterdataAService: index_1.MasterdataAService, StaffService: staff_service_1.StaffService, SalaryScaleGroupService: salaryScaleGroup_service_1.SalaryScaleGroupService, SalaryScaleService: salaryScaleGroup_service_1.SalaryScaleService, NmbrsService: nmbrs_service_1.NmbrsService, HourCodeService: hourCode_service_1.HourCodeService
    }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, settingsAppModule);


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MasterdataController = /** @class */ (function () {
    function MasterdataController() {
        'ngInject';
    }
    return MasterdataController;
}());
exports.masterdataComponent = {
    controller: MasterdataController,
    template: __webpack_require__(472)
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MasterdataEditController = /** @class */ (function () {
    MasterdataEditController.$inject = ["$stateParams", "MasterdataAService", "$state"];
    function MasterdataEditController($stateParams, MasterdataAService, $state) {
        'ngInject';
        var _this = this;
        this.$stateParams = $stateParams;
        this.MasterdataAService = MasterdataAService;
        this.$state = $state;
        this.type = null;
        this.$onInit = function () {
            _this.type = _this.$stateParams['type'];
            _this.item = _this.resolve.item;
            if (!_this.type) {
                alert('No type given!');
            }
        };
        this.save = function () {
            _this.item.type = _this.type;
            if (!_this.item.id) {
                _this.MasterdataAService.postItem(_this.type, _this.item).then(function () {
                    _this.$state.go('^', null, { 'reload': true });
                });
            }
            else {
                _this.MasterdataAService.put(_this.item.id, _this.item).then(function () {
                    _this.$state.go('^', null, { 'reload': true });
                });
            }
        };
        this.delete = function () {
            _this.MasterdataAService.delete(_this.item.id).then(function () {
                _this.$state.go('^', null, { 'reload': true });
            });
        };
    }
    return MasterdataEditController;
}());
exports.masterdataEditComponent = {
    bindings: {
        resolve: "<"
    },
    controller: MasterdataEditController,
    template: __webpack_require__(471)
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MasterdataListController = /** @class */ (function () {
    MasterdataListController.$inject = ["MasterdataAService", "$state", "$stateParams", "$timeout"];
    function MasterdataListController(MasterdataAService, $state, $stateParams, $timeout) {
        'ngInject';
        var _this = this;
        this.MasterdataAService = MasterdataAService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$onInit = function () {
            _this.activePill = parseInt(_this.$stateParams['tab']);
            _this.types = _this.MasterdataAService.getTypes();
            console.log(_this.types);
            _this.types.forEach(function (item) {
                _this.MasterdataAService.getItems(item.id).then(function (data) {
                    item.data = data;
                });
            });
        };
        this.setTab = function (index) {
            _this.$timeout(function () {
                _this.$state.go('.', { tab: _this.activePill }, { notify: false });
            });
        };
    }
    return MasterdataListController;
}());
exports.masterdataListComponent = {
    controller: MasterdataListController,
    template: __webpack_require__(473)
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NmbrsTestController = /** @class */ (function () {
    NmbrsTestController.$inject = ["NmbrsService"];
    function NmbrsTestController(NmbrsService) {
        'ngInject';
        var _this = this;
        this.NmbrsService = NmbrsService;
        this.endpoints = [];
        this.selectedEndpoint = null;
        this.endpointParams = {};
        this.result = null;
        this.loading = false;
        this.error = null;
        this.$onInit = function () {
            _this.endpoints = [
                {
                    name: 'Labour Agreements',
                    method: 'GET',
                    path: 'labourAgreements',
                    description: 'Get all labour agreements for a company',
                    params: [
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee',
                    method: 'GET',
                    path: 'employee/{employeeId}',
                    description: 'Get employee personal info',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Address',
                    method: 'GET',
                    path: 'employeeAddress/{employeeId}',
                    description: 'Get employee address',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Bank Account',
                    method: 'GET',
                    path: 'employeeBankAccount/{employeeId}',
                    description: 'Get employee bank account',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Function',
                    method: 'GET',
                    path: 'employeeFunction/{employeeId}',
                    description: 'Get employee function',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Salary',
                    method: 'GET',
                    path: 'employeeSalary/{employeeId}',
                    description: 'Get employee salary',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Salary List',
                    method: 'GET',
                    path: 'employeeSalaryList/{employeeId}',
                    description: 'Get all salary within given period',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null },
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() }
                    ]
                },
                {
                    name: 'Employee Wage Component Fixed (Current)',
                    method: 'GET',
                    path: 'employeeWageComponentFixed/{employeeId}',
                    description: 'Get all fixed wage components for the current period',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Wage Component Variable',
                    method: 'GET',
                    path: 'employeeWageComponentVar/{employeeId}',
                    description: 'Get all variable wage components for given period',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null },
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() }
                    ]
                },
                {
                    name: 'Employee Wage Component Variable (Current)',
                    method: 'GET',
                    path: 'employeeWageComponentVarCurrent/{employeeId}',
                    description: 'Get all variable wage components for the current period',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Contract',
                    method: 'GET',
                    path: 'employeeContract/{employeeId}',
                    description: 'Get employee contract',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Extra Fields',
                    method: 'GET',
                    path: 'employeeExtraFields/{employeeId}',
                    description: 'Get employee extra fields list',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Employee Cost Center (Current)',
                    method: 'GET',
                    path: 'employeeCostCenter/{employeeId}',
                    description: 'Get all active cost centers of a specific employee on the current period',
                    params: [
                        { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Tables',
                    method: 'GET',
                    path: 'salaryTables',
                    description: 'Get salary tables for a company',
                    params: [
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Tables V2',
                    method: 'GET',
                    path: 'salaryTables2',
                    description: 'Get salary tables V2 for a company (with GUID)',
                    params: [
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Scales',
                    method: 'GET',
                    path: 'salaryScales',
                    description: 'Get salary scales for a company',
                    params: [
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Scales V2',
                    method: 'GET',
                    path: 'salaryScales2',
                    description: 'Get salary scales V2 for a company (with GUID)',
                    params: [
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Steps',
                    method: 'GET',
                    path: 'salarySteps',
                    description: 'Get salary steps for a specific scale',
                    params: [
                        { key: 'scale', label: 'Scale', type: 'text', value: null },
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Salary Steps V2',
                    method: 'GET',
                    path: 'salarySteps2',
                    description: 'Get salary steps V2 for a specific scale (with GUID)',
                    params: [
                        { key: 'scale', label: 'Scale', type: 'text', value: null },
                        { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                        { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Wage Codes',
                    method: 'GET',
                    path: 'wageCodes',
                    description: 'Returns wage codes that belong to a company\'s wagemodel',
                    params: [
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Wage Codes 2',
                    method: 'GET',
                    path: 'wageCodes2',
                    description: 'Returns wage codes that belong to a company\'s wagemodel 2',
                    params: [
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Hour Codes',
                    method: 'GET',
                    path: 'hourCodes',
                    description: 'Get hour codes that belong to a company\'s hour model',
                    params: [
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Hour Codes 2',
                    method: 'GET',
                    path: 'hourCodes2',
                    description: 'Get hour codes that belong to a company\'s hour model 2',
                    params: [
                        { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                    ]
                },
                {
                    name: 'Get All Companies',
                    method: 'GET',
                    path: 'companies',
                    description: 'Returns all companies',
                    params: []
                }
            ];
        };
        this.selectEndpoint = function (endpoint) {
            _this.selectedEndpoint = endpoint;
            _this.endpointParams = {};
            _this.result = null;
            _this.error = null;
            // Initialize params with default values
            if (endpoint.params) {
                endpoint.params.forEach(function (param) {
                    _this.endpointParams[param.key] = param.value;
                });
            }
        };
        this.callEndpoint = function () {
            if (!_this.selectedEndpoint) {
                return;
            }
            _this.loading = true;
            _this.result = null;
            _this.error = null;
            var path = _this.selectedEndpoint.path;
            var queryParams = {};
            // Replace path parameters
            if (_this.selectedEndpoint.params) {
                _this.selectedEndpoint.params.forEach(function (param) {
                    if (path.includes("{" + param.key + "}")) {
                        path = path.replace("{" + param.key + "}", _this.endpointParams[param.key]);
                    }
                    else {
                        // Add as query parameter if it has a value
                        if (_this.endpointParams[param.key] !== null && _this.endpointParams[param.key] !== undefined && _this.endpointParams[param.key] !== '') {
                            queryParams[param.key] = _this.endpointParams[param.key];
                        }
                    }
                });
            }
            _this.NmbrsService.customGet(path, queryParams)
                .then(function (response) {
                _this.result = response;
                _this.loading = false;
            })
                .catch(function (error) {
                _this.error = (error.data && error.data.message) || error.statusText || 'An error occurred';
                _this.result = null;
                _this.loading = false;
            });
        };
        this.formatJson = function (obj) {
            if (!obj) {
                return '';
            }
            // If it's already a string, try to parse it first
            if (typeof obj === 'string') {
                try {
                    obj = JSON.parse(obj);
                }
                catch (e) {
                    // If parsing fails, return as is
                    return obj;
                }
            }
            // Format with proper indentation (2 spaces)
            return JSON.stringify(obj, null, 2);
        };
    }
    return NmbrsTestController;
}());
exports.nmbrsTestComponent = {
    controller: NmbrsTestController,
    template: __webpack_require__(474)
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SalaryScaleDialogController = /** @class */ (function () {
    SalaryScaleDialogController.$inject = ["SalaryScaleGroupService", "SalaryScaleService", "$state", "$stateParams"];
    function SalaryScaleDialogController(SalaryScaleGroupService, SalaryScaleService, $state, $stateParams) {
        'ngInject';
        var _this = this;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.SalaryScaleService = SalaryScaleService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            var groupId = _this.$stateParams['groupId'] || (_this.resolve && _this.resolve.salaryScaleGroupId);
            var scaleId = _this.$stateParams['id'];
            if (groupId) {
                // Editing or creating a salary scale within a group
                _this.isEditMode = false;
                if (_this.resolve && _this.resolve.salaryScale) {
                    // Edit existing scale from resolve
                    _this.salaryScale = _this.resolve.salaryScale;
                    _this.isEditMode = true;
                }
                else if (scaleId && scaleId !== '' && scaleId !== null && scaleId !== undefined && scaleId !== 'null') {
                    // Edit existing scale - load from API
                    _this.SalaryScaleService.get(scaleId).then(function (scale) {
                        _this.salaryScale = scale;
                        _this.isEditMode = true;
                    });
                }
                else {
                    // Create new scale
                    _this.salaryScale = {
                        id: undefined,
                        salaryScaleGroupId: groupId,
                        code: '',
                        name: '',
                        hourlyWage: 0,
                        conversionFactor: 0
                    };
                }
            }
            else {
                // Editing or creating a salary scale group (CAO)
                _this.isEditMode = false;
                if (_this.resolve && _this.resolve.salaryScaleGroup) {
                    // Edit existing group from resolve
                    _this.salaryScaleGroup = _this.resolve.salaryScaleGroup;
                    _this.isEditMode = true;
                }
                else {
                    var groupIdParam = _this.$stateParams['id'];
                    if (groupIdParam && groupIdParam !== '') {
                        // Edit existing group - load from API
                        _this.SalaryScaleGroupService.get(groupIdParam).then(function (group) {
                            _this.salaryScaleGroup = group;
                            _this.isEditMode = true;
                        });
                    }
                    else {
                        // Create new group
                        _this.salaryScaleGroup = {
                            id: undefined,
                            name: '',
                            description: '',
                            isDefaultNmbrsCao: false
                        };
                    }
                }
            }
        };
    }
    SalaryScaleDialogController.prototype.submitSalaryScaleGroup = function () {
        var _this = this;
        if (this.salaryScaleGroup.id === undefined) {
            this.SalaryScaleGroupService.post(this.salaryScaleGroup).then(function (result) {
                _this.$state.go('^', {}, { reload: true });
            });
        }
        else {
            this.SalaryScaleGroupService.put(this.salaryScaleGroup.id, this.salaryScaleGroup).then(function (result) {
                _this.$state.go('^', {}, { reload: true });
            });
        }
    };
    SalaryScaleDialogController.prototype.submitSalaryScale = function () {
        var _this = this;
        if (this.salaryScale.id === undefined) {
            this.SalaryScaleService.post(this.salaryScale).then(function (result) {
                _this.$state.go('^', {}, { reload: true });
            });
        }
        else {
            this.SalaryScaleService.put(this.salaryScale.id, this.salaryScale).then(function (result) {
                _this.$state.go('^', {}, { reload: true });
            });
        }
    };
    SalaryScaleDialogController.prototype.deleteSalaryScaleGroup = function () {
        var _this = this;
        this.SalaryScaleGroupService.delete(this.salaryScaleGroup.id).then(function (result) {
            _this.$state.go('^', {}, { reload: true });
        });
    };
    SalaryScaleDialogController.prototype.deleteSalaryScale = function () {
        var _this = this;
        this.SalaryScaleService.delete(this.salaryScale.id).then(function (result) {
            _this.$state.go('^', {}, { reload: true });
        });
    };
    SalaryScaleDialogController.prototype.onDefaultNmbrsCaoChange = function () {
        var _this = this;
        // Als deze CAO wordt gemarkeerd als default, zorg dat andere CAO's niet meer default zijn
        if (this.salaryScaleGroup && this.salaryScaleGroup.isDefaultNmbrsCao) {
            // Haal alle CAO's op en zet andere op false
            this.SalaryScaleGroupService.all().then(function (groups) {
                var otherGroups = groups.filter(function (g) { return g.id !== _this.salaryScaleGroup.id && g.isDefaultNmbrsCao; });
                // Update andere CAO's die default waren
                otherGroups.forEach(function (group) {
                    group.isDefaultNmbrsCao = false;
                    _this.SalaryScaleGroupService.put(group.id, group);
                });
            });
        }
    };
    return SalaryScaleDialogController;
}());
exports.salaryScalesDialogComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: SalaryScaleDialogController,
    template: __webpack_require__(475)
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __webpack_require__(5);
var SalaryScaleListController = /** @class */ (function () {
    SalaryScaleListController.$inject = ["SalaryScaleGroupService", "SalaryScaleService"];
    function SalaryScaleListController(SalaryScaleGroupService, SalaryScaleService) {
        "ngInject";
        var _this = this;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.SalaryScaleService = SalaryScaleService;
        this.$onInit = function () {
            _this.loadSalaryScaleGroups();
        };
        this.loadSalaryScaleGroups = function () {
            _this.SalaryScaleGroupService.all().then(function (result) {
                // Sorteer alfabetisch op naam
                _this.salaryScaleGroups = result.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Haal salary scales op voor elke groep
                _this.salaryScaleGroups.forEach(function (group) {
                    if (group.id) {
                        _this.SalaryScaleService.getBySalaryScaleGroupId(group.id).then(function (scales) {
                            group.salaryScales = scales;
                        });
                    }
                });
                // Update selectedGroup als die nog bestaat
                if (_this.selectedGroup) {
                    var updatedGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.selectedGroup.id; });
                    if (updatedGroup) {
                        _this.selectedGroup = updatedGroup;
                    }
                }
            });
        };
        this.clearSelection = function () {
            _this.selectedGroup = null;
        };
        this.onGroupChange = function (selectedGroup) {
            _this.selectedGroup = selectedGroup;
        };
        this.openAddScaleModal = function () {
            if (!_this.selectedGroup || !_this.selectedGroup.id) {
                alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een loonschaal toe te voegen.');
                return;
            }
            _this.currentSalaryScale = {
                id: undefined,
                salaryScaleGroupId: _this.selectedGroup.id,
                code: '',
                name: '',
                hourlyWage: 0,
                conversionFactor: 0
            };
            $('#salaryScaleModal').modal('show');
        };
        this.openEditScaleModal = function (scale) {
            _this.currentSalaryScale = angular.copy(scale);
            $('#salaryScaleModal').modal('show');
        };
        this.submitSalaryScale = function () {
            if (_this.currentSalaryScale.id === undefined) {
                _this.SalaryScaleService.post(_this.currentSalaryScale).then(function (result) {
                    $('#salaryScaleModal').modal('hide');
                    _this.loadSalaryScaleGroups();
                });
            }
            else {
                _this.SalaryScaleService.put(_this.currentSalaryScale.id, _this.currentSalaryScale).then(function (result) {
                    $('#salaryScaleModal').modal('hide');
                    _this.loadSalaryScaleGroups();
                });
            }
        };
        this.deleteSalaryScale = function () {
            if (confirm('Weet je zeker dat je deze loonschaal wilt verwijderen?')) {
                _this.SalaryScaleService.delete(_this.currentSalaryScale.id).then(function (result) {
                    $('#salaryScaleModal').modal('hide');
                    _this.loadSalaryScaleGroups();
                });
            }
        };
    }
    return SalaryScaleListController;
}());
exports.salaryScaleListComponent = {
    controller: SalaryScaleListController,
    template: __webpack_require__(476)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SettingsController = /** @class */ (function () {
    function SettingsController() {
        "ngInject";
    }
    return SettingsController;
}());
exports.settingsComponent = {
    controller: SettingsController,
    template: '<div ui-view="main"></div>'
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsState = {
    parent: 'app',
    name: "settings",
    url: "/settings",
    component: 'settingsComponent',
    redirectTo: 'settings.company',
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.settingsCompanyState = {
    name: "settings.company",
    url: "/company",
    resolve: {
        company: ["SettingsService", function (SettingsService) {
            'ngInject';
            return SettingsService.customGet('CompanySettings');
        }]
    },
    views: {
        "main": "settingsCompanyComponent"
    }
};
exports.settingsEmployeeState = {
    name: "settings.employees",
    url: "/employee",
    redirectTo: 'settings.employees.list'
};
exports.settingsEmployeeListState = {
    name: "settings.employees.list",
    url: "/list",
    resolve: {
        "employees": ["PersonService", function (PersonService) {
            "ngInject";
            return PersonService.all();
        }]
    },
    views: {
        "main@settings": "employeeListComponent"
    }
};
exports.settingsEmployeeItemState = {
    name: "settings.employees.item",
    url: "/:id",
    resolve: {
        "employee": ["PersonService", "$stateParams", function (PersonService, $stateParams) {
            "ngInject";
            return PersonService.get($stateParams['id']);
        }]
    },
    views: {
        "main@settings": "employeeItemComponent"
    }
};
exports.settingsSalaryScaleState = {
    name: "settings.salaryscales",
    url: "/salaryscales",
    views: {
        "main@settings": "salaryScaleListComponent"
    }
};
exports.settingsSalaryScaleEditState = {
    name: "settings.salaryscales.edit",
    url: "/:id",
    modal: true,
    resolve: {
        salaryScaleGroup: ["SalaryScaleGroupService", "$stateParams", function (SalaryScaleGroupService, $stateParams) {
            "ngInject";
            if ($stateParams['id'] && $stateParams['id'] !== '') {
                return SalaryScaleGroupService.get($stateParams['id']);
            }
        }]
    },
    component: 'salaryScalesDialogComponent'
};
exports.templatesState = {
    name: "settings.templates",
    url: "/templates",
    resolve: {
        templatesNames: ["TemplatesService", function (TemplatesService) {
            'ngInject';
            return TemplatesService.all();
        }]
    },
    views: {
        "main": "templatesEditorComponent"
    }
};
exports.timezonesState = {
    name: "settings.timezones",
    url: "/timezones",
    redirectTo: 'settings.timezones.list',
    views: {
        "main": "timezonesComponent"
    }
};
exports.timezonesListState = {
    name: "settings.timezones.list",
    url: "/list?:selectedCaoId",
    params: {
        selectedCaoId: { dynamic: true }
    },
    resolve: {
        timezones: ["TimezonesService", function (TimezonesService) {
            'ngInject';
            return TimezonesService.all();
        }]
    },
    views: {
        "main": 'timezonesListComponent'
    }
};
exports.timezonesItemState = {
    name: "settings.timezones.list.item",
    url: "/:id?:caoId",
    resolve: {
        timezone: ["TimezonesService", "$stateParams", function (TimezonesService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return TimezonesService.get($stateParams['id']);
            }
        }],
        hourCodes: ["HourCodeService", "$stateParams", "timezone", function (HourCodeService, $stateParams, timezone) {
            'ngInject';
            // Haal hourCodes op voor de CAO van de timezone (zonder ORT filter)
            var salaryScaleGroupId = (timezone && timezone.salaryScaleGroupId) || $stateParams['caoId'];
            if (salaryScaleGroupId) {
                return HourCodeService.getBySalaryScaleGroupIdForTimezones(salaryScaleGroupId);
            }
            // Als er geen CAO is, retourneer lege array
            return [];
        }]
    },
    modal: ['timezone', 'hourCodes'],
    component: 'timezonesItemBasicComponent'
};
// export const timezonesItemBasicState: aboTheme.IState = {
//   name: "settings.timezones.list.basic",
//   url: "/:id",
//   modal: ['timezone', 'hourCodes'],
//   resolve: {
//   },
//   component: 'timezonesItemBasicComponent'
// };
exports.staffState = {
    name: "settings.staff",
    url: "/staff",
    redirectTo: 'settings.staff.list',
    views: {
        "main": "staffComponent"
    },
    data: {
        permissions: {
            only: ['SUPERUSER'],
            redirectTo: 'schedule'
        }
    }
};
exports.staffListState = {
    name: "settings.staff.list",
    url: "/list",
    resolve: {
        staff: ["StaffService", function (StaffService) {
            'ngInject';
            return StaffService.all();
        }]
    },
    views: {
        "main": "staffListComponent"
    }
};
exports.staffItemState = {
    name: "settings.staff.list.item",
    url: "/:id",
    // modal: [],
    resolve: {
        staff: ["StaffService", "$stateParams", function (StaffService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                // console.log($stateParams['id']);
                return StaffService.get($stateParams['id']);
            }
        }],
    },
    modal: [],
    component: 'staffItemComponent'
};
exports.masterdataState = {
    name: "settings.masterdata",
    url: "/masterdata",
    redirectTo: 'settings.masterdata.list',
    views: {
        "main": "masterdataComponent"
    },
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.masterdataListState = {
    name: "settings.masterdata.list",
    url: "/list?:tab",
    params: {
        tab: { dynamic: true },
    },
    resolve: {
        item: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
        }]
    },
    views: {
        "main": 'masterdataListComponent'
    }
};
exports.masterdataListEditState = {
    name: "settings.masterdata.list.edit",
    url: "/edit/:id?:type",
    params: {
        id: null,
        type: null
    },
    modal: true,
    resolve: {
        item: ["MasterdataAService", "$stateParams", function (MasterdataAService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] !== '') {
                return MasterdataAService.get($stateParams['id']);
            }
        }]
    },
    component: 'masterdataEditComponent'
};
exports.nmbrsTestState = {
    name: "settings.nmbrsTest",
    url: "/nmbrs-test",
    views: {
        "main": "nmbrsTestComponent"
    },
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.hourCodesState = {
    name: "settings.hourcodes",
    url: "/hourcodes",
    redirectTo: 'settings.hourcodes.list',
    views: {
        "main": "hourCodesComponent"
    }
};
exports.hourCodesListState = {
    name: "settings.hourcodes.list",
    url: "/list?:selectedCaoId",
    params: {
        selectedCaoId: { dynamic: true }
    },
    views: {
        "main": 'hourCodesListComponent'
    }
};
exports.hourCodesItemState = {
    name: "settings.hourcodes.list.item",
    url: "/:id?:caoId",
    resolve: {
        hourCode: ["HourCodeService", "$stateParams", function (HourCodeService, $stateParams) {
            'ngInject';
            if ($stateParams['id'] != '') {
                return HourCodeService.get($stateParams['id']);
            }
        }]
    },
    modal: ['hourCode'],
    component: 'hourCodesItemBasicComponent'
};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StaffController = /** @class */ (function () {
    function StaffController() {
        'ngInject';
    }
    return StaffController;
}());
exports.staffComponent = {
    controller: StaffController,
    template: __webpack_require__(477)
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StaffItemController = /** @class */ (function () {
    StaffItemController.$inject = ["StaffService", "$state", "SweetAlert", "$scope"];
    function StaffItemController(StaffService, $state, SweetAlert, $scope) {
        'ngInject';
        var _this = this;
        this.StaffService = StaffService;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
        this.$scope = $scope;
        this.rolesList = ['backoffice', 'superuser', 'finance', 'timesheets'];
        this.password = '';
        this.confirmPassword = '';
        this.$onInit = function () {
            _this.staff = _this.resolve.staff;
            if (_this.staff.id) {
                _this.getUser();
            }
        };
        this.getUser = function () {
            _this.StaffService.getUser(_this.staff.id).then(function (user) {
                _this.user = user;
                if (_this.user.id) {
                    _this.getRoles();
                }
            });
        };
        this.getRoles = function () {
            _this.StaffService.getRoles(_this.staff.id).then(function (roles) {
                _this.roles = roles;
            });
        };
        this.save = function () {
            if (_this.$scope.staffBasicInfoForm.$valid) {
                if (_this.staff.id) {
                    _this.StaffService.put(_this.staff.id, _this.staff).then(function (staff) {
                        _this.staff = staff;
                        _this.StaffService.putRoles(_this.staff.id, _this.roles).then(function (roles) {
                            _this.roles = roles;
                        });
                        if (_this.password.length > 0) {
                            _this.StaffService.putPassword(_this.staff.id, _this.password).then(function (roles) {
                                _this.password = '';
                                _this.confirmPassword = '';
                            });
                        }
                    });
                }
                else {
                    _this.StaffService.post(_this.staff).then(function (staff) {
                        _this.staff = staff;
                        _this.$state.go('settings.staff.list.item', { id: _this.staff.id }, { reload: true });
                    });
                }
            }
        };
        this.createuser = function () {
            var user = {
                userName: _this.staff.email,
                email: _this.staff.email,
                phoneNumber: _this.staff.phoneNumber,
                password: _this.password,
                twoFactorEnabled: false
            };
            if (!_this.user && _this.staff.id) {
                _this.StaffService.createUser(_this.staff.id, user).then(function (user) {
                    _this.password = '';
                    _this.confirmPassword = '';
                    _this.user = user;
                });
            }
        };
        this.deleteUser = function () {
            if (_this.staff.id && _this.user) {
                _this.StaffService.deleteUser(_this.staff.id).then(function (user) {
                });
            }
        };
        this.delete = function () {
            if (_this.staff.id) {
                if (_this.user) {
                    _this.StaffService.deleteUser(_this.staff.id).then(function (user) {
                        _this.StaffService.delete(_this.staff.id).then(function (user) {
                            _this.$state.go('^', {}, { reload: true });
                        });
                    });
                }
                else {
                    _this.StaffService.delete(_this.staff.id).then(function (user) {
                        _this.$state.go('^', {}, { reload: true });
                    });
                }
            }
        };
    }
    return StaffItemController;
}());
exports.staffItemComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: StaffItemController,
    template: __webpack_require__(478)
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StaffListController = /** @class */ (function () {
    function StaffListController() {
        "ngInject";
    }
    return StaffListController;
}());
exports.staffListComponent = {
    bindings: {
        staff: "<"
    },
    controller: StaffListController,
    template: __webpack_require__(479)
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// import * as monaco from "monaco-editor/min/vs/editor/editor.main.js";
var TemplatesEditorController = /** @class */ (function () {
    TemplatesEditorController.$inject = ["TemplatesService", "SweetAlert"];
    function TemplatesEditorController(TemplatesService, SweetAlert) {
        "ngInject";
        var _this = this;
        this.TemplatesService = TemplatesService;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            // monaco.editor.create(document.getElementById("container"), {
            //     value: "function hello() {\n\talert('Hello world!');\n}",
            //     language: "javascript"
            // });
            // console.log('TemplatesEditorController init');
            var onGotAmdLoader = function () {
                // Load monaco
                window.require.config({ paths: { 'vs': '/vs' } });
                window.require(['vs/editor/editor.main'], function () {
                    _this.initMonaco();
                });
            };
            // Load AMD loader if necessary
            if (!window.require) {
                var loaderScript = document.createElement('script');
                loaderScript.type = 'text/javascript';
                loaderScript.src = '/vs/loader.js';
                loaderScript.addEventListener('load', onGotAmdLoader);
                document.body.appendChild(loaderScript);
            }
            else {
                onGotAmdLoader();
            }
        };
        this.sweetAlert = SweetAlert;
    }
    // Will be called once monaco library is available
    TemplatesEditorController.prototype.initMonaco = function () {
        window.editor = window.monaco.editor.create(document.getElementById("container"), {
            value: '',
            language: 'razor'
        });
    };
    TemplatesEditorController.prototype.getTemplate = function () {
        this.TemplatesService.customGet('template/' + this.currentTemplateName).then(function (result) {
            window.editor.setValue(result);
        });
    };
    TemplatesEditorController.prototype.saveTemplate = function () {
        var _this = this;
        var value = window.editor.getValue();
        // console.log(value);
        this.TemplatesService.customPut('template/' + this.currentTemplateName, '"' + value.replace(/[\\"']/g, '\\$&') + '"').then(function () {
            _this.sweetAlert.swal('Updated!', 'Template has been succesfully updated!', 'success');
        });
    };
    return TemplatesEditorController;
}());
exports.templatesEditorComponent = {
    bindings: {
        templatesNames: "<"
    },
    controller: TemplatesEditorController,
    template: __webpack_require__(480)
};


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimezonesController = /** @class */ (function () {
    function TimezonesController() {
        'ngInject';
    }
    return TimezonesController;
}());
exports.timezonesComponent = {
    controller: TimezonesController,
    template: __webpack_require__(481)
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {
Object.defineProperty(exports, "__esModule", { value: true });
var timezone_service_1 = __webpack_require__(270);
var moment = __webpack_require__(0);
var TimezonesItemBasicController = /** @class */ (function () {
    TimezonesItemBasicController.$inject = ["TimezonesService", "SalaryScaleGroupService", "HourCodeService", "$state", "$stateParams", "$timeout", "SweetAlert"];
    function TimezonesItemBasicController(TimezonesService, SalaryScaleGroupService, HourCodeService, $state, $stateParams, $timeout, SweetAlert) {
        'ngInject';
        var _this = this;
        this.TimezonesService = TimezonesService;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.HourCodeService = HourCodeService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.SweetAlert = SweetAlert;
        this.hourCodes = [];
        this.salaryScaleGroups = [];
        this.types = [
            'Dagelijks', 'Dag van de week', 'Vaste dag elk jaar', 'Eenmalig'
        ];
        this.months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
        this.weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
        this.from = {};
        this.till = {};
        this.$onInit = function () {
            if (_this.resolve.timezone) {
                _this.timezone = _this.resolve.timezone;
                // Laad hourCodes voor de CAO van deze timezone
                if (_this.timezone.salaryScaleGroupId) {
                    _this.loadHourCodes(_this.timezone.salaryScaleGroupId);
                }
                else if (_this.resolve.hourCodes && _this.resolve.hourCodes.length > 0) {
                    // Fallback: gebruik hourCodes uit resolve als er geen CAO is
                    _this.hourCodes = _this.resolve.hourCodes;
                }
            }
            else {
                _this.timezone = new timezone_service_1.ITimezone();
                // Get caoId from state params if available (for new timezones)
                var caoId = _this.$stateParams['caoId'];
                _this.timezone = {
                    from: null,
                    till: null,
                    percentage: 0,
                    amount: 0,
                    priority: 0,
                    dayOfWeek: 0,
                    fixedDate: false,
                    fixedDateWithoutYear: false,
                    salaryScaleGroupId: caoId || null,
                };
                // Laad hourCodes als er een CAO is
                if (caoId) {
                    _this.loadHourCodes(caoId);
                }
                else if (_this.resolve.hourCodes && _this.resolve.hourCodes.length > 0) {
                    // Fallback: gebruik hourCodes uit resolve
                    _this.hourCodes = _this.resolve.hourCodes;
                }
            }
            // Load salary scale groups
            _this.SalaryScaleGroupService.all().then(function (result) {
                // Sort alphabetically by name
                _this.salaryScaleGroups = result.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Trigger chosen update after data is loaded
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('select[name="salaryScaleGroup"]').trigger('chosen:updated');
                    }
                }, 0);
            });
            if (_this.timezone.dayOfWeek != null) {
                _this.type = _this.types[1];
            }
            else if (_this.timezone.fixedDateWithoutYear) {
                _this.type = _this.types[2];
            }
            else if (_this.timezone.fixedDate) {
                _this.type = _this.types[3];
            }
            else {
                _this.type = _this.types[0];
            }
            _this.from.weekDay = _this.weekDays[_this.timezone.dayOfWeek];
            _this.from.day = parseInt(moment(_this.timezone.from).format("DD"));
            _this.from.month = _this.months[parseInt(moment(_this.timezone.from).format("MM")) - 1];
            _this.from.year = moment(_this.timezone.from).format("YYYY");
            _this.from.time = moment(_this.timezone.from).format("HH:mm");
            _this.till.weekDay = _this.weekDays[_this.timezone.dayOfWeek];
            _this.till.day = parseInt(moment(_this.timezone.till).format("DD"));
            _this.till.month = _this.months[parseInt(moment(_this.timezone.till).format("MM")) - 1];
            _this.till.year = moment(_this.timezone.till).format("YYYY");
            _this.till.time = moment(_this.timezone.till).format("HH:mm");
        };
        this.loadHourCodes = function (salaryScaleGroupId) {
            _this.HourCodeService.getBySalaryScaleGroupIdForTimezones(salaryScaleGroupId).then(function (result) {
                _this.hourCodes = result || [];
                // Trigger chosen update
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('select[name="hourCode"]').trigger('chosen:updated');
                    }
                }, 0);
            });
        };
        this.watchSalaryScaleGroup = function () {
            if (_this.timezone && _this.timezone.salaryScaleGroupId) {
                _this.loadHourCodes(_this.timezone.salaryScaleGroupId);
            }
            else {
                _this.hourCodes = [];
                _this.$timeout(function () {
                    if (__webpack_provided_window_dot_jQuery && __webpack_provided_window_dot_jQuery.fn.chosen) {
                        __webpack_provided_window_dot_jQuery('select[name="hourCode"]').trigger('chosen:updated');
                    }
                }, 0);
            }
        };
        this.closeModal = function () {
            // Preserve selected CAO when closing modal
            var selectedCaoId = _this.timezone.salaryScaleGroupId || _this.$stateParams['caoId'];
            // Navigate back to list with selected CAO preserved
            _this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId || null }, { reload: false });
        };
    }
    TimezonesItemBasicController.prototype.submitTimezone = function () {
        // this.timezone.from = moment(this.timezone.from).format("YYYY-MM-DD HH:mm");
        // this.timezone.till = moment(this.timezone.till).format("YYYY-MM-DD HH:mm");
        var _this = this;
        var fromDay = this.from.day < 10 ? '0' + this.from.day : this.from.day;
        var fromMonth = this.months.indexOf(this.from.month) + 1 < 10 ? '0' + (this.months.indexOf(this.from.month) + 1) : this.months.indexOf(this.from.month) + 1;
        var tillDay = this.till.day < 10 ? '0' + this.till.day : this.till.day;
        var tillMonth = this.months.indexOf(this.till.month) + 1 < 10 ? '0' + (this.months.indexOf(this.till.month) + 1) : this.months.indexOf(this.till.month) + 1;
        var fts = this.from.time.split(':');
        var fromtimehour = fts[0] < 10 && fts[0].length < 2 ? '0' + fts[0] : fts[0];
        var fromtime = fromtimehour + ':' + fts[1] + ':00';
        var tts = this.till.time.split(':');
        var tilltimehour = tts[0] < 10 && tts[0].length < 2 ? '0' + tts[0] : tts[0];
        var tilltime = tilltimehour + ':' + tts[1] + ':00';
        if (this.type == this.types[0]) {
            this.timezone.from = '1900-01-01T' + fromtime;
            this.timezone.till = '1900-01-01T' + tilltime;
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }
        if (this.type == this.types[1]) {
            this.timezone.from = '1900-01-01T' + fromtime;
            this.timezone.till = '1900-01-01T' + tilltime;
            this.timezone.dayOfWeek = this.weekDays.indexOf(this.from.weekDay);
            this.timezone.fixedDate = false;
            this.timezone.fixedDateWithoutYear = false;
        }
        if (this.type == this.types[2]) {
            this.timezone.from = '1900-' + fromMonth + '-' + fromDay + 'T' + fromtime;
            this.timezone.till = '1900-' + tillMonth + '-' + tillDay + 'T' + tilltime;
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = true;
        }
        if (this.type == this.types[3]) {
            this.timezone.from = this.from.year + '-' + fromMonth + '-' + fromDay + 'T' + fromtime;
            this.timezone.till = this.from.year + '-' + tillMonth + '-' + tillDay + 'T' + tilltime;
            this.timezone.dayOfWeek = null;
            this.timezone.fixedDate = true;
            this.timezone.fixedDateWithoutYear = false;
        }
        if (this.timezone.id === undefined) {
            this.TimezonesService.post(this.timezone).then(function (result) {
                // Preserve selected CAO when navigating back
                var selectedCaoId = _this.timezone.salaryScaleGroupId || _this.$stateParams['caoId'];
                _this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId }, { reload: true });
            });
        }
        else {
            this.TimezonesService.put(this.timezone.id, this.timezone).then(function (result) {
                // Preserve selected CAO when navigating back
                var selectedCaoId = _this.timezone.salaryScaleGroupId;
                _this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedCaoId }, { reload: true });
            });
        }
    };
    TimezonesItemBasicController.prototype.deleteTimezone = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.TimezonesService.delete(_this.timezone.id).then(function () {
                    _this.$state.go('^', { reload: true });
                });
            }
            else {
            }
        });
    };
    TimezonesItemBasicController.prototype.startDateBeforeRender = function ($dates) {
        // console.log('startDateBeforeRender');
        var todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
    };
    TimezonesItemBasicController.prototype.endDateBeforeRender = function ($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.timezone.from) {
            var activeDate = moment(this.timezone.from).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    return TimezonesItemBasicController;
}());
exports.timezonesItemBasicComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: TimezonesItemBasicController,
    template: __webpack_require__(482)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimezonesItemController = /** @class */ (function () {
    TimezonesItemController.$inject = ["TimezonesService", "$state", "SweetAlert"];
    function TimezonesItemController(TimezonesService, $state, SweetAlert) {
        'ngInject';
        this.TimezonesService = TimezonesService;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
    }
    TimezonesItemController.prototype.deleteTimezone = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.TimezonesService.delete(_this.timezone.id).then(function () {
                    _this.$state.go('^', { reload: true });
                });
            }
            else {
            }
        });
    };
    return TimezonesItemController;
}());
exports.timezonesItemComponent = {
    controller: TimezonesItemController,
    bindings: {
        timezone: '<',
        hourCodes: '<'
    },
    template: __webpack_require__(483)
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimezonesListController = /** @class */ (function () {
    TimezonesListController.$inject = ["SalaryScaleGroupService", "$state", "$stateParams"];
    function TimezonesListController(SalaryScaleGroupService, $state, $stateParams) {
        'ngInject';
        var _this = this;
        this.SalaryScaleGroupService = SalaryScaleGroupService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
        this.$onInit = function () {
            _this.loadSalaryScaleGroups();
        };
        this.loadSalaryScaleGroups = function () {
            _this.SalaryScaleGroupService.all().then(function (result) {
                // Sort alphabetically by name
                _this.salaryScaleGroups = result.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
                // Restore selectedGroup from state params if available
                var selectedGroupId = _this.$stateParams['selectedCaoId'];
                if (selectedGroupId) {
                    var group = _this.salaryScaleGroups.find(function (g) { return g.id === selectedGroupId; });
                    if (group) {
                        _this.selectedGroup = group;
                    }
                }
                else if (_this.selectedGroup) {
                    // Update selectedGroup als die nog bestaat
                    var updatedGroup = _this.salaryScaleGroups.find(function (g) { return g.id === _this.selectedGroup.id; });
                    if (updatedGroup) {
                        _this.selectedGroup = updatedGroup;
                    }
                }
            });
        };
        this.clearSelection = function () {
            _this.selectedGroup = null;
            // Clear selected CAO ID from state params
            _this.$state.go('settings.timezones.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
        };
        this.onGroupChange = function (selectedGroup) {
            _this.selectedGroup = selectedGroup;
            // Save selected CAO ID to state params
            _this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedGroup ? selectedGroup.id : null }, { location: 'replace', notify: false });
        };
        this.addTimezone = function () {
            if (!_this.selectedGroup || !_this.selectedGroup.id) {
                alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een timezone toe te voegen.');
                return;
            }
            _this.$state.go('settings.timezones.list.item', { 'id': '', 'caoId': _this.selectedGroup.id });
        };
        this.caoFilter = function (item) {
            if (!_this.selectedGroup || !_this.selectedGroup.id) {
                return false;
            }
            return item.salaryScaleGroupId === _this.selectedGroup.id;
        };
        this.sortType = 'from';
    }
    return TimezonesListController;
}());
exports.timezonesListComponent = {
    controller: TimezonesListController,
    bindings: {
        timezones: '<'
    },
    template: __webpack_require__(484)
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var angular = __webpack_require__(5);
var DateTimePickerController = /** @class */ (function () {
    DateTimePickerController.$inject = ["$element", "$attrs", "$timeout"];
    function DateTimePickerController($element, $attrs, $timeout) {
        'ngInject';
        var _this = this;
        this.$element = $element;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.time = true;
        this.$onInit = function () {
            if (!_this.$attrs.time) {
                _this.time = true;
            }
            _this.previousDate = angular.copy(_this.date);
            $(_this.$element).find('.datepicker').datepicker({
                format: 'dd-mm-yyyy',
                language: 'nl',
                autoclose: true,
            });
            _this.$timeout(function () {
                $(_this.$element).find('.open-datetimepicker').click(function (event) {
                    event.preventDefault();
                    $(_this.$element).find('.datepicker').datepicker('show');
                });
                $(_this.$element).find('.timepickerinput').timepicker({
                    showMeridian: false,
                    minuteStep: 5
                }).on('hide.timepicker', function (e) {
                    _this.$timeout(function () {
                        _this.setTime();
                    });
                });
                _this.dateformat = moment(_this.date).format('DD-MM-YYYY');
                _this.timeformat = moment(_this.date).format('HH:mm');
                $(_this.$element).find('.datepicker').datepicker('setDate', _this.dateformat);
                $(_this.$element).find('.timepickerinput').timepicker('setTime', _this.timeformat);
                _this.checkMinDate();
            });
            _this.classes = _this.addClass;
        };
        this.$doCheck = function () {
            if (!angular.equals(_this.date, _this.previousDate)) {
                // console.log('previousDate', this.previousDate)
                _this.dateformat = moment(_this.date).format('DD-MM-YYYY');
                _this.timeformat = moment(_this.date).format('HH:mm');
                $(_this.$element).find('.timepickerinput').timepicker('setTime', _this.timeformat);
                if (_this.previousDate) {
                    $(_this.$element).find('.datepicker').datepicker('setDate', _this.dateformat);
                }
                _this.previousDate = angular.copy(_this.date);
                _this.$timeout(function () {
                    _this.checkMinDate();
                });
            }
        };
        this.$onChanges = function (changes) {
            if (changes.minDate && changes.minDate.previousValue.constructor.name != 'UNINITIALIZED_VALUE') {
                _this.$timeout(function () {
                    _this.checkMinDate();
                });
            }
        };
        this.checkMinDate = function () {
            if (_this.minDate && _this.date) {
                //console.log(moment(this.date).format('DD-MM-YYYY'));
                //console.log(this.minDate);
                // if (moment(this.minDate).isAfter(this.date)) {
                //     this.date = moment(this.minDate).add(1, 'hour');
                //     this.dateformat = moment(this.date).format('DD-MM-YYYY');
                //     this.timeformat = moment(this.date).format('HH:mm');
                //     $(this.$element).find('.datepicker').datepicker('setDate', this.dateformat);
                // }
                $(_this.$element).find('.datepicker').datepicker('setStartDate', moment(_this.minDate).format('DD-MM-YYYY'));
            }
        };
        this.setDate = function () {
            if (_this.dateformat && _this.timeformat) {
                if (_this.time) {
                    _this.date = moment(_this.dateformat + ' ' + _this.timeformat, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');
                }
                else {
                    _this.date = moment(_this.dateformat, 'DD-MM-YYYY').format('YYYY-MM-DD');
                }
                _this.$timeout(function () { _this.onChange(); });
            }
        };
        this.setTime = function () {
            if (_this.dateformat && _this.timeformat) {
                _this.date = moment(_this.dateformat + ' ' + _this.timeformat, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');
                _this.$timeout(function () { _this.onChange(); });
            }
        };
    }
    return DateTimePickerController;
}());
exports.dateTimePickerComponent = {
    bindings: {
        date: '=',
        time: '<',
        maxDate: '<',
        minDate: '<',
        onChange: '&',
        addClass: '<',
        disabled: '<'
    },
    controller: DateTimePickerController,
    template: __webpack_require__(485)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ListController = /** @class */ (function () {
    ListController.$inject = ["SweetAlert"];
    function ListController(SweetAlert) {
        'ngInject';
        var _this = this;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            _this.currentPage = 1;
            _this.itemsPerPage = 25;
            _this.maxSize = 3;
            var setFields = { description: null };
            if (_this.fields) {
                _this.fields = JSON.parse(_this.fields.replace(/\'/g, '"'));
            }
            else {
                _this.fields = {};
            }
            _this.setFields = {
                description: _this.fields.description ? _this.fields.description : 'description',
                tags: _this.fields.tags ? _this.fields.tags : 'tags',
                date: _this.fields.date ? _this.fields.date : 'date',
                endDate: _this.fields.endDate ? _this.fields.endDate : 'endDate'
            };
        };
    }
    ListController.prototype.delete = function (event, item) {
        var _this = this;
        event.stopPropagation();
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u ' + item[this.setFields.description] + ' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.onUpdate({ item: item, action: 'delete' });
            }
            else {
            }
        });
    };
    ListController.prototype.edit = function (item) {
        this.onUpdate({ item: item, action: 'edit' });
    };
    return ListController;
}());
exports.listComponent = {
    bindings: {
        list: '<',
        onUpdate: '&',
        fields: '@',
        hideDelete: '<'
    },
    controller: ListController,
    template: __webpack_require__(486)
};


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __webpack_require__(13);
var UploaderController = /** @class */ (function () {
    UploaderController.$inject = ["AuthService", "FileUploader"];
    function UploaderController(AuthService, FileUploader) {
        'ngInject';
        var _this = this;
        this.AuthService = AuthService;
        this.FileUploader = FileUploader;
        this.$onInit = function () {
            _this.uploadOptions = {
                url: config_1.default.API_URL + _this.url,
                removeAfterUpload: true,
                headers: {
                    'Authorization': 'Bearer ' + _this.AuthService.GetAuthorizationData()
                },
            };
            _this.uploader = new _this.FileUploader();
            _this.uploader.onCompleteItem = function (item, response, status, headers) {
                _this.onCompleteItem({ item: item, response: response, status: status, headers: headers });
            };
            _this.uploader.onCompleteAll = function () {
                _this.onCompleteAll();
                _this.onUpload();
            };
        };
    }
    return UploaderController;
}());
exports.uploaderComponent = {
    bindings: {
        url: "<",
        single: "<",
        onUpload: "&",
        onCompleteItem: "&",
        onCompleteAll: "&"
    },
    controller: UploaderController,
    template: __webpack_require__(487)
};


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var authusers_service_1 = __webpack_require__(259);
var _ = __webpack_require__(6);
var UserAccountController = /** @class */ (function () {
    UserAccountController.$inject = ["AuthUserService", "EmployeesService", "ContactsService", "$state", "SweetAlert"];
    function UserAccountController(AuthUserService, EmployeesService, ContactsService, $state, SweetAlert) {
        'ngInject';
        var _this = this;
        this.AuthUserService = AuthUserService;
        this.EmployeesService = EmployeesService;
        this.ContactsService = ContactsService;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
        this.checkUserType = function () {
            if (_this.contact)
                return 'contact';
            if (_this.employee)
                return 'employee';
            else
                return undefined;
        };
        this.$onInit = function () {
            _this.newUser = true;
            var userType = _this.checkUserType();
            if (_this[userType].userId) {
                _this.AuthUserService.get(_this[userType].userId).then(function (res) {
                    _this.userAccount = res;
                    _this.newUser = false;
                });
            }
        };
        this.prepareEmployeeForUser = function (employee) {
            var user = {
                displayName: employee.displayName,
                roles: ['EMPLOYEE'],
                email: employee.emailPrivate,
                userName: employee.emailPrivate,
                password: _this.password,
                claims: { 'employeeId': employee.id },
            };
            return user;
        };
        this.prepareContactForUser = function (contact) {
            var user = {
                displayName: contact.name,
                roles: ['CUSTOMER'],
                email: contact.emailAddress,
                userName: contact.emailAddress,
                password: _this.password,
                claims: { 'contactId': contact.id, 'customerId': contact.accountId },
            };
            return user;
        };
        this.createUser = function () {
            var user = new authusers_service_1.IAuthUser();
            if (_this.employee) {
                var user_1 = _this.prepareEmployeeForUser(_this.employee);
                _this.AuthUserService.post(user_1).then(function (result) {
                    _this.employee.userId = result.id;
                    _this.employee.userName = _this.employee.emailPrivate;
                    _this.EmployeesService.put(_this.employee.id, _this.employee).then(function (result) {
                        _this.employee = result;
                        _this.$onInit();
                    });
                }).catch(function (error) {
                    _this.AuthUserService.all().then(function (users) {
                        var existUser = _.find(users, { userName: user_1.userName });
                        _this.SweetAlert.swal({
                            title: "User already exist!",
                            text: "User with " + existUser.userName + " do you want to connect this user to this contactperson?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, connect it!",
                            closeOnConfirm: false
                        }, function (isConfirm) {
                            _this.employee.userId = existUser.id;
                            _this.employee.userName = existUser.userName;
                            _this.EmployeesService.put(_this.employee.id, _this.employee).then(function (employee) {
                                _this.employee = employee;
                                _this.$onInit();
                            });
                        });
                    });
                });
            }
            if (_this.contact) {
                var user_2 = _this.prepareContactForUser(_this.contact);
                _this.AuthUserService.post(user_2).then(function (result) {
                    _this.contact.userId = result.id;
                    _this.ContactsService.put(_this.contact.id, _this.contact).then(function (result) {
                        _this.contact = result;
                        _this.$onInit();
                    });
                });
            }
        };
        this.deleteUser = function () {
            if (_this.employee) {
                _this.AuthUserService.delete(_this.employee.userId).then(function (result) {
                    _this.employee.userId = undefined;
                    _this.EmployeesService.put(_this.employee.id, _this.employee).then(function (employee) {
                        _this.employee = employee;
                        _this.$onInit();
                    });
                });
            }
            if (_this.contact) {
                _this.AuthUserService.delete(_this.contact.userId).then(function (result) {
                    _this.contact.userId = undefined;
                    _this.ContactsService.put(_this.contact.id, _this.contact).then(function (contact) {
                        _this.contact = contact;
                        _this.$onInit();
                    });
                });
            }
        };
    }
    return UserAccountController;
}());
exports.userAccountComponent = {
    bindings: {
        contact: "<",
        employee: "<"
    },
    controller: UserAccountController,
    template: __webpack_require__(488)
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var moment = __webpack_require__(0);
var CheckAvailabilityModalController = /** @class */ (function () {
    CheckAvailabilityModalController.$inject = ["ShiftService", "EmployeesService", "AccountsService", "MasterdataAService", "LocationService", "$stateParams", "$state", "$timeout", "$window"];
    function CheckAvailabilityModalController(ShiftService, EmployeesService, AccountsService, MasterdataAService, LocationService, $stateParams, $state, $timeout, $window) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.AccountsService = AccountsService;
        this.MasterdataAService = MasterdataAService;
        this.LocationService = LocationService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$onInit = function () {
            _this.MasterdataAService.getItems('Functions').then(function (result) {
                _this.functions = result;
            });
            _this.AccountsService.all().then(function (result) {
                _this.accounts = result;
            });
            _this.selectedEmployee = {};
            _this.activeEmployee = {};
            _this.setModalHeight();
            _this.$window.onresize = function (event) {
                _this.setModalHeight();
            };
        };
        this.setModalHeight = function () {
            var docHeight = $(window).height();
            var height = docHeight - 200;
            $("#checkAvailabilityModalBody").height(height);
        };
    }
    CheckAvailabilityModalController.prototype.startDateBeforeRender = function ($dates) {
    };
    CheckAvailabilityModalController.prototype.endDateBeforeRender = function ($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    CheckAvailabilityModalController.prototype.startDateChanged = function () {
        this.shift.end = moment(this.shift.start).add(8, 'hour').toDate();
        if (this.shift.teamLocationId) {
            this.dataFilledIn();
        }
    };
    CheckAvailabilityModalController.prototype.endDateChanged = function () {
        if (this.shift.teamLocationId) {
            this.dataFilledIn();
        }
    };
    CheckAvailabilityModalController.prototype.dataFilledIn = function () {
        var _this = this;
        if (this.shift.start && this.shift.end) {
            var request = {
                accountId: this.shift.teamLocationAccountId,
                locationId: this.shift.teamLocationId,
                startDate: this.shift.start,
                endDate: this.shift.end,
                shiftId: this.shift.id
            };
            this.EmployeesService.customPost('availableEmployees', request, false).then(function (result) {
                _this.employees = result;
            });
        }
    };
    CheckAvailabilityModalController.prototype.selectedAccount = function () {
        var _this = this;
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then(function (result) {
            _this.locations = result;
        });
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'notes/?tag=planning').then(function (result) {
            _this.accountNotes = result;
        });
    };
    CheckAvailabilityModalController.prototype.locationSelected = function () {
        var _this = this;
        this.teams = this.locations.find(function (item) { return item.id === _this.shift.teamLocationId; }).teams;
        this.dataFilledIn();
    };
    CheckAvailabilityModalController.prototype.submitShift = function (after) {
        var _this = this;
        if (after === void 0) { after = null; }
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.employeeId) {
            this.shift.status = 5;
        }
        else {
            this.shift.status = 3;
        }
        if (!this.shift.id) {
            this.ShiftService.post(this.shift).then(function (data) {
                _this.shift = data;
                _this.shifts.push(_this.shift);
                _this.closeModal();
            });
        }
        else {
            this.ShiftService.put(this.shift.id, this.shift).then(function (data) {
                _this.shift = data;
                _this.shifts = _this.shifts.filter(function (s) { return s.id !== _this.shift.id; });
                _this.shifts.push(_this.shift);
                _this.closeModal();
            });
        }
    };
    CheckAvailabilityModalController.prototype.closeModal = function () {
        this.selectedEmployee = {};
        this.activeEmployee = {};
        this.employees = null;
        this.shift = new index_1.IShift();
        $('#check-availability-modal').modal('hide');
    };
    return CheckAvailabilityModalController;
}());
exports.checkAvailabilityModalComponent = {
    controller: CheckAvailabilityModalController,
    bindings: {
        shifts: '=',
        shift: '=',
        locations: '=',
        teams: '=',
        accountNotes: '=',
        employees: '=',
        selectedEmployee: '='
    },
    template: __webpack_require__(489)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(7);
var EmployeePickerController = /** @class */ (function () {
    EmployeePickerController.$inject = ["$scope", "SweetAlert", "EmployeesService"];
    function EmployeePickerController($scope, SweetAlert, EmployeesService) {
        'ngInject';
        var _this = this;
        this.$scope = $scope;
        this.SweetAlert = SweetAlert;
        this.EmployeesService = EmployeesService;
        this.functions = [];
        this.ranges = [];
        this.availabilities = [];
        this.history = [];
        this.subscription = [];
        this.$onInit = function () {
            _this.ranges = [
                {
                    name: '0 to 5',
                    min: 0,
                    max: 5,
                    value: false
                },
                {
                    name: '5 to 15',
                    min: 5,
                    max: 15,
                    value: false
                },
                {
                    name: '15 to 50',
                    min: 15,
                    max: 50,
                    value: false
                },
                {
                    name: '50 to 100',
                    min: 50,
                    max: 100,
                    value: false
                },
                {
                    name: 'More than 100',
                    min: 100,
                    max: 5000,
                    value: false
                }
            ];
            _this.availabilities = [];
            _this.history = [];
            _this.subscription = [];
            //this.allEmployees = this.employees;
            // this.selectedEmployee = this.employees.find(e => e.employee.id == this.shift.employeeId);
            // this.$scope.$watch('this.shift.employeeId', function(newVal, oldVal){
            //     this.selectedEmployee = this.employees.find(e => e.employee.id == this.shift.employeeId);
            // }, true);
        };
        this.$onChanges = function (changes) {
            _this.allEmployees = [];
            if (changes.employees) {
                _this.allEmployees = _this.employees;
                _this.filterEmployees();
                if (_this.allEmployees && _this.allEmployees.length > 0) {
                    _this.allEmployees.forEach(function (item) {
                        if (item.isAvailable) {
                            if (item.subscription) {
                                item.order = 1;
                            }
                            else if (item.availability) {
                                item.order = 2;
                            }
                            else if (!item.availability) {
                                item.order = 4;
                            }
                        }
                        else {
                            if (item.subscription) {
                                item.order = 3;
                            }
                            else {
                                item.order = 5;
                            }
                        }
                    });
                }
            }
        };
    }
    EmployeePickerController.prototype.employeeSelected = function (employeeSummary) {
        var _this = this;
        this.onSelectEmployee();
        if (this.selectedEmployee && this.selectedEmployee.employee.id === employeeSummary.employee.id) {
            this.selectedEmployee = null;
            this.shift.employeeId = null;
            return true;
        }
        if (employeeSummary.conflictingShift) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Deze medewerker heeft al een dienst op dit tijdstip! Wil je deze medewerker alsnog koppelen?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Nee, annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.selectedEmployee = employeeSummary;
                    _this.shift.employeeId = _this.selectedEmployee.employee.id;
                }
                else { }
            });
        }
        else {
            this.selectedEmployee = employeeSummary;
            this.shift.employeeId = this.selectedEmployee.employee.id;
        }
    };
    EmployeePickerController.prototype.employeeActive = function (employeeSummary) {
        this.activeEmployee = employeeSummary;
    };
    EmployeePickerController.prototype.filterEmployees = function () {
        this.employees = this.allEmployees;
        if (this.functions) {
            var selectedFunctions = this.functions.filter(function (f) { return f.value; }).map(function (f) { return f.id; });
            if (selectedFunctions.length > 0) {
                this.employees = this.employees.filter(function (e) { return selectedFunctions.indexOf(e.employee.functionId) > -1; });
            }
        }
        var selectedRanges = this.ranges.filter(function (r) { return r.value; });
        if (selectedRanges.length > 0) {
            var minRange = Math.min.apply(null, selectedRanges.map(function (r) { return parseFloat(r.min); }));
            var maxRange = Math.max.apply(null, selectedRanges.map(function (r) { return parseFloat(r.max); }));
            this.employees = this.employees.filter(function (e) { return e.employee.kilometers > minRange && e.employee.kilometers < maxRange; });
        }
        if (this.availabilities.filter(function (a) { return a; }).length == 1) {
            if (this.availabilities[0]) {
                this.employees = this.employees.filter(function (e) { return e.isAvailable; });
            }
            if (this.availabilities[1]) {
                this.employees = this.employees.filter(function (e) { return !e.isAvailable; });
            }
        }
        if (this.history.filter(function (a) { return a; }).length == 1) {
            if (this.history[0]) {
                this.employees = this.employees.filter(function (e) { return e.history; });
            }
            if (this.history[1]) {
                this.employees = this.employees.filter(function (e) { return !e.history; });
            }
        }
        if (this.subscription.filter(function (a) { return a; }).length == 1) {
            if (this.subscription[0]) {
                this.employees = this.employees.filter(function (e) { return e.subscription; });
            }
            if (this.subscription[1]) {
                this.employees = this.employees.filter(function (e) { return !e.subscription; });
            }
        }
    };
    EmployeePickerController.prototype.removeSubscription = function (subscription, employeeSummary) {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze inschrijving wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.EmployeesService.customDelete('subscriptions/' + subscription.id).then(function () {
                    employeeSummary.subscription = false;
                });
            }
            else {
            }
        });
    };
    return EmployeePickerController;
}());
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = false;
        return _this;
    }
    return Filter;
}(index_1.Masterdata));
exports.employeePickerComponent = {
    bindings: {
        shift: '<',
        employees: '<',
        selectedEmployee: '<',
        activeEmployee: '<',
        functions: '<',
        isEmbedded: '<',
        disableFilter: '<',
        disableInfo: '<',
        onSelectEmployee: '&'
    },
    controller: EmployeePickerController,
    template: __webpack_require__(490)
};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmployeeSummaryController = /** @class */ (function () {
    function EmployeeSummaryController() {
        'ngInject';
        var _this = this;
        this.$onInit = function () {
            //this.employeeSummary.conflictingShift
            // {"employee":{"id":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":"Ebrina Kok","function":"Student VIG","functionId":"98e2e502-4693-e711-80c2-0003ff4b7b6b","addressId":null,"street":null,"number":null,"city":null},"conflictingShift":{"employeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":null,"start":"2017-12-12T11:00:00","end":"2017-12-13T12:00:00","statusId":6,"shiftId":"827f9853-8cde-e711-80c3-0003ff433d90"},"availability":{"EmployeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":"Ziek","value":null,"comment":null,"from":"2017-12-11T13:45:00","till":"2017-12-31T21:45:00"},"isAvailable":false,"subscription":{"employeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","comment":"TEST TEST"},"history":{"count":10,"dates":["2017-12-12T11:00:00","2017-12-11T13:15:00","2017-12-09T11:45:00"]}}
        };
        this.$onChanges = function (change) {
            if (_this.employeeSummary && _this.employeeSummary.conflictingShift && _this.shift) {
                if (_this.employeeSummary.conflictingShift.shiftId == _this.shift.id) {
                    _this.employeeSummary.conflictingShift = null;
                }
            }
        };
    }
    return EmployeeSummaryController;
}());
exports.employeeSummaryComponent = {
    bindings: {
        employeeSummary: '<',
        shift: '<',
        isEmbedded: '<'
    },
    controller: EmployeeSummaryController,
    template: __webpack_require__(491)
};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shift_list_employee_component_1 = __webpack_require__(685);
var shift_list_item_component_1 = __webpack_require__(686);
var calendar_service_1 = __webpack_require__(18);
var shift_list_component_1 = __webpack_require__(684);
var shift_calendar_component_1 = __webpack_require__(681);
var shift_item_component_1 = __webpack_require__(683);
var shift_component_1 = __webpack_require__(682);
var shift_states_1 = __webpack_require__(261);
var ngmodule_1 = __webpack_require__(4);
var employeeSummary_component_1 = __webpack_require__(679);
var checkAvailabilityModal_component_1 = __webpack_require__(677);
var employeePicker_component_1 = __webpack_require__(678);
var shift_states_2 = __webpack_require__(261);
var subscriptionsModal_component_1 = __webpack_require__(687);
var applicationsAppModule = {
    components: { shiftComponent: shift_component_1.shiftComponent, shiftItemComponent: shift_item_component_1.shiftItemComponent, shiftCalendarComponent: shift_calendar_component_1.shiftCalendarComponent, shiftListComponent: shift_list_component_1.shiftListComponent, checkAvailabilityModalComponent: checkAvailabilityModal_component_1.checkAvailabilityModalComponent, employeePickerComponent: employeePicker_component_1.employeePickerComponent, employeeSummaryComponent: employeeSummary_component_1.employeeSummaryComponent, shiftListItemComponent: shift_list_item_component_1.shiftListItemComponent, shiftListEmployeeComponent: shift_list_employee_component_1.shiftListEmployeeComponent, subscriptionsModalComponent: subscriptionsModal_component_1.subscriptionsModalComponent },
    states: [shift_states_1.shiftState, shift_states_1.shiftItemState, shift_states_1.shiftCalendarState, shift_states_1.shiftListState, shift_states_1.shiftListItemState, shift_states_1.checkAvailabilityState,
        shift_states_1.shiftListEmployeeState, shift_states_2.shiftListSubscriptionsModalState],
    services: { CalendarService: calendar_service_1.CalendarService }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, applicationsAppModule);


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var calendar_service_1 = __webpack_require__(18);
var moment = __webpack_require__(0);
var ShiftCalendarController = /** @class */ (function () {
    ShiftCalendarController.$inject = ["ShiftService", "CalendarService", "$state", "uiCalendarConfig", "$scope", "$compile"];
    function ShiftCalendarController(ShiftService, CalendarService, $state, uiCalendarConfig, $scope, $compile) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.CalendarService = CalendarService;
        this.$state = $state;
        this.uiCalendarConfig = uiCalendarConfig;
        this.$scope = $scope;
        this.$compile = $compile;
        this.eventSources = [];
        this.$onInit = function () {
            // console.log('ShiftCalendarController');
            // var eventSource = {
            //     url: 'http://www.google.com/calendar/feeds/usa__en%40holiday.calendar.google.com/public/basic',
            //     className: 'gcal-event', // an option!
            //     currentTimezone: 'America/Chicago' // an option!
            // };
            _this.eventSources = [_this.getEvents];
            _this.uiConfig = {
                calendar: {
                    height: 700,
                    locale: 'nl',
                    header: {
                        left: 'title',
                        right: ' prev,next month,agendaWeek,agendaDay'
                    },
                    buttonIcons: {
                        prev: ' fa fa-caret-left',
                        next: ' fa fa-caret-right',
                    },
                    displayEventEnd: true,
                    axisFormat: 'h:mm',
                    allDaySlot: false,
                    timeFormat: 'H:mm',
                    eventLimit: true,
                    eventClick: _this.openItem,
                    //eventDrop: $scope.alertOnDrop,
                    //eventResize: $scope.alertOnResize,
                    eventRender: _this.eventRender
                }
            };
            _this.ShiftService.subscribe('ShiftCalendarController', function (type) {
                var newShift;
                var calendarItem;
                switch (type) {
                    case 'post': {
                        newShift = _this.ShiftService.item;
                        calendarItem = new calendar_service_1.ICalendarShift();
                        calendarItem.start = newShift.start;
                        calendarItem.end = newShift.end;
                        if (newShift.status) {
                            calendarItem.status = newShift.status.toString();
                        }
                        calendarItem.statusColor = newShift.statusColor;
                        calendarItem.title = newShift.teamLocationName;
                        calendarItem.shift = newShift;
                        _this.shifts.push(calendarItem);
                        break;
                    }
                    case 'put': {
                        newShift = _this.ShiftService.item;
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== newShift.id; });
                        if (_this.ShiftService.item.status !== 99) {
                            calendarItem = new calendar_service_1.ICalendarShift();
                            calendarItem.start = newShift.start;
                            calendarItem.end = newShift.end;
                            if (newShift.status) {
                                calendarItem.status = newShift.status.toString();
                            }
                            calendarItem.statusColor = newShift.statusColor;
                            calendarItem.title = newShift.teamLocationName;
                            calendarItem.shift = newShift;
                            _this.shifts.push(calendarItem);
                        }
                        break;
                    }
                    case 'delete': {
                        _this.shifts = _this.shifts.filter(function (s) { return s.shift.id !== _this.ShiftService.itemId; });
                        break;
                    }
                }
                _this.uiCalendarConfig.calendars['shiftsCalendar'].fullCalendar('refetchEvents');
            });
        };
        this.openItem = function (event) {
            //this.$state.go('shifts.calendar.item', { 'id': event.shift.id });
            _this.$state.go('shifts.list.item', { 'id': event.shift.id, 'start': event.shift.start });
        };
        this.eventRender = function (event, element, view) {
            element.attr({
                'uib-tooltip': event.title,
                'tooltip-append-to-body': true
            });
            if (moment().isBefore(event.start)) {
                element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor });
            }
            else {
                element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor, 'opacity': 0.7 });
            }
            _this.$compile(element)(_this.$scope);
        };
        this.getEvents = function (start, end, timezone, callback) {
            _this.CalendarService.all({ 'start': start.toDate(), 'end': end.toDate() }).then(function (events) {
                _this.shifts = events;
                var employeeName;
                _this.shifts.forEach(function (s) {
                    employeeName = s.shift.employeeDisplayName || '-';
                    s.title = s.title + '\n' + employeeName;
                });
                callback(events);
            });
        };
        this.$onDestroy = function () {
            _this.ShiftService.unsubscribe('ShiftCalendarController');
        };
    }
    return ShiftCalendarController;
}());
exports.shiftCalendarComponent = {
    controller: ShiftCalendarController,
    template: __webpack_require__(492)
};


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ShiftController = /** @class */ (function () {
    function ShiftController() {
        'ngInject';
    }
    return ShiftController;
}());
exports.shiftComponent = {
    controller: ShiftController,
    template: __webpack_require__(493)
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(7);
var moment = __webpack_require__(0);
var ShiftItemController = /** @class */ (function () {
    ShiftItemController.$inject = ["ShiftService", "EmployeesService", "AccountsService", "AuthService", "$stateParams", "$state", "$timeout", "$scope", "SweetAlert"];
    function ShiftItemController(ShiftService, EmployeesService, AccountsService, AuthService, $stateParams, $state, $timeout, $scope, SweetAlert) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.AccountsService = AccountsService;
        this.AuthService = AuthService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            _this.sortType = 'start';
            //this.onChange({type: 'open', data: ''});
            _this.shift = _this.resolve.shift;
            _this.accounts = _this.resolve.accounts;
            _this.functions = _this.resolve.functions;
            _this.statuses = _this.resolve.statuses;
            _this.employees = _this.resolve.employees;
            if (!_this.employees.find(function (e) { return e.displayName === '--- Geen ---'; })) {
                var emp = new services_1.IEmployee();
                emp.displayName = '--- Geen ---';
                _this.employees.push(emp);
            }
            if (_this.shift) {
                _this.shift.start = new Date(_this.shift.start);
                _this.shift.end = new Date(_this.shift.end);
                if (moment().isAfter(_this.shift.start)) {
                    _this.shift.isInThePast = true;
                }
            }
            else {
                _this.shift = new services_1.IShift();
                _this.shift.start = _this.roundMinutes(new Date());
                _this.shift.end = moment(_this.shift.start).add(8, 'hour').toDate();
                if (_this.AuthService.hasRole('customer')) {
                    _this.shift.status = 6;
                }
                // console.log(this.$stateParams['status']);
                if (_this.$stateParams['status']) {
                    _this.shift.status = _this.$stateParams['status'];
                }
                _this.shift.employeeId = null;
            }
            // console.log(this.AuthService.getTokenData().customerId);
            if (_this.AuthService.hasRole('customer')) {
                _this.shift.teamLocationAccountId = _this.AuthService.getTokenData().customerId;
            }
            if (_this.shift.teamLocationAccountId) {
                _this.AccountsService.getChild(_this.shift.teamLocationAccountId, 'locations').then(function (result) {
                    _this.locations = result;
                    if (_this.shift.teamLocationId) {
                        _this.teams = _this.locations.find(function (item) { return item.id === _this.shift.teamLocationId; }).teams;
                    }
                });
            }
        };
    }
    ShiftItemController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    ShiftItemController.prototype.startDateBeforeRender = function ($dates) {
    };
    ShiftItemController.prototype.endDateBeforeRender = function ($view, $dates) {
        // console.log('endDateBeforeRender');
        if (this.shift.start) {
            var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    ShiftItemController.prototype.selectedAccount = function () {
        var _this = this;
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then(function (result) {
            _this.locations = result;
        });
    };
    ShiftItemController.prototype.locationSelected = function () {
        var _this = this;
        this.teams = this.locations.find(function (item) { return item.id === _this.shift.teamLocationId; }).teams;
    };
    ShiftItemController.prototype.submitShift = function (after) {
        var _this = this;
        if (after === void 0) { after = null; }
        if (this.shift.isInThePast) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Deze dienst is in het verleden. Weet je zeker dit zeker?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja, opslaan',
                cancelButtonText: 'Nee, annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.save(after);
                }
                else {
                }
            });
        }
        else {
            this.save(after);
        }
    };
    ShiftItemController.prototype.save = function (after) {
        var _this = this;
        if (moment(this.shift.start).isAfter(this.shift.end)) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Eindtijd ligt voor starttijd',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
            }, function (isConfirm) {
                if (isConfirm) {
                }
            });
        }
        else {
            this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
            this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
            if (!this.shift.id) {
                this.ShiftService.post(this.shift).then(function (data) {
                    _this.shift = data;
                    _this.handleAfterSubmit(after);
                });
            }
            else {
                this.ShiftService.put(this.shift.id, this.shift).then(function (data) {
                    _this.handleAfterSubmit(after);
                });
            }
        }
    };
    ShiftItemController.prototype.deleteShift = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze dienst wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.ShiftService.delete(_this.shift.id).then(function () {
                    // this.shifts = this.shifts.filter(s => s.id !== this.shift.id);
                    _this.shift = null;
                    _this.closeModal();
                });
            }
            else {
            }
        });
    };
    ShiftItemController.prototype.handleAfterSubmit = function (after) {
        switch (after) {
            case "copy": {
                this.shift.id = null;
                this.shift.start = moment(this.shift.start).add(1, 'day').toDate();
                this.shift.end = moment(this.shift.end).add(1, 'day').toDate();
                if (moment().isAfter(this.shift.start)) {
                    this.shift.isInThePast = true;
                }
                else {
                    this.shift.isInThePast = false;
                }
                break;
            }
            case "new": {
                this.shift = new services_1.IShift();
                break;
            }
            default: {
                this.closeModal();
            }
        }
    };
    ShiftItemController.prototype.closeModal = function () {
        if (this.shift && this.shift.id) {
            this.$state.go('^', { 'id': this.shift.id }, { reload: true });
        }
        else {
            this.$state.go('^', { 'id': null }, { reload: true });
        }
    };
    return ShiftItemController;
}());
exports.shiftItemComponent = {
    bindings: {
        resolve: '<',
    },
    controller: ShiftItemController,
    template: __webpack_require__(494)
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shifts_service_1 = __webpack_require__(15);
var moment = __webpack_require__(0);
var _ = __webpack_require__(6);
var ShiftListController = /** @class */ (function () {
    ShiftListController.$inject = ["ShiftService", "EmployeesService", "ThemeAppService", "$scope", "$state", "SweetAlert", "$timeout", "$filter", "$sce", "AuthUserService", "$stateParams"];
    function ShiftListController(ShiftService, EmployeesService, ThemeAppService, $scope, $state, SweetAlert, $timeout, $filter, $sce, AuthUserService, $stateParams) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.ThemeAppService = ThemeAppService;
        this.$scope = $scope;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$sce = $sce;
        this.AuthUserService = AuthUserService;
        this.$stateParams = $stateParams;
        this.groupedShifts = [];
        this.days = [];
        this.teams = [];
        this.$onInit = function () {
            _this.isMessageOpen = false;
            _this.shiftsGrouping = 'date';
            ///console.log(this.$stateParams);
            _this.$scope.$watchCollection(function () {
                return _this.$state.params;
            }, function () {
                if (_this.$stateParams['refreshShift']) {
                    _this.refreshShift(_this.$stateParams['refreshShift']);
                    _this.$state.go(".", { "refreshShift": '' }, { notify: false });
                }
            });
            _this.filter = {
                status: null
            };
            var date = moment();
            if (_this.$stateParams['start']) {
                date = moment(_this.$stateParams['start']);
                _this.startDate = date.format("YYYY-MM-DD");
                if (_this.$stateParams['end']) {
                    _this.endDate = moment(_this.$stateParams['end']).format("YYYY-MM-DD");
                }
                else {
                    _this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
                }
            }
            else {
                _this.startDate = date.format("YYYY-MM-DD");
                _this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
            }
            _this.AuthUserService.getCurrentUser().then(function (user) {
                _this.user = user;
            });
            _this.getShiftsByDate();
        };
        this.$onDestroy = function () {
            _this.ShiftService.unsubscribe('ShiftListController');
        };
        this.isSameDay = function (start, end) {
            if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
                return true;
            }
            else {
                return false;
            }
        };
        this.getShiftsByDate = function () {
            _this.$state.go(".", { "start": _this.startDate, "end": _this.endDate }, { notify: false });
            _this.shifts = [];
            _this.getShifts();
        };
        this.prevWeek = function () {
            _this.startDate = moment(_this.startDate).add(-7, 'day').toDate();
            _this.endDate = moment(_this.endDate).add(-7, 'day').toDate();
            _this.shifts = [];
            _this.getShiftsByDate();
        };
        this.nextWeek = function () {
            _this.startDate = moment(_this.startDate).add(7, 'day').toDate();
            _this.endDate = moment(_this.endDate).add(7, 'day').toDate();
            _this.shifts = [];
            _this.getShiftsByDate();
        };
        this.resetFilters = function () {
            _this.filter = {
                search: null,
                status: null,
                createdby: null,
                createdsince: null
            };
            _this.shifts = [];
            _this.getShifts();
        };
        this.nextPage = function () {
            _this.loading = true;
            _this.getShifts(true, _this.shifts.length);
        };
        this.setFilters = function (resetTime) {
            if (resetTime === void 0) { resetTime = true; }
            _this.loading = true;
            _this.shifts = [];
            if (resetTime) {
                _this.filter.createdsince = null;
                _this.filter.updatedsince = null;
            }
            _this.getShifts(true, 0);
        };
        this.getShifts = function (scrollTo, offset) {
            if (scrollTo === void 0) { scrollTo = true; }
            if (offset === void 0) { offset = 0; }
            _this.loading = true;
            var params = {
                from: _this.startDate,
                till: _this.endDate,
                includeSubscriptions: true,
                sortfield: 'start',
                sortorder: 'asc',
                limit: 25,
                offset: offset
            };
            if (_this.filter) {
                if (_this.filter.status) {
                    params.status = _this.filter.status;
                }
                if (_this.filter.search && _this.filter.search.length > 3) {
                    params.q = _this.filter.search;
                }
                if (_this.filter.createdby) {
                    params.createdBy = _this.filter.createdby;
                    // params.updatedBy = this.filter.createdby;
                }
                if (_this.filter.createdsince) {
                    params.createdSince = _this.filter.createdsince;
                    params.updatedSince = _this.filter.createdsince;
                }
            }
            if (!_this.shiftLoading) {
                _this.shiftLoading = true;
                if (!_this.shifts) {
                    _this.shifts = [];
                }
                _this.ShiftService.getFilter(params).then(function (result) {
                    result.forEach(function (item) {
                        _this.shifts.push(item);
                    });
                    //this.shifts = [...result];
                    _this.getTeams();
                    _this.filterShifts(scrollTo);
                    _this.shiftLoading = false;
                    if (result.length >= 25) {
                        _this.loading = false;
                    }
                    else {
                        _this.endList = true;
                    }
                });
            }
        };
        this.filterShifts = function (scrollTo) {
            // this.shifts = this.$filter('filter')(this.shifts, this.filter.search);
            if (scrollTo === void 0) { scrollTo = true; }
            if (_this.shiftsGrouping && _this.shiftsGrouping == 'date') {
                _this.groupedShifts = _.groupBy(_this.shifts, function (item) {
                    return moment(item.start).format('dd DD-MM-YYYY');
                });
            }
            if (!_this.shifts.length) {
                // this.$state.go("shifts.list");
            }
            else if (_this.currentShift) {
                if (!_.find(_this.shifts, { id: _this.currentShift.id }) && !_this.handlingChildChange) {
                    // this.$state.go(this.$state.current, { id: this.shifts[0].id });
                    // this.currentShift = this.shifts[0];
                    // this.$timeout(() => {
                    //     if (this.isMessageOpen && scrollTo) {
                    //         this.scrollToShift(this.currentShift.id);
                    //     }
                    // });
                }
                else {
                    _this.$timeout(function () {
                        if (_this.handlingChildChange) {
                            _this.handlingChildChange = false;
                        }
                        if (_this.isMessageOpen && scrollTo) {
                            _this.scrollToShift(_this.currentShift.id);
                        }
                    });
                }
            }
        };
        // private mailTeam = (team) => {
        //     var ids = [];
        //     this.shifts.forEach(s => {
        //         if (s.teamName && s.teamName == team && ids.find(id => id == s.id) == null) {
        //             ids.push(s.id);
        //         }
        //     });
        //     this.ShiftService.customPost('email/team', ids);
        // }
        this.notifyTeam = function () {
            _this.ShiftService.customPost('email/team', [_this.currentShift.id]);
        };
        this.notifyEmployee = function () {
            _this.ShiftService.customPost('email/employee', [_this.currentShift.id]);
        };
        this.getTeams = function () {
            _this.shifts.forEach(function (s) {
                if (_this.teams.indexOf(s.teamName) == -1) {
                    _this.teams.push(s.teamName);
                }
            });
        };
        this.handleChildChange = function (type, data) {
            // console.log('handleChildChange')
            // console.log(type)
            _this.handlingChildChange = true;
            switch (type) {
                case 'open':
                    _this.isMessageOpen = true;
                    _this.currentShift = data;
                    break;
                case 'close':
                    _this.isMessageOpen = false;
                    break;
                case 'new':
                    _this.setFilters();
                    break;
                case 'updated':
                    _this.setFilters();
                    break;
                case 'deleted':
                    _this.setFilters();
                    break;
                case 'copy':
                    _this.setFilters(false);
                    break;
            }
        };
        this.scrollToShift = function (shiftID) {
            // var target_offset = $("#s-" + shiftID).offset();
            // var parent_offset = $('#shiftsmalllist').offset();
            // var target_top = target_offset.top - parent_offset.top - 10;
            // $('#shiftsmalllist').animate({ scrollTop: target_top }, 500);
        };
        this.selectAllChange = function () {
            _this.shifts.forEach(function (shift) {
                shift.$selected = _this.selectAll;
            });
        };
        this.submitAction = function () {
            var shifts = _.filter(_this.shifts, { $selected: true });
            var data = new shifts_service_1.IBulkactionData();
            data.ids = [];
            shifts.forEach(function (shift) {
                data.ids.push(shift.id);
            });
            var text = '';
            switch (_this.actionform.action) {
                case 'setstatus':
                    var status = _this.actionform.status;
                    data.shiftBulkAction = "ChangeStatus";
                    data.statusId = status.code;
                    text = 'Weet u zeker dat u van alle ' + shifts.length + ' geselecteerde diensten de status op ' + status.name + ' wilt zetten?';
                    break;
                case 'emailteam':
                    data.shiftBulkAction = "SendEmail";
                    data.shiftEmail = "Customer";
                    text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt mailen naar team?';
                    break;
                case 'emailemployee':
                    data.shiftBulkAction = "SendEmail";
                    data.shiftEmail = "EmployeeConfirm";
                    text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt mailen naar de medewerkers?';
                    break;
                    ;
                case 'setemployee':
                    var employee = _this.actionform.employee;
                    data.shiftBulkAction = "SetEmployee";
                    data.employeeId = employee.id;
                    text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt toewijzen aan ' + employee.displayName + '?';
                    break;
                case 'delete':
                    data.shiftBulkAction = "Delete";
                    text = 'Weet u zeker dat u  alle ' + shifts.length + ' geselecteerde diensten wilt verwijderen?';
                    break;
            }
            _this.SweetAlert.swal({
                title: 'Let op!',
                text: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Nee, annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.ShiftService.bulkAction(data).then(function () {
                        _this.actionform.action = "";
                        _this.shifts = [];
                        _this.getShifts();
                    });
                }
                else {
                }
            });
        };
        this.months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    }
    ShiftListController.prototype.refreshShift = function (id) {
        var _this = this;
        this.ShiftService.get(id).then(function (shift) {
            var index = _.findIndex(_this.shifts, { id: id });
            _this.shifts[index] = shift;
            _this.filterShifts();
        });
    };
    return ShiftListController;
}());
exports.shiftListComponent = {
    bindings: {
        statuses: '<',
        functions: '<',
        employees: '<'
    },
    controller: ShiftListController,
    template: __webpack_require__(496)
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var ShiftListEmployeeController = /** @class */ (function () {
    ShiftListEmployeeController.$inject = ["ShiftService", "EmployeesService"];
    function ShiftListEmployeeController(ShiftService, EmployeesService) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.$onInit = function () {
            _this.onChange({ type: 'open', data: _this.shift });
            _this.getEmployees();
        };
        this.$onDestroy = function () {
            _this.onChange({ type: 'close', data: _this.shift });
        };
        this.getEmployees = function () {
            var request = {
                accountId: _this.shift.teamLocationAccountId,
                locationId: _this.shift.teamLocationId,
                startDate: _this.shift.start,
                endDate: _this.shift.end,
                shiftId: _this.shift.id
            };
            _this.EmployeesService.customPost('availableEmployees', request, false).then(function (result) {
                _this.employees = result;
                _this.selectedEmployee = _this.employees.find(function (employeeSummary) { return employeeSummary.employee.id == _this.shift.employeeId; });
            });
        };
        this.unassignEmployee = function () {
            _this.shift.employeeId = null;
            _this.shift.status = 2;
            _this.selectedEmployee = null;
            _this.submitShift();
        };
    }
    ShiftListEmployeeController.prototype.submitShift = function () {
        var _this = this;
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.employeeId !== null) {
            this.shift.status = 6;
        }
        this.ShiftService.put(this.shift.id, this.shift).then(function (data) {
            _this.onChange({ type: 'updated', data: data });
            _this.getEmployees();
        });
    };
    return ShiftListEmployeeController;
}());
exports.shiftListEmployeeComponent = {
    bindings: {
        shift: '<',
        //employees: '<',
        functions: '<',
        onChange: '&',
    },
    controller: ShiftListEmployeeController,
    template: __webpack_require__(495)
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(7);
var moment = __webpack_require__(0);
var ShiftListItemController = /** @class */ (function () {
    ShiftListItemController.$inject = ["ShiftService", "EmployeesService", "AccountsService", "AuthService", "$stateParams", "$state", "$timeout", "$scope", "SweetAlert"];
    function ShiftListItemController(ShiftService, EmployeesService, AccountsService, AuthService, $stateParams, $state, $timeout, $scope, SweetAlert) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.AccountsService = AccountsService;
        this.AuthService = AuthService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.SweetAlert = SweetAlert;
        this.isBackoffice = false;
        this.isCustomer = false;
        this.isEmployee = false;
        this.$onInit = function () {
            _this.onChange({ type: 'open', data: _this.shift });
            // Initialiseer availableFunctions - alle functies zijn nu beschikbaar (geen filter meer)
            _this.availableFunctions = _this.functions || [];
            // Initialiseer employee CAO warning
            _this.employeeCaoWarning = '';
            // Initialiseer functie CAO warning
            _this.functionCaoWarning = '';
            // Controleer of functions beschikbaar zijn
            if (!_this.functions) {
                _this.functions = [];
            }
            // Update availableFunctions als functions beschikbaar zijn
            if (_this.functions && _this.functions.length > 0) {
                _this.availableFunctions = _this.functions;
            }
            if (_this.employees && !_this.employees.find(function (e) { return e.displayName === '--- Geen ---'; })) {
                var emp = new services_1.IEmployee();
                emp.displayName = '--- Geen ---';
                _this.employees.push(emp);
            }
            if (_this.shift) {
                if (moment().isAfter(_this.shift.start)) {
                    _this.shift.isInThePast = true;
                }
                _this.currentShiftStatus = _this.shift.status;
            }
            else {
                _this.shift = new services_1.IShift();
                _this.shift.start = _this.roundMinutes(new Date());
                _this.shift.end = moment(_this.shift.start).add(8, 'hour').toDate();
                _this.shift.status = 2;
                // if (this.AuthService.hasRole('customer')) {
                //     this.shift.status = 6;
                // }
                if (_this.$stateParams['status']) {
                    _this.shift.status = _this.$stateParams['status'];
                }
                _this.shift.employeeId = null;
            }
            if (_this.AuthService.hasRole('customer')) {
                _this.shift.teamLocationAccountId = _this.AuthService.getTokenData().customerId;
            }
            if (_this.shift.teamLocationAccountId) {
                _this.AccountsService.get(_this.shift.teamLocationAccountId).then(function (account) {
                    _this.currentAccount = account;
                    // Update CAO naam (roept automatisch validateEmployeeCao aan)
                    _this.updateUsedCaoName();
                });
                _this.AccountsService.getChild(_this.shift.teamLocationAccountId, 'locations').then(function (result) {
                    _this.locations = result;
                    if (_this.shift.teamLocationId) {
                        var location_1 = _this.locations.find(function (item) { return item.id === _this.shift.teamLocationId; });
                        _this.currentLocation = location_1;
                        _this.teams = location_1 ? location_1.teams : [];
                        // Update CAO naam
                        _this.updateUsedCaoName();
                    }
                });
            }
            _this.currentDate = new Date(Date.now());
            _this.isBackoffice = _this.AuthService.hasRole('backoffice');
            _this.isCustomer = _this.AuthService.hasRole('customer');
            _this.isEmployee = _this.AuthService.hasRole('employee');
            // Watch voor functie wijzigingen
            _this.$scope.$watch(function () { return _this.shift.functionId; }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    _this.$timeout(function () {
                        // Valideer employee CAO als er een employee is geselecteerd
                        if (_this.shift.employeeId) {
                            _this.validateEmployeeCao();
                        }
                    }, 100);
                }
            });
        };
        this.$onDestroy = function () {
            _this.onChange({ type: 'close', data: _this.shift });
        };
        // startDateBeforeRender($dates) {
        // }
        // endDateBeforeRender($view, $dates) {
        //     // console.log('endDateBeforeRender');
        //     if (this.shift.start) {
        //         var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');
        //         $dates.filter(function (date) {
        //             return date.localDateValue() <= activeDate.valueOf();
        //         }).forEach(function (date) {
        //             date.selectable = false;
        //         });
        //     }
        // }
        this.selectEmployee = function () {
            if (_this.shift.employeeId) {
                _this.shift.status = 6;
            }
            else {
                _this.shift.status = 2;
            }
            // Valideer CAO wanneer employee wordt geselecteerd
            _this.validateEmployeeCao();
        };
        this.updateUsedCaoName = function () {
            // Reset cached naam
            _this.usedCaoName = '';
            // Check location eerst (override)
            if (_this.currentLocation && _this.currentLocation.salaryScaleGroup && _this.currentLocation.salaryScaleGroup.name) {
                _this.usedCaoName = _this.currentLocation.salaryScaleGroup.name;
            }
            else if (_this.currentAccount && _this.currentAccount.salaryScaleGroup && _this.currentAccount.salaryScaleGroup.name) {
                // Check account (fallback)
                _this.usedCaoName = _this.currentAccount.salaryScaleGroup.name;
            }
            // Valideer employee CAO wanneer CAO verandert
            if (_this.shift.employeeId) {
                _this.$timeout(function () {
                    _this.validateEmployeeCao();
                }, 100);
            }
        };
        this.getUsedCaoName = function () {
            return _this.usedCaoName || '';
        };
        this.validateEmployeeCao = function () {
            _this.employeeCaoWarning = '';
            // Controleer of alle benodigde velden zijn ingevuld
            if (!_this.shift.employeeId || !_this.currentAccount) {
                return;
            }
            // Controleer of employee ZZP is - geen CAO waarschuwing voor ZZP medewerkers
            var selectedEmployee = _this.employees.find(function (e) { return e.id === _this.shift.employeeId; });
            if (selectedEmployee && selectedEmployee.zzp === true) {
                return; // ZZP medewerkers hebben geen CAO waarschuwing nodig
            }
            // Als employee niet in array staat of zzp property niet beschikbaar, haal employee op
            if (!selectedEmployee || selectedEmployee.zzp === undefined) {
                _this.EmployeesService.get(_this.shift.employeeId).then(function (employee) {
                    if (employee && employee.zzp === true) {
                        return; // ZZP medewerkers hebben geen CAO waarschuwing nodig
                    }
                    // Continue met CAO validatie als niet ZZP
                    _this.performCaoValidation();
                }).catch(function () {
                    // Bij fout, continue met CAO validatie
                    _this.performCaoValidation();
                });
                return;
            }
            // Continue met CAO validatie als niet ZZP
            _this.performCaoValidation();
        };
        this.performCaoValidation = function () {
            // Bepaal welke CAO gebruikt moet worden: location override of account CAO
            var requiredCaoGroup = _this.currentLocation && _this.currentLocation.salaryScaleGroup
                ? _this.currentLocation.salaryScaleGroup
                : (_this.currentAccount.salaryScaleGroup || null);
            if (!requiredCaoGroup || !requiredCaoGroup.id) {
                return;
            }
            // Haal employee salary scales op en controleer of employee de juiste CAO heeft
            _this.EmployeesService.getSalaryScales(_this.shift.employeeId).then(function (salaryScales) {
                _this.selectedEmployeeSalaryScales = salaryScales;
                var hasRequiredCao = salaryScales.some(function (ess) {
                    return ess.salaryScale && ess.salaryScale.salaryScaleGroupId === requiredCaoGroup.id;
                });
                if (!hasRequiredCao) {
                    var functionName = _this.functions.find(function (f) { return f.id === _this.shift.functionId; });
                    var functionDisplayName = functionName ? functionName.name : 'deze functie';
                    _this.employeeCaoWarning = "Deze medewerker heeft niet de juiste CAO (" + requiredCaoGroup.name + ") voor " + functionDisplayName + ".";
                }
            }).catch(function () {
                _this.employeeCaoWarning = 'Kon de CAO informatie van de medewerker niet ophalen.';
            });
        };
        this.save = function (after) {
            _this.shift.start = moment(_this.shift.start).format("YYYY-MM-DD HH:mm");
            _this.shift.end = moment(_this.shift.end).format("YYYY-MM-DD HH:mm");
            if (!_this.shift.id) {
                _this.ShiftService.post(_this.shift).then(function (data) {
                    _this.shift = data;
                    _this.handleAfterSubmit(after, 'new');
                });
            }
            else {
                _this.ShiftService.put(_this.shift.id, _this.shift).then(function (data) {
                    _this.shift = data;
                    _this.handleAfterSubmit(after, 'updated');
                });
            }
        };
        this.deleteShift = function () {
            _this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Weet u zeker dat u deze dienst wilt verwijderen?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Nee, annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    _this.ShiftService.delete(_this.shift.id).then(function () {
                        _this.onChange({ type: 'deleted', data: _this.shift });
                        _this.$state.go('^');
                    });
                }
                else {
                }
            });
        };
        this.handleAfterSubmit = function (after, type) {
            switch (after) {
                case "copy": {
                    _this.onChange({ type: 'copy', data: _this.shift });
                    //this.$state.go('.', {'id': ''}, {notify: false});
                    _this.shift.id = null;
                    // this.shift.start = moment(this.shift.start).add(1, 'day').toDate();
                    // this.shift.end = moment(this.shift.end).add(1, 'day').toDate();
                    if (moment().isAfter(_this.shift.start)) {
                        _this.shift.isInThePast = true;
                    }
                    else {
                        _this.shift.isInThePast = false;
                    }
                    break;
                }
                case "new": {
                    _this.onChange({ type: 'copy', data: _this.shift });
                    _this.shift = null;
                    _this.$state.go('shifts.list.item', { 'id': '' });
                    break;
                }
                default: {
                    _this.$state.go('shifts.list.item', { 'id': _this.shift.id });
                    _this.onChange({ type: "new", data: _this.shift });
                }
            }
        };
    }
    ShiftListItemController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    ShiftListItemController.prototype.selectedAccount = function () {
        var _this = this;
        this.AccountsService.get(this.shift.teamLocationAccountId).then(function (account) {
            _this.currentAccount = account;
            // Update CAO naam (roept automatisch validateEmployeeCao aan)
            _this.updateUsedCaoName();
        });
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then(function (result) {
            _this.locations = result;
        });
        // Alle functies zijn nu beschikbaar (geen filter meer op accountFunctions)
        this.availableFunctions = this.functions || [];
    };
    ShiftListItemController.prototype.locationSelected = function () {
        var _this = this;
        if (this.shift.teamLocationId) {
            var location_2 = this.locations.find(function (item) { return item.id === _this.shift.teamLocationId; });
            this.currentLocation = location_2;
            this.teams = location_2 ? location_2.teams : [];
            // Update CAO naam (roept automatisch validateEmployeeCao aan)
            this.updateUsedCaoName();
        }
    };
    ShiftListItemController.prototype.submitShift = function (after) {
        var _this = this;
        if (after === void 0) { after = null; }
        this.$scope.shiftForm.$setSubmitted();
        if (this.$scope.shiftForm.$valid) {
            if (this.isCustomer && moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal('Dienst in het verleden', 'U kunt geen dienst in het verleden creëren.', 'warning');
            }
            else if (moment(this.shift.start).isAfter(this.shift.end)) {
                this.SweetAlert.swal('Let op!', 'Eindtijd ligt voor starttijd.', 'warning');
            }
            else if (moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Deze dienst is in het verleden. Weet je zeker dit zeker?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, function (isConfirm) {
                    if (isConfirm) {
                        _this.currentShiftStatus = _this.shift.status;
                        _this.save(after);
                    }
                    else {
                    }
                });
            }
            else if ((this.shift.status === 92 || this.shift.status === 7) && moment().add(4, 'day').isAfter(moment(this.shift.start))) {
                // console.log("HERE")
                if (!this.shift.employeeId) {
                    // console.log("1")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er is geen medewerker geselecteerd waarop een decalartie kan worden aangemaakt. Je kunt deze dienst niet annuleren',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Stop',
                    }, function (isConfirm) {
                        if (isConfirm) {
                        }
                        else {
                        }
                    });
                }
                else {
                    // console.log("2")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er worden automatisch een declaratie aangemaakt. Weet u zeker dat u de dienst wilt annuleren?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ja, opslaan',
                        cancelButtonText: 'Nee, annuleren',
                    }, function (isConfirm) {
                        if (isConfirm) {
                            _this.shift.status = 7;
                            _this.currentShiftStatus = _this.shift.status;
                            _this.save(after);
                        }
                        else {
                        }
                    });
                }
            }
            else if ((this.currentShiftStatus === 7 && this.shift.status != 7)) {
                // console.log("3")
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Let op: Deze dienst had status Geannuleerd 96 uur. Bij het opslaan zullen alle declaraties worden verwijderd. Weet je zeker dat je dit wilt?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, function (isConfirm) {
                    if (isConfirm) {
                        _this.currentShiftStatus = _this.shift.status;
                        _this.save(after);
                    }
                    else {
                    }
                });
            }
            else {
                this.currentShiftStatus = this.shift.status;
                this.save(after);
            }
        }
    };
    return ShiftListItemController;
}());
exports.shiftListItemComponent = {
    bindings: {
        shift: '<',
        employees: '<',
        statuses: '<',
        accounts: '<',
        functions: '<',
        onChange: '&',
    },
    controller: ShiftListItemController,
    template: __webpack_require__(497)
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var SubscriptionsModalController = /** @class */ (function () {
    SubscriptionsModalController.$inject = ["ShiftService", "EmployeesService", "$state", "$timeout", "SweetAlert"];
    function SubscriptionsModalController(ShiftService, EmployeesService, $state, $timeout, SweetAlert) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.$state = $state;
        this.$timeout = $timeout;
        this.SweetAlert = SweetAlert;
        this.mailcustomer = false;
        this.mailemployee = false;
        this.$onInit = function () {
            _this.shift = _this.resolve.shift;
            _this.statuses = _this.resolve.statuses;
            _this.getEmployee();
            _this.getEmployees();
            _this.setModalHeight();
        };
        this.setModalHeight = function () {
            // var docHeight = $(window).height();
            // var height = docHeight - 225;
            $("#checkAvailabilityModalBody #employeelist").height(450);
        };
        this.getEmployees = function () {
            var request = {
                accountId: _this.shift.teamLocationAccountId,
                locationId: _this.shift.teamLocationId,
                startDate: _this.shift.start,
                endDate: _this.shift.end,
                shiftId: _this.shift.id
            };
            _this.EmployeesService.customPost('availableEmployees', request, false).then(function (result) {
                _this.employees = result;
                _this.employees = _this.employees.filter(function (employeeSummary) { return employeeSummary.subscription; });
                //this.selectedEmployee = this.employees.find(employeeSummary => employeeSummary.employee.id == this.shift.employeeId);
            });
        };
        this.onSelectEmployee = function () {
            _this.$timeout(function () {
                if (_this.shift.employeeId) {
                    _this.shift.status = 6;
                }
                else {
                    _this.shift.status = 2;
                }
                _this.getEmployee();
            });
        };
        this.getEmployee = function () {
            if (_this.shift.employeeId) {
                _this.EmployeesService.get(_this.shift.employeeId).then(function (employee) {
                    _this.employee = employee;
                });
            }
        };
        this.save = function () {
            if (moment(_this.shift.start).isAfter(_this.shift.end)) {
                _this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Eindtijd ligt voor starttijd',
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK',
                }, function (isConfirm) {
                    if (isConfirm) {
                    }
                });
            }
            else {
                _this.ShiftService.put(_this.shift.id, _this.shift).then(function (data) {
                    _this.shift = data;
                    if (_this.mailcustomer) {
                        _this.notifyTeam();
                    }
                    if (_this.mailemployee) {
                        _this.notifyEmployee();
                    }
                    _this.closeModal();
                });
            }
        };
        this.notifyTeam = function () {
            _this.ShiftService.customPost('email/team', [_this.shift.id]);
        };
        this.notifyEmployee = function () {
            _this.ShiftService.customPost('email/employee', [_this.shift.id]);
        };
    }
    // getEmployee(id) {
    //     return this.EmployeesService.get(id).then(employee => {
    //         return employee;
    //     })
    // }
    SubscriptionsModalController.prototype.closeModal = function () {
        this.$state.go('^', { 'refreshShift': this.shift.id }, {
            location: true,
            reload: false,
            inherit: true,
            notify: true
        });
    };
    return SubscriptionsModalController;
}());
exports.subscriptionsModalComponent = {
    controller: SubscriptionsModalController,
    bindings: {
        resolve: "<",
        close: "&"
    },
    template: __webpack_require__(498)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var skills_states_1 = __webpack_require__(691);
var skills_dashboard_component_1 = __webpack_require__(690);
var skills_component_1 = __webpack_require__(689);
var skillAppModule = {
    components: { skillsComponent: skills_component_1.skillsComponent, skillsDashboardComponent: skills_dashboard_component_1.skillsDashboardComponent },
    states: [skills_states_1.skillsState, skills_states_1.skillsDashboardState, skills_states_1.employeeSkillsItemState],
    filters: {}
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, skillAppModule);


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SkillsController = /** @class */ (function () {
    function SkillsController() {
        'ngInject';
    }
    return SkillsController;
}());
exports.skillsComponent = {
    controller: SkillsController,
    template: __webpack_require__(500)
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SkillsDashboardController = /** @class */ (function () {
    SkillsDashboardController.$inject = ["EmployeeSkillsService", "$state", "$stateParams"];
    function SkillsDashboardController(EmployeeSkillsService, $state, $stateParams) {
        "ngInject";
        this.EmployeeSkillsService = EmployeeSkillsService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
        };
    }
    return SkillsDashboardController;
}());
exports.skillsDashboardComponent = {
    controller: SkillsDashboardController,
    bindings: {
        employeeSkills: '<'
    },
    template: __webpack_require__(499)
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.skillsState = {
    parent: 'app',
    name: "skills",
    url: "/skills",
    redirectTo: "skills.dashboard",
    component: 'skillsComponent',
    data: {
        permissions: {
            only: ['EMPLOYEE']
        }
    }
};
exports.skillsDashboardState = {
    name: "skills.dashboard",
    url: "/skillsDashboard",
    resolve: {
        employeeSkills: ["EmployeeSkillsService", function (EmployeeSkillsService) {
            "ngInject";
            return EmployeeSkillsService.all();
        }]
    },
    views: {
        "main": 'skillsDashboardComponent'
    }
};
exports.employeeSkillsItemState = {
    name: "skills.dashboard.skill",
    url: "/employeeSkill/:employeeSkillId",
    params: {
        "employeeSkillId": null
    },
    modal: ['employeeSkills'],
    resolve: {
        skills: ["MasterdataAService", function (MasterdataAService) {
            'ngInject';
            return MasterdataAService.getItems('Skills');
        }]
    },
    component: 'skillsItemComponent'
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var subscriptions_item_component_1 = __webpack_require__(695);
var ngmodule_1 = __webpack_require__(4);
var subscriptions_states_1 = __webpack_require__(696);
var subscriptions_dashboard_component_1 = __webpack_require__(694);
var subscriptions_component_1 = __webpack_require__(693);
var isDay_filter_1 = __webpack_require__(553);
var subscriptionAppModule = {
    components: { subscriptionsComponent: subscriptions_component_1.subscriptionsComponent, subscriptionsDashboardComponent: subscriptions_dashboard_component_1.subscriptionsDashboardComponent, subscriptionsItemComponent: subscriptions_item_component_1.subscriptionsItemComponent },
    states: [subscriptions_states_1.subscriptionsState, subscriptions_states_1.subscriptionsDashboardState, subscriptions_states_1.subscriptionsDashboardItemState],
    filters: { isDay: isDay_filter_1.isDay }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, subscriptionAppModule);


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionsController = /** @class */ (function () {
    function SubscriptionsController() {
        'ngInject';
    }
    return SubscriptionsController;
}());
exports.subscriptionsComponent = {
    controller: SubscriptionsController,
    template: __webpack_require__(502)
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(6);
var moment = __webpack_require__(0);
var SubscriptionsDashboardController = /** @class */ (function () {
    SubscriptionsDashboardController.$inject = ["EmployeesService", "$state", "$stateParams", "ShiftService", "screenSize"];
    function SubscriptionsDashboardController(EmployeesService, $state, $stateParams, ShiftService, screenSize) {
        "ngInject";
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.ShiftService = ShiftService;
        this.screenSize = screenSize;
        this.days = [];
        this.$onInit = function () {
            _this.isMessageOpen = false;
            _this.shiftsGrouping = 'date';
            _this.filter = {
                status: null
            };
            _this.maxDistanceFilter = '50';
            _this.isInitializing = true;
            _this.startDate = moment().toDate();
            _this.endDate = moment().add(1, 'w').toDate();
            _this.getShifts(true, true);
        };
        this.handleChildChange = function (type, data) {
            switch (type) {
                case 'init':
                    _this.isMessageOpen = true;
                    break;
                case 'update':
                    _this.getShifts();
                    break;
                default:
                    break;
            }
        };
        this.resetFilters = function () {
            _this.filter = {
                search: null,
                status: null,
                createdby: null,
                createdsince: null
            };
            _this.getShifts();
        };
        this.getShifts = function (scrollTo, isFirstGet) {
            if (scrollTo === void 0) { scrollTo = true; }
            if (isFirstGet === void 0) { isFirstGet = false; }
            if (!_this.isInitializing || isFirstGet) {
                // console.log('this.getShifts')
                var termTooShort = false;
                _this.currentShift = null;
                var params = {
                    from: _this.startDate,
                    till: _this.endDate,
                    includeSubscriptions: false,
                    includeDistance: true,
                    sortfield: 'start',
                    sortorder: 'asc'
                };
                if (_this.filter) {
                    params.status = '2';
                    // if (this.filter.status) {
                    //     params.status = '2';
                    // }
                    if (_this.filter.search) {
                        if (_this.filter.search.length > 3) {
                            params.q = _this.filter.search;
                        }
                        else {
                            termTooShort = true;
                        }
                    }
                    // if (this.filter.createdby) {
                    //     params.createdBy = this.filter.createdby;
                    //     params.updatedBy = this.filter.createdby;
                    // }
                    // if (this.filter.createdsince) {
                    //     params.createdSince = this.filter.createdsince;
                    //     params.updatedSince = this.filter.createdsince;
                    // }
                }
                if (!termTooShort) {
                    _this.ShiftService.getFilter(params).then(function (result) {
                        _this.shifts = result;
                        _this.setFilters();
                        if (_this.isInitializing) {
                            _this.isInitializing = false;
                        }
                    });
                }
            }
        };
    }
    SubscriptionsDashboardController.prototype.prevWeek = function () {
        this.startDate = moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = moment(this.endDate).add(-7, 'day').toDate();
        this.getShifts();
    };
    SubscriptionsDashboardController.prototype.nextWeek = function () {
        this.startDate = moment(this.startDate).add(7, 'day').toDate();
        this.endDate = moment(this.endDate).add(7, 'day').toDate();
        this.getShifts();
    };
    SubscriptionsDashboardController.prototype.setFilters = function () {
        var _this = this;
        var filteredShifts = this.shifts;
        // filter by distance
        if (this.maxDistanceFilter) {
            var filteredShifts = filteredShifts.filter(function (s) { return s.distance < Number(_this.maxDistanceFilter); });
        }
        // filter by function
        if (this.functionFilter) {
            var filteredShifts = filteredShifts.filter(function (s) { return s.functionId === _this.functionFilter; });
        }
        if (this.shiftsGrouping && this.shiftsGrouping == 'date') {
            this.groupShifts(filteredShifts);
        }
    };
    SubscriptionsDashboardController.prototype.groupShifts = function (shifts) {
        // console.log('groupShifts')
        this.groupedShifts = _.groupBy(shifts, function (item) {
            return moment(item.start).format('dd DD-MM-YYYY');
        });
    };
    return SubscriptionsDashboardController;
}());
exports.subscriptionsDashboardComponent = {
    controller: SubscriptionsDashboardController,
    bindings: {
        subscriptions: '<',
        functions: '<'
    },
    template: __webpack_require__(501)
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(7);
var SubscriptionsItemController = /** @class */ (function () {
    SubscriptionsItemController.$inject = ["ShiftService", "EmployeesService", "TeamService", "LocationService", "$stateParams"];
    function SubscriptionsItemController(ShiftService, EmployeesService, TeamService, LocationService, $stateParams) {
        'ngInject';
        var _this = this;
        this.ShiftService = ShiftService;
        this.EmployeesService = EmployeesService;
        this.TeamService = TeamService;
        this.LocationService = LocationService;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.getShift();
            if (_this.$stateParams['id']) {
                _this.onChange({ type: 'init', data: _this.$stateParams['id'] });
            }
        };
        this.getShift = function () {
            _this.ShiftService.customGet(_this.$stateParams['id'] + '/withDistance').then(function (shift) {
                _this.shift = shift;
                if (_this.shift.subscriptionsCount > 0) {
                    _this.shift.subscribed = true;
                    _this.subscription = _this.shift.mySubscription;
                }
                else {
                    _this.subscription = new services_1.IEmployeeSubscription();
                    _this.subscription.shiftId = _this.shift.id;
                }
                _this.getLocation();
            });
        };
        this.signUp = function () {
            if (!_this.subscription.id) {
                _this.EmployeesService.postSubscription(_this.subscription).then(function (result) {
                    _this.shift.subscribed = true;
                    _this.onChange({ type: 'update', data: _this.$stateParams['id'] });
                });
            }
            else {
                _this.EmployeesService.putSubscription(_this.subscription).then(function (result) {
                    _this.shift.subscribed = true;
                    _this.onChange({ type: 'update', data: _this.$stateParams['id'] });
                });
            }
        };
        this.unsubscribe = function () {
            var subscriptionId = _this.shift.mySubscription.id;
            _this.EmployeesService.customDelete('subscriptions/' + subscriptionId).then(function () {
                _this.shift.subscribed = false;
                _this.onChange({ type: 'update', data: _this.$stateParams['id'] });
            });
        };
    }
    SubscriptionsItemController.prototype.getLocation = function () {
        var _this = this;
        this.LocationService.get(this.shift.teamLocationId).then(function (location) {
            _this.location = location;
        });
    };
    return SubscriptionsItemController;
}());
exports.subscriptionsItemComponent = {
    bindings: {
        onChange: '&',
    },
    controller: SubscriptionsItemController,
    template: __webpack_require__(503)
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionsState = {
    parent: 'app',
    name: "subscriptions",
    url: "/subscriptions",
    redirectTo: "subscriptions.dashboard",
    component: 'subscriptionsComponent',
    data: {
        permissions: {
            only: ['EMPLOYEE']
        }
    }
};
exports.subscriptionsDashboardState = {
    name: "subscriptions.dashboard",
    url: "/dashboard?currentShiftId",
    params: {
        currentShiftId: null
    },
    resolve: {
        // shifts: (ShiftService: ShiftService) => { 
        //     "ngInject";
        //     var moment = require('moment');
        //     var startDate = moment().toDate();
        //     var endDate = moment().add(30, 'day').toDate();
        //     return ShiftService.getLightByDate({start: startDate, end: endDate});
        // },
        subscriptions: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getSubscriptions();
        }],
        functions: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('Functions');
        }]
    },
    views: {
        "main": 'subscriptionsDashboardComponent'
    }
};
exports.subscriptionsDashboardItemState = {
    name: "subscriptions.dashboard.item",
    url: "/item/:id",
    resolve: {},
    views: {
        "shiflistitem@subscriptions.dashboard": 'subscriptionsItemComponent'
    },
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var task_component_1 = __webpack_require__(699);
var task_list_component_1 = __webpack_require__(702);
var tasks_states_1 = __webpack_require__(703);
var task_item_component_1 = __webpack_require__(701);
var task_item_basic_component_1 = __webpack_require__(700);
var task_archive_component_1 = __webpack_require__(698);
var subscriptionAppModule = {
    components: { taskComponent: task_component_1.taskComponent, taskListComponent: task_list_component_1.taskListComponent, taskItemComponent: task_item_component_1.taskItemComponent, taskItemBasicComponent: task_item_basic_component_1.taskItemBasicComponent, taskArchiveComponent: task_archive_component_1.taskArchiveComponent },
    states: [tasks_states_1.taskState, tasks_states_1.taskListState, tasks_states_1.taskItemState, tasks_states_1.taskItemBasicState, tasks_states_1.taskArchiveState],
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, subscriptionAppModule);


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskArchiveController = /** @class */ (function () {
    TaskArchiveController.$inject = ["$filter"];
    function TaskArchiveController($filter) {
        'ngInject';
        var _this = this;
        this.$filter = $filter;
        this.$onInit = function () {
            _this.sortType = 'date';
            _this.filter();
        };
    }
    TaskArchiveController.prototype.filter = function () {
        this.filteredTasks = this.$filter('filterBy')(this.tasks, ['taskStatusName'], this.selectedStatus);
    };
    return TaskArchiveController;
}());
exports.taskArchiveComponent = {
    bindings: {
        tasks: '<',
        taskStatuses: '<'
    },
    controller: TaskArchiveController,
    template: __webpack_require__(504)
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskController = /** @class */ (function () {
    function TaskController() {
        'ngInject';
    }
    return TaskController;
}());
exports.taskComponent = {
    controller: TaskController,
    template: __webpack_require__(505)
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskItemBasicController = /** @class */ (function () {
    TaskItemBasicController.$inject = ["TasksService", "AccountsService", "$state"];
    function TaskItemBasicController(TasksService, AccountsService, $state) {
        'ngInject';
        var _this = this;
        this.TasksService = TasksService;
        this.AccountsService = AccountsService;
        this.$state = $state;
        this.$onInit = function () {
            _this.task = _this.resolve.task;
            _this.users = _this.resolve.users;
            _this.accounts = _this.resolve.accounts;
            _this.contacts = _this.resolve.contacts;
            _this.employees = _this.resolve.employees;
            _this.taskStatuses = _this.resolve.taskStatuses;
        };
        this.save = function () {
            _this.setUserName();
            if (_this.task.id != undefined) {
                _this.TasksService.put(_this.task.id, _this.task).then(function (task) {
                    _this.closeModal();
                });
            }
            else {
                _this.TasksService.post(_this.task).then(function (task) {
                    _this.$state.go('^', { 'id': task.id });
                });
            }
        };
    }
    TaskItemBasicController.prototype.setUserName = function () {
        var _this = this;
        var selectedUser = this.users.find(function (u) { return u.id === _this.task.userId; });
        if (selectedUser) {
            this.task.userName = selectedUser.userName;
        }
        else {
            this.task.userName = null;
        }
    };
    TaskItemBasicController.prototype.accountSelected = function () {
        var _this = this;
        this.AccountsService.getChild(this.task.accountId, 'locations').then(function (result) {
            _this.locations = result;
            // console.log(this.locations);
        });
    };
    TaskItemBasicController.prototype.locationSelected = function () {
        var _this = this;
        this.teams = this.locations.find(function (item) { return item.id === _this.task.locationId; }).teams;
    };
    TaskItemBasicController.prototype.closeModal = function () {
        this.$state.go('^', {}, { reload: true });
    };
    return TaskItemBasicController;
}());
exports.taskItemBasicComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: TaskItemBasicController,
    template: __webpack_require__(506)
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskItemController = /** @class */ (function () {
    TaskItemController.$inject = ["TasksService", "AuthUserService", "$stateParams", "$state", "SweetAlert"];
    function TaskItemController(TasksService, AuthUserService, $stateParams, $state, SweetAlert) {
        'ngInject';
        var _this = this;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            if (_this.$stateParams['isArchive']) {
                _this.isArchive = true;
            }
        };
        this.tasksService = TasksService;
        this.userService = AuthUserService;
    }
    TaskItemController.prototype.submitTask = function () {
        if (this.task.id == null) {
            this.saveTask();
        }
        else {
            this.tasksService.put(this.task.id, this.task);
        }
    };
    TaskItemController.prototype.saveTask = function () {
        var _this = this;
        this.tasksService.post(this.task).then(function (result) {
            _this.$state.go('hr.tasks.item', { 'id': result.id });
        });
    };
    TaskItemController.prototype.deleteTask = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze medewerker wilt verwijderen?\n Diensten en declaraties van de medewerker blijven onveranderd!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.tasksService.delete(_this.task.id);
                _this.$state.go('^.list').then(function () { _this.$state.reload(); });
            }
            else {
            }
        });
    };
    return TaskItemController;
}());
exports.taskItemComponent = {
    bindings: {
        task: '<',
    },
    controller: TaskItemController,
    template: __webpack_require__(507)
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskListController = /** @class */ (function () {
    TaskListController.$inject = ["$filter"];
    function TaskListController($filter) {
        'ngInject';
        var _this = this;
        this.$filter = $filter;
        this.$onInit = function () {
            _this.sortType = 'date';
            _this.filter();
        };
    }
    TaskListController.prototype.filter = function () {
        this.filteredTasks = this.$filter('filterBy')(this.tasks, ['taskStatusName'], this.selectedStatus);
    };
    return TaskListController;
}());
exports.taskListComponent = {
    bindings: {
        tasks: '<',
        taskStatuses: '<'
    },
    controller: TaskListController,
    template: __webpack_require__(508)
};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.taskState = {
    parent: 'app',
    name: "tasks",
    url: "/tasks",
    component: 'taskComponent',
    redirectTo: "tasks.list",
    data: {
        permissions: {
            only: ['BACKOFFICE'],
            redirectTo: 'schedule'
        }
    }
};
exports.taskListState = {
    name: "tasks.list",
    url: "/list",
    resolve: {
        tasks: ["TasksService", function (TasksService) {
            "ngInject";
            return TasksService.all();
        }],
        taskStatuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('TaskStatus');
        }]
    },
    views: {
        "main": 'taskListComponent'
    },
};
exports.taskItemState = {
    name: "tasks.item",
    url: "/:id",
    params: {
        "isArchive": null
    },
    resolve: {
        task: ["TasksService", "$stateParams", function (TasksService, $stateParams) {
            "ngInject";
            if ($stateParams['id']) {
                return TasksService.get($stateParams['id']);
            }
        }]
    },
    views: {
        "main": 'taskItemComponent'
    }
};
exports.taskItemBasicState = {
    name: "tasks.item.basic",
    url: "/basic",
    modal: ['task'],
    resolve: {
        users: ["EmployeesService", function (EmployeesService) {
            'ngInject';
            return EmployeesService.gatBackoffice();
        }],
        accounts: ["AccountsService", function (AccountsService) {
            "ngInject";
            return AccountsService.all();
        }],
        contacts: ["ContactsService", function (ContactsService) {
            'ngInject';
            return ContactsService.all();
        }],
        employees: ["EmployeesService", function (EmployeesService) {
            "ngInject";
            return EmployeesService.getEmployeesByStatus();
        }],
        taskStatuses: ["MasterdataAService", function (MasterdataAService) {
            "ngInject";
            return MasterdataAService.getItems('TaskStatus');
        }]
    },
    component: 'taskItemBasicComponent'
};
exports.taskArchiveState = {
    name: "tasks.archive",
    url: "/archive",
    resolve: {
        tasks: ["TasksService", function (TasksService) {
            "ngInject";
            return TasksService.getArchive();
        }],
    },
    views: {
        "main": 'taskArchiveComponent'
    },
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(7);
var moment = __webpack_require__(0);
var DeclarationController = /** @class */ (function () {
    DeclarationController.$inject = ["DeclarationService", "EmployeesService", "ShiftService", "HourCodeService", "$state", "$stateParams", "SweetAlert"];
    function DeclarationController(DeclarationService, EmployeesService, ShiftService, HourCodeService, $state, $stateParams, SweetAlert) {
        'ngInject';
        var _this = this;
        this.DeclarationService = DeclarationService;
        this.EmployeesService = EmployeesService;
        this.ShiftService = ShiftService;
        this.HourCodeService = HourCodeService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.SweetAlert = SweetAlert;
        this.$onInit = function () {
            _this.declaration = _this.resolve.declaration;
            _this.employee = _this.resolve.employee;
            console.log(_this.employee);
            if (_this.declaration) {
                // Bestaande declaratie: controleer of het oude of nieuwe systeem is
                _this.declaration.dateTimeFrom = new Date(Date.parse(_this.declaration.dateTimeFrom));
                _this.declaration.dateTimeTo = new Date(Date.parse(_this.declaration.dateTimeTo));
                // Initialiseer selectedHourCodeId voor backward compatibility
                _this.selectedHourCodeId = _this.declaration.hourCodeId || _this.declaration.wageCodeId;
                // Als het een oude declaratie is (alleen wageCodeId), behoud deze
                // Als het een nieuwe declaratie is (hourCodeId), gebruik deze
                // Beide kunnen naast elkaar bestaan tijdens migratie
            }
            else {
                // Nieuwe declaratie: gebruik hourCodeId
                _this.declaration = new services_1.IDeclaration();
                _this.declaration.dateTimeFrom = _this.$stateParams['shiftStartDate'];
                _this.declaration.dateTimeTo = _this.$stateParams['shiftEndDate'];
                _this.declaration.shiftId = _this.$stateParams['shiftId'];
                _this.declaration.employeeId = _this.$stateParams['employeeId'];
                _this.declaration.registrationType = _this.$stateParams['type'];
                _this.declaration.status = 0;
                _this.selectedHourCodeId = null;
            }
            // Als het een onkosten declaratie is (type = 2), laad hourcodes dynamisch op basis van CAO
            if (_this.declaration.registrationType == '2' && _this.declaration.shiftId) {
                _this.loadExpenseHourCodes();
            }
            else {
                // Voor tijd declaraties (type = 1), gebruik de looncomponent hourcodes uit resolve
                _this.wageCodes = _this.resolve.wageCodes || [];
            }
        };
        this.loadExpenseHourCodes = function () {
            console.log('[Declaration] Laden van onkosten hourcodes', { shiftId: _this.declaration.shiftId });
            if (!_this.declaration.shiftId) {
                console.log('[Declaration] Geen shiftId beschikbaar');
                _this.wageCodes = [];
                return;
            }
            // Haal shift op via ShiftService - de CAO is nu al in de shift response
            _this.ShiftService.get(_this.declaration.shiftId).then(function (shift) {
                console.log('[Declaration] Shift opgehaald:', {
                    shiftId: shift.id,
                    teamLocationId: shift.teamLocationId,
                    teamLocationAccountId: shift.teamLocationAccountId,
                    teamLocationSalaryScaleGroupId: shift.teamLocationSalaryScaleGroupId,
                    teamLocationSalaryScaleGroupName: shift.teamLocationSalaryScaleGroupName
                });
                if (!shift) {
                    console.log('[Declaration] Geen shift gevonden');
                    _this.wageCodes = [];
                    return;
                }
                // Gebruik de CAO direct uit de shift response
                if (shift.teamLocationSalaryScaleGroupId) {
                    var salaryScaleGroupId = shift.teamLocationSalaryScaleGroupId;
                    var caoSource = 'Shift (Location/Account)';
                    console.log('[Declaration] CAO gevonden in shift response:', {
                        salaryScaleGroupId: salaryScaleGroupId,
                        salaryScaleGroupName: shift.teamLocationSalaryScaleGroupName,
                        source: caoSource
                    });
                    _this.loadHourCodesByCao(salaryScaleGroupId, caoSource);
                }
                else {
                    console.log('[Declaration] Geen CAO beschikbaar in shift response:', { shift: shift });
                    _this.wageCodes = [];
                }
            }).catch(function (error) {
                console.error('[Declaration] Fout bij ophalen Shift:', error);
                _this.wageCodes = [];
            });
        };
        this.loadHourCodesByCao = function (salaryScaleGroupId, caoSource) {
            console.log('[Declaration] Ophalen hourcodes voor CAO:', { salaryScaleGroupId: salaryScaleGroupId, caoSource: caoSource });
            _this.HourCodeService.getBySalaryScaleGroupId(salaryScaleGroupId).then(function (hourCodes) {
                console.log('[Declaration] Alle hourcodes opgehaald:', {
                    total: hourCodes.length,
                    hourCodes: hourCodes.map(function (hc) { return ({ id: hc.id, code: hc.code, name: hc.name, type: hc.type }); })
                });
                // Filter alleen onkosten (type = 1)
                _this.wageCodes = hourCodes.filter(function (hc) { return hc.type === 1; });
                console.log('[Declaration] Gefilterde onkosten hourcodes:', {
                    total: _this.wageCodes.length,
                    wageCodes: _this.wageCodes.map(function (hc) { return ({ id: hc.id, code: hc.code, name: hc.name, type: hc.type }); })
                });
            }).catch(function (error) {
                console.error('[Declaration] Fout bij ophalen hourcodes:', error);
                _this.wageCodes = [];
            });
        };
    }
    DeclarationController.prototype.roundMinutes = function (date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    };
    DeclarationController.prototype.startDateBeforeRender = function ($dates) {
    };
    DeclarationController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.declaration.dateTimeFrom) {
            var activeDate = moment(this.declaration.dateTimeFrom).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    DeclarationController.prototype.submitDeclaration = function () {
        var _this = this;
        if (this.declaration.registrationType == '1') {
            var duration = moment.duration(moment(this.declaration.dateTimeTo).diff(moment(this.declaration.dateTimeFrom))).asHours();
            this.declaration.dateTimeFrom = moment(this.declaration.dateTimeFrom).format("YYYY-MM-DD HH:mm");
            this.declaration.dateTimeTo = moment(this.declaration.dateTimeTo).format("YYYY-MM-DD HH:mm");
            if (duration > 6) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'In geval van pauzes, maak 2 declaraties aan.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja',
                    cancelButtonText: 'Nee, annuleren',
                }, function (isConfirm) {
                    if (isConfirm) {
                        _this.saveDeclaration();
                    }
                    else { }
                });
            }
            else {
                this.saveDeclaration();
            }
        }
        else {
            // Validatie: minstens één moet zijn ingesteld (backward compatible)
            var wageCodeId = this.getWageCodeId();
            if (!wageCodeId) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Vul een type in',
                    type: 'warning',
                    confirmButtonColor: '#2ECC71',
                    confirmButtonText: 'Ok',
                });
                return;
            }
            this.declaration.dateTimeFrom = null;
            this.declaration.dateTimeTo = null;
            // Gebruik helper method voor code retrieval
            var code = this.getWageCodeCode();
            if (code == '5091' || code == '5090') {
                this.declaration.value = 1;
            }
            // Voor nieuwe declaraties: gebruik hourCodeId
            if (!this.declaration.id) {
                // Nieuwe declaratie: zet hourCodeId, clear wageCodeId
                if (this.declaration.hourCodeId) {
                    // Al ingesteld via wageCodeUpdated
                }
                else if (this.declaration.wageCodeId) {
                    // Fallback: converteer wageCodeId naar hourCodeId
                    this.declaration.hourCodeId = this.declaration.wageCodeId;
                    this.declaration.hourCodeCode = this.declaration.wageCodeCode || this.getWageCodeCode();
                    this.declaration.wageCodeId = null;
                    this.declaration.wageCodeCode = null;
                }
            }
            // Voor bestaande declaraties: behoud wageCodeId voor backward compatibility
            this.saveDeclaration();
        }
    };
    DeclarationController.prototype.saveDeclaration = function () {
        var _this = this;
        // Check of declaratie gefactureerd is
        var isInvoiced = this.declaration.invoiceId || this.declaration.sendToCootje;
        if (isInvoiced && !this.declaration.forceRecalculate) {
            // Toon waarschuwing
            this.SweetAlert.swal({
                title: 'Waarschuwing!',
                html: 'Deze declaratie is al gefactureerd. ' +
                    'Als u deze toch wilt herberekenen, kan dit gevolgen hebben voor de factuur. ' +
                    'Weet u zeker dat u door wilt gaan?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ja, toch herberekenen',
                cancelButtonText: 'Annuleren',
            }, function (isConfirm) {
                if (isConfirm) {
                    // Zet forceRecalculate flag
                    _this.declaration.forceRecalculate = true;
                    _this.performSave();
                }
            });
        }
        else {
            this.performSave();
        }
    };
    DeclarationController.prototype.performSave = function () {
        var _this = this;
        if (!this.declaration.id) {
            this.DeclarationService.post(this.declaration).then(function (result) {
                _this.closeModal();
            });
        }
        else {
            this.DeclarationService.put(this.declaration.id, this.declaration).then(function (result) {
                _this.closeModal();
            });
        }
    };
    // Helper methods voor backward compatibility
    DeclarationController.prototype.getWageCodeCode = function () {
        return this.declaration.hourCodeCode || this.declaration.wageCodeCode;
    };
    DeclarationController.prototype.getWageCodeName = function () {
        return this.declaration.hourCodeName || this.declaration.wageCodeName;
    };
    DeclarationController.prototype.getWageCodeId = function () {
        return this.declaration.hourCodeId || this.declaration.wageCodeId;
    };
    DeclarationController.prototype.wageCodeUpdated = function () {
        var _this = this;
        var wageCode = this.wageCodes.find(function (w) { return w.id == _this.selectedHourCodeId; });
        if (wageCode) {
            // Voor nieuwe declaraties: gebruik hourCodeId
            this.declaration.hourCodeId = wageCode.id;
            this.declaration.hourCodeCode = wageCode.code;
            // Voor backward compatibility: behoud ook wageCodeId voor oude declaraties
            // Maar bij nieuwe declaraties wordt alleen hourCodeId gebruikt
            if (!this.declaration.id) {
                // Nieuwe declaratie: alleen hourCodeId
                this.declaration.wageCodeId = null;
                this.declaration.wageCodeCode = null;
            }
            else {
                // Bestaande declaratie: behoud wageCodeId voor backward compatibility
                this.declaration.wageCodeId = wageCode.id;
                this.declaration.wageCodeCode = wageCode.code;
            }
        }
    };
    DeclarationController.prototype.deleteDeclaration = function () {
        var _this = this;
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze declaration wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d96557',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.DeclarationService.delete(_this.declaration.id).then(function () {
                    _this.closeModal();
                });
            }
            else {
            }
        });
    };
    DeclarationController.prototype.closeModal = function () {
        if (this.resolve.refresh) {
            this.$state.go('^', { "openShiftId": this.declaration.shiftId }, { reload: true });
        }
        else {
            this.$state.go('^', { "openShiftId": this.declaration.shiftId }, { reload: false });
        }
    };
    return DeclarationController;
}());
exports.declarationComponent = {
    bindings: {
        resolve: "<",
        close: "&"
    },
    controller: DeclarationController,
    template: __webpack_require__(509)
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var timesheets_states_1 = __webpack_require__(709);
var timesheets_component_1 = __webpack_require__(707);
var timesheets_dashboard_component_1 = __webpack_require__(708);
var ngmodule_1 = __webpack_require__(4);
var timesheetDetails_component_1 = __webpack_require__(706);
var declaration_component_1 = __webpack_require__(704);
var timesheetsOverview_component_1 = __webpack_require__(710);
var timesheetsSummary_component_1 = __webpack_require__(711);
var hourCode_service_1 = __webpack_require__(23);
var shifts_service_1 = __webpack_require__(15);
var quotationsAppModule = {
    components: { timesheetsComponent: timesheets_component_1.timesheetsComponent, timesheetsDashboardComponent: timesheets_dashboard_component_1.timesheetsDashboardComponent, timesheetDetailsComponent: timesheetDetails_component_1.timesheetDetailsComponent,
        declarationComponent: declaration_component_1.declarationComponent, timesheetsOverviewComponent: timesheetsOverview_component_1.timesheetsOverviewComponent, timesheetsSummaryComponent: timesheetsSummary_component_1.timesheetsSummaryComponent },
    states: [timesheets_states_1.timesheetsState, timesheets_states_1.timesheetsDashboardState, timesheets_states_1.timesheetsDeclarationState,
        timesheets_states_1.timesheetsOverviewState],
    services: {
        HourCodeService: hourCode_service_1.HourCodeService,
        ShiftService: shifts_service_1.ShiftService
    }
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, quotationsAppModule);


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var TimesheetDetailsController = /** @class */ (function () {
    TimesheetDetailsController.$inject = ["$state", "DeclarationService", "SweetAlert", "$stateParams"];
    function TimesheetDetailsController($state, DeclarationService, SweetAlert, $stateParams) {
        'ngInject';
        var _this = this;
        this.$state = $state;
        this.DeclarationService = DeclarationService;
        this.SweetAlert = SweetAlert;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.openShift = _this.$stateParams['openShiftId'];
            _this.timesheet.shifts.forEach(function (s) {
                if (s.declarations.length > 0) {
                    s.declarationsApproved = true;
                    s.declarations.forEach(function (d) {
                        if (d.status != 3) {
                            s.declarationsApproved = false;
                        }
                    });
                }
                else {
                    s.declarationsApproved = false;
                }
            });
        };
    }
    TimesheetDetailsController.prototype.approve = function (shift) {
        var _this = this;
        shift.declarations.forEach(function (declaration) {
            if (!declaration.invoiceId && !declaration.sendToCootje) {
                if (!_this.timesheet.employeeIsZZp || declaration.zzpInvoiceNumber.length > 0) {
                    declaration.status = 3;
                    _this.DeclarationService.put(declaration.id, declaration).then(function (result) {
                        declaration = result;
                        shift.declarationsApproved = true;
                    });
                }
            }
        });
    };
    TimesheetDetailsController.prototype.reject = function (shift) {
        var _this = this;
        shift.declarations.forEach(function (declaration) {
            if (!declaration.invoiceId && !declaration.sendToCootje) {
                if (_this.timesheet.employeeIsZZp && declaration.status > 0) {
                    declaration.status = 2;
                    _this.DeclarationService.put(declaration.id, declaration).then(function (result) {
                        declaration = result;
                    });
                }
            }
        });
    };
    TimesheetDetailsController.prototype.isSameDay = function (start, end) {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        }
        else {
            return false;
        }
    };
    TimesheetDetailsController.prototype.deleteDeclaration = function (event, declaration, shift) {
        var _this = this;
        event.stopPropagation();
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze declaration wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d96557',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, function (isConfirm) {
            if (isConfirm) {
                _this.DeclarationService.item = declaration;
                _this.DeclarationService.delete(declaration.id).then(function () {
                    shift.declarations = shift.declarations.filter(function (d) { return d.id !== declaration.id; });
                });
            }
            else {
            }
        });
    };
    TimesheetDetailsController.prototype.isInvoiced = function (shift) {
        for (var i = 0; i < shift.declarations.length; i++) {
            if (shift.declarations[i].invoiceId || shift.declarations[i].sendToCootje) {
                return true;
            }
        }
        return false;
    };
    TimesheetDetailsController.prototype.isZZPOpen = function (shift) {
        for (var i = 0; i < shift.declarations.length; i++) {
            if (this.timesheet.employeeIsZZp && (shift.declarations[i].status == 0 && shift.declarations[i].zzpInvoiceNumber.length == 0)) {
                return true;
            }
        }
        return false;
    };
    return TimesheetDetailsController;
}());
exports.timesheetDetailsComponent = {
    bindings: {
        timesheet: '<',
        calendarStartDate: '<',
        calendarEndDate: '<'
    },
    controller: TimesheetDetailsController,
    template: __webpack_require__(510)
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimesheetsController = /** @class */ (function () {
    function TimesheetsController() {
        'ngInject';
    }
    return TimesheetsController;
}());
exports.timesheetsComponent = {
    controller: TimesheetsController,
    template: __webpack_require__(512)
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var TimesheetsDashboardController = /** @class */ (function () {
    TimesheetsDashboardController.$inject = ["EmployeesService", "DeclarationService", "ShiftService", "$stateParams"];
    function TimesheetsDashboardController(EmployeesService, DeclarationService, ShiftService, $stateParams) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.DeclarationService = DeclarationService;
        this.ShiftService = ShiftService;
        this.$stateParams = $stateParams;
        this.$onInit = function () {
            _this.moment = __webpack_require__(0);
            _this.sortType = 'employeeName';
            _this.startDate = _this.moment().startOf('isoweek').format("YYYY-MM-DD");
            _this.endDate = _this.moment().endOf('isoweek').format("YYYY-MM-DD");
            _this.DeclarationService.subscribe('TimesheetsDashboardController', function (type) {
                var currentShift;
                switch (type) {
                    case 'post': {
                        currentShift = _this.currentEmployee.shifts.find(function (s) { return s.id == _this.DeclarationService.item.shiftId; });
                        _this.DeclarationService.get(_this.DeclarationService.item.id).then(function (declaration) {
                            currentShift.declarations.push(declaration);
                            _this.updateShiftDeclarationsSummary(currentShift);
                        });
                        break;
                    }
                    case 'put': {
                        currentShift = _this.currentEmployee.shifts.find(function (s) { return s.id == _this.DeclarationService.item.shiftId; });
                        currentShift.declarations = currentShift.declarations.filter(function (s) { return s.id !== _this.DeclarationService.item.id; });
                        _this.DeclarationService.get(_this.DeclarationService.item.id).then(function (declaration) {
                            currentShift.declarations.push(declaration);
                            _this.updateShiftDeclarationsSummary(currentShift);
                        });
                        break;
                    }
                    case 'delete': {
                        currentShift = _this.currentEmployee.shifts.find(function (s) { return s.id == _this.DeclarationService.item.shiftId; });
                        _this.updateShiftDeclarationsSummary(currentShift);
                        break;
                    }
                }
            });
            // this.getTimesheets();
            _this.checkCompletionStatus();
        };
        // public $onChange = (change) => {
        //     console.log(change);
        // }
        this.$onDestroy = function () {
            _this.DeclarationService.unsubscribe('TimesheetsDashboardController');
        };
    }
    TimesheetsDashboardController.prototype.updateShiftDeclarationsSummary = function (currentShift) {
        var _this = this;
        // console.log('updateShiftDeclarationsSummary')
        this.ShiftService.customGet(this.DeclarationService.item.shiftId + '/shiftDeclarations').then(function (result) {
            currentShift.plannedHours = result.plannedHours;
            currentShift.declaredHours = result.declaredHours;
            currentShift.hoursDifference = result.hoursDifference;
            _this.EmployeesService.customGet(_this.DeclarationService.item.employeeId + '/employeeSummary', { from: _this.startDate, till: _this.endDate }).then(function (result) {
                _this.currentEmployee.shiftHours = result.shiftHours;
                _this.currentEmployee.shiftDeclarationHours = result.shiftDeclarationHours;
            });
            _this.checkEmployeeCompletionsStatus(_this.currentEmployee);
        });
    };
    TimesheetsDashboardController.prototype.startDateBeforeRender = function ($dates) {
    };
    TimesheetsDashboardController.prototype.endDateBeforeRender = function ($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');
            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    };
    TimesheetsDashboardController.prototype.checkCompletionStatus = function () {
        var _this = this;
        this.employees.forEach(function (e) {
            _this.checkEmployeeCompletionsStatus(e);
        });
    };
    TimesheetsDashboardController.prototype.checkEmployeeCompletionsStatus = function (employee) {
        // console.log('checkEmployeeCompletionsStatus')
        employee.doneShiftCount = employee.shifts.filter(function (s) { return s.declarations.length > 0; }).length;
        employee.declarationsApproved = true;
        employee.shifts.forEach(function (s) {
            s.declarations.forEach(function (d) {
                if (d.status != 3) {
                    employee.declarationsApproved = false;
                }
            });
        });
    };
    TimesheetsDashboardController.prototype.getTimesheets = function () {
        var _this = this;
        this.EmployeesService.customAll('employeeSummary', { from: this.startDate, till: this.endDate }).then(function (result) {
            _this.employees = result;
            _this.checkCompletionStatus();
        });
    };
    TimesheetsDashboardController.prototype.prevWeek = function () {
        this.startDate = this.moment(this.startDate).add(-7, 'day').format("YYYY-MM-DD");
        this.endDate = this.moment(this.endDate).add(-7, 'day').format("YYYY-MM-DD");
        this.currentEmployee = null;
        this.getTimesheets();
    };
    TimesheetsDashboardController.prototype.nextWeek = function () {
        this.startDate = this.moment(this.startDate).add(7, 'day').format("YYYY-MM-DD");
        this.endDate = this.moment(this.endDate).add(7, 'day').format("YYYY-MM-DD");
        this.currentEmployee = null;
        this.getTimesheets();
    };
    TimesheetsDashboardController.prototype.selectEmployee = function (item) {
        this.currentEmployee = item;
    };
    TimesheetsDashboardController.prototype.sendToNmbrs = function () {
        var start = this.startDate.getFullYear() + '-' + this.startDate.getMonth() + '-' + this.startDate.getDate();
        var end = this.endDate.getFullYear() + '-' + this.endDate.getMonth() + '-' + this.endDate.getDate();
        this.DeclarationService.customGet('pushtonmbrs', { from: start, till: end });
    };
    return TimesheetsDashboardController;
}());
exports.timesheetsDashboardComponent = {
    controller: TimesheetsDashboardController,
    bindings: {
        employees: '='
    },
    template: __webpack_require__(511)
};


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.timesheetsState = {
    parent: "app",
    name: "timesheets",
    url: "/timesheets",
    redirectTo: "timesheets.dashboard",
    component: "timesheetsComponent",
    data: {
        permissions: {
            only: ['TIMESHEETS'],
            redirectTo: 'schedule'
        }
    }
};
exports.timesheetsDashboardState = {
    name: "timesheets.dashboard",
    url: "/dashboard",
    resolve: {
        employees: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            "ngInject";
            var moment = __webpack_require__(0);
            var startDate = moment().startOf('isoweek').toDate();
            var endDate = moment().endOf('isoweek').toDate();
            return EmployeesService.customAll('employeeSummary', { from: startDate, till: endDate });
        }]
    },
    views: {
        "main": 'timesheetsDashboardComponent'
    }
};
exports.timesheetsOverviewState = {
    name: "timesheets.overview",
    url: "/overview?employeeId",
    resolve: {},
    views: {
        "main": 'timesheetsOverviewComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'timesheets'
        }
    }
};
exports.timesheetsDeclarationState = {
    name: "timesheets.dashboard.declaration",
    url: "/declaration/:declarationId?employeeId&shiftId&type&shiftStartDate&shiftEndDate",
    params: {
        employeeId: null,
        shiftId: null,
        type: null,
        shiftStartDate: null,
        shiftEndDate: null
    },
    modal: true,
    resolve: {
        wageCodes: ["HourCodeService", function (HourCodeService) {
            "ngInject";
            // Haal alleen looncomponent hourcodes op (type = 0)
            return HourCodeService.getByType(0);
        }],
        declaration: ["DeclarationService", "$stateParams", function (DeclarationService, $stateParams) {
            "ngInject";
            if ($stateParams['declarationId']) {
                return DeclarationService.get($stateParams['declarationId']);
            }
        }],
        employee: ["EmployeesService", "$stateParams", function (EmployeesService, $stateParams) {
            "ngInject";
            if ($stateParams['employeeId']) {
                return EmployeesService.get($stateParams['employeeId']);
            }
        }]
    },
    component: 'declarationComponent'
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var signalR = __webpack_require__(305);
var config_1 = __webpack_require__(13);
var TimesheetsOverviewController = /** @class */ (function () {
    TimesheetsOverviewController.$inject = ["EmployeesService", "$stateParams", "DeclarationService", "EnumService", "$scope"];
    function TimesheetsOverviewController(EmployeesService, $stateParams, DeclarationService, EnumService, $scope) {
        'ngInject';
        var _this = this;
        this.EmployeesService = EmployeesService;
        this.$stateParams = $stateParams;
        this.DeclarationService = DeclarationService;
        this.EnumService = EnumService;
        this.$scope = $scope;
        this.months = [];
        // _hubConnection: HubConnection;
        this.notifications = [];
        this.progressNotifications = [];
        this.$onInit = function () {
            _this.sortType = 'account.name';
            _this.moment = __webpack_require__(0);
            if (_this.moment().subtract(1, 'year').format('YYYY') < 2020) {
                for (var i = 11; i <= 13; i++) {
                    _this.months.push({
                        index: i,
                        startDate: _this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                        endDate: _this.moment().subtract(1, 'year').startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                        year: _this.moment().subtract(1, 'year').format('YYYY'),
                        month: i
                    });
                }
                _this.months.find(function (m) { return m.month == 13 && m.year == 2019; }).endDate = _this.moment('2019-12-02').endOf('month').toDate();
            }
            else {
                for (var i = 9; i <= 11; i++) {
                    _this.months.push({
                        index: i,
                        startDate: _this.moment().subtract(1, 'year').startOf('year').add(i, 'months').toDate(),
                        endDate: _this.moment().subtract(1, 'year').startOf('year').add(i, 'months').endOf('month').toDate(),
                        year: _this.moment().subtract(1, 'year').format('YYYY'),
                        month: _this.moment().subtract(1, 'year').startOf('year').add(i, 'months').format('M')
                    });
                }
            }
            if (_this.moment().format('YYYY') < 2020) {
                for (var i = 1; i <= 13; i++) {
                    _this.months.push({
                        index: i,
                        startDate: _this.moment().startOf('year').add((i - 1) * 4, 'weeks').startOf('isoweek').toDate(),
                        endDate: _this.moment().startOf('year').add((i - 1) * 4 + 3, 'weeks').endOf('isoweek').toDate(),
                        year: _this.moment().format('YYYY'),
                        month: i
                    });
                }
                _this.months.find(function (m) { return m.month == 13 && m.year == 2019; }).endDate = _this.moment('2019-12-02').endOf('month').toDate();
            }
            else {
                for (var i = 0; i <= 11; i++) {
                    _this.months.push({
                        index: i,
                        startDate: _this.moment().startOf('year').add(i, 'months').toDate(),
                        endDate: _this.moment().startOf('year').add(i, 'months').endOf('month').toDate(),
                        year: _this.moment().format('YYYY'),
                        month: _this.moment().startOf('year').add(i, 'months').format('M')
                    });
                }
            }
            _this.currentMonth = _this.months.find(function (m) { return m.month == _this.moment().format('M') && m.year == _this.moment().format('YYYY'); });
            _this.initHubConnection();
        };
    }
    TimesheetsOverviewController.prototype.initHubConnection = function () {
        var _this = this;
        // console.log('initHubConnection');
        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(config_1.default.BASE_URL + 'notification')
            .build();
        //this._hubConnection = new HubConnection(env.BASE_URL + 'notification');
        this._hubConnection.on('Notify', function (notificationItem) {
            // console.log('event');
            // console.log(notificationItem);
            _this.notify(notificationItem);
        });
        // console.log('Hello ._hubConnection.start');
        this._hubConnection.start()
            .then(function () {
            // console.log('Hub connection started');
        })
            .catch(function (reason) {
            // console.log('Error while establishing connection');
            // console.log(reason);
        });
    };
    TimesheetsOverviewController.prototype.notify = function (notificationItem) {
        var _this = this;
        switch (notificationItem.notificationType) {
            case 1:
                //Start
                this.$scope.$apply(function () {
                    _this.currentNotification = notificationItem;
                    _this.inprogress = true;
                    _this.notifications.push(notificationItem);
                });
                break;
            case 2:
                //Progress
                this.inprogress = true;
                var percentage = (notificationItem.currentValue / notificationItem.totalValue) * 100;
                this.progresscounter = { currentValue: notificationItem.currentValue, totalValue: notificationItem.totalValue, percentage: percentage };
                this.currentNotification = notificationItem;
                this.$scope.$apply(function () {
                    _this.progressNotifications.push(notificationItem);
                });
                break;
            case 3:
                //Information
                this.$scope.$apply(function () {
                    _this.currentNotification = notificationItem;
                    _this.notifications.push(notificationItem);
                });
                break;
            case 4:
                //Finish
                this.$scope.$apply(function () {
                    _this.currentNotification = notificationItem;
                    _this.notifications.push(notificationItem);
                    _this.inprogress = false;
                });
                break;
        }
    };
    TimesheetsOverviewController.prototype.getTimesheets = function () {
        var _this = this;
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        this.EmployeesService.customAll('employeeSummary', { from: start, till: end }).then(function (result) {
            _this.employees = result;
            _this.getCompletionData();
        });
    };
    TimesheetsOverviewController.prototype.getCompletionData = function () {
        var _this = this;
        // console.log('getCompletionData')
        this.summary = {};
        this.summary.scheduledHours = 0;
        this.summary.scheduledShiftsCount = 0;
        this.summary.declaredHours = 0;
        this.summary.declaredShiftsCount = 0;
        this.summary.approvedHours = 0;
        this.summary.approvedShiftsCount = 0;
        this.employees.forEach(function (e) {
            e.approvedShiftCount = 0;
            e.approvedShiftHours = 0;
            e.declarationsApproved = true;
            e.doneShiftCount = e.shifts.filter(function (s) { return s.declarations.length > 0; }).length;
            e.shifts.forEach(function (s) {
                if (s.declarations.length > 0) {
                    _this.summary.declaredShiftsCount++;
                    if (s.declarations.filter(function (d) { return d.status != 3; }).length == 0) {
                        e.approvedShiftCount++;
                    }
                }
                s.declarations.forEach(function (d) {
                    _this.summary.declaredHours += d.duration;
                    if (d.status == 3) {
                        e.approvedShiftHours += d.duration;
                    }
                    else {
                        e.declarationsApproved = false;
                    }
                });
            });
            _this.summary.scheduledHours += e.shiftHours;
            _this.summary.scheduledShiftsCount += e.shiftCount;
            _this.summary.approvedHours += e.approvedShiftHours;
            _this.summary.approvedShiftsCount += e.approvedShiftCount;
        });
        this.summary.scheduledHours = this.summary.scheduledHours.toFixed(2);
        this.summary.scheduledShiftsCount = this.summary.scheduledShiftsCount.toFixed(2);
        this.summary.declaredHours = this.summary.declaredHours.toFixed(2);
        this.summary.declaredShiftsCount = this.summary.declaredShiftsCount.toFixed(2);
        this.summary.approvedHours = this.summary.approvedHours.toFixed(2);
        this.summary.approvedShiftsCount = this.summary.approvedShiftsCount.toFixed(2);
    };
    TimesheetsOverviewController.prototype.sendToNmbrs = function () {
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        // lil hack here, so they bill the last period in 2019 correctly
        if (start == '2019-01-01')
            start = '2019-01-02';
        $('#notificationModal').modal({ backdrop: 'static', keyboard: false });
        if (!this.inprogress) {
            this.DeclarationService.customGet('pushtonmbrs', { from: start, till: end }).then(function () {
                $('#notificationModal').modal('show');
            });
        }
        else {
            $('#notificationModal').modal('show');
        }
    };
    TimesheetsOverviewController.prototype.selectEmployee = function (employee) {
        this.currentEmployee = employee;
        this.loadPreviewForEmployee(employee);
    };
    TimesheetsOverviewController.prototype.previewNmbrs = function (employee) {
        this.loadPreviewForEmployee(employee);
        $('#previewNmbrsModal').modal('show');
    };
    TimesheetsOverviewController.prototype.loadPreviewForEmployee = function (employee) {
        var _this = this;
        var start = moment(this.currentMonth.startDate).format('YYYY-MM-DD');
        var end = moment(this.currentMonth.endDate).format('YYYY-MM-DD');
        // lil hack here, so they bill the last period in 2019 correctly
        if (start == '2019-01-01')
            start = '2019-01-02';
        this.DeclarationService.customGet('previewnmbrs', {
            employeeId: employee.employeeId,
            from: start,
            till: end
        }).then(function (result) {
            _this.previewData = result;
        }).catch(function (error) {
            var errorMessage = (error.data && error.data.message) || error.statusText || 'Unknown error';
            _this.previewData = null;
            console.error('Error loading preview: ' + errorMessage);
        });
    };
    return TimesheetsOverviewController;
}());
exports.timesheetsOverviewComponent = {
    controller: TimesheetsOverviewController,
    template: __webpack_require__(513)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimesheetsSummaryController = /** @class */ (function () {
    function TimesheetsSummaryController() {
        'ngInject';
        var _this = this;
        this.$onChanges = function () {
            // console.log('TimesheetsSummaryController')
            _this.getCompletionData();
        };
    }
    TimesheetsSummaryController.prototype.getCompletionData = function () {
        var _this = this;
        // console.log('getCompletionData')
        this.summary = {};
        this.summary.scheduledHours = 0;
        this.summary.scheduledShiftsCount = 0;
        this.summary.declaredHours = 0;
        this.summary.declaredShiftsCount = 0;
        this.summary.approvedHours = 0;
        this.summary.approvedShiftsCount = 0;
        this.summary.canceledShiftsCount = 0;
        this.summary.sickShiftsCount = 0;
        this.summary.canceledShiftsHours = 0;
        this.summary.sickShiftsHours = 0;
        this.employees.forEach(function (e) {
            e.approvedShiftCount = 0;
            e.approvedShiftHours = 0;
            e.declarationsApproved = true;
            e.doneShiftCount = e.shifts.filter(function (s) { return s.declarations.length > 0; }).length;
            e.shifts.forEach(function (s) {
                if (s.declarations.length > 0) {
                    _this.summary.declaredShiftsCount++;
                    if (s.declarations.filter(function (d) { return d.status != 3; }).length == 0) {
                        e.approvedShiftCount++;
                    }
                }
                s.declarations.forEach(function (d) {
                    _this.summary.declaredHours += d.duration;
                    if (d.status == 3) {
                        e.approvedShiftHours += d.duration;
                    }
                    else {
                        e.declarationsApproved = false;
                    }
                });
            });
            _this.summary.scheduledHours += e.shiftHours;
            _this.summary.scheduledShiftsCount += e.shiftCount;
            _this.summary.approvedHours += e.approvedShiftHours;
            _this.summary.approvedShiftsCount += e.approvedShiftCount;
            _this.summary.canceledShiftsCount += e.shiftCanceledCount;
            _this.summary.sickShiftsCount += e.shiftSickCount;
            _this.summary.canceledShiftsHours += e.shiftCanceledHours;
            _this.summary.sickShiftsHours += e.shiftSickHours;
        });
        this.summary.scheduledHours = this.summary.scheduledHours.toFixed(2);
        this.summary.scheduledShiftsCount = this.summary.scheduledShiftsCount.toFixed(2);
        this.summary.declaredHours = this.summary.declaredHours.toFixed(2);
        this.summary.declaredShiftsCount = this.summary.declaredShiftsCount.toFixed(2);
        this.summary.approvedHours = this.summary.approvedHours.toFixed(2);
        this.summary.approvedShiftsCount = this.summary.approvedShiftsCount.toFixed(2);
        this.summary.canceledShiftsCount = this.summary.canceledShiftsCount.toFixed(2);
        this.summary.sickShiftsCount = this.summary.sickShiftsCount.toFixed(2);
        this.summary.canceledShiftsHours = this.summary.canceledShiftsHours.toFixed(2);
        this.summary.sickShiftsHours = this.summary.sickShiftsHours.toFixed(2);
    };
    return TimesheetsSummaryController;
}());
exports.timesheetsSummaryComponent = {
    controller: TimesheetsSummaryController,
    bindings: {
        employees: '<'
    },
    template: __webpack_require__(514)
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ngmodule_1 = __webpack_require__(4);
var twinfield_service_1 = __webpack_require__(271);
var twinfield_component_1 = __webpack_require__(713);
var twinfield_states_1 = __webpack_require__(714);
var twinfieldAppModule = {
    components: {
        twinfieldOAuthCallbackComponent: twinfield_component_1.twinfieldOAuthCallbackComponent
    },
    services: {
        TwinfieldService: twinfield_service_1.TwinfieldService,
    },
    states: [twinfield_states_1.twinfieldState],
};
ngmodule_1.loadNg1Module(ngmodule_1.ngmodule, twinfieldAppModule);


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TwinfieldOAuthCallbackController = /** @class */ (function () {
    /**
     * Constructor
     *
     * @return  {void}
     */
    TwinfieldOAuthCallbackController.$inject = ["TwinfieldService", "$scope", "localStorageService"];
    function TwinfieldOAuthCallbackController(TwinfieldService, $scope, localStorageService) {
        'ngInject';
        var _this = this;
        this.TwinfieldService = TwinfieldService;
        this.$scope = $scope;
        this.localStorageService = localStorageService;
        /**
         * Initiator
         *
         * @return  {void}
         */
        this.$onInit = function () {
            /** Send code to API on oAuth2 callback */
            if (_this.getParameter('code')) {
                _this.TwinfieldService.setToken(_this.getParameter('code')).then(function (status) {
                    _this.$scope.status = status == 'true';
                    console.log('token: set ' + _this.$scope.status);
                    _this.redirect();
                }).catch(function () {
                    _this.$scope.status = false;
                    _this.redirect();
                });
                /** Or redirect to app */
            }
            else {
                _this.redirect();
            }
        };
        /**
         * Get URI parameters
         *
         * @param   {string}  parameter
         * @return  {mixed}             Value or false
         */
        this.getParameter = function (parameter) {
            var url = window.location.href;
            var regex = new RegExp('^.*[\?\&]{1}' + parameter + '=');
            var value = url.match(regex) ? url.replace(regex, '').replace(/(\&.+)?$/, '') : false;
            return value;
        };
        /**
         * Redirect after Twinfield token
         *
         * @return  {void}
         */
        this.redirect = function () {
            /** Set twinfield URI nonces */
            var defaultUri = '/app';
            var redirectTo = _this.localStorageService.get('twinfieldRedirect') || defaultUri;
            /** Log */
            console.log('redirectTo: ' + redirectTo);
            /** Redirect */
            if (parent.location.pathname !== redirectTo.replace(/\/*\?+.*$/, '')) {
                /** Reset to prevent loop */
                _this.localStorageService.set('twinfieldRedirect', defaultUri);
                /** Redirect */
                parent.location.href = redirectTo;
            }
        };
    }
    return TwinfieldOAuthCallbackController;
}());
exports.twinfieldOAuthCallbackComponent = {
    controller: TwinfieldOAuthCallbackController,
    template: __webpack_require__(515)
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.twinfieldState = {
    parent: 'app',
    name: "twinfield",
    url: "/twinfield",
    component: 'twinfieldOAuthCallbackComponent'
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IAccountEmployee = /** @class */ (function (_super) {
    __extends(IAccountEmployee, _super);
    function IAccountEmployee() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IAccountEmployee;
}(base_entity_1.BaseEntity));
exports.IAccountEmployee = IAccountEmployee;
var AccountEmployeeService = /** @class */ (function (_super) {
    __extends(AccountEmployeeService, _super);
    AccountEmployeeService.$inject = ["Restangular", "AppService"];
    function AccountEmployeeService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/AccountEmployees') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return AccountEmployeeService;
}(base_service_1.BaseService));
exports.AccountEmployeeService = AccountEmployeeService;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IAccount = /** @class */ (function () {
    function IAccount() {
    }
    return IAccount;
}());
exports.IAccount = IAccount;
var AccountsService = /** @class */ (function (_super) {
    __extends(AccountsService, _super);
    AccountsService.$inject = ["Restangular", "AppService", "EnumService"];
    function AccountsService(Restangular, AppService, EnumService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/accounts') || this;
        _this.AppService = AppService;
        _this.EnumService = EnumService;
        _this.getContacts = function (id) {
            return _this.one(id).all('contacts').getList().then(function (result) {
                var contacts = result.value;
                contacts.forEach(function (item) {
                    item.name = item.firstName + ' ' + item.lastName;
                });
                return contacts.plain();
            });
        };
        return _this;
    }
    return AccountsService;
}(base_service_1.BaseService));
exports.AccountsService = AccountsService;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IApplicantStatusHistory = /** @class */ (function () {
    function IApplicantStatusHistory() {
    }
    return IApplicantStatusHistory;
}());
exports.IApplicantStatusHistory = IApplicantStatusHistory;
var ApplicantStatusHistoryService = /** @class */ (function (_super) {
    __extends(ApplicantStatusHistoryService, _super);
    ApplicantStatusHistoryService.$inject = ["Restangular", "AppService"];
    function ApplicantStatusHistoryService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/applicantStatusHistory') || this;
        _this.AppService = AppService;
        _this.getPerApplicant = function (applicantId) {
            return _this.Restangular.all(_this.itemName).customGET('', { "applicantId": applicantId }).then(function (response) {
                return _this.getListLoaded(response.plain());
            });
        };
        return _this;
    }
    return ApplicantStatusHistoryService;
}(base_service_1.BaseService));
exports.ApplicantStatusHistoryService = ApplicantStatusHistoryService;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var base_entity_1 = __webpack_require__(8);
var angular = __webpack_require__(5);
var IApplicant = /** @class */ (function (_super) {
    __extends(IApplicant, _super);
    function IApplicant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IApplicant;
}(base_entity_1.BaseEntity));
exports.IApplicant = IApplicant;
var ApplicantsService = /** @class */ (function (_super) {
    __extends(ApplicantsService, _super);
    ApplicantsService.$inject = ["Restangular", "AppService"];
    function ApplicantsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/applicant') || this;
        _this.AppService = AppService;
        _this.getArchive = function (queryParams) {
            if (queryParams === void 0) { queryParams = null; }
            return _this.Restangular.all(_this.itemName).customGET('archive').then(function (list) {
                _this.list = list.plain().value;
                return _this.listLoaded(_this.list);
            });
        };
        return _this;
    }
    ApplicantsService.prototype.postBlob = function (id, file) {
        var _this = this;
        // Create FormData to send in the request
        var formData = new FormData();
        formData.append('file', file, file.name);
        return this.Restangular.one('hr/applicant', id)
            .withHttpConfig({ transformRequest: angular.identity })
            .customPOST(formData, 'blobs', undefined, { 'Content-Type': undefined })
            .then(function (item) {
            _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            _this.item = item.plain();
            return item.plain();
        })
            .catch(function (error) {
            _this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    };
    ApplicantsService.prototype.getBlobs = function (id) {
        return this.Restangular.one('hr/applicant', id).all('blobs').customGET('').then(function (collection) {
            return collection.plain();
        });
    };
    ApplicantsService.prototype.deleteBlob = function (id, blobid) {
        return this.Restangular.one('hr/applicant', id).customDELETE('/blobs/' + blobid).then(function (res) {
            return res;
        });
    };
    ApplicantsService.prototype.getBlob = function (id, blobid) {
        // this.Restangular.setFullResponse(true);
        // return this.Restangular.one('hr/applicant', id).one('blobs', blobid).customGET('', {}, { responseType: 'blob'}).then((response) => {
        //     console.log(response);
        //     const link = document.createElement('a');
        //     link.href = URL.createObjectURL(response);
        //     link.download = 'test.doc';
        //     link.click();
        //     return new Blob(response.data, { type: response.headers('Content-Type') });
        // })
    };
    return ApplicantsService;
}(base_service_1.BaseService));
exports.ApplicantsService = ApplicantsService;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IContact = /** @class */ (function () {
    function IContact() {
    }
    return IContact;
}());
exports.IContact = IContact;
var ContactsService = /** @class */ (function (_super) {
    __extends(ContactsService, _super);
    ContactsService.$inject = ["Restangular", "AppService", "AuthUserService"];
    function ContactsService(Restangular, AppService, AuthUserService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/contacts') || this;
        _this.AppService = AppService;
        _this.AuthUserService = AuthUserService;
        return _this;
    }
    ContactsService.prototype.deleteAccount = function (authUser, contact) {
        var _this = this;
        // console.log('ContactsService deleteAccount');
        return this.AuthUserService.delete(authUser.id).then(function () {
            contact.userId = "";
            return _this.put(contact.id, contact).then(function (item) {
                // console.log(contact);
                // console.log('Account removed');
                return item;
            });
        });
    };
    ContactsService.prototype.createAccount = function (authUser, contact) {
        var _this = this;
        authUser.email = contact.emailAddress;
        authUser.userName = contact.emailAddress;
        authUser.roles = ['customer'];
        authUser.claims = {
            "displayName": contact.firstName + contact.lastName,
            "customerId": contact.accountId
        };
        return this.AuthUserService.post(authUser).then(function (response) {
            contact.userId = response.id;
            return _this.put(contact.id, contact).then(function (item) {
                // console.log('Account created');
                return item;
            });
        });
    };
    return ContactsService;
}(base_service_1.BaseService));
exports.ContactsService = ContactsService;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var IDashboard = /** @class */ (function () {
    function IDashboard() {
    }
    return IDashboard;
}());
exports.IDashboard = IDashboard;
var DashboardService = /** @class */ (function (_super) {
    __extends(DashboardService, _super);
    DashboardService.$inject = ["Restangular", "AppService"];
    function DashboardService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'dashboard') || this;
        _this.AppService = AppService;
        return _this;
    }
    return DashboardService;
}(base_service_1.BaseService));
exports.DashboardService = DashboardService;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IDeclaration = /** @class */ (function (_super) {
    __extends(IDeclaration, _super);
    function IDeclaration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IDeclaration;
}(base_entity_1.BaseEntity));
exports.IDeclaration = IDeclaration;
var DeclarationService = /** @class */ (function (_super) {
    __extends(DeclarationService, _super);
    DeclarationService.$inject = ["Restangular", "AppService"];
    function DeclarationService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'declaration') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    DeclarationService.prototype.confirm = function (data) {
        return this.Restangular.all(this.itemName).one('confirm').customPOST(data).then(function (item) {
            return item;
        });
    };
    return DeclarationService;
}(base_service_1.BaseService));
exports.DeclarationService = DeclarationService;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var base_entity_1 = __webpack_require__(8);
var IEmployee = /** @class */ (function () {
    function IEmployee() {
    }
    return IEmployee;
}());
exports.IEmployee = IEmployee;
var IEmployeeSubscription = /** @class */ (function (_super) {
    __extends(IEmployeeSubscription, _super);
    function IEmployeeSubscription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IEmployeeSubscription;
}(base_entity_1.BaseEntity));
exports.IEmployeeSubscription = IEmployeeSubscription;
var EmployeesService = /** @class */ (function (_super) {
    __extends(EmployeesService, _super);
    EmployeesService.$inject = ["Restangular", "AppService", "AuthUserService"];
    function EmployeesService(Restangular, AppService, AuthUserService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/employee') || this;
        _this.AppService = AppService;
        _this.AuthUserService = AuthUserService;
        _this.refresh = function (id) {
            return _this.Restangular.one('hr/employee', id.toString()).one('refreshFromNmbrs', 'true').get().then(function (item) {
                _this.item = item;
                return item.plain();
            });
        };
        _this.refreshAll = function () {
            return _this.Restangular.all('nmbrs/employeeupdate').getList().then(function (items) {
                return items.plain();
            });
        };
        _this.getSubscriptions = function () {
            return _this.Restangular.all('hr/employee/subscriptions').getList().then(function (subscriptions) {
                return subscriptions.plain();
            });
        };
        _this.getAvailability = function () {
            return _this.Restangular.all('hr/employee/availability').getList().then(function (availability) {
                return availability.plain();
            });
        };
        _this.getAvailabilityByRange = function (start, end) {
            return _this.Restangular.all('hr/employee/availabilityByRange').getList({ start: start, end: end }).then(function (availability) {
                return availability.plain();
            });
        };
        _this.postSubscription = function (data) {
            return _this.Restangular.all('hr/employee/subscriptions').post(data).then(function (item) {
                _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                return item.plain();
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
        };
        _this.putSubscription = function (data) {
            return _this.Restangular.one('hr/employee/subscriptions', data.id.toString()).customPUT(data).then(function (item) {
                _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                return item.plain();
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
        };
        _this.gatBackoffice = function () {
            return _this.Restangular.all('hr/employee/backoffice').getList().then(function (list) {
                return list.plain();
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
        };
        _this.getSalaryScales = function (employeeId) {
            return _this.Restangular.one(_this.itemName, employeeId).one('salaryscales').get().then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            });
        };
        _this.addSalaryScale = function (employeeId, salaryScaleId) {
            return _this.Restangular.one(_this.itemName, employeeId).customPOST({ salaryScaleId: salaryScaleId }, 'salaryscales').then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij toevoegen salary scale');
                throw error;
            });
        };
        _this.removeSalaryScale = function (employeeId, salaryScaleId) {
            return _this.Restangular.one(_this.itemName, employeeId).one('salaryscales', salaryScaleId).remove().then(function () {
                _this.AppService.NotifyService.success('Verwijderd', 'Salary scale is verwijderd');
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij verwijderen salary scale');
                throw error;
            });
        };
        _this.addSalaryScaleToScaleNumber = function (employeeId, salaryScaleId, scaleNumber) {
            return _this.Restangular.one(_this.itemName, employeeId).customPOST({ salaryScaleId: salaryScaleId, scaleNumber: scaleNumber }, 'salaryscales').then(function (response) {
                if (response && typeof response !== "string" && response.plain) {
                    return response.plain();
                }
                return response;
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij toevoegen salary scale');
                throw error;
            });
        };
        _this.removeSalaryScaleFromScaleNumber = function (employeeId, scaleNumber) {
            return _this.Restangular.one(_this.itemName, employeeId).one('salaryscales/scale', scaleNumber.toString()).remove().then(function () {
                _this.AppService.NotifyService.success('Verwijderd', 'Salary scale is verwijderd');
            })
                .catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error.data || error.message || 'Fout bij verwijderen salary scale');
                throw error;
            });
        };
        return _this;
    }
    EmployeesService.prototype.getEmployeesByStatus = function (active) {
        var _this = this;
        if (active === void 0) { active = true; }
        var type = '';
        if (active) {
            type = 'active';
        }
        else {
            type = 'inactive';
        }
        return this.Restangular.all(this.itemName).customGET('', { 'limit': 5000, 'type': type }).then(function (response) {
            _this.list = response.plain().value;
            return _this.listLoaded(_this.list);
        });
    };
    EmployeesService.prototype.getIsZZP = function () {
        return this.Restangular.all(this.itemName).one('iszzp').get().then(function (item) {
            var e = item.result;
            return { "zzp": e.zzp, "invoiceMonthly": e.incoiceMonthly };
        });
    };
    EmployeesService.prototype.deleteAccount = function (authUser, employee) {
        var _this = this;
        // console.log('EmployeesService deleteAccount');
        return this.AuthUserService.delete(authUser.id).then(function () {
            employee.userId = "";
            return _this.put(employee.id, employee).then(function (item) {
                // console.log('Account removed');
                return item;
            });
        });
    };
    EmployeesService.prototype.createAccount = function (authUser, employee) {
        var _this = this;
        authUser.email = employee.emailPrivate;
        authUser.userName = employee.emailPrivate;
        employee.username = authUser.userName;
        authUser.roles = ['employee'];
        authUser.claims = {
            "displayName": employee.displayName,
            "employeeId": employee.id
        };
        return this.AuthUserService.post(authUser).then(function (response) {
            employee.userId = response.id;
            return _this.put(employee.id, employee).then(function (item) {
                // console.log('Account created');
                return item;
            });
        });
    };
    return EmployeesService;
}(base_service_1.BaseService));
exports.EmployeesService = EmployeesService;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EnumService = /** @class */ (function () {
    function EnumService() {
        this.accountTypes = [
            "Leverancier",
            "Relatie",
            "Gemeente",
            "Uitzendbureau",
            "Opdrachtgever"
        ];
        this.contactTypes = [
            "backoffice",
            "employee"
        ];
        this.employeeTypes = [
            "Student",
            "Kantoormedewerker",
            "Medewerker",
            "Solicitant"
        ];
        this.monthsOfTheYear = [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december",
        ];
    }
    return EnumService;
}());
exports.EnumService = EnumService;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IInvoice = /** @class */ (function (_super) {
    __extends(IInvoice, _super);
    function IInvoice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasUnpaid = false;
        return _this;
    }
    return IInvoice;
}(base_entity_1.BaseEntity));
exports.IInvoice = IInvoice;
var IInvoiceLine = /** @class */ (function (_super) {
    __extends(IInvoiceLine, _super);
    function IInvoiceLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IInvoiceLine;
}(base_entity_1.BaseEntity));
exports.IInvoiceLine = IInvoiceLine;
var InvoicesService = /** @class */ (function (_super) {
    __extends(InvoicesService, _super);
    InvoicesService.$inject = ["Restangular", "AppService"];
    function InvoicesService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'finance/invoice') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return InvoicesService;
}(base_service_1.BaseService));
exports.InvoicesService = InvoicesService;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var ILead = /** @class */ (function () {
    function ILead() {
    }
    return ILead;
}());
exports.ILead = ILead;
var LeadsService = /** @class */ (function (_super) {
    __extends(LeadsService, _super);
    LeadsService.$inject = ["Restangular", "AppService"];
    function LeadsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/leads') || this;
        _this.AppService = AppService;
        return _this;
    }
    return LeadsService;
}(base_service_1.BaseService));
exports.LeadsService = LeadsService;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var Masterdata = /** @class */ (function (_super) {
    __extends(Masterdata, _super);
    function Masterdata() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Masterdata;
}(base_entity_1.BaseEntity));
exports.Masterdata = Masterdata;
var MasterdataAService = /** @class */ (function (_super) {
    __extends(MasterdataAService, _super);
    MasterdataAService.$inject = ["Restangular", "AppService"];
    function MasterdataAService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'masterdata') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.types = [];
        _this.setApiItemName = function (name) {
            _this.apiItemName = name;
        };
        _this.setType = function (name, id) {
            _this.types.push({ "name": name, "id": id });
        };
        _this.setTypes = function (types) {
            _this.types.push(types);
        };
        _this.getTypes = function () {
            return _this.types;
        };
        _this.setItemName = function (name) {
            _this.itemName = name;
            _this.collection = _this.Restangular.all(_this.itemName);
            return true;
        };
        _this.postItem = function (type, data) {
            return _this.collection.customPOST(data, type).then(function (response) {
                _this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                return response;
            }).catch(function (error) {
                _this.AppService.NotifyService.error('Foutmelding', error);
                return error;
            });
        };
        _this.getItems = function (type) {
            return _this.collection.customGET('types/' + type).then(function (response) {
                return response.plain();
            });
        };
        _this.setType('Skills', 'SKILLS');
        _this.setType('Functions', 'Functions');
        _this.setType('Hour codes', 'HourCodes');
        _this.setType('Availability status', 'AvalabilityStatus');
        _this.setType('Transportation type', 'TransportationType');
        _this.setType('Note Tags', 'NoteTags');
        _this.setType('Contact Tags', 'ContactTags');
        _this.setType('Task Status', 'TaskStatus');
        _this.setType('Preferred target audience', 'PreferredTargetAudience');
        _this.setType('Application status', 'ApplicationStatus');
        return _this;
    }
    return MasterdataAService;
}(base_service_1.BaseService));
exports.MasterdataAService = MasterdataAService;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var INote = /** @class */ (function () {
    function INote() {
    }
    return INote;
}());
exports.INote = INote;
var NotesService = /** @class */ (function (_super) {
    __extends(NotesService, _super);
    NotesService.$inject = ["Restangular", "AppService"];
    function NotesService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/notes') || this;
        _this.AppService = AppService;
        return _this;
    }
    return NotesService;
}(base_service_1.BaseService));
exports.NotesService = NotesService;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var SettingsService = /** @class */ (function (_super) {
    __extends(SettingsService, _super);
    SettingsService.$inject = ["Restangular", "AppService"];
    function SettingsService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'settings') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return SettingsService;
}(base_service_1.BaseService));
exports.SettingsService = SettingsService;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_entity_1 = __webpack_require__(8);
var base_service_1 = __webpack_require__(3);
var IStaff = /** @class */ (function (_super) {
    __extends(IStaff, _super);
    function IStaff() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IStaff;
}(base_entity_1.BaseEntity));
exports.IStaff = IStaff;
var StaffService = /** @class */ (function (_super) {
    __extends(StaffService, _super);
    StaffService.$inject = ["Restangular", "AppService"];
    function StaffService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'hr/staffmember') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        _this.getUser = function (id) {
            return _this.customGet(id + '/user').then(function (item) {
                return item;
            });
        };
        _this.createUser = function (id, user) {
            return _this.customPost(id + '/user', user).then(function (item) {
                return item;
            });
        };
        _this.deleteUser = function (id) {
            return _this.customDelete(id + '/user').then(function (item) {
                return item;
            });
        };
        _this.getRoles = function (id) {
            return _this.customGet(id + '/roles').then(function (item) {
                return item;
            });
        };
        _this.putRoles = function (id, roles) {
            return _this.customPut(id + '/roles', { roles: roles }).then(function (item) {
                return item;
            });
        };
        _this.putPassword = function (id, password) {
            return _this.customPut(id + '/password', { password: password }).then(function (item) {
                return item;
            });
        };
        return _this;
    }
    return StaffService;
}(base_service_1.BaseService));
exports.StaffService = StaffService;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var ITask = /** @class */ (function () {
    function ITask() {
    }
    return ITask;
}());
exports.ITask = ITask;
var TasksService = /** @class */ (function (_super) {
    __extends(TasksService, _super);
    TasksService.$inject = ["Restangular", "AppService"];
    function TasksService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'crm/Tasks') || this;
        _this.AppService = AppService;
        _this.getArchive = function (queryParams) {
            if (queryParams === void 0) { queryParams = null; }
            return _this.Restangular.all(_this.itemName).customGET('archive', queryParams).then(function (list) {
                _this.list = list.plain().value;
                return _this.listLoaded(_this.list);
            });
        };
        return _this;
    }
    return TasksService;
}(base_service_1.BaseService));
exports.TasksService = TasksService;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_service_1 = __webpack_require__(3);
var TemplatesService = /** @class */ (function (_super) {
    __extends(TemplatesService, _super);
    TemplatesService.$inject = ["Restangular", "AppService"];
    function TemplatesService(Restangular, AppService) {
        "ngInject";
        var _this = _super.call(this, Restangular, AppService, 'emails') || this;
        _this.Restangular = Restangular;
        _this.AppService = AppService;
        return _this;
    }
    return TemplatesService;
}(base_service_1.BaseService));
exports.TemplatesService = TemplatesService;


/***/ })
],[546]);


// WEBPACK FOOTER //
// js/common.e6f18e1787abb97d7dba.js